var Alime =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 315);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
})(undefined, function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            return false;
        }
        return true;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    var some$1 = some;

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }

        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
        if (number < 0) {
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2);
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;

        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var keys$1 = keys;

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/;
    var match2 = /\d\d/;
    var match3 = /\d{3}/;
    var match4 = /\d{4}/;
    var match6 = /[+-]?\d{6}/;
    var match1to2 = /\d\d?/;
    var match3to4 = /\d\d\d\d?/;
    var match5to6 = /\d\d\d\d\d\d?/;
    var match1to3 = /\d{1,3}/;
    var match1to4 = /\d{1,4}/;
    var match1to6 = /[+-]?\d{1,6}/;

    var matchUnsigned = /\d+/;
    var matchSigned = /[+-]?\d+/;

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi;
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi;

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/;
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    var indexOf$1 = indexOf;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    addUnitAlias('month', 'M');

    addUnitPriority('month', 8);

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);

        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }

            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);

                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }

        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    addUnitAlias('year', 'y');

    addUnitPriority('year', 1);

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        var date = new Date(y, m, d, h, M, s, ms);

        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy,
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0,
        doy: 6 };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);

        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays : this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }

            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }

        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    addUnitAlias('hour', 'h');

    addUnitPriority('hour', 13);

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    function localeIsPM(input) {
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;

        if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                __webpack_require__(261)("./" + name);

                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            getSetGlobalLocale(name);

            return locales[name];
        } else {
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                parentConfig = baseConfig;

            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            getSetGlobalLocale(name);
        } else {
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys$1(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];

    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

    function configFromRFC2822(config) {
        var string, match, dayFormat, dateFormat, timeFormat, tzFormat;
        var timezones = {
            ' GMT': ' +0000',
            ' EDT': ' -0400',
            ' EST': ' -0500',
            ' CDT': ' -0500',
            ' CST': ' -0600',
            ' MDT': ' -0600',
            ' MST': ' -0700',
            ' PDT': ' -0700',
            ' PST': ' -0800'
        };
        var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
        var timezone, timezoneIndex;

        string = config._i.replace(/\([^\)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s|\s$/g, '');
        match = basicRfcRegex.exec(string);

        if (match) {
            dayFormat = match[1] ? 'ddd' + (match[1].length === 5 ? ', ' : ' ') : '';
            dateFormat = 'D MMM ' + (match[2].length > 10 ? 'YYYY ' : 'YY ');
            timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

            if (match[1]) {
                var momentDate = new Date(match[2]);
                var momentDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][momentDate.getDay()];

                if (match[1].substr(0, 3) !== momentDay) {
                    getParsingFlags(config).weekdayMismatch = true;
                    config._isValid = false;
                    return;
                }
            }

            switch (match[5].length) {
                case 2:
                    if (timezoneIndex === 0) {
                        timezone = ' +0000';
                    } else {
                        timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                        timezone = (timezoneIndex < 0 ? ' -' : ' +') + ('' + timezoneIndex).replace(/^-?/, '0').match(/..$/)[0] + '00';
                    }
                    break;
                case 4:
                    timezone = timezones[match[5]];
                    break;
                default:
                    timezone = timezones[' GMT'];
            }
            match[5] = timezone;
            config._i = match.splice(1).join('');
            tzFormat = ' ZZ';
            config._f = dayFormat + dateFormat + timeFormat + tzFormat;
            configFromStringAndFormat(config);
            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);

        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    hooks.ISO_8601 = function () {};

    hooks.RFC_2822 = function () {};

    function configFromStringAndFormat(config) {
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }

            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;

        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            return hour;
        }
    }

    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }

        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    });

    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false;
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
        this._days = +days + weeks * 7;

        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();

            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    hooks.updateOffset = function () {};

    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        var res = inp && parseFloat(inp.replace(',', '.'));

        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;

            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;val = period;period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) && (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : units === 'minute' ? delta / 6e4 : units === 'hour' ? delta / 36e5 : units === 'day' ? (delta - zoneDelta) / 864e5 : units === 'week' ? (delta - zoneDelta) / 6048e5 : delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');

            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');

            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        if (!this.isValid()) {
            return null;
        }
        var m = this.clone().utc();
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
        if (isFunction(Date.prototype.toISOString)) {
            return this.toDate().toISOString();
        }
        return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }

    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    function startOf(units) {
        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                this.month(0);

            case 'quarter':
            case 'month':
                this.date(1);

            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);

            case 'hour':
                this.minutes(0);

            case 'minute':
                this.seconds(0);

            case 'second':
                this.milliseconds(0);
        }

        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    addFormatToken('Q', 0, 'Qo', 'quarter');

    addUnitAlias('quarter', 'Q');

    addUnitPriority('quarter', 7);

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    addUnitAlias('date', 'D');

    addUnitPriority('date', 9);

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    var getSetDayOfMonth = makeGetSet('Date', true);

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    addUnitAlias('dayOfYear', 'DDD');

    addUnitPriority('dayOfYear', 4);

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    addFormatToken('m', ['mm', 2], 0, 'minute');

    addUnitAlias('minute', 'm');

    addUnitPriority('minute', 14);

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    var getSetMinute = makeGetSet('Minutes', false);

    addFormatToken('s', ['ss', 2], 0, 'second');

    addUnitAlias('second', 's');

    addUnitPriority('second', 15);

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    var getSetSecond = makeGetSet('Seconds', false);

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    addUnitAlias('millisecond', 'ms');

    addUnitPriority('millisecond', 16);

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }


    var getSetMillisecond = makeGetSet('Milliseconds', false);

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;

    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;

    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

    proto.quarter = proto.quarters = getSetQuarter;

    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;

    proto.hour = proto.hours = getSetHour;

    proto.minute = proto.minutes = getSetMinute;

    proto.second = proto.seconds = getSetSecond;

    proto.millisecond = proto.milliseconds = getSetMillisecond;

    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;

    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;

    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;

                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asYears = makeAs('y');

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11 };

    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function toISOString$1() {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        years = absFloor(months / 12);
        months %= 12;

        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            return 'P0D';
        }

        return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    hooks.version = '2.18.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    return hooks;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Zepto = function () {
  var undefined,
      key,
      $,
      classList,
      emptyArray = [],
      _concat = emptyArray.concat,
      _filter = emptyArray.filter,
      _slice = emptyArray.slice,
      document = window.document,
      elementDisplay = {},
      classCache = {},
      cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1, 'opacity': 1, 'z-index': 1, 'zoom': 1 },
      fragmentRE = /^\s*<(\w+|!)[^>]*>/,
      singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
      rootNodeRE = /^(?:body|html)$/i,
      capitalRE = /([A-Z])/g,
      methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
      adjacencyOperators = ['after', 'prepend', 'before', 'append'],
      table = document.createElement('table'),
      tableRow = document.createElement('tr'),
      containers = {
    'tr': document.createElement('tbody'),
    'tbody': table, 'thead': table, 'tfoot': table,
    'td': tableRow, 'th': tableRow,
    '*': document.createElement('div')
  },
      simpleSelectorRE = /^[\w-]*$/,
      class2type = {},
      toString = class2type.toString,
      zepto = {},
      camelize,
      uniq,
      tempParent = document.createElement('div'),
      propMap = {
    'tabindex': 'tabIndex',
    'readonly': 'readOnly',
    'for': 'htmlFor',
    'class': 'className',
    'maxlength': 'maxLength',
    'cellspacing': 'cellSpacing',
    'cellpadding': 'cellPadding',
    'rowspan': 'rowSpan',
    'colspan': 'colSpan',
    'usemap': 'useMap',
    'frameborder': 'frameBorder',
    'contenteditable': 'contentEditable'
  },
      isArray = Array.isArray || function (object) {
    return object instanceof Array;
  };

  zepto.matches = function (element, selector) {
    if (!selector || !element || element.nodeType !== 1) return false;
    var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
    if (matchesSelector) return matchesSelector.call(element, selector);

    var match,
        parent = element.parentNode,
        temp = !parent;
    if (temp) (parent = tempParent).appendChild(element);
    match = ~zepto.qsa(parent, selector).indexOf(element);
    temp && tempParent.removeChild(element);
    return match;
  };

  function type(obj) {
    return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
  }

  function isFunction(value) {
    return type(value) == "function";
  }
  function isWindow(obj) {
    return obj != null && obj == obj.window;
  }
  function isDocument(obj) {
    return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
  }
  function isObject(obj) {
    return type(obj) == "object";
  }
  function isPlainObject(obj) {
    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
  }

  function likeArray(obj) {
    var length = !!obj && 'length' in obj && obj.length,
        type = $.type(obj);

    return 'function' != type && !isWindow(obj) && ('array' == type || length === 0 || typeof length == 'number' && length > 0 && length - 1 in obj);
  }

  function compact(array) {
    return _filter.call(array, function (item) {
      return item != null;
    });
  }
  function flatten(array) {
    return array.length > 0 ? $.fn.concat.apply([], array) : array;
  }
  camelize = function camelize(str) {
    return str.replace(/-+(.)?/g, function (match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
  };
  function dasherize(str) {
    return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
  }
  uniq = function uniq(array) {
    return _filter.call(array, function (item, idx) {
      return array.indexOf(item) == idx;
    });
  };

  function classRE(name) {
    return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
  }

  function maybeAddPx(name, value) {
    return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
  }

  function defaultDisplay(nodeName) {
    var element, display;
    if (!elementDisplay[nodeName]) {
      element = document.createElement(nodeName);
      document.body.appendChild(element);
      display = getComputedStyle(element, '').getPropertyValue("display");
      element.parentNode.removeChild(element);
      display == "none" && (display = "block");
      elementDisplay[nodeName] = display;
    }
    return elementDisplay[nodeName];
  }

  function _children(element) {
    return 'children' in element ? _slice.call(element.children) : $.map(element.childNodes, function (node) {
      if (node.nodeType == 1) return node;
    });
  }

  function Z(dom, selector) {
    var i,
        len = dom ? dom.length : 0;
    for (i = 0; i < len; i++) {
      this[i] = dom[i];
    }this.length = len;
    this.selector = selector || '';
  }

  zepto.fragment = function (html, name, properties) {
    var dom, nodes, container;

    if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1));

    if (!dom) {
      if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
      if (name === undefined) name = fragmentRE.test(html) && RegExp.$1;
      if (!(name in containers)) name = '*';

      container = containers[name];
      container.innerHTML = '' + html;
      dom = $.each(_slice.call(container.childNodes), function () {
        container.removeChild(this);
      });
    }

    if (isPlainObject(properties)) {
      nodes = $(dom);
      $.each(properties, function (key, value) {
        if (methodAttributes.indexOf(key) > -1) nodes[key](value);else nodes.attr(key, value);
      });
    }

    return dom;
  };

  zepto.Z = function (dom, selector) {
    return new Z(dom, selector);
  };

  zepto.isZ = function (object) {
    return object instanceof zepto.Z;
  };

  zepto.init = function (selector, context) {
    var dom;

    if (!selector) return zepto.Z();else if (typeof selector == 'string') {
        selector = selector.trim();

        if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;else if (context !== undefined) return $(context).find(selector);else dom = zepto.qsa(document, selector);
      } else if (isFunction(selector)) return $(document).ready(selector);else if (zepto.isZ(selector)) return selector;else {
            if (isArray(selector)) dom = compact(selector);else if (isObject(selector)) dom = [selector], selector = null;else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;else if (context !== undefined) return $(context).find(selector);else dom = zepto.qsa(document, selector);
          }

    return zepto.Z(dom, selector);
  };

  $ = function $(selector, context) {
    return zepto.init(selector, context);
  };

  function extend(target, source, deep) {
    for (key in source) {
      if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
        if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
        if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
        extend(target[key], source[key], deep);
      } else if (source[key] !== undefined) target[key] = source[key];
    }
  }

  $.extend = function (target) {
    var deep,
        args = _slice.call(arguments, 1);
    if (typeof target == 'boolean') {
      deep = target;
      target = args.shift();
    }
    args.forEach(function (arg) {
      extend(target, arg, deep);
    });
    return target;
  };

  zepto.qsa = function (element, selector) {
    var found,
        maybeID = selector[0] == '#',
        maybeClass = !maybeID && selector[0] == '.',
        nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
        isSimple = simpleSelectorRE.test(nameOnly);
    return element.getElementById && isSimple && maybeID ? (found = element.getElementById(nameOnly)) ? [found] : [] : element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11 ? [] : _slice.call(isSimple && !maybeID && element.getElementsByClassName ? maybeClass ? element.getElementsByClassName(nameOnly) : element.getElementsByTagName(selector) : element.querySelectorAll(selector));
  };

  function filtered(nodes, selector) {
    return selector == null ? $(nodes) : $(nodes).filter(selector);
  }

  $.contains = document.documentElement.contains ? function (parent, node) {
    return parent !== node && parent.contains(node);
  } : function (parent, node) {
    while (node && (node = node.parentNode)) {
      if (node === parent) return true;
    }return false;
  };

  function funcArg(context, arg, idx, payload) {
    return isFunction(arg) ? arg.call(context, idx, payload) : arg;
  }

  function setAttribute(node, name, value) {
    value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
  }

  function className(node, value) {
    var klass = node.className || '',
        svg = klass && klass.baseVal !== undefined;

    if (value === undefined) return svg ? klass.baseVal : klass;
    svg ? klass.baseVal = value : node.className = value;
  }

  function deserializeValue(value) {
    try {
      return value ? value == "true" || (value == "false" ? false : value == "null" ? null : +value + "" == value ? +value : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
    } catch (e) {
      return value;
    }
  }

  $.type = type;
  $.isFunction = isFunction;
  $.isWindow = isWindow;
  $.isArray = isArray;
  $.isPlainObject = isPlainObject;

  $.isEmptyObject = function (obj) {
    var name;
    for (name in obj) {
      return false;
    }return true;
  };

  $.isNumeric = function (val) {
    var num = Number(val),
        type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
    return val != null && type != 'boolean' && (type != 'string' || val.length) && !isNaN(num) && isFinite(num) || false;
  };

  $.inArray = function (elem, array, i) {
    return emptyArray.indexOf.call(array, elem, i);
  };

  $.camelCase = camelize;
  $.trim = function (str) {
    return str == null ? "" : String.prototype.trim.call(str);
  };

  $.uuid = 0;
  $.support = {};
  $.expr = {};
  $.noop = function () {};

  $.map = function (elements, callback) {
    var value,
        values = [],
        i,
        key;
    if (likeArray(elements)) for (i = 0; i < elements.length; i++) {
      value = callback(elements[i], i);
      if (value != null) values.push(value);
    } else for (key in elements) {
      value = callback(elements[key], key);
      if (value != null) values.push(value);
    }
    return flatten(values);
  };

  $.each = function (elements, callback) {
    var i, key;
    if (likeArray(elements)) {
      for (i = 0; i < elements.length; i++) {
        if (callback.call(elements[i], i, elements[i]) === false) return elements;
      }
    } else {
      for (key in elements) {
        if (callback.call(elements[key], key, elements[key]) === false) return elements;
      }
    }

    return elements;
  };

  $.grep = function (elements, callback) {
    return _filter.call(elements, callback);
  };

  if (window.JSON) $.parseJSON = JSON.parse;

  $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });

  $.fn = {
    constructor: zepto.Z,
    length: 0,

    forEach: emptyArray.forEach,
    reduce: emptyArray.reduce,
    push: emptyArray.push,
    sort: emptyArray.sort,
    splice: emptyArray.splice,
    indexOf: emptyArray.indexOf,
    concat: function concat() {
      var i,
          value,
          args = [];
      for (i = 0; i < arguments.length; i++) {
        value = arguments[i];
        args[i] = zepto.isZ(value) ? value.toArray() : value;
      }
      return _concat.apply(zepto.isZ(this) ? this.toArray() : this, args);
    },

    map: function map(fn) {
      return $($.map(this, function (el, i) {
        return fn.call(el, i, el);
      }));
    },
    slice: function slice() {
      return $(_slice.apply(this, arguments));
    },

    ready: function ready(callback) {
      if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) setTimeout(function () {
        callback($);
      }, 0);else {
        var handler = function handler() {
          document.removeEventListener("DOMContentLoaded", handler, false);
          window.removeEventListener("load", handler, false);
          callback($);
        };
        document.addEventListener("DOMContentLoaded", handler, false);
        window.addEventListener("load", handler, false);
      }
      return this;
    },
    get: function get(idx) {
      return idx === undefined ? _slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
    },
    toArray: function toArray() {
      return this.get();
    },
    size: function size() {
      return this.length;
    },
    remove: function remove() {
      return this.each(function () {
        if (this.parentNode != null) this.parentNode.removeChild(this);
      });
    },
    each: function each(callback) {
      emptyArray.every.call(this, function (el, idx) {
        return callback.call(el, idx, el) !== false;
      });
      return this;
    },
    filter: function filter(selector) {
      if (isFunction(selector)) return this.not(this.not(selector));
      return $(_filter.call(this, function (element) {
        return zepto.matches(element, selector);
      }));
    },
    add: function add(selector, context) {
      return $(uniq(this.concat($(selector, context))));
    },
    is: function is(selector) {
      return this.length > 0 && zepto.matches(this[0], selector);
    },
    not: function not(selector) {
      var nodes = [];
      if (isFunction(selector) && selector.call !== undefined) this.each(function (idx) {
        if (!selector.call(this, idx)) nodes.push(this);
      });else {
        var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? _slice.call(selector) : $(selector);
        this.forEach(function (el) {
          if (excludes.indexOf(el) < 0) nodes.push(el);
        });
      }
      return $(nodes);
    },
    has: function has(selector) {
      return this.filter(function () {
        return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
      });
    },
    eq: function eq(idx) {
      return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
    },
    first: function first() {
      var el = this[0];
      return el && !isObject(el) ? el : $(el);
    },
    last: function last() {
      var el = this[this.length - 1];
      return el && !isObject(el) ? el : $(el);
    },
    find: function find(selector) {
      var result,
          $this = this;
      if (!selector) result = $();else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) == 'object') result = $(selector).filter(function () {
        var node = this;
        return emptyArray.some.call($this, function (parent) {
          return $.contains(parent, node);
        });
      });else if (this.length == 1) result = $(zepto.qsa(this[0], selector));else result = this.map(function () {
        return zepto.qsa(this, selector);
      });
      return result;
    },
    closest: function closest(selector, context) {
      var nodes = [],
          collection = (typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) == 'object' && $(selector);
      this.each(function (_, node) {
        while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector))) {
          node = node !== context && !isDocument(node) && node.parentNode;
        }if (node && nodes.indexOf(node) < 0) nodes.push(node);
      });
      return $(nodes);
    },
    parents: function parents(selector) {
      var ancestors = [],
          nodes = this;
      while (nodes.length > 0) {
        nodes = $.map(nodes, function (node) {
          if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
            ancestors.push(node);
            return node;
          }
        });
      }return filtered(ancestors, selector);
    },
    parent: function parent(selector) {
      return filtered(uniq(this.pluck('parentNode')), selector);
    },
    children: function children(selector) {
      return filtered(this.map(function () {
        return _children(this);
      }), selector);
    },
    contents: function contents() {
      return this.map(function () {
        return this.contentDocument || _slice.call(this.childNodes);
      });
    },
    siblings: function siblings(selector) {
      return filtered(this.map(function (i, el) {
        return _filter.call(_children(el.parentNode), function (child) {
          return child !== el;
        });
      }), selector);
    },
    empty: function empty() {
      return this.each(function () {
        this.innerHTML = '';
      });
    },

    pluck: function pluck(property) {
      return $.map(this, function (el) {
        return el[property];
      });
    },
    show: function show() {
      return this.each(function () {
        this.style.display == "none" && (this.style.display = '');
        if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
      });
    },
    replaceWith: function replaceWith(newContent) {
      return this.before(newContent).remove();
    },
    wrap: function wrap(structure) {
      var func = isFunction(structure);
      if (this[0] && !func) var dom = $(structure).get(0),
          clone = dom.parentNode || this.length > 1;

      return this.each(function (index) {
        $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
      });
    },
    wrapAll: function wrapAll(structure) {
      if (this[0]) {
        $(this[0]).before(structure = $(structure));
        var children;

        while ((children = structure.children()).length) {
          structure = children.first();
        }$(structure).append(this);
      }
      return this;
    },
    wrapInner: function wrapInner(structure) {
      var func = isFunction(structure);
      return this.each(function (index) {
        var self = $(this),
            contents = self.contents(),
            dom = func ? structure.call(this, index) : structure;
        contents.length ? contents.wrapAll(dom) : self.append(dom);
      });
    },
    unwrap: function unwrap() {
      this.parent().each(function () {
        $(this).replaceWith($(this).children());
      });
      return this;
    },
    clone: function clone() {
      return this.map(function () {
        return this.cloneNode(true);
      });
    },
    hide: function hide() {
      return this.css("display", "none");
    },
    toggle: function toggle(setting) {
      return this.each(function () {
        var el = $(this);(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide();
      });
    },
    prev: function prev(selector) {
      return $(this.pluck('previousElementSibling')).filter(selector || '*');
    },
    next: function next(selector) {
      return $(this.pluck('nextElementSibling')).filter(selector || '*');
    },
    html: function html(_html) {
      return 0 in arguments ? this.each(function (idx) {
        var originHtml = this.innerHTML;
        $(this).empty().append(funcArg(this, _html, idx, originHtml));
      }) : 0 in this ? this[0].innerHTML : null;
    },
    text: function text(_text) {
      return 0 in arguments ? this.each(function (idx) {
        var newText = funcArg(this, _text, idx, this.textContent);
        this.textContent = newText == null ? '' : '' + newText;
      }) : 0 in this ? this.pluck('textContent').join("") : null;
    },
    attr: function attr(name, value) {
      var result;
      return typeof name == 'string' && !(1 in arguments) ? 0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined : this.each(function (idx) {
        if (this.nodeType !== 1) return;
        if (isObject(name)) for (key in name) {
          setAttribute(this, key, name[key]);
        } else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
      });
    },
    removeAttr: function removeAttr(name) {
      return this.each(function () {
        this.nodeType === 1 && name.split(' ').forEach(function (attribute) {
          setAttribute(this, attribute);
        }, this);
      });
    },
    prop: function prop(name, value) {
      name = propMap[name] || name;
      return 1 in arguments ? this.each(function (idx) {
        this[name] = funcArg(this, value, idx, this[name]);
      }) : this[0] && this[0][name];
    },
    removeProp: function removeProp(name) {
      name = propMap[name] || name;
      return this.each(function () {
        delete this[name];
      });
    },
    data: function data(name, value) {
      var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase();

      var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);

      return data !== null ? deserializeValue(data) : undefined;
    },
    val: function val(value) {
      if (0 in arguments) {
        if (value == null) value = "";
        return this.each(function (idx) {
          this.value = funcArg(this, value, idx, this.value);
        });
      } else {
        return this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function () {
          return this.selected;
        }).pluck('value') : this[0].value);
      }
    },
    offset: function offset(coordinates) {
      if (coordinates) return this.each(function (index) {
        var $this = $(this),
            coords = funcArg(this, coordinates, index, $this.offset()),
            parentOffset = $this.offsetParent().offset(),
            props = {
          top: coords.top - parentOffset.top,
          left: coords.left - parentOffset.left
        };

        if ($this.css('position') == 'static') props['position'] = 'relative';
        $this.css(props);
      });
      if (!this.length) return null;
      if (document.documentElement !== this[0] && !$.contains(document.documentElement, this[0])) return { top: 0, left: 0 };
      var obj = this[0].getBoundingClientRect();
      return {
        left: obj.left + window.pageXOffset,
        top: obj.top + window.pageYOffset,
        width: Math.round(obj.width),
        height: Math.round(obj.height)
      };
    },
    css: function css(property, value) {
      if (arguments.length < 2) {
        var element = this[0];
        if (typeof property == 'string') {
          if (!element) return;
          return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property);
        } else if (isArray(property)) {
          if (!element) return;
          var props = {};
          var computedStyle = getComputedStyle(element, '');
          $.each(property, function (_, prop) {
            props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
          });
          return props;
        }
      }

      var css = '';
      if (type(property) == 'string') {
        if (!value && value !== 0) this.each(function () {
          this.style.removeProperty(dasherize(property));
        });else css = dasherize(property) + ":" + maybeAddPx(property, value);
      } else {
        for (key in property) {
          if (!property[key] && property[key] !== 0) this.each(function () {
            this.style.removeProperty(dasherize(key));
          });else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
        }
      }

      return this.each(function () {
        this.style.cssText += ';' + css;
      });
    },
    index: function index(element) {
      return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
    },
    hasClass: function hasClass(name) {
      if (!name) return false;
      return emptyArray.some.call(this, function (el) {
        return this.test(className(el));
      }, classRE(name));
    },
    addClass: function addClass(name) {
      if (!name) return this;
      return this.each(function (idx) {
        if (!('className' in this)) return;
        classList = [];
        var cls = className(this),
            newName = funcArg(this, name, idx, cls);
        newName.split(/\s+/g).forEach(function (klass) {
          if (!$(this).hasClass(klass)) classList.push(klass);
        }, this);
        classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
      });
    },
    removeClass: function removeClass(name) {
      return this.each(function (idx) {
        if (!('className' in this)) return;
        if (name === undefined) return className(this, '');
        classList = className(this);
        funcArg(this, name, idx, classList).split(/\s+/g).forEach(function (klass) {
          classList = classList.replace(classRE(klass), " ");
        });
        className(this, classList.trim());
      });
    },
    toggleClass: function toggleClass(name, when) {
      if (!name) return this;
      return this.each(function (idx) {
        var $this = $(this),
            names = funcArg(this, name, idx, className(this));
        names.split(/\s+/g).forEach(function (klass) {
          (when === undefined ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
        });
      });
    },
    scrollTop: function scrollTop(value) {
      if (!this.length) return;
      var hasScrollTop = 'scrollTop' in this[0];
      if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
      return this.each(hasScrollTop ? function () {
        this.scrollTop = value;
      } : function () {
        this.scrollTo(this.scrollX, value);
      });
    },
    scrollLeft: function scrollLeft(value) {
      if (!this.length) return;
      var hasScrollLeft = 'scrollLeft' in this[0];
      if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
      return this.each(hasScrollLeft ? function () {
        this.scrollLeft = value;
      } : function () {
        this.scrollTo(value, this.scrollY);
      });
    },
    position: function position() {
      if (!this.length) return;

      var elem = this[0],
          offsetParent = this.offsetParent(),
          offset = this.offset(),
          parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();

      offset.top -= parseFloat($(elem).css('margin-top')) || 0;
      offset.left -= parseFloat($(elem).css('margin-left')) || 0;

      parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
      parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;

      return {
        top: offset.top - parentOffset.top,
        left: offset.left - parentOffset.left
      };
    },
    offsetParent: function offsetParent() {
      return this.map(function () {
        var parent = this.offsetParent || document.body;
        while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static") {
          parent = parent.offsetParent;
        }return parent;
      });
    }
  };

  $.fn.detach = $.fn.remove;['width', 'height'].forEach(function (dimension) {
    var dimensionProperty = dimension.replace(/./, function (m) {
      return m[0].toUpperCase();
    });

    $.fn[dimension] = function (value) {
      var offset,
          el = this[0];
      if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];else return this.each(function (idx) {
        el = $(this);
        el.css(dimension, funcArg(this, value, idx, el[dimension]()));
      });
    };
  });

  function traverseNode(node, fun) {
    fun(node);
    for (var i = 0, len = node.childNodes.length; i < len; i++) {
      traverseNode(node.childNodes[i], fun);
    }
  }

  adjacencyOperators.forEach(function (operator, operatorIndex) {
    var inside = operatorIndex % 2;

    $.fn[operator] = function () {
      var argType,
          nodes = $.map(arguments, function (arg) {
        var arr = [];
        argType = type(arg);
        if (argType == "array") {
          arg.forEach(function (el) {
            if (el.nodeType !== undefined) return arr.push(el);else if ($.zepto.isZ(el)) return arr = arr.concat(el.get());
            arr = arr.concat(zepto.fragment(el));
          });
          return arr;
        }
        return argType == "object" || arg == null ? arg : zepto.fragment(arg);
      }),
          parent,
          copyByClone = this.length > 1;
      if (nodes.length < 1) return this;

      return this.each(function (_, target) {
        parent = inside ? target : target.parentNode;

        target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;

        var parentInDocument = $.contains(document.documentElement, parent);

        nodes.forEach(function (node) {
          if (copyByClone) node = node.cloneNode(true);else if (!parent) return $(node).remove();

          parent.insertBefore(node, target);
          if (parentInDocument) traverseNode(node, function (el) {
            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) {
              var target = el.ownerDocument ? el.ownerDocument.defaultView : window;
              target['eval'].call(target, el.innerHTML);
            }
          });
        });
      });
    };

    $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function (html) {
      $(html)[operator](this);
      return this;
    };
  });

  zepto.Z.prototype = Z.prototype = $.fn;

  zepto.uniq = uniq;
  zepto.deserializeValue = deserializeValue;
  $.zepto = zepto;

  return $;
}();

window.Zepto = Zepto;
window.$ === undefined && (window.$ = Zepto);(function ($) {
  var _zid = 1,
      undefined,
      slice = Array.prototype.slice,
      isFunction = $.isFunction,
      isString = function isString(obj) {
    return typeof obj == 'string';
  },
      handlers = {},
      specialEvents = {},
      focusinSupported = 'onfocusin' in window,
      focus = { focus: 'focusin', blur: 'focusout' },
      hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' };

  specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';

  function zid(element) {
    return element._zid || (element._zid = _zid++);
  }
  function findHandlers(element, event, fn, selector) {
    event = parse(event);
    if (event.ns) var matcher = matcherFor(event.ns);
    return (handlers[zid(element)] || []).filter(function (handler) {
      return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
    });
  }
  function parse(event) {
    var parts = ('' + event).split('.');
    return { e: parts[0], ns: parts.slice(1).sort().join(' ') };
  }
  function matcherFor(ns) {
    return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
  }

  function eventCapture(handler, captureSetting) {
    return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
  }

  function realEvent(type) {
    return hover[type] || focusinSupported && focus[type] || type;
  }

  function add(element, events, fn, data, selector, delegator, capture) {
    var id = zid(element),
        set = handlers[id] || (handlers[id] = []);
    events.split(/\s/).forEach(function (event) {
      if (event == 'ready') return $(document).ready(fn);
      var handler = parse(event);
      handler.fn = fn;
      handler.sel = selector;

      if (handler.e in hover) fn = function fn(e) {
        var related = e.relatedTarget;
        if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
      };
      handler.del = delegator;
      var callback = delegator || fn;
      handler.proxy = function (e) {
        e = compatible(e);
        if (e.isImmediatePropagationStopped()) return;
        try {
          var dataPropDescriptor = Object.getOwnPropertyDescriptor(e, 'data');
          if (!dataPropDescriptor || dataPropDescriptor.writable) e.data = data;
        } catch (e) {}
        var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args));
        if (result === false) e.preventDefault(), e.stopPropagation();
        return result;
      };
      handler.i = set.length;
      set.push(handler);
      if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
    });
  }
  function remove(element, events, fn, selector, capture) {
    var id = zid(element);(events || '').split(/\s/).forEach(function (event) {
      findHandlers(element, event, fn, selector).forEach(function (handler) {
        delete handlers[id][handler.i];
        if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
      });
    });
  }

  $.event = { add: add, remove: remove };

  $.proxy = function (fn, context) {
    var args = 2 in arguments && slice.call(arguments, 2);
    if (isFunction(fn)) {
      var proxyFn = function proxyFn() {
        return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments);
      };
      proxyFn._zid = zid(fn);
      return proxyFn;
    } else if (isString(context)) {
      if (args) {
        args.unshift(fn[context], fn);
        return $.proxy.apply(null, args);
      } else {
        return $.proxy(fn[context], fn);
      }
    } else {
      throw new TypeError("expected function");
    }
  };

  $.fn.bind = function (event, data, callback) {
    return this.on(event, data, callback);
  };
  $.fn.unbind = function (event, callback) {
    return this.off(event, callback);
  };
  $.fn.one = function (event, selector, data, callback) {
    return this.on(event, selector, data, callback, 1);
  };

  var returnTrue = function returnTrue() {
    return true;
  },
      returnFalse = function returnFalse() {
    return false;
  },
      ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
      eventMethods = {
    preventDefault: 'isDefaultPrevented',
    stopImmediatePropagation: 'isImmediatePropagationStopped',
    stopPropagation: 'isPropagationStopped'
  };

  function compatible(event, source) {
    if (source || !event.isDefaultPrevented) {
      source || (source = event);

      $.each(eventMethods, function (name, predicate) {
        var sourceMethod = source[name];
        event[name] = function () {
          this[predicate] = returnTrue;
          return sourceMethod && sourceMethod.apply(source, arguments);
        };
        event[predicate] = returnFalse;
      });

      try {
        event.timeStamp || (event.timeStamp = Date.now());
      } catch (ignored) {}

      if (source.defaultPrevented !== undefined ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
    }
    return event;
  }

  function createProxy(event) {
    var key,
        proxy = { originalEvent: event };
    for (key in event) {
      if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key];
    }return compatible(proxy, event);
  }

  $.fn.delegate = function (selector, event, callback) {
    return this.on(event, selector, callback);
  };
  $.fn.undelegate = function (selector, event, callback) {
    return this.off(event, selector, callback);
  };

  $.fn.live = function (event, callback) {
    $(document.body).delegate(this.selector, event, callback);
    return this;
  };
  $.fn.die = function (event, callback) {
    $(document.body).undelegate(this.selector, event, callback);
    return this;
  };

  $.fn.on = function (event, selector, data, callback, one) {
    var autoRemove,
        delegator,
        $this = this;
    if (event && !isString(event)) {
      $.each(event, function (type, fn) {
        $this.on(type, selector, data, fn, one);
      });
      return $this;
    }

    if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined;
    if (callback === undefined || data === false) callback = data, data = undefined;

    if (callback === false) callback = returnFalse;

    return $this.each(function (_, element) {
      if (one) autoRemove = function autoRemove(e) {
        remove(element, e.type, callback);
        return callback.apply(this, arguments);
      };

      if (selector) delegator = function delegator(e) {
        var evt,
            match = $(e.target).closest(selector, element).get(0);
        if (match && match !== element) {
          evt = $.extend(createProxy(e), { currentTarget: match, liveFired: element });
          return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)));
        }
      };

      add(element, event, callback, data, selector, delegator || autoRemove);
    });
  };
  $.fn.off = function (event, selector, callback) {
    var $this = this;
    if (event && !isString(event)) {
      $.each(event, function (type, fn) {
        $this.off(type, selector, fn);
      });
      return $this;
    }

    if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined;

    if (callback === false) callback = returnFalse;

    return $this.each(function () {
      remove(this, event, callback, selector);
    });
  };

  $.fn.trigger = function (event, args) {
    event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
    event._args = args;
    return this.each(function () {
      if (event.type in focus && typeof this[event.type] == "function") this[event.type]();else if ('dispatchEvent' in this) this.dispatchEvent(event);else $(this).triggerHandler(event, args);
    });
  };

  $.fn.triggerHandler = function (event, args) {
    var e, result;
    this.each(function (i, element) {
      e = createProxy(isString(event) ? $.Event(event) : event);
      e._args = args;
      e.target = element;
      $.each(findHandlers(element, event.type || event), function (i, handler) {
        result = handler.proxy(e);
        if (e.isImmediatePropagationStopped()) return false;
      });
    });
    return result;
  };('focusin focusout focus blur load resize scroll unload click dblclick ' + 'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' + 'change select keydown keypress keyup error').split(' ').forEach(function (event) {
    $.fn[event] = function (callback) {
      return 0 in arguments ? this.bind(event, callback) : this.trigger(event);
    };
  });

  $.Event = function (type, props) {
    if (!isString(type)) props = type, type = props.type;
    var event = document.createEvent(specialEvents[type] || 'Events'),
        bubbles = true;
    if (props) for (var name in props) {
      name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
    }event.initEvent(type, bubbles, true);
    return compatible(event);
  };
})(Zepto);(function ($) {
  var jsonpID = +new Date(),
      document = window.document,
      key,
      name,
      rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
      scriptTypeRE = /^(?:text|application)\/javascript/i,
      xmlTypeRE = /^(?:text|application)\/xml/i,
      jsonType = 'application/json',
      htmlType = 'text/html',
      blankRE = /^\s*$/,
      originAnchor = document.createElement('a');

  originAnchor.href = window.location.href;

  function triggerAndReturn(context, eventName, data) {
    var event = $.Event(eventName);
    $(context).trigger(event, data);
    return !event.isDefaultPrevented();
  }

  function triggerGlobal(settings, context, eventName, data) {
    if (settings.global) return triggerAndReturn(context || document, eventName, data);
  }

  $.active = 0;

  function ajaxStart(settings) {
    if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
  }
  function ajaxStop(settings) {
    if (settings.global && ! --$.active) triggerGlobal(settings, null, 'ajaxStop');
  }

  function ajaxBeforeSend(xhr, settings) {
    var context = settings.context;
    if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false) return false;

    triggerGlobal(settings, context, 'ajaxSend', [xhr, settings]);
  }
  function ajaxSuccess(data, xhr, settings, deferred) {
    var context = settings.context,
        status = 'success';
    settings.success.call(context, data, status, xhr);
    if (deferred) deferred.resolveWith(context, [data, status, xhr]);
    triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data]);
    ajaxComplete(status, xhr, settings);
  }

  function ajaxError(error, type, xhr, settings, deferred) {
    var context = settings.context;
    settings.error.call(context, xhr, type, error);
    if (deferred) deferred.rejectWith(context, [xhr, type, error]);
    triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type]);
    ajaxComplete(type, xhr, settings);
  }

  function ajaxComplete(status, xhr, settings) {
    var context = settings.context;
    settings.complete.call(context, xhr, status);
    triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings]);
    ajaxStop(settings);
  }

  function ajaxDataFilter(data, type, settings) {
    if (settings.dataFilter == empty) return data;
    var context = settings.context;
    return settings.dataFilter.call(context, data, type);
  }

  function empty() {}

  $.ajaxJSONP = function (options, deferred) {
    if (!('type' in options)) return $.ajax(options);

    var _callbackName = options.jsonpCallback,
        callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'Zepto' + jsonpID++,
        script = document.createElement('script'),
        originalCallback = window[callbackName],
        responseData,
        abort = function abort(errorType) {
      $(script).triggerHandler('error', errorType || 'abort');
    },
        xhr = { abort: abort },
        abortTimeout;

    if (deferred) deferred.promise(xhr);

    $(script).on('load error', function (e, errorType) {
      clearTimeout(abortTimeout);
      $(script).off().remove();

      if (e.type == 'error' || !responseData) {
        ajaxError(null, errorType || 'error', xhr, options, deferred);
      } else {
        ajaxSuccess(responseData[0], xhr, options, deferred);
      }

      window[callbackName] = originalCallback;
      if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);

      originalCallback = responseData = undefined;
    });

    if (ajaxBeforeSend(xhr, options) === false) {
      abort('abort');
      return xhr;
    }

    window[callbackName] = function () {
      responseData = arguments;
    };

    script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
    document.head.appendChild(script);

    if (options.timeout > 0) abortTimeout = setTimeout(function () {
      abort('timeout');
    }, options.timeout);

    return xhr;
  };

  $.ajaxSettings = {
    type: 'GET',

    beforeSend: empty,

    success: empty,

    error: empty,

    complete: empty,

    context: null,

    global: true,

    xhr: function xhr() {
      return new window.XMLHttpRequest();
    },

    accepts: {
      script: 'text/javascript, application/javascript, application/x-javascript',
      json: jsonType,
      xml: 'application/xml, text/xml',
      html: htmlType,
      text: 'text/plain'
    },

    crossDomain: false,

    timeout: 0,

    processData: true,

    cache: true,

    dataFilter: empty
  };

  function mimeToDataType(mime) {
    if (mime) mime = mime.split(';', 2)[0];
    return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
  }

  function appendQuery(url, query) {
    if (query == '') return url;
    return (url + '&' + query).replace(/[&?]{1,2}/, '?');
  }

  function serializeData(options) {
    if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
    if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType)) options.url = appendQuery(options.url, options.data), options.data = undefined;
  }

  $.ajax = function (options) {
    var settings = $.extend({}, options || {}),
        deferred = $.Deferred && $.Deferred(),
        urlAnchor,
        hashIndex;
    for (key in $.ajaxSettings) {
      if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
    }ajaxStart(settings);

    if (!settings.crossDomain) {
      urlAnchor = document.createElement('a');
      urlAnchor.href = settings.url;

      urlAnchor.href = urlAnchor.href;
      settings.crossDomain = originAnchor.protocol + '//' + originAnchor.host !== urlAnchor.protocol + '//' + urlAnchor.host;
    }

    if (!settings.url) settings.url = window.location.toString();
    if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex);
    serializeData(settings);

    var dataType = settings.dataType,
        hasPlaceholder = /\?.+=\?/.test(settings.url);
    if (hasPlaceholder) dataType = 'jsonp';

    if (settings.cache === false || (!options || options.cache !== true) && ('script' == dataType || 'jsonp' == dataType)) settings.url = appendQuery(settings.url, '_=' + Date.now());

    if ('jsonp' == dataType) {
      if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
      return $.ajaxJSONP(settings, deferred);
    }

    var mime = settings.accepts[dataType],
        headers = {},
        setHeader = function setHeader(name, value) {
      headers[name.toLowerCase()] = [name, value];
    },
        protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
        xhr = settings.xhr(),
        nativeSetHeader = xhr.setRequestHeader,
        abortTimeout;

    if (deferred) deferred.promise(xhr);

    if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
    setHeader('Accept', mime || '*/*');
    if (mime = settings.mimeType || mime) {
      if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
      xhr.overrideMimeType && xhr.overrideMimeType(mime);
    }
    if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');

    if (settings.headers) for (name in settings.headers) {
      setHeader(name, settings.headers[name]);
    }xhr.setRequestHeader = setHeader;

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        xhr.onreadystatechange = empty;
        clearTimeout(abortTimeout);
        var result,
            error = false;
        if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
          dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));

          if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob') result = xhr.response;else {
            result = xhr.responseText;

            try {
              result = ajaxDataFilter(result, dataType, settings);
              if (dataType == 'script') (1, eval)(result);else if (dataType == 'xml') result = xhr.responseXML;else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
            } catch (e) {
              error = e;
            }

            if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred);
          }

          ajaxSuccess(result, xhr, settings, deferred);
        } else {
          ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
        }
      }
    };

    if (ajaxBeforeSend(xhr, settings) === false) {
      xhr.abort();
      ajaxError(null, 'abort', xhr, settings, deferred);
      return xhr;
    }

    var async = 'async' in settings ? settings.async : true;
    xhr.open(settings.type, settings.url, async, settings.username, settings.password);

    if (settings.xhrFields) for (name in settings.xhrFields) {
      xhr[name] = settings.xhrFields[name];
    }for (name in headers) {
      nativeSetHeader.apply(xhr, headers[name]);
    }if (settings.timeout > 0) abortTimeout = setTimeout(function () {
      xhr.onreadystatechange = empty;
      xhr.abort();
      ajaxError(null, 'timeout', xhr, settings, deferred);
    }, settings.timeout);

    xhr.send(settings.data ? settings.data : null);
    return xhr;
  };

  function parseArguments(url, data, success, dataType) {
    if ($.isFunction(data)) dataType = success, success = data, data = undefined;
    if (!$.isFunction(success)) dataType = success, success = undefined;
    return {
      url: url,
      data: data,
      success: success,
      dataType: dataType
    };
  }

  $.get = function () {
    return $.ajax(parseArguments.apply(null, arguments));
  };

  $.post = function () {
    var options = parseArguments.apply(null, arguments);
    options.type = 'POST';
    return $.ajax(options);
  };

  $.getJSON = function () {
    var options = parseArguments.apply(null, arguments);
    options.dataType = 'json';
    return $.ajax(options);
  };

  $.fn.load = function (url, data, success) {
    if (!this.length) return this;
    var self = this,
        parts = url.split(/\s/),
        selector,
        options = parseArguments(url, data, success),
        callback = options.success;
    if (parts.length > 1) options.url = parts[0], selector = parts[1];
    options.success = function (response) {
      self.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
      callback && callback.apply(self, arguments);
    };
    $.ajax(options);
    return this;
  };

  var escape = encodeURIComponent;

  function serialize(params, obj, traditional, scope) {
    var type,
        array = $.isArray(obj),
        hash = $.isPlainObject(obj);
    $.each(obj, function (key, value) {
      type = $.type(value);
      if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';

      if (!scope && array) params.add(value.name, value.value);else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);else params.add(key, value);
    });
  }

  $.param = function (obj, traditional) {
    var params = [];
    params.add = function (key, value) {
      if ($.isFunction(value)) value = value();
      if (value == null) value = "";
      this.push(escape(key) + '=' + escape(value));
    };
    serialize(params, obj, traditional);
    return params.join('&').replace(/%20/g, '+');
  };
})(Zepto);(function ($, undefined) {
  var prefix = '',
      eventPrefix,
      vendors = { Webkit: 'webkit', Moz: '', O: 'o' },
      testEl = document.createElement('div'),
      supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i,
      transform,
      transitionProperty,
      transitionDuration,
      transitionTiming,
      transitionDelay,
      animationName,
      animationDuration,
      animationTiming,
      animationDelay,
      cssReset = {};

  function dasherize(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
  }
  function normalizeEvent(name) {
    return eventPrefix ? eventPrefix + name : name.toLowerCase();
  }

  if (testEl.style.transform === undefined) $.each(vendors, function (vendor, event) {
    if (testEl.style[vendor + 'TransitionProperty'] !== undefined) {
      prefix = '-' + vendor.toLowerCase() + '-';
      eventPrefix = event;
      return false;
    }
  });

  transform = prefix + 'transform';
  cssReset[transitionProperty = prefix + 'transition-property'] = cssReset[transitionDuration = prefix + 'transition-duration'] = cssReset[transitionDelay = prefix + 'transition-delay'] = cssReset[transitionTiming = prefix + 'transition-timing-function'] = cssReset[animationName = prefix + 'animation-name'] = cssReset[animationDuration = prefix + 'animation-duration'] = cssReset[animationDelay = prefix + 'animation-delay'] = cssReset[animationTiming = prefix + 'animation-timing-function'] = '';

  $.fx = {
    off: eventPrefix === undefined && testEl.style.transitionProperty === undefined,
    speeds: { _default: 400, fast: 200, slow: 600 },
    cssPrefix: prefix,
    transitionEnd: normalizeEvent('TransitionEnd'),
    animationEnd: normalizeEvent('AnimationEnd')
  };

  $.fn.animate = function (properties, duration, ease, callback, delay) {
    if ($.isFunction(duration)) callback = duration, ease = undefined, duration = undefined;
    if ($.isFunction(ease)) callback = ease, ease = undefined;
    if ($.isPlainObject(duration)) ease = duration.easing, callback = duration.complete, delay = duration.delay, duration = duration.duration;
    if (duration) duration = (typeof duration == 'number' ? duration : $.fx.speeds[duration] || $.fx.speeds._default) / 1000;
    if (delay) delay = parseFloat(delay) / 1000;
    return this.anim(properties, duration, ease, callback, delay);
  };

  $.fn.anim = function (properties, duration, ease, callback, delay) {
    var key,
        cssValues = {},
        cssProperties,
        transforms = '',
        that = this,
        _wrappedCallback,
        endEvent = $.fx.transitionEnd,
        fired = false;

    if (duration === undefined) duration = $.fx.speeds._default / 1000;
    if (delay === undefined) delay = 0;
    if ($.fx.off) duration = 0;

    if (typeof properties == 'string') {
      cssValues[animationName] = properties;
      cssValues[animationDuration] = duration + 's';
      cssValues[animationDelay] = delay + 's';
      cssValues[animationTiming] = ease || 'linear';
      endEvent = $.fx.animationEnd;
    } else {
      cssProperties = [];

      for (key in properties) {
        if (supportedTransforms.test(key)) transforms += key + '(' + properties[key] + ') ';else cssValues[key] = properties[key], cssProperties.push(dasherize(key));
      }if (transforms) cssValues[transform] = transforms, cssProperties.push(transform);
      if (duration > 0 && (typeof properties === 'undefined' ? 'undefined' : _typeof(properties)) === 'object') {
        cssValues[transitionProperty] = cssProperties.join(', ');
        cssValues[transitionDuration] = duration + 's';
        cssValues[transitionDelay] = delay + 's';
        cssValues[transitionTiming] = ease || 'linear';
      }
    }

    _wrappedCallback = function wrappedCallback(event) {
      if (typeof event !== 'undefined') {
        if (event.target !== event.currentTarget) return;
        $(event.target).unbind(endEvent, _wrappedCallback);
      } else $(this).unbind(endEvent, _wrappedCallback);

      fired = true;
      $(this).css(cssReset);
      callback && callback.call(this);
    };
    if (duration > 0) {
      this.bind(endEvent, _wrappedCallback);

      setTimeout(function () {
        if (fired) return;
        _wrappedCallback.call(that);
      }, (duration + delay) * 1000 + 25);
    }

    this.size() && this.get(0).clientLeft;

    this.css(cssValues);

    if (duration <= 0) setTimeout(function () {
      that.each(function () {
        _wrappedCallback.call(this);
      });
    }, 0);

    return this;
  };

  testEl = null;
})(Zepto);(function ($, undefined) {
  var document = window.document,
      docElem = document.documentElement,
      origShow = $.fn.show,
      origHide = $.fn.hide,
      origToggle = $.fn.toggle;

  function anim(el, speed, opacity, scale, callback) {
    if (typeof speed == 'function' && !callback) callback = speed, speed = undefined;
    var props = { opacity: opacity };
    if (scale) {
      props.scale = scale;
      el.css($.fx.cssPrefix + 'transform-origin', '0 0');
    }
    return el.animate(props, speed, null, callback);
  }

  function hide(el, speed, scale, callback) {
    return anim(el, speed, 0, scale, function () {
      origHide.call($(this));
      callback && callback.call(this);
    });
  }

  $.fn.show = function (speed, callback) {
    origShow.call(this);
    if (speed === undefined) speed = 0;else this.css('opacity', 0);
    return anim(this, speed, 1, '1,1', callback);
  };

  $.fn.hide = function (speed, callback) {
    if (speed === undefined) return origHide.call(this);else return hide(this, speed, '0,0', callback);
  };

  $.fn.toggle = function (speed, callback) {
    if (speed === undefined || typeof speed == 'boolean') return origToggle.call(this, speed);else return this.each(function () {
      var el = $(this);
      el[el.css('display') == 'none' ? 'show' : 'hide'](speed, callback);
    });
  };

  $.fn.fadeTo = function (speed, opacity, callback) {
    return anim(this, speed, opacity, null, callback);
  };

  $.fn.fadeIn = function (speed, callback) {
    var target = this.css('opacity');
    if (target > 0) this.css('opacity', 0);else target = 1;
    return origShow.call(this).fadeTo(speed, target, callback);
  };

  $.fn.fadeOut = function (speed, callback) {
    return hide(this, speed, null, callback);
  };

  $.fn.fadeToggle = function (speed, callback) {
    return this.each(function () {
      var el = $(this);
      el[el.css('opacity') == 0 || el.css('display') == 'none' ? 'fadeIn' : 'fadeOut'](speed, callback);
    });
  };
})(Zepto);(function ($) {
  function detect(ua, platform) {
    var os = this.os = {},
        browser = this.browser = {},
        webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
        android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
        osx = !!ua.match(/\(Macintosh\; Intel /),
        ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
        iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
        win = /Win\d{2}|Windows/.test(platform),
        wp = ua.match(/Windows Phone ([\d.]+)/),
        touchpad = webos && ua.match(/TouchPad/),
        kindle = ua.match(/Kindle\/([\d.]+)/),
        silk = ua.match(/Silk\/([\d._]+)/),
        blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
        bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
        rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
        playbook = ua.match(/PlayBook/),
        chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
        firefox = ua.match(/Firefox\/([\d.]+)/),
        firefoxos = ua.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
        ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
        webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
        safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);

    if (browser.webkit = !!webkit) browser.version = webkit[1];

    if (android) os.android = true, os.version = android[2];
    if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
    if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
    if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    if (wp) os.wp = true, os.version = wp[1];
    if (webos) os.webos = true, os.version = webos[2];
    if (touchpad) os.touchpad = true;
    if (blackberry) os.blackberry = true, os.version = blackberry[2];
    if (bb10) os.bb10 = true, os.version = bb10[2];
    if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
    if (playbook) browser.playbook = true;
    if (kindle) os.kindle = true, os.version = kindle[1];
    if (silk) browser.silk = true, browser.version = silk[1];
    if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
    if (chrome) browser.chrome = true, browser.version = chrome[1];
    if (firefox) browser.firefox = true, browser.version = firefox[1];
    if (firefoxos) os.firefoxos = true, os.version = firefoxos[1];
    if (ie) browser.ie = true, browser.version = ie[1];
    if (safari && (osx || os.ios || win)) {
      browser.safari = true;
      if (!os.ios) browser.version = safari[1];
    }
    if (webview) browser.webview = true;

    os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/) || ie && !ua.match(/Phone/) && ua.match(/Touch/));
    os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/) || ie && ua.match(/Touch/)));
  }

  detect.call($, navigator.userAgent, navigator.platform);

  $.__detect = detect;
})(Zepto);(function ($) {
  var touch = {},
      touchTimeout,
      tapTimeout,
      swipeTimeout,
      longTapTimeout,
      longTapDelay = 750,
      gesture;

  function swipeDirection(x1, x2, y1, y2) {
    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? 'Left' : 'Right' : y1 - y2 > 0 ? 'Up' : 'Down';
  }

  function longTap() {
    longTapTimeout = null;
    if (touch.last) {
      touch.el.trigger('longTap');
      touch = {};
    }
  }

  function cancelLongTap() {
    if (longTapTimeout) clearTimeout(longTapTimeout);
    longTapTimeout = null;
  }

  function cancelAll() {
    if (touchTimeout) clearTimeout(touchTimeout);
    if (tapTimeout) clearTimeout(tapTimeout);
    if (swipeTimeout) clearTimeout(swipeTimeout);
    if (longTapTimeout) clearTimeout(longTapTimeout);
    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null;
    touch = {};
  }

  function isPrimaryTouch(event) {
    return (event.pointerType == 'touch' || event.pointerType == event.MSPOINTER_TYPE_TOUCH) && event.isPrimary;
  }

  function isPointerEventType(e, type) {
    return e.type == 'pointer' + type || e.type.toLowerCase() == 'mspointer' + type;
  }

  $(document).ready(function () {
    var now,
        delta,
        deltaX = 0,
        deltaY = 0,
        firstTouch,
        _isPointerType;

    if ('MSGesture' in window) {
      gesture = new MSGesture();
      gesture.target = document.body;
    }

    $(document).bind('MSGestureEnd', function (e) {
      var swipeDirectionFromVelocity = e.velocityX > 1 ? 'Right' : e.velocityX < -1 ? 'Left' : e.velocityY > 1 ? 'Down' : e.velocityY < -1 ? 'Up' : null;
      if (swipeDirectionFromVelocity) {
        touch.el.trigger('swipe');
        touch.el.trigger('swipe' + swipeDirectionFromVelocity);
      }
    }).on('touchstart', function (e) {
      if ((_isPointerType = isPointerEventType(e, 'down')) && !isPrimaryTouch(e)) return;
      firstTouch = _isPointerType ? e : e.touches[0];
      if (e.touches && e.touches.length === 1 && touch.x2) {
        touch.x2 = undefined;
        touch.y2 = undefined;
      }
      now = Date.now();
      delta = now - (touch.last || now);
      touch.el = $('tagName' in firstTouch.target ? firstTouch.target : firstTouch.target.parentNode);
      touchTimeout && clearTimeout(touchTimeout);
      touch.x1 = firstTouch.pageX;
      touch.y1 = firstTouch.pageY;
      if (delta > 0 && delta <= 250) touch.isDoubleTap = true;
      touch.last = now;
      longTapTimeout = setTimeout(longTap, longTapDelay);

      if (gesture && _isPointerType) gesture.addPointer(e.pointerId);
    }).on('touchmove', function (e) {
      if ((_isPointerType = isPointerEventType(e, 'move')) && !isPrimaryTouch(e)) return;
      firstTouch = _isPointerType ? e : e.touches[0];
      cancelLongTap();
      touch.x2 = firstTouch.pageX;
      touch.y2 = firstTouch.pageY;

      deltaX += Math.abs(touch.x1 - touch.x2);
      deltaY += Math.abs(touch.y1 - touch.y2);
    }).on('touchend', function (e) {
      if ((_isPointerType = isPointerEventType(e, 'up')) && !isPrimaryTouch(e)) return;
      cancelLongTap();

      if (touch.x2 && Math.abs(touch.x1 - touch.x2) > 30 || touch.y2 && Math.abs(touch.y1 - touch.y2) > 30) swipeTimeout = setTimeout(function () {
        if (touch.el) {
          touch.el.trigger('swipe');
          touch.el.trigger('swipe' + swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2));
        }
        touch = {};
      }, 0);else if ('last' in touch) if (deltaX < 30 && deltaY < 30) {
            tapTimeout = setTimeout(function () {
              var event = $.Event('tap');
              event.cancelTouch = cancelAll;

              if (touch.el) touch.el.trigger(event);

              if (touch.isDoubleTap) {
                if (touch.el) touch.el.trigger('doubleTap');
                touch = {};
              } else {
                  touchTimeout = setTimeout(function () {
                    touchTimeout = null;
                    if (touch.el) touch.el.trigger('singleTap');
                    touch = {};
                  }, 250);
                }
            }, 0);
          } else {
            touch = {};
          }
      deltaX = deltaY = 0;
    }).on('touchcancel MSPointerCancel pointercancel', cancelAll);

    $(window).on('scroll', cancelAll);
  });['swipe', 'swipeLeft', 'swipeRight', 'swipeUp', 'swipeDown', 'doubleTap', 'tap', 'singleTap', 'longTap'].forEach(function (eventName) {
    $.fn[eventName] = function (callback) {
      return this.on(eventName, callback);
    };
  });
})(Zepto);(function ($) {
  if ($.os.ios) {
    var parentIfText = function parentIfText(node) {
      return 'tagName' in node ? node : node.parentNode;
    };

    var gesture = {},
        gestureTimeout;

    $(document).bind('gesturestart', function (e) {
      var now = Date.now(),
          delta = now - (gesture.last || now);
      gesture.target = parentIfText(e.target);
      gestureTimeout && clearTimeout(gestureTimeout);
      gesture.e1 = e.scale;
      gesture.last = now;
    }).bind('gesturechange', function (e) {
      gesture.e2 = e.scale;
    }).bind('gestureend', function (e) {
      if (gesture.e2 > 0) {
        Math.abs(gesture.e1 - gesture.e2) != 0 && $(gesture.target).trigger('pinch') && $(gesture.target).trigger('pinch' + (gesture.e1 - gesture.e2 > 0 ? 'In' : 'Out'));
        gesture.e1 = gesture.e2 = gesture.last = 0;
      } else if ('last' in gesture) {
        gesture = {};
      }
    });['pinch', 'pinchIn', 'pinchOut'].forEach(function (m) {
      $.fn[m] = function (callback) {
        return this.bind(m, callback);
      };
    });
  }
})(Zepto);
module.exports = Zepto;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var list = [];

	list.toString = function toString() {
		var result = [];
		for (var i = 0; i < this.length; i++) {
			var item = this[i];
			if (item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];

			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(139);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _co = __webpack_require__(142);

var _co2 = _interopRequireDefault(_co);

var _querystring = __webpack_require__(15);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var util = {};

function isType(type) {
  return function (obj) {
    return {}.toString.call(obj) === '[object ' + type + ']';
  };
}

function waterfall() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var steps = args.shift();
  var tasks = [];

  steps.forEach(function (item) {
    tasks.push(new Promise(function (resolve) {
      item.apply(undefined, _toConsumableArray(args.concat(function () {
        resolve();
      })));
    }));
  });

  return (0, _co2.default)(_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return tasks;

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}

function makeArray(o) {
  if (o == null) {
    return [];
  }
  if (Object.prototype.toString.call(o) === '[object Array]') {
    return o;
  }
  var lengthType = _typeof(o.length);
  var oType = typeof o === 'undefined' ? 'undefined' : _typeof(o);

  if (lengthType !== 'number' || typeof o.nodeName === 'string' || o != null && o === o.window || oType === 'string' || oType === 'function' && !('item' in o && lengthType === 'number')) {
    return [o];
  }
  var ret = [];
  for (var i = 0, l = o.length; i < l; i++) {
    ret[i] = o[i];
  }
  return ret;
}

function later(fn) {
  var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var periodic = arguments[2];
  var context = arguments[3];
  var data = arguments[4];

  var m = fn;
  var d = makeArray(data);
  if (typeof fn === 'string') {
    m = context[fn];
  }
  var f = function f() {
    m.apply(context, d);
  };
  var r = periodic ? setInterval(f, when) : setTimeout(f, when);
  return {
    id: r,
    interval: periodic,
    cancel: function cancel() {
      if (this.interval) {
        clearInterval(r);
      } else {
        clearTimeout(r);
      }
    }
  };
}

function buffer(fn) {
  var _this = this;

  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  var context = arguments[2];

  var args = [fn, ms, context];
  if (ms === -1) {
    return function () {
      fn.apply(context || _this, args);
    };
  }
  var bufferTimer = null;

  function f() {
    f.stop();
    bufferTimer = later(fn, ms, 0, context || this, args);
  }
  f.stop = function () {
    if (bufferTimer) {
      bufferTimer.cancel();
      bufferTimer = 0;
    }
  };
  return f;
}

function UA() {
  var userAgent = navigator.userAgent;
  var isIOS = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
  var isAndroid = /(Android)/i.test(userAgent);
  return {
    ios: isIOS,
    android: isAndroid
  };
}

function detectWebp() {
  var cvx = document.createElement('canvas');
  return cvx.toDataURL('image/webp').indexOf('image/webp') > -1;
}

util.isPC = function () {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

util.click = function () {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag ? 'click' : 'tap';
};

util.dateFormat = function (ts, fmt) {
  var res = fmt;
  var date = new Date(ts);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds() };
  if (/(y+)/.test(res)) {
    res = res.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      res = res.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
    }
  }
  return res;
};

util.getEnvironment = function () {
  var qs = _querystring2.default.parse(location.search.substring(1));

  return qs.env || 'prod';
};

util.htmlEncodeAll = function (e) {
  if (e) {
    return e.replace(/\</g, '&lt;').replace(/\>/g, '&gt;').replace(/\&/g, '&amp;').replace(/'/g, '&quot;').replace(/'/g, '&#39;');
  }
  return '';
};

util.parseTime = function (ts) {
  var res = '';
  var now = new Date();
  var day = new Date(ts);
  var yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  if (now.toDateString() === day.toDateString()) {
    res = '\u4ECA\u5929 ' + util.dateFormat(new Date(ts), 'hh:mm');
  } else if (yesterday.toDateString() === day.toDateString()) {
    res = '\u6628\u5929 ' + util.dateFormat(new Date(ts), 'hh:mm');
  } else if (new Date(ts).getFullYear() === now.getFullYear()) {
    res = util.dateFormat(new Date(ts), 'M月dd日 hh:mm');
  } else {
    res = util.dateFormat(new Date(ts), 'yyyy年M月dd日 hh:mm');
  }
  return res;
};

util.lang = Object.create({
  __lang: {},
  resetLang: function resetLang(lang) {
    this.__lang = Object.assign(this.__lang, lang);
  },
  get: function get(key) {
    var str = this.__lang[key] || '??';

    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return args.length > 0 ? util.format(str, args) : str;
  }
});

util.storage = function () {
  var localStorage = window.localStorage;
  var prefix = 'alicare:';

  return {
    setItem: function setItem(key, val) {
      try {
        localStorage.setItem(prefix + key, val);
      } catch (e) {
        console.log(e);
      }
    },
    getItem: function getItem(key) {
      try {
        return localStorage.getItem(prefix + key);
      } catch (e) {
        return {};
      }
    }
  };
}();

var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
  window.setTimeout(callback, 1000 / 60);
};

util.requestAnimationFrame = function (fn) {
  return raf.call(window, fn);
};

util.setIconfont = function (url) {
  $('svg').eq(0).remove();
  var script = document.createElement('script');
  var position = document.getElementsByTagName('script')[0];
  script.src = url;
  position.parentNode.insertBefore(script, position);
};

util.setCss = function (name, url) {
  $('body').attr('class', 'skin-' + name);
  if (!url) {
    return;
  }
  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.id = 'alicarecss';
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  link.media = 'all';
  head.appendChild(link);
};

util.htmlEncodeAll = function (e) {
  return null == e ? "" : e.replace(/\</g, "&lt;").replace(/\>/g, "&gt;").replace(/\&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
};

Object.assign(util, {
  waterfall: waterfall,
  queryString: _querystring2.default,
  buffer: buffer,
  makeArray: makeArray,
  later: later,
  UA: UA,
  detectWebp: detectWebp,
  isObject: isType('Object'),
  isString: isType('String'),
  isNumber: isType('Number'),
  isArray: Array.isArray || isType('Array'),
  isFunction: isType('Function'),
  isUndefined: isType('Undefined')
});

exports.default = util;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["nunjucks"] = factory();else root["nunjucks"] = factory();
})(undefined, function () {
	return function (modules) {
		var installedModules = {};

		function __webpack_require__(moduleId) {
			if (installedModules[moduleId]) return installedModules[moduleId].exports;

			var module = installedModules[moduleId] = { exports: {},
				id: moduleId,
				loaded: false
			};

			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

			module.loaded = true;

			return module.exports;
		}

		__webpack_require__.m = modules;

		__webpack_require__.c = installedModules;

		__webpack_require__.p = "";

		return __webpack_require__(0);
	}([function (module, exports, __webpack_require__) {

		'use strict';

		var lib = __webpack_require__(1);
		var env = __webpack_require__(2);
		var Loader = __webpack_require__(15);
		var loaders = __webpack_require__(3);
		var precompile = __webpack_require__(3);

		module.exports = {};
		module.exports.Environment = env.Environment;
		module.exports.Template = env.Template;

		module.exports.Loader = Loader;
		module.exports.FileSystemLoader = loaders.FileSystemLoader;
		module.exports.PrecompiledLoader = loaders.PrecompiledLoader;
		module.exports.WebLoader = loaders.WebLoader;

		module.exports.compiler = __webpack_require__(3);
		module.exports.parser = __webpack_require__(3);
		module.exports.lexer = __webpack_require__(3);
		module.exports.runtime = __webpack_require__(8);
		module.exports.lib = lib;
		module.exports.nodes = __webpack_require__(3);

		module.exports.installJinjaCompat = __webpack_require__(16);

		var e;
		module.exports.configure = function (templatesPath, opts) {
			opts = opts || {};
			if (lib.isObject(templatesPath)) {
				opts = templatesPath;
				templatesPath = null;
			}

			var TemplateLoader;
			if (loaders.FileSystemLoader) {
				TemplateLoader = new loaders.FileSystemLoader(templatesPath, {
					watch: opts.watch,
					noCache: opts.noCache
				});
			} else if (loaders.WebLoader) {
				TemplateLoader = new loaders.WebLoader(templatesPath, {
					useCache: opts.web && opts.web.useCache,
					async: opts.web && opts.web.async
				});
			}

			e = new env.Environment(TemplateLoader, opts);

			if (opts && opts.express) {
				e.express(opts.express);
			}

			return e;
		};

		module.exports.compile = function (src, env, path, eagerCompile) {
			if (!e) {
				module.exports.configure();
			}
			return new module.exports.Template(src, env, path, eagerCompile);
		};

		module.exports.render = function (name, ctx, cb) {
			if (!e) {
				module.exports.configure();
			}

			return e.render(name, ctx, cb);
		};

		module.exports.renderString = function (src, ctx, cb) {
			if (!e) {
				module.exports.configure();
			}

			return e.renderString(src, ctx, cb);
		};

		if (precompile) {
			module.exports.precompile = precompile.precompile;
			module.exports.precompileString = precompile.precompileString;
		}
	}, function (module, exports) {

		'use strict';

		var ArrayProto = Array.prototype;
		var ObjProto = Object.prototype;

		var escapeMap = {
			'&': '&amp;',
			'"': '&quot;',
			'\'': '&#39;',
			'<': '&lt;',
			'>': '&gt;'
		};

		var escapeRegex = /[&"'<>]/g;

		var lookupEscape = function lookupEscape(ch) {
			return escapeMap[ch];
		};

		var exports = module.exports = {};

		exports.prettifyError = function (path, withInternals, err) {
			if (!err.Update) {
				err = new exports.TemplateError(err);
			}
			err.Update(path);

			if (!withInternals) {
				var old = err;
				err = new Error(old.message);
				err.name = old.name;
			}

			return err;
		};

		exports.TemplateError = function (message, lineno, colno) {
			var err = this;

			if (message instanceof Error) {
				err = message;
				message = message.name + ': ' + message.message;

				try {
					if (err.name = '') {}
				} catch (e) {
					err = this;
				}
			} else {
				if (Error.captureStackTrace) {
					Error.captureStackTrace(err);
				}
			}

			err.name = 'Template render error';
			err.message = message;
			err.lineno = lineno;
			err.colno = colno;
			err.firstUpdate = true;

			err.Update = function (path) {
				var message = '(' + (path || 'unknown path') + ')';

				if (this.firstUpdate) {
					if (this.lineno && this.colno) {
						message += ' [Line ' + this.lineno + ', Column ' + this.colno + ']';
					} else if (this.lineno) {
						message += ' [Line ' + this.lineno + ']';
					}
				}

				message += '\n ';
				if (this.firstUpdate) {
					message += ' ';
				}

				this.message = message + (this.message || '');
				this.firstUpdate = false;
				return this;
			};

			return err;
		};

		exports.TemplateError.prototype = Error.prototype;

		exports.escape = function (val) {
			return val.replace(escapeRegex, lookupEscape);
		};

		exports.isFunction = function (obj) {
			return ObjProto.toString.call(obj) === '[object Function]';
		};

		exports.isArray = Array.isArray || function (obj) {
			return ObjProto.toString.call(obj) === '[object Array]';
		};

		exports.isString = function (obj) {
			return ObjProto.toString.call(obj) === '[object String]';
		};

		exports.isObject = function (obj) {
			return ObjProto.toString.call(obj) === '[object Object]';
		};

		exports.groupBy = function (obj, val) {
			var result = {};
			var iterator = exports.isFunction(val) ? val : function (obj) {
				return obj[val];
			};
			for (var i = 0; i < obj.length; i++) {
				var value = obj[i];
				var key = iterator(value, i);
				(result[key] || (result[key] = [])).push(value);
			}
			return result;
		};

		exports.toArray = function (obj) {
			return Array.prototype.slice.call(obj);
		};

		exports.without = function (array) {
			var result = [];
			if (!array) {
				return result;
			}
			var index = -1,
			    length = array.length,
			    contains = exports.toArray(arguments).slice(1);

			while (++index < length) {
				if (exports.indexOf(contains, array[index]) === -1) {
					result.push(array[index]);
				}
			}
			return result;
		};

		exports.extend = function (obj, obj2) {
			for (var k in obj2) {
				obj[k] = obj2[k];
			}
			return obj;
		};

		exports.repeat = function (char_, n) {
			var str = '';
			for (var i = 0; i < n; i++) {
				str += char_;
			}
			return str;
		};

		exports.each = function (obj, func, context) {
			if (obj == null) {
				return;
			}

			if (ArrayProto.each && obj.each === ArrayProto.each) {
				obj.forEach(func, context);
			} else if (obj.length === +obj.length) {
				for (var i = 0, l = obj.length; i < l; i++) {
					func.call(context, obj[i], i, obj);
				}
			}
		};

		exports.map = function (obj, func) {
			var results = [];
			if (obj == null) {
				return results;
			}

			if (ArrayProto.map && obj.map === ArrayProto.map) {
				return obj.map(func);
			}

			for (var i = 0; i < obj.length; i++) {
				results[results.length] = func(obj[i], i);
			}

			if (obj.length === +obj.length) {
				results.length = obj.length;
			}

			return results;
		};

		exports.asyncIter = function (arr, iter, cb) {
			var i = -1;

			function next() {
				i++;

				if (i < arr.length) {
					iter(arr[i], i, next, cb);
				} else {
					cb();
				}
			}

			next();
		};

		exports.asyncFor = function (obj, iter, cb) {
			var keys = exports.keys(obj);
			var len = keys.length;
			var i = -1;

			function next() {
				i++;
				var k = keys[i];

				if (i < len) {
					iter(k, obj[k], i, len, next);
				} else {
					cb();
				}
			}

			next();
		};

		exports.indexOf = Array.prototype.indexOf ? function (arr, searchElement, fromIndex) {
			return Array.prototype.indexOf.call(arr, searchElement, fromIndex);
		} : function (arr, searchElement, fromIndex) {
			var length = this.length >>> 0;

			fromIndex = +fromIndex || 0;

			if (Math.abs(fromIndex) === Infinity) {
				fromIndex = 0;
			}

			if (fromIndex < 0) {
				fromIndex += length;
				if (fromIndex < 0) {
					fromIndex = 0;
				}
			}

			for (; fromIndex < length; fromIndex++) {
				if (arr[fromIndex] === searchElement) {
					return fromIndex;
				}
			}

			return -1;
		};

		if (!Array.prototype.map) {
			Array.prototype.map = function () {
				throw new Error('map is unimplemented for this js engine');
			};
		}

		exports.keys = function (obj) {
			if (Object.prototype.keys) {
				return obj.keys();
			} else {
				var keys = [];
				for (var k in obj) {
					if (obj.hasOwnProperty(k)) {
						keys.push(k);
					}
				}
				return keys;
			}
		};

		exports.inOperator = function (key, val) {
			if (exports.isArray(val)) {
				return exports.indexOf(val, key) !== -1;
			} else if (exports.isObject(val)) {
				return key in val;
			} else if (exports.isString(val)) {
				return val.indexOf(key) !== -1;
			} else {
				throw new Error('Cannot use "in" operator to search for "' + key + '" in unexpected types.');
			}
		};
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var path = __webpack_require__(3);
		var asap = __webpack_require__(4);
		var lib = __webpack_require__(1);
		var Obj = __webpack_require__(6);
		var compiler = __webpack_require__(3);
		var builtin_filters = __webpack_require__(7);
		var builtin_loaders = __webpack_require__(3);
		var runtime = __webpack_require__(8);
		var globals = __webpack_require__(9);
		var waterfall = __webpack_require__(10);
		var Frame = runtime.Frame;
		var Template;

		builtin_loaders.PrecompiledLoader = __webpack_require__(14);

		function callbackAsap(cb, err, res) {
			asap(function () {
				cb(err, res);
			});
		}

		var Environment = Obj.extend({
			init: function init(loaders, opts) {
				opts = this.opts = opts || {};
				this.opts.dev = !!opts.dev;

				this.opts.autoescape = opts.autoescape != null ? opts.autoescape : true;

				this.opts.throwOnUndefined = !!opts.throwOnUndefined;
				this.opts.trimBlocks = !!opts.trimBlocks;
				this.opts.lstripBlocks = !!opts.lstripBlocks;

				this.loaders = [];

				if (!loaders) {
					if (builtin_loaders.FileSystemLoader) {
						this.loaders = [new builtin_loaders.FileSystemLoader('views')];
					} else if (builtin_loaders.WebLoader) {
						this.loaders = [new builtin_loaders.WebLoader('/views')];
					}
				} else {
					this.loaders = lib.isArray(loaders) ? loaders : [loaders];
				}

				if (true && window.nunjucksPrecompiled) {
					this.loaders.unshift(new builtin_loaders.PrecompiledLoader(window.nunjucksPrecompiled));
				}

				this.initCache();

				this.globals = globals();
				this.filters = {};
				this.asyncFilters = [];
				this.extensions = {};
				this.extensionsList = [];

				for (var name in builtin_filters) {
					this.addFilter(name, builtin_filters[name]);
				}
			},

			initCache: function initCache() {
				lib.each(this.loaders, function (loader) {
					loader.cache = {};

					if (typeof loader.on === 'function') {
						loader.on('update', function (template) {
							loader.cache[template] = null;
						});
					}
				});
			},

			addExtension: function addExtension(name, extension) {
				extension._name = name;
				this.extensions[name] = extension;
				this.extensionsList.push(extension);
				return this;
			},

			removeExtension: function removeExtension(name) {
				var extension = this.getExtension(name);
				if (!extension) return;

				this.extensionsList = lib.without(this.extensionsList, extension);
				delete this.extensions[name];
			},

			getExtension: function getExtension(name) {
				return this.extensions[name];
			},

			hasExtension: function hasExtension(name) {
				return !!this.extensions[name];
			},

			addGlobal: function addGlobal(name, value) {
				this.globals[name] = value;
				return this;
			},

			getGlobal: function getGlobal(name) {
				if (typeof this.globals[name] === 'undefined') {
					throw new Error('global not found: ' + name);
				}
				return this.globals[name];
			},

			addFilter: function addFilter(name, func, async) {
				var wrapped = func;

				if (async) {
					this.asyncFilters.push(name);
				}
				this.filters[name] = wrapped;
				return this;
			},

			getFilter: function getFilter(name) {
				if (!this.filters[name]) {
					throw new Error('filter not found: ' + name);
				}
				return this.filters[name];
			},

			resolveTemplate: function resolveTemplate(loader, parentName, filename) {
				var isRelative = loader.isRelative && parentName ? loader.isRelative(filename) : false;
				return isRelative && loader.resolve ? loader.resolve(parentName, filename) : filename;
			},

			getTemplate: function getTemplate(name, eagerCompile, parentName, ignoreMissing, cb) {
				var that = this;
				var tmpl = null;
				if (name && name.raw) {
					name = name.raw;
				}

				if (lib.isFunction(parentName)) {
					cb = parentName;
					parentName = null;
					eagerCompile = eagerCompile || false;
				}

				if (lib.isFunction(eagerCompile)) {
					cb = eagerCompile;
					eagerCompile = false;
				}

				if (name instanceof Template) {
					tmpl = name;
				} else if (typeof name !== 'string') {
					throw new Error('template names must be a string: ' + name);
				} else {
					for (var i = 0; i < this.loaders.length; i++) {
						var _name = this.resolveTemplate(this.loaders[i], parentName, name);
						tmpl = this.loaders[i].cache[_name];
						if (tmpl) break;
					}
				}

				if (tmpl) {
					if (eagerCompile) {
						tmpl.compile();
					}

					if (cb) {
						cb(null, tmpl);
					} else {
						return tmpl;
					}
				} else {
					var syncResult;
					var _this = this;

					var createTemplate = function createTemplate(err, info) {
						if (!info && !err) {
							if (!ignoreMissing) {
								err = new Error('template not found: ' + name);
							}
						}

						if (err) {
							if (cb) {
								cb(err);
							} else {
								throw err;
							}
						} else {
							var tmpl;
							if (info) {
								tmpl = new Template(info.src, _this, info.path, eagerCompile);

								if (!info.noCache) {
									info.loader.cache[name] = tmpl;
								}
							} else {
								tmpl = new Template('', _this, '', eagerCompile);
							}

							if (cb) {
								cb(null, tmpl);
							} else {
								syncResult = tmpl;
							}
						}
					};

					lib.asyncIter(this.loaders, function (loader, i, next, done) {
						function handle(err, src) {
							if (err) {
								done(err);
							} else if (src) {
								src.loader = loader;
								done(null, src);
							} else {
								next();
							}
						}

						name = that.resolveTemplate(loader, parentName, name);

						if (loader.async) {
							loader.getSource(name, handle);
						} else {
							handle(null, loader.getSource(name));
						}
					}, createTemplate);

					return syncResult;
				}
			},

			express: function express(app) {
				var env = this;

				function NunjucksView(name, opts) {
					this.name = name;
					this.path = name;
					this.defaultEngine = opts.defaultEngine;
					this.ext = path.extname(name);
					if (!this.ext && !this.defaultEngine) throw new Error('No default engine was specified and no extension was provided.');
					if (!this.ext) this.name += this.ext = ('.' !== this.defaultEngine[0] ? '.' : '') + this.defaultEngine;
				}

				NunjucksView.prototype.render = function (opts, cb) {
					env.render(this.name, opts, cb);
				};

				app.set('view', NunjucksView);
				app.set('nunjucksEnv', this);
				return this;
			},

			render: function render(name, ctx, cb) {
				if (lib.isFunction(ctx)) {
					cb = ctx;
					ctx = null;
				}

				var syncResult = null;

				this.getTemplate(name, function (err, tmpl) {
					if (err && cb) {
						callbackAsap(cb, err);
					} else if (err) {
						throw err;
					} else {
						syncResult = tmpl.render(ctx, cb);
					}
				});

				return syncResult;
			},

			renderString: function renderString(src, ctx, opts, cb) {
				if (lib.isFunction(opts)) {
					cb = opts;
					opts = {};
				}
				opts = opts || {};

				var tmpl = new Template(src, this, opts.path);
				return tmpl.render(ctx, cb);
			},

			waterfall: waterfall
		});

		var Context = Obj.extend({
			init: function init(ctx, blocks, env) {
				this.env = env || new Environment();

				this.ctx = {};
				for (var k in ctx) {
					if (ctx.hasOwnProperty(k)) {
						this.ctx[k] = ctx[k];
					}
				}

				this.blocks = {};
				this.exported = [];

				for (var name in blocks) {
					this.addBlock(name, blocks[name]);
				}
			},

			lookup: function lookup(name) {
				if (name in this.env.globals && !(name in this.ctx)) {
					return this.env.globals[name];
				} else {
					return this.ctx[name];
				}
			},

			setVariable: function setVariable(name, val) {
				this.ctx[name] = val;
			},

			getVariables: function getVariables() {
				return this.ctx;
			},

			addBlock: function addBlock(name, block) {
				this.blocks[name] = this.blocks[name] || [];
				this.blocks[name].push(block);
				return this;
			},

			getBlock: function getBlock(name) {
				if (!this.blocks[name]) {
					throw new Error('unknown block "' + name + '"');
				}

				return this.blocks[name][0];
			},

			getSuper: function getSuper(env, name, block, frame, runtime, cb) {
				var idx = lib.indexOf(this.blocks[name] || [], block);
				var blk = this.blocks[name][idx + 1];
				var context = this;

				if (idx === -1 || !blk) {
					throw new Error('no super block available for "' + name + '"');
				}

				blk(env, context, frame, runtime, cb);
			},

			addExport: function addExport(name) {
				this.exported.push(name);
			},

			getExported: function getExported() {
				var exported = {};
				for (var i = 0; i < this.exported.length; i++) {
					var name = this.exported[i];
					exported[name] = this.ctx[name];
				}
				return exported;
			}
		});

		Template = Obj.extend({
			init: function init(src, env, path, eagerCompile) {
				this.env = env || new Environment();

				if (lib.isObject(src)) {
					switch (src.type) {
						case 'code':
							this.tmplProps = src.obj;break;
						case 'string':
							this.tmplStr = src.obj;break;
					}
				} else if (lib.isString(src)) {
					this.tmplStr = src;
				} else {
					throw new Error('src must be a string or an object describing ' + 'the source');
				}

				this.path = path;

				if (eagerCompile) {
					var _this = this;
					try {
						_this._compile();
					} catch (err) {
						throw lib.prettifyError(this.path, this.env.opts.dev, err);
					}
				} else {
					this.compiled = false;
				}
			},

			render: function render(ctx, parentFrame, cb) {
				if (typeof ctx === 'function') {
					cb = ctx;
					ctx = {};
				} else if (typeof parentFrame === 'function') {
					cb = parentFrame;
					parentFrame = null;
				}

				var forceAsync = true;
				if (parentFrame) {
					forceAsync = false;
				}

				var _this = this;

				try {
					_this.compile();
				} catch (_err) {
					var err = lib.prettifyError(this.path, this.env.opts.dev, _err);
					if (cb) return callbackAsap(cb, err);else throw err;
				}

				var context = new Context(ctx || {}, _this.blocks, _this.env);
				var frame = parentFrame ? parentFrame.push(true) : new Frame();
				frame.topLevel = true;
				var syncResult = null;

				_this.rootRenderFunc(_this.env, context, frame || new Frame(), runtime, function (err, res) {
					if (err) {
						err = lib.prettifyError(_this.path, _this.env.opts.dev, err);
					}

					if (cb) {
						if (forceAsync) {
							callbackAsap(cb, err, res);
						} else {
							cb(err, res);
						}
					} else {
						if (err) {
							throw err;
						}
						syncResult = res;
					}
				});

				return syncResult;
			},

			getExported: function getExported(ctx, parentFrame, cb) {
				if (typeof ctx === 'function') {
					cb = ctx;
					ctx = {};
				}

				if (typeof parentFrame === 'function') {
					cb = parentFrame;
					parentFrame = null;
				}

				try {
					this.compile();
				} catch (e) {
					if (cb) return cb(e);else throw e;
				}

				var frame = parentFrame ? parentFrame.push() : new Frame();
				frame.topLevel = true;

				var context = new Context(ctx || {}, this.blocks, this.env);
				this.rootRenderFunc(this.env, context, frame, runtime, function (err) {
					if (err) {
						cb(err, null);
					} else {
						cb(null, context.getExported());
					}
				});
			},

			compile: function compile() {
				if (!this.compiled) {
					this._compile();
				}
			},

			_compile: function _compile() {
				var props;

				if (this.tmplProps) {
					props = this.tmplProps;
				} else {
					var source = compiler.compile(this.tmplStr, this.env.asyncFilters, this.env.extensionsList, this.path, this.env.opts);

					var func = new Function(source);
					props = func();
				}

				this.blocks = this._getBlocks(props);
				this.rootRenderFunc = props.root;
				this.compiled = true;
			},

			_getBlocks: function _getBlocks(props) {
				var blocks = {};

				for (var k in props) {
					if (k.slice(0, 2) === 'b_') {
						blocks[k.slice(2)] = props[k];
					}
				}

				return blocks;
			}
		});

		module.exports = {
			Environment: Environment,
			Template: Template
		};
	}, function (module, exports) {}, function (module, exports, __webpack_require__) {

		"use strict";

		var rawAsap = __webpack_require__(5);

		var freeTasks = [];

		var pendingErrors = [];
		var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

		function throwFirstError() {
			if (pendingErrors.length) {
				throw pendingErrors.shift();
			}
		}

		module.exports = asap;
		function asap(task) {
			var rawTask;
			if (freeTasks.length) {
				rawTask = freeTasks.pop();
			} else {
				rawTask = new RawTask();
			}
			rawTask.task = task;
			rawAsap(rawTask);
		}

		function RawTask() {
			this.task = null;
		}

		RawTask.prototype.call = function () {
			try {
				this.task.call();
			} catch (error) {
				if (asap.onerror) {
					asap.onerror(error);
				} else {
					pendingErrors.push(error);
					requestErrorThrow();
				}
			} finally {
				this.task = null;
				freeTasks[freeTasks.length] = this;
			}
		};
	}, function (module, exports) {
		(function (global) {
			"use strict";

			module.exports = rawAsap;
			function rawAsap(task) {
				if (!queue.length) {
					requestFlush();
					flushing = true;
				}

				queue[queue.length] = task;
			}

			var queue = [];

			var flushing = false;

			var requestFlush;

			var index = 0;

			var capacity = 1024;

			function flush() {
				while (index < queue.length) {
					var currentIndex = index;

					index = index + 1;
					queue[currentIndex].call();

					if (index > capacity) {
						for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
							queue[scan] = queue[scan + index];
						}
						queue.length -= index;
						index = 0;
					}
				}
				queue.length = 0;
				index = 0;
				flushing = false;
			}

			var scope = typeof global !== "undefined" ? global : self;
			var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

			if (typeof BrowserMutationObserver === "function") {
				requestFlush = makeRequestCallFromMutationObserver(flush);
			} else {
				requestFlush = makeRequestCallFromTimer(flush);
			}

			rawAsap.requestFlush = requestFlush;

			function makeRequestCallFromMutationObserver(callback) {
				var toggle = 1;
				var observer = new BrowserMutationObserver(callback);
				var node = document.createTextNode("");
				observer.observe(node, { characterData: true });
				return function requestCall() {
					toggle = -toggle;
					node.data = toggle;
				};
			}

			function makeRequestCallFromTimer(callback) {
				return function requestCall() {
					var timeoutHandle = setTimeout(handleTimer, 0);

					var intervalHandle = setInterval(handleTimer, 50);

					function handleTimer() {
						clearTimeout(timeoutHandle);
						clearInterval(intervalHandle);
						callback();
					}
				};
			}

			rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
		}).call(exports, function () {
			return this;
		}());
	}, function (module, exports) {

		'use strict';

		function extend(cls, name, props) {
			var F = function F() {};
			F.prototype = cls.prototype;
			var prototype = new F();

			var fnTest = /xyz/.test(function () {
				xyz;
			}) ? /\bparent\b/ : /.*/;
			props = props || {};

			for (var k in props) {
				var src = props[k];
				var parent = prototype[k];

				if (typeof parent === 'function' && typeof src === 'function' && fnTest.test(src)) {
					prototype[k] = function (src, parent) {
						return function () {
							var tmp = this.parent;

							this.parent = parent;
							var res = src.apply(this, arguments);
							this.parent = tmp;

							return res;
						};
					}(src, parent);
				} else {
					prototype[k] = src;
				}
			}

			prototype.typename = name;

			var new_cls = function new_cls() {
				if (prototype.init) {
					prototype.init.apply(this, arguments);
				}
			};

			new_cls.prototype = prototype;
			new_cls.prototype.constructor = new_cls;

			new_cls.extend = function (name, props) {
				if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
					props = name;
					name = 'anonymous';
				}
				return extend(new_cls, name, props);
			};

			return new_cls;
		}

		module.exports = extend(Object, 'Object', {});
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var lib = __webpack_require__(1);
		var r = __webpack_require__(8);

		function normalize(value, defaultValue) {
			if (value === null || value === undefined || value === false) {
				return defaultValue;
			}
			return value;
		}

		var filters = {
			abs: Math.abs,

			batch: function batch(arr, linecount, fill_with) {
				var i;
				var res = [];
				var tmp = [];

				for (i = 0; i < arr.length; i++) {
					if (i % linecount === 0 && tmp.length) {
						res.push(tmp);
						tmp = [];
					}

					tmp.push(arr[i]);
				}

				if (tmp.length) {
					if (fill_with) {
						for (i = tmp.length; i < linecount; i++) {
							tmp.push(fill_with);
						}
					}

					res.push(tmp);
				}

				return res;
			},

			capitalize: function capitalize(str) {
				str = normalize(str, '');
				var ret = str.toLowerCase();
				return r.copySafeness(str, ret.charAt(0).toUpperCase() + ret.slice(1));
			},

			center: function center(str, width) {
				str = normalize(str, '');
				width = width || 80;

				if (str.length >= width) {
					return str;
				}

				var spaces = width - str.length;
				var pre = lib.repeat(' ', spaces / 2 - spaces % 2);
				var post = lib.repeat(' ', spaces / 2);
				return r.copySafeness(str, pre + str + post);
			},

			'default': function _default(val, def, bool) {
				if (bool) {
					return val ? val : def;
				} else {
					return val !== undefined ? val : def;
				}
			},

			dictsort: function dictsort(val, case_sensitive, by) {
				if (!lib.isObject(val)) {
					throw new lib.TemplateError('dictsort filter: val must be an object');
				}

				var array = [];
				for (var k in val) {
					array.push([k, val[k]]);
				}

				var si;
				if (by === undefined || by === 'key') {
					si = 0;
				} else if (by === 'value') {
					si = 1;
				} else {
					throw new lib.TemplateError('dictsort filter: You can only sort by either key or value');
				}

				array.sort(function (t1, t2) {
					var a = t1[si];
					var b = t2[si];

					if (!case_sensitive) {
						if (lib.isString(a)) {
							a = a.toUpperCase();
						}
						if (lib.isString(b)) {
							b = b.toUpperCase();
						}
					}

					return a > b ? 1 : a === b ? 0 : -1;
				});

				return array;
			},

			dump: function dump(obj, spaces) {
				return JSON.stringify(obj, null, spaces);
			},

			escape: function escape(str) {
				if (str instanceof r.SafeString) {
					return str;
				}
				str = str === null || str === undefined ? '' : str;
				return r.markSafe(lib.escape(str.toString()));
			},

			safe: function safe(str) {
				if (str instanceof r.SafeString) {
					return str;
				}
				str = str === null || str === undefined ? '' : str;
				return r.markSafe(str.toString());
			},

			first: function first(arr) {
				return arr[0];
			},

			groupby: function groupby(arr, attr) {
				return lib.groupBy(arr, attr);
			},

			indent: function indent(str, width, indentfirst) {
				str = normalize(str, '');

				if (str === '') return '';

				width = width || 4;
				var res = '';
				var lines = str.split('\n');
				var sp = lib.repeat(' ', width);

				for (var i = 0; i < lines.length; i++) {
					if (i === 0 && !indentfirst) {
						res += lines[i] + '\n';
					} else {
						res += sp + lines[i] + '\n';
					}
				}

				return r.copySafeness(str, res);
			},

			join: function join(arr, del, attr) {
				del = del || '';

				if (attr) {
					arr = lib.map(arr, function (v) {
						return v[attr];
					});
				}

				return arr.join(del);
			},

			last: function last(arr) {
				return arr[arr.length - 1];
			},

			length: function length(val) {
				var value = normalize(val, '');

				if (value !== undefined) {
					if (typeof Map === 'function' && value instanceof Map || typeof Set === 'function' && value instanceof Set) {
						return value.size;
					}
					if (lib.isObject(value) && !(value instanceof r.SafeString)) {
						return Object.keys(value).length;
					}
					return value.length;
				}
				return 0;
			},

			list: function list(val) {
				if (lib.isString(val)) {
					return val.split('');
				} else if (lib.isObject(val)) {
					var keys = [];

					if (Object.keys) {
						keys = Object.keys(val);
					} else {
						for (var k in val) {
							keys.push(k);
						}
					}

					return lib.map(keys, function (k) {
						return { key: k,
							value: val[k] };
					});
				} else if (lib.isArray(val)) {
					return val;
				} else {
					throw new lib.TemplateError('list filter: type not iterable');
				}
			},

			lower: function lower(str) {
				str = normalize(str, '');
				return str.toLowerCase();
			},

			nl2br: function nl2br(str) {
				if (str === null || str === undefined) {
					return '';
				}
				return r.copySafeness(str, str.replace(/\r\n|\n/g, '<br />\n'));
			},

			random: function random(arr) {
				return arr[Math.floor(Math.random() * arr.length)];
			},

			rejectattr: function rejectattr(arr, attr) {
				return arr.filter(function (item) {
					return !item[attr];
				});
			},

			selectattr: function selectattr(arr, attr) {
				return arr.filter(function (item) {
					return !!item[attr];
				});
			},

			replace: function replace(str, old, new_, maxCount) {
				var originalStr = str;

				if (old instanceof RegExp) {
					return str.replace(old, new_);
				}

				if (typeof maxCount === 'undefined') {
					maxCount = -1;
				}

				var res = '';
				if (typeof old === 'number') {
					old = old + '';
				} else if (typeof old !== 'string') {
					return str;
				}

				if (typeof str === 'number') {
					str = str + '';
				}

				if (typeof str !== 'string' && !(str instanceof r.SafeString)) {
					return str;
				}

				if (old === '') {
					res = new_ + str.split('').join(new_) + new_;
					return r.copySafeness(str, res);
				}

				var nextIndex = str.indexOf(old);

				if (maxCount === 0 || nextIndex === -1) {
					return str;
				}

				var pos = 0;
				var count = 0;

				while (nextIndex > -1 && (maxCount === -1 || count < maxCount)) {
					res += str.substring(pos, nextIndex) + new_;

					pos = nextIndex + old.length;
					count++;

					nextIndex = str.indexOf(old, pos);
				}

				if (pos < str.length) {
					res += str.substring(pos);
				}

				return r.copySafeness(originalStr, res);
			},

			reverse: function reverse(val) {
				var arr;
				if (lib.isString(val)) {
					arr = filters.list(val);
				} else {
					arr = lib.map(val, function (v) {
						return v;
					});
				}

				arr.reverse();

				if (lib.isString(val)) {
					return r.copySafeness(val, arr.join(''));
				}
				return arr;
			},

			round: function round(val, precision, method) {
				precision = precision || 0;
				var factor = Math.pow(10, precision);
				var rounder;

				if (method === 'ceil') {
					rounder = Math.ceil;
				} else if (method === 'floor') {
					rounder = Math.floor;
				} else {
					rounder = Math.round;
				}

				return rounder(val * factor) / factor;
			},

			slice: function slice(arr, slices, fillWith) {
				var sliceLength = Math.floor(arr.length / slices);
				var extra = arr.length % slices;
				var offset = 0;
				var res = [];

				for (var i = 0; i < slices; i++) {
					var start = offset + i * sliceLength;
					if (i < extra) {
						offset++;
					}
					var end = offset + (i + 1) * sliceLength;

					var slice = arr.slice(start, end);
					if (fillWith && i >= extra) {
						slice.push(fillWith);
					}
					res.push(slice);
				}

				return res;
			},

			sum: function sum(arr, attr, start) {
				var sum = 0;

				if (typeof start === 'number') {
					sum += start;
				}

				if (attr) {
					arr = lib.map(arr, function (v) {
						return v[attr];
					});
				}

				for (var i = 0; i < arr.length; i++) {
					sum += arr[i];
				}

				return sum;
			},

			sort: r.makeMacro(['value', 'reverse', 'case_sensitive', 'attribute'], [], function (arr, reverse, caseSens, attr) {
				arr = lib.map(arr, function (v) {
					return v;
				});

				arr.sort(function (a, b) {
					var x, y;

					if (attr) {
						x = a[attr];
						y = b[attr];
					} else {
						x = a;
						y = b;
					}

					if (!caseSens && lib.isString(x) && lib.isString(y)) {
						x = x.toLowerCase();
						y = y.toLowerCase();
					}

					if (x < y) {
						return reverse ? 1 : -1;
					} else if (x > y) {
						return reverse ? -1 : 1;
					} else {
						return 0;
					}
				});

				return arr;
			}),

			string: function string(obj) {
				return r.copySafeness(obj, obj);
			},

			striptags: function striptags(input, preserve_linebreaks) {
				input = normalize(input, '');
				preserve_linebreaks = preserve_linebreaks || false;
				var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>|<!--[\s\S]*?-->/gi;
				var trimmedInput = filters.trim(input.replace(tags, ''));
				var res = '';
				if (preserve_linebreaks) {
					res = trimmedInput.replace(/^ +| +$/gm, '').replace(/ +/g, ' ').replace(/(\r\n)/g, '\n').replace(/\n\n\n+/g, '\n\n');
				} else {
					res = trimmedInput.replace(/\s+/gi, ' ');
				}
				return r.copySafeness(input, res);
			},

			title: function title(str) {
				str = normalize(str, '');
				var words = str.split(' ');
				for (var i = 0; i < words.length; i++) {
					words[i] = filters.capitalize(words[i]);
				}
				return r.copySafeness(str, words.join(' '));
			},

			trim: function trim(str) {
				return r.copySafeness(str, str.replace(/^\s*|\s*$/g, ''));
			},

			truncate: function truncate(input, length, killwords, end) {
				var orig = input;
				input = normalize(input, '');
				length = length || 255;

				if (input.length <= length) return input;

				if (killwords) {
					input = input.substring(0, length);
				} else {
					var idx = input.lastIndexOf(' ', length);
					if (idx === -1) {
						idx = length;
					}

					input = input.substring(0, idx);
				}

				input += end !== undefined && end !== null ? end : '...';
				return r.copySafeness(orig, input);
			},

			upper: function upper(str) {
				str = normalize(str, '');
				return str.toUpperCase();
			},

			urlencode: function urlencode(obj) {
				var enc = encodeURIComponent;
				if (lib.isString(obj)) {
					return enc(obj);
				} else {
					var parts;
					if (lib.isArray(obj)) {
						parts = obj.map(function (item) {
							return enc(item[0]) + '=' + enc(item[1]);
						});
					} else {
						parts = [];
						for (var k in obj) {
							if (obj.hasOwnProperty(k)) {
								parts.push(enc(k) + '=' + enc(obj[k]));
							}
						}
					}
					return parts.join('&');
				}
			},

			urlize: function urlize(str, length, nofollow) {
				if (isNaN(length)) length = Infinity;

				var noFollowAttr = nofollow === true ? ' rel="nofollow"' : '';

				var puncRE = /^(?:\(|<|&lt;)?(.*?)(?:\.|,|\)|\n|&gt;)?$/;

				var emailRE = /^[\w.!#$%&'*+\-\/=?\^`{|}~]+@[a-z\d\-]+(\.[a-z\d\-]+)+$/i;
				var httpHttpsRE = /^https?:\/\/.*$/;
				var wwwRE = /^www\./;
				var tldRE = /\.(?:org|net|com)(?:\:|\/|$)/;

				var words = str.split(/(\s+)/).filter(function (word) {
					return word && word.length;
				}).map(function (word) {
					var matches = word.match(puncRE);
					var possibleUrl = matches && matches[1] || word;

					if (httpHttpsRE.test(possibleUrl)) return '<a href="' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

					if (wwwRE.test(possibleUrl)) return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

					if (emailRE.test(possibleUrl)) return '<a href="mailto:' + possibleUrl + '">' + possibleUrl + '</a>';

					if (tldRE.test(possibleUrl)) return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';

					return word;
				});

				return words.join('');
			},

			wordcount: function wordcount(str) {
				str = normalize(str, '');
				var words = str ? str.match(/\w+/g) : null;
				return words ? words.length : null;
			},

			'float': function float(val, def) {
				var res = parseFloat(val);
				return isNaN(res) ? def : res;
			},

			'int': function int(val, def) {
				var res = parseInt(val, 10);
				return isNaN(res) ? def : res;
			}
		};

		filters.d = filters['default'];
		filters.e = filters.escape;

		module.exports = filters;
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var lib = __webpack_require__(1);
		var Obj = __webpack_require__(6);

		var Frame = Obj.extend({
			init: function init(parent, isolateWrites) {
				this.variables = {};
				this.parent = parent;
				this.topLevel = false;

				this.isolateWrites = isolateWrites;
			},

			set: function set(name, val, resolveUp) {
				var parts = name.split('.');
				var obj = this.variables;
				var frame = this;

				if (resolveUp) {
					if (frame = this.resolve(parts[0], true)) {
						frame.set(name, val);
						return;
					}
				}

				for (var i = 0; i < parts.length - 1; i++) {
					var id = parts[i];

					if (!obj[id]) {
						obj[id] = {};
					}
					obj = obj[id];
				}

				obj[parts[parts.length - 1]] = val;
			},

			get: function get(name) {
				var val = this.variables[name];
				if (val !== undefined) {
					return val;
				}
				return null;
			},

			lookup: function lookup(name) {
				var p = this.parent;
				var val = this.variables[name];
				if (val !== undefined) {
					return val;
				}
				return p && p.lookup(name);
			},

			resolve: function resolve(name, forWrite) {
				var p = forWrite && this.isolateWrites ? undefined : this.parent;
				var val = this.variables[name];
				if (val !== undefined) {
					return this;
				}
				return p && p.resolve(name);
			},

			push: function push(isolateWrites) {
				return new Frame(this, isolateWrites);
			},

			pop: function pop() {
				return this.parent;
			}
		});

		function makeMacro(argNames, kwargNames, func) {
			return function () {
				var argCount = numArgs(arguments);
				var args;
				var kwargs = getKeywordArgs(arguments);
				var i;

				if (argCount > argNames.length) {
					args = Array.prototype.slice.call(arguments, 0, argNames.length);

					var vals = Array.prototype.slice.call(arguments, args.length, argCount);
					for (i = 0; i < vals.length; i++) {
						if (i < kwargNames.length) {
							kwargs[kwargNames[i]] = vals[i];
						}
					}

					args.push(kwargs);
				} else if (argCount < argNames.length) {
					args = Array.prototype.slice.call(arguments, 0, argCount);

					for (i = argCount; i < argNames.length; i++) {
						var arg = argNames[i];

						args.push(kwargs[arg]);
						delete kwargs[arg];
					}

					args.push(kwargs);
				} else {
					args = arguments;
				}

				return func.apply(this, args);
			};
		}

		function makeKeywordArgs(obj) {
			obj.__keywords = true;
			return obj;
		}

		function getKeywordArgs(args) {
			var len = args.length;
			if (len) {
				var lastArg = args[len - 1];
				if (lastArg && lastArg.hasOwnProperty('__keywords')) {
					return lastArg;
				}
			}
			return {};
		}

		function numArgs(args) {
			var len = args.length;
			if (len === 0) {
				return 0;
			}

			var lastArg = args[len - 1];
			if (lastArg && lastArg.hasOwnProperty('__keywords')) {
				return len - 1;
			} else {
				return len;
			}
		}

		function SafeString(val) {
			if (typeof val !== 'string') {
				return val;
			}

			this.val = val;
			this.length = val.length;
		}

		SafeString.prototype = Object.create(String.prototype, {
			length: { writable: true, configurable: true, value: 0 }
		});
		SafeString.prototype.valueOf = function () {
			return this.val;
		};
		SafeString.prototype.toString = function () {
			return this.val;
		};

		function copySafeness(dest, target) {
			if (dest instanceof SafeString) {
				return new SafeString(target);
			}
			return target.toString();
		}

		function markSafe(val) {
			var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);

			if (type === 'string') {
				return new SafeString(val);
			} else if (type !== 'function') {
				return val;
			} else {
				return function () {
					var ret = val.apply(this, arguments);

					if (typeof ret === 'string') {
						return new SafeString(ret);
					}

					return ret;
				};
			}
		}

		function suppressValue(val, autoescape) {
			val = val !== undefined && val !== null ? val : '';

			if (autoescape && !(val instanceof SafeString)) {
				val = lib.escape(val.toString());
			}

			return val;
		}

		function ensureDefined(val, lineno, colno) {
			if (val === null || val === undefined) {
				throw new lib.TemplateError('attempted to output null or undefined value', lineno + 1, colno + 1);
			}
			return val;
		}

		function memberLookup(obj, val) {
			obj = obj || {};

			if (typeof obj[val] === 'function') {
				return function () {
					return obj[val].apply(obj, arguments);
				};
			}

			return obj[val];
		}

		function callWrap(obj, name, context, args) {
			if (!obj) {
				throw new Error('Unable to call `' + name + '`, which is undefined or falsey');
			} else if (typeof obj !== 'function') {
				throw new Error('Unable to call `' + name + '`, which is not a function');
			}

			return obj.apply(context, args);
		}

		function contextOrFrameLookup(context, frame, name) {
			var val = frame.lookup(name);
			return val !== undefined ? val : context.lookup(name);
		}

		function handleError(error, lineno, colno) {
			if (error.lineno) {
				return error;
			} else {
				return new lib.TemplateError(error, lineno, colno);
			}
		}

		function asyncEach(arr, dimen, iter, cb) {
			if (lib.isArray(arr)) {
				var len = arr.length;

				lib.asyncIter(arr, function (item, i, next) {
					switch (dimen) {
						case 1:
							iter(item, i, len, next);break;
						case 2:
							iter(item[0], item[1], i, len, next);break;
						case 3:
							iter(item[0], item[1], item[2], i, len, next);break;
						default:
							item.push(i, next);
							iter.apply(this, item);
					}
				}, cb);
			} else {
				lib.asyncFor(arr, function (key, val, i, len, next) {
					iter(key, val, i, len, next);
				}, cb);
			}
		}

		function asyncAll(arr, dimen, func, cb) {
			var finished = 0;
			var len, i;
			var outputArr;

			function done(i, output) {
				finished++;
				outputArr[i] = output;

				if (finished === len) {
					cb(null, outputArr.join(''));
				}
			}

			if (lib.isArray(arr)) {
				len = arr.length;
				outputArr = new Array(len);

				if (len === 0) {
					cb(null, '');
				} else {
					for (i = 0; i < arr.length; i++) {
						var item = arr[i];

						switch (dimen) {
							case 1:
								func(item, i, len, done);break;
							case 2:
								func(item[0], item[1], i, len, done);break;
							case 3:
								func(item[0], item[1], item[2], i, len, done);break;
							default:
								item.push(i, done);

								func.apply(this, item);
						}
					}
				}
			} else {
				var keys = lib.keys(arr);
				len = keys.length;
				outputArr = new Array(len);

				if (len === 0) {
					cb(null, '');
				} else {
					for (i = 0; i < keys.length; i++) {
						var k = keys[i];
						func(k, arr[k], i, len, done);
					}
				}
			}
		}

		module.exports = {
			Frame: Frame,
			makeMacro: makeMacro,
			makeKeywordArgs: makeKeywordArgs,
			numArgs: numArgs,
			suppressValue: suppressValue,
			ensureDefined: ensureDefined,
			memberLookup: memberLookup,
			contextOrFrameLookup: contextOrFrameLookup,
			callWrap: callWrap,
			handleError: handleError,
			isArray: lib.isArray,
			keys: lib.keys,
			SafeString: SafeString,
			copySafeness: copySafeness,
			markSafe: markSafe,
			asyncEach: asyncEach,
			asyncAll: asyncAll,
			inOperator: lib.inOperator
		};
	}, function (module, exports) {

		'use strict';

		function _cycler(items) {
			var index = -1;

			return {
				current: null,
				reset: function reset() {
					index = -1;
					this.current = null;
				},

				next: function next() {
					index++;
					if (index >= items.length) {
						index = 0;
					}

					this.current = items[index];
					return this.current;
				}
			};
		}

		function _joiner(sep) {
			sep = sep || ',';
			var first = true;

			return function () {
				var val = first ? '' : sep;
				first = false;
				return val;
			};
		}

		function globals() {
			return {
				range: function range(start, stop, step) {
					if (typeof stop === 'undefined') {
						stop = start;
						start = 0;
						step = 1;
					} else if (!step) {
						step = 1;
					}

					var arr = [];
					var i;
					if (step > 0) {
						for (i = start; i < stop; i += step) {
							arr.push(i);
						}
					} else {
						for (i = start; i > stop; i += step) {
							arr.push(i);
						}
					}
					return arr;
				},

				cycler: function cycler() {
					return _cycler(Array.prototype.slice.call(arguments));
				},

				joiner: function joiner(sep) {
					return _joiner(sep);
				}
			};
		}

		module.exports = globals;
	}, function (module, exports, __webpack_require__) {

		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (setImmediate, process) {
			(function (globals) {
				'use strict';

				var executeSync = function executeSync() {
					var args = Array.prototype.slice.call(arguments);
					if (typeof args[0] === 'function') {
						args[0].apply(null, args.splice(1));
					}
				};

				var executeAsync = function executeAsync(fn) {
					if (typeof setImmediate === 'function') {
						setImmediate(fn);
					} else if (typeof process !== 'undefined' && process.nextTick) {
						process.nextTick(fn);
					} else {
						setTimeout(fn, 0);
					}
				};

				var makeIterator = function makeIterator(tasks) {
					var makeCallback = function makeCallback(index) {
						var fn = function fn() {
							if (tasks.length) {
								tasks[index].apply(null, arguments);
							}
							return fn.next();
						};
						fn.next = function () {
							return index < tasks.length - 1 ? makeCallback(index + 1) : null;
						};
						return fn;
					};
					return makeCallback(0);
				};

				var _isArray = Array.isArray || function (maybeArray) {
					return Object.prototype.toString.call(maybeArray) === '[object Array]';
				};

				var waterfall = function waterfall(tasks, callback, forceAsync) {
					var nextTick = forceAsync ? executeAsync : executeSync;
					callback = callback || function () {};
					if (!_isArray(tasks)) {
						var err = new Error('First argument to waterfall must be an array of functions');
						return callback(err);
					}
					if (!tasks.length) {
						return callback();
					}
					var wrapIterator = function wrapIterator(iterator) {
						return function (err) {
							if (err) {
								callback.apply(null, arguments);
								callback = function callback() {};
							} else {
								var args = Array.prototype.slice.call(arguments, 1);
								var next = iterator.next();
								if (next) {
									args.push(wrapIterator(next));
								} else {
									args.push(callback);
								}
								nextTick(function () {
									iterator.apply(null, args);
								});
							}
						};
					};
					wrapIterator(makeIterator(tasks))();
				};

				if (true) {
					!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
						return waterfall;
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else if (typeof module !== 'undefined' && module.exports) {
					module.exports = waterfall;
				} else {
					globals.waterfall = waterfall;
				}
			})(this);
		}).call(exports, __webpack_require__(11).setImmediate, __webpack_require__(13));
	}, function (module, exports, __webpack_require__) {

		var apply = Function.prototype.apply;

		exports.setTimeout = function () {
			return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
		};
		exports.setInterval = function () {
			return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
		};
		exports.clearTimeout = exports.clearInterval = function (timeout) {
			if (timeout) {
				timeout.close();
			}
		};

		function Timeout(id, clearFn) {
			this._id = id;
			this._clearFn = clearFn;
		}
		Timeout.prototype.unref = Timeout.prototype.ref = function () {};
		Timeout.prototype.close = function () {
			this._clearFn.call(window, this._id);
		};

		exports.enroll = function (item, msecs) {
			clearTimeout(item._idleTimeoutId);
			item._idleTimeout = msecs;
		};

		exports.unenroll = function (item) {
			clearTimeout(item._idleTimeoutId);
			item._idleTimeout = -1;
		};

		exports._unrefActive = exports.active = function (item) {
			clearTimeout(item._idleTimeoutId);

			var msecs = item._idleTimeout;
			if (msecs >= 0) {
				item._idleTimeoutId = setTimeout(function onTimeout() {
					if (item._onTimeout) item._onTimeout();
				}, msecs);
			}
		};

		__webpack_require__(12);
		exports.setImmediate = setImmediate;
		exports.clearImmediate = clearImmediate;
	}, function (module, exports, __webpack_require__) {
		(function (global, process) {
			(function (global, undefined) {
				"use strict";

				if (global.setImmediate) {
					return;
				}

				var nextHandle = 1;
				var tasksByHandle = {};
				var currentlyRunningATask = false;
				var doc = global.document;
				var registerImmediate;

				function setImmediate(callback) {
					if (typeof callback !== "function") {
						callback = new Function("" + callback);
					}

					var args = new Array(arguments.length - 1);
					for (var i = 0; i < args.length; i++) {
						args[i] = arguments[i + 1];
					}

					var task = { callback: callback, args: args };
					tasksByHandle[nextHandle] = task;
					registerImmediate(nextHandle);
					return nextHandle++;
				}

				function clearImmediate(handle) {
					delete tasksByHandle[handle];
				}

				function run(task) {
					var callback = task.callback;
					var args = task.args;
					switch (args.length) {
						case 0:
							callback();
							break;
						case 1:
							callback(args[0]);
							break;
						case 2:
							callback(args[0], args[1]);
							break;
						case 3:
							callback(args[0], args[1], args[2]);
							break;
						default:
							callback.apply(undefined, args);
							break;
					}
				}

				function runIfPresent(handle) {
					if (currentlyRunningATask) {
						setTimeout(runIfPresent, 0, handle);
					} else {
						var task = tasksByHandle[handle];
						if (task) {
							currentlyRunningATask = true;
							try {
								run(task);
							} finally {
								clearImmediate(handle);
								currentlyRunningATask = false;
							}
						}
					}
				}

				function installNextTickImplementation() {
					registerImmediate = function registerImmediate(handle) {
						process.nextTick(function () {
							runIfPresent(handle);
						});
					};
				}

				function canUsePostMessage() {
					if (global.postMessage && !global.importScripts) {
						var postMessageIsAsynchronous = true;
						var oldOnMessage = global.onmessage;
						global.onmessage = function () {
							postMessageIsAsynchronous = false;
						};
						global.postMessage("", "*");
						global.onmessage = oldOnMessage;
						return postMessageIsAsynchronous;
					}
				}

				function installPostMessageImplementation() {

					var messagePrefix = "setImmediate$" + Math.random() + "$";
					var onGlobalMessage = function onGlobalMessage(event) {
						if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
							runIfPresent(+event.data.slice(messagePrefix.length));
						}
					};

					if (global.addEventListener) {
						global.addEventListener("message", onGlobalMessage, false);
					} else {
						global.attachEvent("onmessage", onGlobalMessage);
					}

					registerImmediate = function registerImmediate(handle) {
						global.postMessage(messagePrefix + handle, "*");
					};
				}

				function installMessageChannelImplementation() {
					var channel = new MessageChannel();
					channel.port1.onmessage = function (event) {
						var handle = event.data;
						runIfPresent(handle);
					};

					registerImmediate = function registerImmediate(handle) {
						channel.port2.postMessage(handle);
					};
				}

				function installReadyStateChangeImplementation() {
					var html = doc.documentElement;
					registerImmediate = function registerImmediate(handle) {
						var script = doc.createElement("script");
						script.onreadystatechange = function () {
							runIfPresent(handle);
							script.onreadystatechange = null;
							html.removeChild(script);
							script = null;
						};
						html.appendChild(script);
					};
				}

				function installSetTimeoutImplementation() {
					registerImmediate = function registerImmediate(handle) {
						setTimeout(runIfPresent, 0, handle);
					};
				}

				var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
				attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

				if ({}.toString.call(global.process) === "[object process]") {
					installNextTickImplementation();
				} else if (canUsePostMessage()) {
					installPostMessageImplementation();
				} else if (global.MessageChannel) {
					installMessageChannelImplementation();
				} else if (doc && "onreadystatechange" in doc.createElement("script")) {
					installReadyStateChangeImplementation();
				} else {
					installSetTimeoutImplementation();
				}

				attachTo.setImmediate = setImmediate;
				attachTo.clearImmediate = clearImmediate;
			})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
		}).call(exports, function () {
			return this;
		}(), __webpack_require__(13));
	}, function (module, exports) {}, function (module, exports, __webpack_require__) {

		'use strict';

		var Loader = __webpack_require__(15);

		var PrecompiledLoader = Loader.extend({
			init: function init(compiledTemplates) {
				this.precompiled = compiledTemplates || {};
			},

			getSource: function getSource(name) {
				if (this.precompiled[name]) {
					return {
						src: { type: 'code',
							obj: this.precompiled[name] },
						path: name
					};
				}
				return null;
			}
		});

		module.exports = PrecompiledLoader;
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var path = __webpack_require__(3);
		var Obj = __webpack_require__(6);
		var lib = __webpack_require__(1);

		var Loader = Obj.extend({
			on: function on(name, func) {
				this.listeners = this.listeners || {};
				this.listeners[name] = this.listeners[name] || [];
				this.listeners[name].push(func);
			},

			emit: function emit(name) {
				var args = Array.prototype.slice.call(arguments, 1);

				if (this.listeners && this.listeners[name]) {
					lib.each(this.listeners[name], function (listener) {
						listener.apply(null, args);
					});
				}
			},

			resolve: function resolve(from, to) {
				return path.resolve(path.dirname(from), to);
			},

			isRelative: function isRelative(filename) {
				return filename.indexOf('./') === 0 || filename.indexOf('../') === 0;
			}
		});

		module.exports = Loader;
	}, function (module, exports) {

		function installCompat() {
			'use strict';

			var runtime = this.runtime;
			var lib = this.lib;
			var Compiler = this.compiler.Compiler;
			var Parser = this.parser.Parser;
			var nodes = this.nodes;
			var lexer = this.lexer;

			var orig_contextOrFrameLookup = runtime.contextOrFrameLookup;
			var orig_Compiler_assertType = Compiler.prototype.assertType;
			var orig_Parser_parseAggregate = Parser.prototype.parseAggregate;
			var orig_memberLookup = runtime.memberLookup;

			function uninstall() {
				runtime.contextOrFrameLookup = orig_contextOrFrameLookup;
				Compiler.prototype.assertType = orig_Compiler_assertType;
				Parser.prototype.parseAggregate = orig_Parser_parseAggregate;
				runtime.memberLookup = orig_memberLookup;
			}

			runtime.contextOrFrameLookup = function (context, frame, key) {
				var val = orig_contextOrFrameLookup.apply(this, arguments);
				if (val === undefined) {
					switch (key) {
						case 'True':
							return true;
						case 'False':
							return false;
						case 'None':
							return null;
					}
				}

				return val;
			};

			var Slice = nodes.Node.extend('Slice', {
				fields: ['start', 'stop', 'step'],
				init: function init(lineno, colno, start, stop, step) {
					start = start || new nodes.Literal(lineno, colno, null);
					stop = stop || new nodes.Literal(lineno, colno, null);
					step = step || new nodes.Literal(lineno, colno, 1);
					this.parent(lineno, colno, start, stop, step);
				}
			});

			Compiler.prototype.assertType = function (node) {
				if (node instanceof Slice) {
					return;
				}
				return orig_Compiler_assertType.apply(this, arguments);
			};
			Compiler.prototype.compileSlice = function (node, frame) {
				this.emit('(');
				this._compileExpression(node.start, frame);
				this.emit('),(');
				this._compileExpression(node.stop, frame);
				this.emit('),(');
				this._compileExpression(node.step, frame);
				this.emit(')');
			};

			function getTokensState(tokens) {
				return {
					index: tokens.index,
					lineno: tokens.lineno,
					colno: tokens.colno
				};
			}

			Parser.prototype.parseAggregate = function () {
				var self = this;
				var origState = getTokensState(this.tokens);

				origState.colno--;
				origState.index--;
				try {
					return orig_Parser_parseAggregate.apply(this);
				} catch (e) {
					var errState = getTokensState(this.tokens);
					var rethrow = function rethrow() {
						lib.extend(self.tokens, errState);
						return e;
					};

					lib.extend(this.tokens, origState);
					this.peeked = false;

					var tok = this.peekToken();
					if (tok.type !== lexer.TOKEN_LEFT_BRACKET) {
						throw rethrow();
					} else {
						this.nextToken();
					}

					var node = new Slice(tok.lineno, tok.colno);

					var isSlice = false;

					for (var i = 0; i <= node.fields.length; i++) {
						if (this.skip(lexer.TOKEN_RIGHT_BRACKET)) {
							break;
						}
						if (i === node.fields.length) {
							if (isSlice) {
								this.fail('parseSlice: too many slice components', tok.lineno, tok.colno);
							} else {
								break;
							}
						}
						if (this.skip(lexer.TOKEN_COLON)) {
							isSlice = true;
						} else {
							var field = node.fields[i];
							node[field] = this.parseExpression();
							isSlice = this.skip(lexer.TOKEN_COLON) || isSlice;
						}
					}
					if (!isSlice) {
						throw rethrow();
					}
					return new nodes.Array(tok.lineno, tok.colno, [node]);
				}
			};

			function sliceLookup(obj, start, stop, step) {
				obj = obj || [];
				if (start === null) {
					start = step < 0 ? obj.length - 1 : 0;
				}
				if (stop === null) {
					stop = step < 0 ? -1 : obj.length;
				} else {
					if (stop < 0) {
						stop += obj.length;
					}
				}

				if (start < 0) {
					start += obj.length;
				}

				var results = [];

				for (var i = start;; i += step) {
					if (i < 0 || i > obj.length) {
						break;
					}
					if (step > 0 && i >= stop) {
						break;
					}
					if (step < 0 && i <= stop) {
						break;
					}
					results.push(runtime.memberLookup(obj, i));
				}
				return results;
			}

			var ARRAY_MEMBERS = {
				pop: function pop(index) {
					if (index === undefined) {
						return this.pop();
					}
					if (index >= this.length || index < 0) {
						throw new Error('KeyError');
					}
					return this.splice(index, 1);
				},
				append: function append(element) {
					return this.push(element);
				},
				remove: function remove(element) {
					for (var i = 0; i < this.length; i++) {
						if (this[i] === element) {
							return this.splice(i, 1);
						}
					}
					throw new Error('ValueError');
				},
				count: function count(element) {
					var count = 0;
					for (var i = 0; i < this.length; i++) {
						if (this[i] === element) {
							count++;
						}
					}
					return count;
				},
				index: function index(element) {
					var i;
					if ((i = this.indexOf(element)) === -1) {
						throw new Error('ValueError');
					}
					return i;
				},
				find: function find(element) {
					return this.indexOf(element);
				},
				insert: function insert(index, elem) {
					return this.splice(index, 0, elem);
				}
			};
			var OBJECT_MEMBERS = {
				items: function items() {
					var ret = [];
					for (var k in this) {
						ret.push([k, this[k]]);
					}
					return ret;
				},
				values: function values() {
					var ret = [];
					for (var k in this) {
						ret.push(this[k]);
					}
					return ret;
				},
				keys: function keys() {
					var ret = [];
					for (var k in this) {
						ret.push(k);
					}
					return ret;
				},
				get: function get(key, def) {
					var output = this[key];
					if (output === undefined) {
						output = def;
					}
					return output;
				},
				has_key: function has_key(key) {
					return this.hasOwnProperty(key);
				},
				pop: function pop(key, def) {
					var output = this[key];
					if (output === undefined && def !== undefined) {
						output = def;
					} else if (output === undefined) {
						throw new Error('KeyError');
					} else {
						delete this[key];
					}
					return output;
				},
				popitem: function popitem() {
					for (var k in this) {
						var val = this[k];
						delete this[k];
						return [k, val];
					}
					throw new Error('KeyError');
				},
				setdefault: function setdefault(key, def) {
					if (key in this) {
						return this[key];
					}
					if (def === undefined) {
						def = null;
					}
					return this[key] = def;
				},
				update: function update(kwargs) {
					for (var k in kwargs) {
						this[k] = kwargs[k];
					}
					return null;
				}
			};
			OBJECT_MEMBERS.iteritems = OBJECT_MEMBERS.items;
			OBJECT_MEMBERS.itervalues = OBJECT_MEMBERS.values;
			OBJECT_MEMBERS.iterkeys = OBJECT_MEMBERS.keys;
			runtime.memberLookup = function (obj, val, autoescape) {
				if (arguments.length === 4) {
					return sliceLookup.apply(this, arguments);
				}
				obj = obj || {};

				if (lib.isArray(obj) && ARRAY_MEMBERS.hasOwnProperty(val)) {
					return function () {
						return ARRAY_MEMBERS[val].apply(obj, arguments);
					};
				}

				if (lib.isObject(obj) && OBJECT_MEMBERS.hasOwnProperty(val)) {
					return function () {
						return OBJECT_MEMBERS[val].apply(obj, arguments);
					};
				}

				return orig_memberLookup.apply(this, arguments);
			};

			return uninstall;
		}

		module.exports = installCompat;
	}]);
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16).setImmediate, __webpack_require__(16).clearImmediate, __webpack_require__(10)(module)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (nunjucks, env, obj, dependencies) {

    var oldRoot = obj.root;

    obj.root = function (env, context, frame, runtime, ignoreMissing, cb) {
        var oldGetTemplate = env.getTemplate;
        env.getTemplate = function (name, ec, parentName, ignoreMissing, cb) {
            if (typeof ec === "function") {
                cb = ec = false;
            }
            var _require = function _require(name) {
                try {
                    return dependencies[name];
                } catch (e) {
                    if (frame.get("_require")) {
                        return frame.get("_require")(name);
                    } else {
                        console.warn('Could not load template "%s"', name);
                    }
                }
            };

            var tmpl = _require(name);
            frame.set("_require", _require);

            if (ec) tmpl.compile();
            cb(null, tmpl);
        };

        oldRoot(env, context, frame, runtime, ignoreMissing, function (err, res) {
            env.getTemplate = oldGetTemplate;
            cb(err, res);
        });
    };

    var src = {
        obj: obj,
        type: 'code'
    };

    return new nunjucks.Template(src, env);
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

EventEmitter.defaultMaxListeners = 10;

EventEmitter.prototype.setMaxListeners = function (n) {
  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function (type) {
  var er, handler, len, args, i, listeners;

  if (!this._events) this._events = {};

  if (type === 'error') {
    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er;
      } else {
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler)) return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;

      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++) {
      listeners[i].apply(this, args);
    }
  }

  return true;
};

EventEmitter.prototype.addListener = function (type, listener) {
  var m;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events) this._events = {};

  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);

  if (!this._events[type]) this._events[type] = listener;else if (isObject(this._events[type])) this._events[type].push(listener);else this._events[type] = [this._events[type], listener];

  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
      if (typeof console.trace === 'function') {
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function (type, listener) {
  if (!isFunction(listener)) throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

EventEmitter.prototype.removeListener = function (type, listener) {
  var list, position, length, i;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events || !this._events[type]) return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener || isFunction(list.listener) && list.listener === listener) {
    delete this._events[type];
    if (this._events.removeListener) this.emit('removeListener', type, listener);
  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener) this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function (type) {
  var key, listeners;

  if (!this._events) return this;

  if (!this._events.removeListener) {
    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
    return this;
  }

  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    while (listeners.length) {
      this.removeListener(type, listeners[listeners.length - 1]);
    }
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function (type) {
  var ret;
  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function (type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function (emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(146);

var _index2 = _interopRequireDefault(_index);

var _msg = __webpack_require__(150);

var _msg2 = _interopRequireDefault(_msg);

var _slideup = __webpack_require__(151);

var _slideup2 = _interopRequireDefault(_slideup);

var _orderItem = __webpack_require__(152);

var _orderItem2 = _interopRequireDefault(_orderItem);

var _popup = __webpack_require__(153);

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Template = {
  showAvatar: false,

  frame: function frame(data) {
    var $node = _index2.default.render(data);
    return $node;
  },

  msg: function msg(data) {
    var side = data.side || 'left';
    data.side = side;
    var node = _msg2.default.render(data);
    return node;
  },

  slideUp: function slideUp(data) {
    var $node = _slideup2.default.render(data);
    return $node;
  },

  orderItem: function orderItem(data) {
    data.id = data.parentId || data.id;
    if (data.tradeTime) {
      data.type = 'order';
    } else {
      data.type = 'item';
    }
    var $node = _orderItem2.default.render(data);
    return $node;
  },

  popup: function popup(data) {
    var $node = _popup2.default.render(data);
    return $node;
  }
};

exports.default = Template;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = __webpack_require__(7);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = new _events2.default();

exports.default = EventBus;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];

		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

g = function () {
	return this;
}();

try {
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

module.exports = g;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deviceType = _util2.default.isPC() ? '2' : '1';

var config = {};

var Log = {
  send: function send(data) {
    var isImmediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var img = new Image();
    var id = 'img_' + Math.random();
    var param = data;
    var timestamp = new Date().getTime();
    var from = config.from || 'lazada';
    from = from || 'unknown';
    data.ext = data.ext || {};
    data.ext = JSON.stringify(data.ext);
    param._input_charset = 'utf-8';

    var src = '//gm.mmstat.com/merobot.a2o35.8276445.' + data.c + '.' + data.d + '?cache=' + timestamp + '&ext=' + data.ext + '&memberType=' + config.memberType + '&from=' + from + '&imsid=' + config.imsid + '&autosend=1&userId=' + config.userId + '&robotCode=' + config.robotCode + '&deviceType=' + deviceType;

    window[id] = img;
    img.onload = img.onerror = function () {
      window[id] = null;
    };
    if (isImmediate) {
      img.setAttribute('src', src);
    } else {
      setTimeout(function () {
        img.setAttribute('src', src);
      }, 500);
    }
  },
  perfLog: function perfLog(data) {
    if (window.performance && window.performance.now) {
      var time = performance.now();
      this.send({
        c: data.c,
        d: data.d,
        ext: JSON.stringify({
          time: time
        })
      }, true);
    }
  },
  setLog: function setLog(data) {
    config = data;
  },
  getConfig: function getConfig() {
    return config;
  },
  liveAgent: function liveAgent(e) {
    this.send({
      c: 'knowledge',
      d: 'gomanual',
      ext: e
    });
  }
};

exports.default = Log;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["Smiley"] = factory();else root["Smiley"] = factory();
})(undefined, function () {
	return function (modules) {
		var installedModules = {};

		function __webpack_require__(moduleId) {
			if (installedModules[moduleId]) return installedModules[moduleId].exports;

			var module = installedModules[moduleId] = { exports: {},
				id: moduleId,
				loaded: false
			};

			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

			module.loaded = true;

			return module.exports;
		}

		__webpack_require__.m = modules;

		__webpack_require__.c = installedModules;

		__webpack_require__.p = "";

		return __webpack_require__(0);
	}([function (module, exports, __webpack_require__) {

		'use strict';

		var _slicedToArray = function () {
			function sliceIterator(arr, i) {
				var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
					for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
						_arr.push(_s.value);if (i && _arr.length === i) break;
					}
				} catch (err) {
					_d = true;_e = err;
				} finally {
					try {
						if (!_n && _i["return"]) _i["return"]();
					} finally {
						if (_d) throw _e;
					}
				}return _arr;
			}return function (arr, i) {
				if (Array.isArray(arr)) {
					return arr;
				} else if (Symbol.iterator in Object(arr)) {
					return sliceIterator(arr, i);
				} else {
					throw new TypeError("Invalid attempt to destructure non-iterable instance");
				}
			};
		}();

		var _map = __webpack_require__(1);

		var CDN_HOST = '//g.alicdn.com/crm/static/0.5.1/';

		var GIF_SUPPORT_LIST = ['xm'];

		var LARGE_SUPPORT_LIST = ['xm', 'wx'];

		var GIF_EXT = '.gif';

		var EXT_MAP = {
			ww: '.png',
			xm: '.png',
			wx: '.png'
		};

		var SMILEY_MAP = {
			ww: toMap(_map.WW_SMILEY.concat(_map.WW_BLACKLIST), 'ww'),
			xm: toMap(_map.XM_SMILEY.concat(_map.XM_BLACKLIST), 'xm'),
			wx: toMap(_map.WX_SMILEY, 'wx')
		};

		function toMap(arr, prefix) {
			return arr.reduce(function (map, item) {
				var _item = _slicedToArray(item, 2),
				    code = _item[0],
				    word = _item[1];

				map[word] = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix];
				return map;
			}, {});
		}

		function toArrayWithURL(arr, prefix) {
			return arr.map(function (item) {
				var _item2 = _slicedToArray(item, 2),
				    code = _item2[0],
				    word = _item2[1];

				var url = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix];
				return [word, url];
			});
		}

		function urlToImg(url, text) {
			return '<img alt="' + text + '" src="' + url + '">';
		}

		function getURL(prefix, word) {
			var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'small';

			var map = SMILEY_MAP[prefix];
			if (!map) return;

			var url = map[word];
			if (!url) return;

			if (~GIF_SUPPORT_LIST.indexOf(prefix)) {
				var ext = EXT_MAP[prefix].replace('.', '');
				url = url.replace(new RegExp('\\.' + ext + '$'), GIF_EXT);
			}

			if (size === 'large' && ~LARGE_SUPPORT_LIST.indexOf(prefix)) {
				url = url.replace(new RegExp('(' + prefix + '/\\d{3})'), '$1@2x');
			}
			return url;
		}

		function toImage(str) {
			var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';

			var reg = /\[(\w{2}:)?([^\]]+)\]/gm;
			if (!reg.test(str)) return str;
			return toText(str).replace(reg, function (text) {
				var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ww';
				var word = arguments[2];

				prefix = prefix.replace(':', '');
				var url = getURL(prefix, word, size);
				return url ? urlToImg(url, text) : text;
			});
		}

		function toText(str) {
			var reg = /<img alt=["'](\[(\w{2}:)?([^\]]+)\])["'][^>]+>/gm;
			if (!reg.test(str)) return str;
			return str.replace(reg, function (matched, text, prefix, word) {
				return text;
			});
		}

		var WANG_WANG = toArrayWithURL(_map.WW_SMILEY, 'ww');
		var XIAO_MI = toArrayWithURL(_map.XM_SMILEY, 'xm');
		var WAN_XIANG = toArrayWithURL(_map.WX_SMILEY, 'wx');

		module.exports = {
			WANG_WANG: WANG_WANG,
			XIAO_MI: XIAO_MI,
			WAN_XIANG: WAN_XIANG,
			toImage: toImage,
			toText: toText
		};
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var WW_SMILEY = exports.WW_SMILEY = [['001', 'smile_emoji'], ['002', 'shy_emoji'], ['003', 'tongue_emoji'], ['047', 'sadness_emoji'], ['024', 'goodbye_emoji'], ['030', 'confused_emoji'], ['009', 'comfort_emoji'], ['008', 'air_kiss_emoji'], ['023', 'angel_emoji'], ['054', 'goodbye_with_tears_emoji'], ['005', 'love_emoji'], ['011', 'come_on_emoji'], ['040', 'giggle_emoji'], ['036', 'wronged_emoji'], ['048', 'aggrieved_emoji'], ['049', 'sob_emoji'], ['050', 'break_into_tears_emoji'], ['051', 'cry_emoji'], ['053', 'sorry_emoji'], ['070', 'waiter_emoji'], ['069', 'Kung_Hei_Fat_Choi_emoji'], ['067', 'Fortuna_emoji'], ['010', 'hug_emoji'], ['085', 'rose_emoji'], ['087', 'sweetheart_emoji'], ['078', 'beautiful_lady_emoji'], ['079', 'handsome_emoji'], ['012', 'victory_emoji'], ['081', 'deal_emoji'], ['082', 'applaud_emoji'], ['083', 'shake hands_emoji'], ['031', 'wondering_emoji'], ['042', 'helpless_emoji'], ['013', 'good_emoji'], ['007', 'dancing_emoji'], ['017', 'search_emoji'], ['026', 'enjoying_emoji'], ['004', 'snicker_emoji'], ['021', 'good_idea_emoji'], ['025', 'slobber_emoji'], ['016', 'toothy_laugh_emoji'], ['043', 'sweating_emoji'], ['028', 'transfixed_emoji'], ['055', 'frown_emoji'], ['037', 'shaking_head_emoji'], ['019', 'afterwards_emoji'], ['014', 'kiss_emoji'], ['015', 'anthomaniac_emoji'], ['018', 'calling_emoji'], ['029', 'thinking_emoji'], ['006', 'laughing_emoji'], ['035', 'shhh_emoji'], ['060', 'surprise_emoji'], ['061', 'consternation_emoji'], ['066', 'mad_emoji'], ['071', 'boss_emoji'], ['068', 'learn_from_Lei_Feng_emoji'], ['088', 'heart_breaking_emoji'], ['080', 'Lucky_Cat_emoji'], ['084', 'red_lips_emoji'], ['094', 'cheers_emoji'], ['089', 'money_emoji'], ['097', 'too_late_emoji'], ['091', 'gift_emoji'], ['090', 'shopping_emoji'], ['096', 'waiting_emoji'], ['095', 'clock_emoji']];

		var WW_BLACKLIST = exports.WW_BLACKLIST = [['020', 'miser_emoji'], ['022', 'grimace_emoji'], ['027', 'erotic_emoji'], ['032', 'no_money_emoji'], ['033', 'boring_emoji'], ['034', 'doubt_emoji'], ['038', 'cold_emoji'], ['039', 'awkward_emoji'], ['041', 'no_way_emoji'], ['044', 'desolate_emoji'], ['045', 'sleepy_emoji'], ['046', 'gosh_emoji'], ['052', 'I_give_up_emoji'], ['056', 'too_tired_emoji'], ['058', 'threw_up_emoji'], ['059', 'recite_emoji'], ['062', 'shut_up_emoji'], ['063', 'owe_flat_emoji'], ['064', 'despise_you_emoji'], ['065', 'furious_emoji'], ['072', 'evil_emoji'], ['073', 'solo_emoji'], ['074', 'CS_emoji'], ['075', 'invisible_man_emoji'], ['076', 'bomb_emoji'], ['077', 'screaming_emoji'], ['086', 'residual_flowers_emoji'], ['092', 'email_emoji'], ['093', 'phone_call_emoji'], ['098', 'airplane_emoji'], ['099', 'Alipay_emoji']];

		var XM_SMILEY = exports.XM_SMILEY = [['001', '打招呼'], ['002', '唱歌'], ['003', '打屁屁'], ['006', '开心'], ['007', '可怜'], ['010', '么么哒'], ['011', '帅'], ['012', '送花'], ['013', '微笑'], ['014', '委屈'], ['016', '再见'], ['017', 'OK']];

		var XM_BLACKLIST = exports.XM_BLACKLIST = [['004', '愤怒'], ['005', '惊吓'], ['008', '抠鼻'], ['009', '冷漠'], ['015', '怨念']];

		var WX_SMILEY = exports.WX_SMILEY = [['001', '开心极了'], ['002', '爱你哟'], ['003', '加油喔'], ['004', '厉害啦'], ['005', 'Goodbye'], ['006', '送你花'], ['007', '羞羞脸'], ['008', '桑心了'], ['009', '看我的'], ['010', '谢谢你'], ['011', '怎么破'], ['012', '交给我吧'], ['013', '燥起来'], ['014', '天啦噜'], ['015', 'OK'], ['016', '让我瞅瞅'], ['017', '么么哒'], ['018', '灵感来啦'], ['019', '给你点赞'], ['020', '好好学习'], ['021', '拼一拼'], ['022', '可怜兮兮'], ['023', 'Sorry啦'], ['024', '撒花咯']];
	}]);
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (window, document, Math) {
	var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
		window.setTimeout(callback, 1000 / 60);
	};

	var utils = function () {
		var me = {};

		var _elementStyle = document.createElement('div').style;
		var _vendor = function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			    transform,
			    i = 0,
			    l = vendors.length;

			for (; i < l; i++) {
				transform = vendors[i] + 'ransform';
				if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
			}

			return false;
		}();

		function _prefixStyle(style) {
			if (_vendor === false) return false;
			if (_vendor === '') return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}

		me.getTime = Date.now || function getTime() {
			return new Date().getTime();
		};

		me.extend = function (target, obj) {
			for (var i in obj) {
				target[i] = obj[i];
			}
		};

		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};

		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};

		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8) : pointerEvent;
		};

		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
			    speed = Math.abs(distance) / time,
			    destination,
			    duration;

			deceleration = deceleration === undefined ? 0.0006 : deceleration;

			destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
			duration = speed / deceleration;

			if (destination < lowerMargin) {
				destination = wrapperSize ? lowerMargin - wrapperSize / 2.5 * (speed / 8) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if (destination > 0) {
				destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}

			return {
				destination: Math.round(destination),
				duration: duration
			};
		};

		var _transform = _prefixStyle('transform');

		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent),
			hasTransition: _prefixStyle('transition') in _elementStyle
		});

		me.isBadAndroid = function () {
			var appVersion = window.navigator.appVersion;

			if (/Android/.test(appVersion) && !/Chrome\/\d/.test(appVersion)) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if (safariVersion && (typeof safariVersion === 'undefined' ? 'undefined' : _typeof(safariVersion)) === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}();

		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin')
		});

		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};

		me.addClass = function (e, c) {
			if (me.hasClass(e, c)) {
				return;
			}

			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};

		me.removeClass = function (e, c) {
			if (!me.hasClass(e, c)) {
				return;
			}

			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};

		me.offset = function (el) {
			var left = -el.offsetLeft,
			    top = -el.offsetTop;

			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}


			return {
				left: left,
				top: top
			};
		};

		me.preventDefaultException = function (el, exceptions) {
			for (var i in exceptions) {
				if (exceptions[i].test(el[i])) {
					return true;
				}
			}

			return false;
		};

		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,

			mousedown: 2,
			mousemove: 2,
			mouseup: 2,

			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,

			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});

		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function fn(k) {
					return k * (2 - k);
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',
				fn: function fn(k) {
					return Math.sqrt(1 - --k * k);
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function fn(k) {
					var b = 4;
					return (k = k - 1) * k * ((b + 1) * k + b) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function fn(k) {
					if ((k /= 1) < 1 / 2.75) {
						return 7.5625 * k * k;
					} else if (k < 2 / 2.75) {
						return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
					} else if (k < 2.5 / 2.75) {
						return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
					} else {
						return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function fn(k) {
					var f = 0.22,
					    e = 0.4;

					if (k === 0) {
						return 0;
					}
					if (k == 1) {
						return 1;
					}

					return e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1;
				}
			}
		});

		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};

		me.click = function (e) {
			var target = e.target,
			    ev;

			if (!/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {
				ev = document.createEvent('MouseEvents');
				ev.initMouseEvent('click', true, true, e.view, 1, target.screenX, target.screenY, target.clientX, target.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, 0, null);

				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};

		return me;
	}();
	function IScroll(el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style;

		this.options = {

			resizeScrollbars: true,

			mouseWheelSpeed: 20,

			snapThreshold: 0.334,

			disablePointer: !utils.hasPointer,
			disableTouch: utils.hasPointer || !utils.hasTouch,
			disableMouse: utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,

			bounce: true,
			bounceTime: 600,
			bounceEasing: '',

			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;

		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

		if (this.options.tap === true) {
			this.options.tap = 'tap';
		}

		if (this.options.shrinkScrollbars == 'scale') {
			this.options.useTransition = false;
		}

		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};

		this._init();
		this.refresh();

		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}

	IScroll.prototype = {
		version: '5.2.0',

		_init: function _init() {
			this._initEvents();

			if (this.options.scrollbars || this.options.indicators) {
				this._initIndicators();
			}

			if (this.options.mouseWheel) {
				this._initWheel();
			}

			if (this.options.snap) {
				this._initSnap();
			}

			if (this.options.keyBindings) {
				this._initKeys();
			}
		},

		destroy: function destroy() {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = null;
			this._execEvent('destroy');
		},

		_transitionEnd: function _transitionEnd(e) {
			if (e.target != this.scroller || !this.isInTransition) {
				return;
			}

			this._transitionTime();
			if (!this.resetPosition(this.options.bounceTime)) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},

		_start: function _start(e) {
			if (utils.eventType[e.type] != 1) {
				var button;
				if (!e.which) {
					button = e.button < 2 ? 0 : e.button == 4 ? 1 : 2;
				} else {
					button = e.button;
				}
				if (button !== 0) {
					return;
				}
			}

			if (!this.enabled || this.initiated && utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    pos;

			this.initiated = utils.eventType[e.type];
			this.moved = false;
			this.distX = 0;
			this.distY = 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;

			this.startTime = utils.getTime();

			if (this.options.useTransition && this.isInTransition) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if (!this.options.useTransition && this.isAnimating) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}

			this.startX = this.x;
			this.startY = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault) {
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    deltaX = point.pageX - this.pointX,
			    deltaY = point.pageY - this.pointY,
			    timestamp = utils.getTime(),
			    newX,
			    newY,
			    absDistX,
			    absDistY;

			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this.distX += deltaX;
			this.distY += deltaY;
			absDistX = Math.abs(this.distX);
			absDistY = Math.abs(this.distY);

			if (timestamp - this.endTime > 300 && absDistX < 10 && absDistY < 10) {
				return;
			}

			if (!this.directionLocked && !this.options.freeScroll) {
				if (absDistX > absDistY + this.options.directionLockThreshold) {
					this.directionLocked = 'h';
				} else if (absDistY >= absDistX + this.options.directionLockThreshold) {
					this.directionLocked = 'v';
				} else {
					this.directionLocked = 'n';
				}
			}

			if (this.directionLocked == 'h') {
				if (this.options.eventPassthrough == 'vertical') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'horizontal') {
					this.initiated = false;
					return;
				}

				deltaY = 0;
			} else if (this.directionLocked == 'v') {
				if (this.options.eventPassthrough == 'horizontal') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'vertical') {
					this.initiated = false;
					return;
				}

				deltaX = 0;
			}

			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			if (newX > 0 || newX < this.maxScrollX) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if (newY > 0 || newY < this.maxScrollY) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}

			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

			if (!this.moved) {
				this._execEvent('scrollStart');
			}

			this.moved = true;

			this._translate(newX, newY);

			if (timestamp - this.startTime > 300) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;
			}
		},

		_end: function _end(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.changedTouches ? e.changedTouches[0] : e,
			    momentumX,
			    momentumY,
			    duration = utils.getTime() - this.startTime,
			    newX = Math.round(this.x),
			    newY = Math.round(this.y),
			    distanceX = Math.abs(newX - this.startX),
			    distanceY = Math.abs(newY - this.startY),
			    time = 0,
			    easing = '';

			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();

			if (this.resetPosition(this.options.bounceTime)) {
				return;
			}

			this.scrollTo(newX, newY);
			if (!this.moved) {
				if (this.options.tap) {
					utils.tap(e, this.options.tap);
				}

				if (this.options.click) {
					utils.click(e);
				}

				this._execEvent('scrollCancel');
				return;
			}

			if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
				this._execEvent('flick');
				return;
			}

			if (this.options.momentum && duration < 300) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}

			if (this.options.snap) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
				newX = snap.x;
				newY = snap.y;

				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}

			if (newX != this.x || newY != this.y) {
				if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
					easing = utils.ease.quadratic;
				}

				this.scrollTo(newX, newY, time, easing);
				return;
			}

			this._execEvent('scrollEnd');
		},

		_resize: function _resize() {
			var that = this;

			clearTimeout(this.resizeTimeout);

			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},

		resetPosition: function resetPosition(time) {
			var x = this.x,
			    y = this.y;

			time = time || 0;

			if (!this.hasHorizontalScroll || this.x > 0) {
				x = 0;
			} else if (this.x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (!this.hasVerticalScroll || this.y > 0) {
				y = 0;
			} else if (this.y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			if (x == this.x && y == this.y) {
				return false;
			}

			this.scrollTo(x, y, time, this.options.bounceEasing);

			return true;
		},

		disable: function disable() {
			this.enabled = false;
		},

		enable: function enable() {
			this.enabled = true;
		},

		refresh: function refresh() {
			var rf = this.wrapper.offsetHeight;

			this.wrapperWidth = this.wrapper.clientWidth;
			this.wrapperHeight = this.wrapper.clientHeight;

			this.scrollerWidth = this.scroller.offsetWidth;
			this.scrollerHeight = this.scroller.offsetHeight;

			this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

			this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

			if (!this.hasHorizontalScroll) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}

			if (!this.hasVerticalScroll) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}

			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;

			this.wrapperOffset = utils.offset(this.wrapper);

			this._execEvent('refresh');

			this.resetPosition();
		},

		on: function on(type, fn) {
			if (!this._events[type]) {
				this._events[type] = [];
			}

			this._events[type].push(fn);
		},

		off: function off(type, fn) {
			if (!this._events[type]) {
				return;
			}

			var index = this._events[type].indexOf(fn);

			if (index > -1) {
				this._events[type].splice(index, 1);
			}
		},

		_execEvent: function _execEvent(type) {
			if (!this._events[type]) {
				return;
			}

			var i = 0,
			    l = this._events[type].length;

			if (!l) {
				return;
			}

			for (; i < l; i++) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},

		scrollBy: function scrollBy(x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;

			this.scrollTo(x, y, time, easing);
		},

		scrollTo: function scrollTo(x, y, time, easing) {
			easing = easing || utils.ease.circular;

			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if (!time || transitionType) {
				if (transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},

		scrollToElement: function scrollToElement(el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);

			if (!el) {
				return;
			}

			var pos = utils.offset(el);

			pos.left -= this.wrapperOffset.left;
			pos.top -= this.wrapperOffset.top;

			if (offsetX === true) {
				offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
			}
			if (offsetY === true) {
				offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
			}

			pos.left -= offsetX || 0;
			pos.top -= offsetY || 0;

			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

			this.scrollTo(pos.left, pos.top, time, easing);
		},

		_transitionTime: function _transitionTime(time) {
			time = time || 0;

			var durationProp = utils.style.transitionDuration;
			this.scrollerStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.scrollerStyle[durationProp] = '0.0001ms';

				var self = this;
				rAF(function () {
					if (self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTime(time);
				}
			}
		},

		_transitionTimingFunction: function _transitionTimingFunction(easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}
		},

		_translate: function _translate(x, y) {
			if (this.options.useTransform) {

				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}

			this.x = x;
			this.y = y;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].updatePosition();
				}
			}
		},

		_initEvents: function _initEvents(remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
			    target = this.options.bindToWrapper ? this.wrapper : window;

			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);

			if (this.options.click) {
				eventType(this.wrapper, 'click', this, true);
			}

			if (!this.options.disableMouse) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}

			if (utils.hasPointer && !this.options.disablePointer) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}

			if (utils.hasTouch && !this.options.disableTouch) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}

			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},

		getComputedPosition: function getComputedPosition() {
			var matrix = window.getComputedStyle(this.scroller, null),
			    x,
			    y;

			if (this.options.useTransform) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}

			return { x: x, y: y };
		},
		_initIndicators: function _initIndicators() {
			var interactive = this.options.interactiveScrollbars,
			    customStyle = typeof this.options.scrollbars != 'string',
			    indicators = [],
			    indicator;

			var that = this;

			this.indicators = [];

			if (this.options.scrollbars) {
				if (this.options.scrollY) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}

				if (this.options.scrollX) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}

			if (this.options.indicators) {
				indicators = indicators.concat(this.options.indicators);
			}

			for (var i = indicators.length; i--;) {
				this.indicators.push(new Indicator(this, indicators[i]));
			}

			function _indicatorsMap(fn) {
				if (that.indicators) {
					for (var i = that.indicators.length; i--;) {
						fn.call(that.indicators[i]);
					}
				}
			}

			if (this.options.fadeScrollbars) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});

				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}

			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});

			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});

				delete this.indicators;
			});
		},

		_initWheel: function _initWheel() {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},

		_wheel: function _wheel(e) {
			if (!this.enabled) {
				return;
			}

			e.preventDefault();

			var wheelDeltaX,
			    wheelDeltaY,
			    newX,
			    newY,
			    that = this;

			if (this.wheelTimeout === undefined) {
				that._execEvent('scrollStart');
			}

			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if (!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);

			if ('deltaX' in e) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ('wheelDeltaX' in e) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ('wheelDelta' in e) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ('detail' in e) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}

			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;

			if (!this.hasVerticalScroll) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}

			if (this.options.snap) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;

				if (wheelDeltaX > 0) {
					newX--;
				} else if (wheelDeltaX < 0) {
					newX++;
				}

				if (wheelDeltaY > 0) {
					newY--;
				} else if (wheelDeltaY < 0) {
					newY++;
				}

				this.goToPage(newX, newY);

				return;
			}

			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

			if (newX > 0) {
				newX = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
			}

			if (newY > 0) {
				newY = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
			}

			this.scrollTo(newX, newY, 0);
		},

		_initSnap: function _initSnap() {
			this.currentPage = {};

			if (typeof this.options.snap == 'string') {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}

			this.on('refresh', function () {
				var i = 0,
				    l,
				    m = 0,
				    n,
				    cx,
				    cy,
				    x = 0,
				    y,
				    stepX = this.options.snapStepX || this.wrapperWidth,
				    stepY = this.options.snapStepY || this.wrapperHeight,
				    el;

				this.pages = [];

				if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
					return;
				}

				if (this.options.snap === true) {
					cx = Math.round(stepX / 2);
					cy = Math.round(stepY / 2);

					while (x > -this.scrollerWidth) {
						this.pages[i] = [];
						l = 0;
						y = 0;

						while (y > -this.scrollerHeight) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};

							y -= stepY;
							l++;
						}

						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;

					for (; i < l; i++) {
						if (i === 0 || el[i].offsetLeft <= el[i - 1].offsetLeft) {
							m = 0;
							n++;
						}

						if (!this.pages[m]) {
							this.pages[m] = [];
						}

						x = Math.max(-el[i].offsetLeft, this.maxScrollX);
						y = Math.max(-el[i].offsetTop, this.maxScrollY);
						cx = x - Math.round(el[i].offsetWidth / 2);
						cy = y - Math.round(el[i].offsetHeight / 2);

						this.pages[m][n] = {
							x: x,
							y: y,
							width: el[i].offsetWidth,
							height: el[i].offsetHeight,
							cx: cx,
							cy: cy
						};

						if (x > this.maxScrollX) {
							m++;
						}
					}
				}

				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

				if (this.options.snapThreshold % 1 === 0) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});

			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.x - this.startX), 1000), Math.min(Math.abs(this.y - this.startY), 1000)), 300);

				this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, time);
			});
		},

		_nearestSnap: function _nearestSnap(x, y) {
			if (!this.pages.length) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}

			var i = 0,
			    l = this.pages.length,
			    m = 0;

			if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
				return this.currentPage;
			}

			if (x > 0) {
				x = 0;
			} else if (x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (y > 0) {
				y = 0;
			} else if (y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			for (; i < l; i++) {
				if (x >= this.pages[i][0].cx) {
					x = this.pages[i][0].x;
					break;
				}
			}

			l = this.pages[i].length;

			for (; m < l; m++) {
				if (y >= this.pages[0][m].cy) {
					y = this.pages[0][m].y;
					break;
				}
			}

			if (i == this.currentPage.pageX) {
				i += this.directionX;

				if (i < 0) {
					i = 0;
				} else if (i >= this.pages.length) {
					i = this.pages.length - 1;
				}

				x = this.pages[i][0].x;
			}

			if (m == this.currentPage.pageY) {
				m += this.directionY;

				if (m < 0) {
					m = 0;
				} else if (m >= this.pages[0].length) {
					m = this.pages[0].length - 1;
				}

				y = this.pages[0][m].y;
			}

			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},

		goToPage: function goToPage(x, y, time, easing) {
			easing = easing || this.options.bounceEasing;

			if (x >= this.pages.length) {
				x = this.pages.length - 1;
			} else if (x < 0) {
				x = 0;
			}

			if (y >= this.pages[x].length) {
				y = this.pages[x].length - 1;
			} else if (y < 0) {
				y = 0;
			}

			var posX = this.pages[x][y].x,
			    posY = this.pages[x][y].y;

			time = time === undefined ? this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};

			this.scrollTo(posX, posY, time, easing);
		},

		next: function next(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x++;

			if (x >= this.pages.length && this.hasVerticalScroll) {
				x = 0;
				y++;
			}

			this.goToPage(x, y, time, easing);
		},

		prev: function prev(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x--;

			if (x < 0 && this.hasVerticalScroll) {
				x = 0;
				y--;
			}

			this.goToPage(x, y, time, easing);
		},

		_initKeys: function _initKeys(e) {
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;

			if (_typeof(this.options.keyBindings) == 'object') {
				for (i in this.options.keyBindings) {
					if (typeof this.options.keyBindings[i] == 'string') {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}

			for (i in keys) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}

			utils.addEvent(window, 'keydown', this);

			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},

		_key: function _key(e) {
			if (!this.enabled) {
				return;
			}

			var snap = this.options.snap,
			    newX = snap ? this.currentPage.pageX : this.x,
			    newY = snap ? this.currentPage.pageY : this.y,
			    now = utils.getTime(),
			    prevTime = this.keyTime || 0,
			    acceleration = 0.250,
			    pos;

			if (this.options.useTransition && this.isInTransition) {
				pos = this.getComputedPosition();

				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}

			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

			switch (e.keyCode) {
				case this.options.keyBindings.pageUp:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length - 1 : this.maxScrollX;
					newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				default:
					return;
			}

			if (snap) {
				this.goToPage(newX, newY);
				return;
			}

			if (newX > 0) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}

			if (newY > 0) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}

			this.scrollTo(newX, newY, 0);

			this.keyTime = now;
		},

		_animate: function _animate(destX, destY, duration, easingFn) {
			var that = this,
			    startX = this.x,
			    startY = this.y,
			    startTime = utils.getTime(),
			    destTime = startTime + duration;

			function step() {
				var now = utils.getTime(),
				    newX,
				    newY,
				    easing;

				if (now >= destTime) {
					that.isAnimating = false;
					that._translate(destX, destY);

					if (!that.resetPosition(that.options.bounceTime)) {
						that._execEvent('scrollEnd');
					}

					return;
				}

				now = (now - startTime) / duration;
				easing = easingFn(now);
				newX = (destX - startX) * easing + startX;
				newY = (destY - startY) * easing + startY;
				that._translate(newX, newY);

				if (that.isAnimating) {
					rAF(step);
				}
			}

			this.isAnimating = true;
			step();
		},
		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if (this.enabled && !e._constructed) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar(direction, interactive, type) {
		var scrollbar = document.createElement('div'),
		    indicator = document.createElement('div');

		if (type === true) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}

		indicator.className = 'iScrollIndicator';

		if (direction == 'h') {
			if (type === true) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if (type === true) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}

		scrollbar.style.cssText += ';overflow:hidden';

		if (!interactive) {
			scrollbar.style.pointerEvents = 'none';
		}

		scrollbar.appendChild(indicator);

		return scrollbar;
	}

	function Indicator(scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;

		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;

		if (this.options.interactive) {
			if (!this.options.disableTouch) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}

		if (this.options.fade) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';

			var self = this;
			if (utils.isBadAndroid) {
				rAF(function () {
					if (self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}

	Indicator.prototype = {
		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},

		destroy: function destroy() {
			if (this.options.fadeScrollbars) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if (this.options.interactive) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);

				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);

				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}

			if (this.options.defaultScrollbars) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},

		_start: function _start(e) {
			var point = e.touches ? e.touches[0] : e;

			e.preventDefault();
			e.stopPropagation();

			this.transitionTime();

			this.initiated = true;
			this.moved = false;
			this.lastPointX = point.pageX;
			this.lastPointY = point.pageY;

			this.startTime = utils.getTime();

			if (!this.options.disableTouch) {
				utils.addEvent(window, 'touchmove', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(window, 'mousemove', this);
			}

			this.scroller._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			var point = e.touches ? e.touches[0] : e,
			    deltaX,
			    deltaY,
			    newX,
			    newY,
			    timestamp = utils.getTime();

			if (!this.moved) {
				this.scroller._execEvent('scrollStart');
			}

			this.moved = true;

			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;

			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			this._pos(newX, newY);

			e.preventDefault();
			e.stopPropagation();
		},

		_end: function _end(e) {
			if (!this.initiated) {
				return;
			}

			this.initiated = false;

			e.preventDefault();
			e.stopPropagation();

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			if (this.scroller.options.snap) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

				if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}

			if (this.moved) {
				this.scroller._execEvent('scrollEnd');
			}
		},

		transitionTime: function transitionTime(time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			this.indicatorStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.indicatorStyle[durationProp] = '0.0001ms';

				var self = this;
				rAF(function () {
					if (self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},

		transitionTimingFunction: function transitionTimingFunction(easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},

		refresh: function refresh() {
			this.transitionTime();

			if (this.options.listenX && !this.options.listenY) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if (this.options.listenY && !this.options.listenX) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}

			if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}

			var r = this.wrapper.offsetHeight;

			if (this.options.listenX) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if (this.options.resize) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}

				this.maxPosX = this.wrapperWidth - this.indicatorWidth;

				if (this.options.shrink == 'clip') {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}

				this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX;
			}

			if (this.options.listenY) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if (this.options.resize) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;

				if (this.options.shrink == 'clip') {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY;
			}

			this.updatePosition();
		},

		updatePosition: function updatePosition() {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			    y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

			if (!this.options.ignoreBoundaries) {
				if (x < this.minBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if (x > this.maxBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}

				if (y < this.minBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if (y > this.maxBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}

			this.x = x;
			this.y = y;

			if (this.scroller.options.useTransform) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},

		_pos: function _pos(x, y) {
			if (x < 0) {
				x = 0;
			} else if (x > this.maxPosX) {
				x = this.maxPosX;
			}

			if (y < 0) {
				y = 0;
			} else if (y > this.maxPosY) {
				y = this.maxPosY;
			}

			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

			this.scroller.scrollTo(x, y);
		},

		fade: function fade(val, hold) {
			if (hold && !this.visible) {
				return;
			}

			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;

			var time = val ? 250 : 500,
			    delay = val ? 0 : 300;

			val = val ? '1' : '0';

			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

			this.fadeTimeout = setTimeout(function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}.bind(this, val), delay);
		}
	};

	IScroll.utils = utils;

	if (typeof module != 'undefined' && module.exports) {
		module.exports = IScroll;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return IScroll;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
})(window, document, Math);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(133);
exports.encode = exports.stringify = __webpack_require__(134);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var apply = Function.prototype.apply;

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(window, this._id);
};

exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

__webpack_require__(147);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (window, document, Math) {
	var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
		window.setTimeout(callback, 1000 / 60);
	};

	var utils = function () {
		var me = {};

		var _elementStyle = document.createElement('div').style;
		var _vendor = function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			    transform,
			    i = 0,
			    l = vendors.length;

			for (; i < l; i++) {
				transform = vendors[i] + 'ransform';
				if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
			}

			return false;
		}();

		function _prefixStyle(style) {
			if (_vendor === false) return false;
			if (_vendor === '') return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}

		me.getTime = Date.now || function getTime() {
			return new Date().getTime();
		};

		me.extend = function (target, obj) {
			for (var i in obj) {
				target[i] = obj[i];
			}
		};

		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};

		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};

		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8) : pointerEvent;
		};

		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
			    speed = Math.abs(distance) / time,
			    destination,
			    duration;

			deceleration = deceleration === undefined ? 0.0006 : deceleration;

			destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
			duration = speed / deceleration;

			if (destination < lowerMargin) {
				destination = wrapperSize ? lowerMargin - wrapperSize / 2.5 * (speed / 8) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if (destination > 0) {
				destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}

			return {
				destination: Math.round(destination),
				duration: duration
			};
		};

		var _transform = _prefixStyle('transform');

		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent),
			hasTransition: _prefixStyle('transition') in _elementStyle
		});

		me.isBadAndroid = function () {
			var appVersion = window.navigator.appVersion;

			if (/Android/.test(appVersion) && !/Chrome\/\d/.test(appVersion)) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if (safariVersion && (typeof safariVersion === 'undefined' ? 'undefined' : _typeof(safariVersion)) === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}();

		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin')
		});

		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};

		me.addClass = function (e, c) {
			if (me.hasClass(e, c)) {
				return;
			}

			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};

		me.removeClass = function (e, c) {
			if (!me.hasClass(e, c)) {
				return;
			}

			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};

		me.offset = function (el) {
			var left = -el.offsetLeft,
			    top = -el.offsetTop;

			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}


			return {
				left: left,
				top: top
			};
		};

		me.preventDefaultException = function (el, exceptions) {
			for (var i in exceptions) {
				if (exceptions[i].test(el[i])) {
					return true;
				}
			}

			return false;
		};

		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,

			mousedown: 2,
			mousemove: 2,
			mouseup: 2,

			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,

			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});

		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function fn(k) {
					return k * (2 - k);
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',
				fn: function fn(k) {
					return Math.sqrt(1 - --k * k);
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function fn(k) {
					var b = 4;
					return (k = k - 1) * k * ((b + 1) * k + b) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function fn(k) {
					if ((k /= 1) < 1 / 2.75) {
						return 7.5625 * k * k;
					} else if (k < 2 / 2.75) {
						return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
					} else if (k < 2.5 / 2.75) {
						return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
					} else {
						return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function fn(k) {
					var f = 0.22,
					    e = 0.4;

					if (k === 0) {
						return 0;
					}
					if (k == 1) {
						return 1;
					}

					return e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1;
				}
			}
		});

		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};

		me.click = function (e) {
			var target = e.target,
			    ev;

			if (!/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {
				ev = document.createEvent('MouseEvents');
				ev.initMouseEvent('click', true, true, e.view, 1, target.screenX, target.screenY, target.clientX, target.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, 0, null);

				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};

		return me;
	}();
	function IScroll(el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style;

		this.options = {

			resizeScrollbars: true,

			mouseWheelSpeed: 20,

			snapThreshold: 0.334,

			disablePointer: !utils.hasPointer,
			disableTouch: utils.hasPointer || !utils.hasTouch,
			disableMouse: utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,

			bounce: true,
			bounceTime: 600,
			bounceEasing: '',

			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;

		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

		if (this.options.tap === true) {
			this.options.tap = 'tap';
		}

		if (this.options.shrinkScrollbars == 'scale') {
			this.options.useTransition = false;
		}

		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

		if (this.options.probeType == 3) {
			this.options.useTransition = false;
		}

		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};

		this._init();
		this.refresh();

		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}

	IScroll.prototype = {
		version: '5.2.0',

		_init: function _init() {
			this._initEvents();

			if (this.options.scrollbars || this.options.indicators) {
				this._initIndicators();
			}

			if (this.options.mouseWheel) {
				this._initWheel();
			}

			if (this.options.snap) {
				this._initSnap();
			}

			if (this.options.keyBindings) {
				this._initKeys();
			}
		},

		destroy: function destroy() {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = null;
			this._execEvent('destroy');
		},

		_transitionEnd: function _transitionEnd(e) {
			if (e.target != this.scroller || !this.isInTransition) {
				return;
			}

			this._transitionTime();
			if (!this.resetPosition(this.options.bounceTime)) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},

		_start: function _start(e) {
			if (utils.eventType[e.type] != 1) {
				var button;
				if (!e.which) {
					button = e.button < 2 ? 0 : e.button == 4 ? 1 : 2;
				} else {
					button = e.button;
				}
				if (button !== 0) {
					return;
				}
			}

			if (!this.enabled || this.initiated && utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    pos;

			this.initiated = utils.eventType[e.type];
			this.moved = false;
			this.distX = 0;
			this.distY = 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;

			this.startTime = utils.getTime();

			if (this.options.useTransition && this.isInTransition) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if (!this.options.useTransition && this.isAnimating) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}

			this.startX = this.x;
			this.startY = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault) {
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    deltaX = point.pageX - this.pointX,
			    deltaY = point.pageY - this.pointY,
			    timestamp = utils.getTime(),
			    newX,
			    newY,
			    absDistX,
			    absDistY;

			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this.distX += deltaX;
			this.distY += deltaY;
			absDistX = Math.abs(this.distX);
			absDistY = Math.abs(this.distY);

			if (timestamp - this.endTime > 300 && absDistX < 10 && absDistY < 10) {
				return;
			}

			if (!this.directionLocked && !this.options.freeScroll) {
				if (absDistX > absDistY + this.options.directionLockThreshold) {
					this.directionLocked = 'h';
				} else if (absDistY >= absDistX + this.options.directionLockThreshold) {
					this.directionLocked = 'v';
				} else {
					this.directionLocked = 'n';
				}
			}

			if (this.directionLocked == 'h') {
				if (this.options.eventPassthrough == 'vertical') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'horizontal') {
					this.initiated = false;
					return;
				}

				deltaY = 0;
			} else if (this.directionLocked == 'v') {
				if (this.options.eventPassthrough == 'horizontal') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'vertical') {
					this.initiated = false;
					return;
				}

				deltaX = 0;
			}

			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			if (newX > 0 || newX < this.maxScrollX) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if (newY > 0 || newY < this.maxScrollY) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}

			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

			if (!this.moved) {
				this._execEvent('scrollStart');
			}

			this.moved = true;

			this._translate(newX, newY);

			if (timestamp - this.startTime > 300) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;

				if (this.options.probeType == 1) {
					this._execEvent('scroll');
				}
			}

			if (this.options.probeType > 1) {
				this._execEvent('scroll');
			}
		},

		_end: function _end(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.changedTouches ? e.changedTouches[0] : e,
			    momentumX,
			    momentumY,
			    duration = utils.getTime() - this.startTime,
			    newX = Math.round(this.x),
			    newY = Math.round(this.y),
			    distanceX = Math.abs(newX - this.startX),
			    distanceY = Math.abs(newY - this.startY),
			    time = 0,
			    easing = '';

			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();

			if (this.resetPosition(this.options.bounceTime)) {
				return;
			}

			this.scrollTo(newX, newY);
			if (!this.moved) {
				if (this.options.tap) {
					utils.tap(e, this.options.tap);
				}

				if (this.options.click) {
					utils.click(e);
				}

				this._execEvent('scrollCancel');
				return;
			}

			if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
				this._execEvent('flick');
				return;
			}

			if (this.options.momentum && duration < 300) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}

			if (this.options.snap) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
				newX = snap.x;
				newY = snap.y;

				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}

			if (newX != this.x || newY != this.y) {
				if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
					easing = utils.ease.quadratic;
				}

				this.scrollTo(newX, newY, time, easing);
				return;
			}

			this._execEvent('scrollEnd');
		},

		_resize: function _resize() {
			var that = this;

			clearTimeout(this.resizeTimeout);

			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},

		resetPosition: function resetPosition(time) {
			var x = this.x,
			    y = this.y;

			time = time || 0;

			if (!this.hasHorizontalScroll || this.x > 0) {
				x = 0;
			} else if (this.x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (!this.hasVerticalScroll || this.y > 0) {
				y = 0;
			} else if (this.y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			if (x == this.x && y == this.y) {
				return false;
			}

			this.scrollTo(x, y, time, this.options.bounceEasing);

			return true;
		},

		disable: function disable() {
			this.enabled = false;
		},

		enable: function enable() {
			this.enabled = true;
		},

		refresh: function refresh() {
			var rf = this.wrapper.offsetHeight;

			this.wrapperWidth = this.wrapper.clientWidth;
			this.wrapperHeight = this.wrapper.clientHeight;

			this.scrollerWidth = this.scroller.offsetWidth;
			this.scrollerHeight = this.scroller.offsetHeight;

			this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

			this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

			if (!this.hasHorizontalScroll) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}

			if (!this.hasVerticalScroll) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}

			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;

			this.wrapperOffset = utils.offset(this.wrapper);

			this._execEvent('refresh');

			this.resetPosition();
		},

		on: function on(type, fn) {
			if (!this._events[type]) {
				this._events[type] = [];
			}

			this._events[type].push(fn);
		},

		off: function off(type, fn) {
			if (!this._events[type]) {
				return;
			}

			var index = this._events[type].indexOf(fn);

			if (index > -1) {
				this._events[type].splice(index, 1);
			}
		},

		_execEvent: function _execEvent(type) {
			if (!this._events[type]) {
				return;
			}

			var i = 0,
			    l = this._events[type].length;

			if (!l) {
				return;
			}

			for (; i < l; i++) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},

		scrollBy: function scrollBy(x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;

			this.scrollTo(x, y, time, easing);
		},

		scrollTo: function scrollTo(x, y, time, easing) {
			easing = easing || utils.ease.circular;

			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if (!time || transitionType) {
				if (transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},

		scrollToElement: function scrollToElement(el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);

			if (!el) {
				return;
			}

			var pos = utils.offset(el);

			pos.left -= this.wrapperOffset.left;
			pos.top -= this.wrapperOffset.top;

			if (offsetX === true) {
				offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
			}
			if (offsetY === true) {
				offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
			}

			pos.left -= offsetX || 0;
			pos.top -= offsetY || 0;

			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

			this.scrollTo(pos.left, pos.top, time, easing);
		},

		_transitionTime: function _transitionTime(time) {
			time = time || 0;

			var durationProp = utils.style.transitionDuration;
			this.scrollerStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.scrollerStyle[durationProp] = '0.0001ms';

				var self = this;
				rAF(function () {
					if (self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTime(time);
				}
			}
		},

		_transitionTimingFunction: function _transitionTimingFunction(easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}
		},

		_translate: function _translate(x, y) {
			if (this.options.useTransform) {

				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}

			this.x = x;
			this.y = y;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].updatePosition();
				}
			}
		},

		_initEvents: function _initEvents(remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
			    target = this.options.bindToWrapper ? this.wrapper : window;

			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);

			if (this.options.click) {
				eventType(this.wrapper, 'click', this, true);
			}

			if (!this.options.disableMouse) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}

			if (utils.hasPointer && !this.options.disablePointer) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}

			if (utils.hasTouch && !this.options.disableTouch) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}

			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},

		getComputedPosition: function getComputedPosition() {
			var matrix = window.getComputedStyle(this.scroller, null),
			    x,
			    y;

			if (this.options.useTransform) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}

			return { x: x, y: y };
		},
		_initIndicators: function _initIndicators() {
			var interactive = this.options.interactiveScrollbars,
			    customStyle = typeof this.options.scrollbars != 'string',
			    indicators = [],
			    indicator;

			var that = this;

			this.indicators = [];

			if (this.options.scrollbars) {
				if (this.options.scrollY) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}

				if (this.options.scrollX) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}

			if (this.options.indicators) {
				indicators = indicators.concat(this.options.indicators);
			}

			for (var i = indicators.length; i--;) {
				this.indicators.push(new Indicator(this, indicators[i]));
			}

			function _indicatorsMap(fn) {
				if (that.indicators) {
					for (var i = that.indicators.length; i--;) {
						fn.call(that.indicators[i]);
					}
				}
			}

			if (this.options.fadeScrollbars) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});

				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}

			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});

			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});

				delete this.indicators;
			});
		},

		_initWheel: function _initWheel() {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},

		_wheel: function _wheel(e) {
			if (!this.enabled) {
				return;
			}

			e.preventDefault();

			var wheelDeltaX,
			    wheelDeltaY,
			    newX,
			    newY,
			    that = this;

			if (this.wheelTimeout === undefined) {
				that._execEvent('scrollStart');
			}

			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if (!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);

			if ('deltaX' in e) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ('wheelDeltaX' in e) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ('wheelDelta' in e) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ('detail' in e) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}

			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;

			if (!this.hasVerticalScroll) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}

			if (this.options.snap) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;

				if (wheelDeltaX > 0) {
					newX--;
				} else if (wheelDeltaX < 0) {
					newX++;
				}

				if (wheelDeltaY > 0) {
					newY--;
				} else if (wheelDeltaY < 0) {
					newY++;
				}

				this.goToPage(newX, newY);

				return;
			}

			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

			if (newX > 0) {
				newX = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
			}

			if (newY > 0) {
				newY = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
			}

			this.scrollTo(newX, newY, 0);

			if (this.options.probeType > 1) {
				this._execEvent('scroll');
			}
		},

		_initSnap: function _initSnap() {
			this.currentPage = {};

			if (typeof this.options.snap == 'string') {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}

			this.on('refresh', function () {
				var i = 0,
				    l,
				    m = 0,
				    n,
				    cx,
				    cy,
				    x = 0,
				    y,
				    stepX = this.options.snapStepX || this.wrapperWidth,
				    stepY = this.options.snapStepY || this.wrapperHeight,
				    el;

				this.pages = [];

				if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
					return;
				}

				if (this.options.snap === true) {
					cx = Math.round(stepX / 2);
					cy = Math.round(stepY / 2);

					while (x > -this.scrollerWidth) {
						this.pages[i] = [];
						l = 0;
						y = 0;

						while (y > -this.scrollerHeight) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};

							y -= stepY;
							l++;
						}

						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;

					for (; i < l; i++) {
						if (i === 0 || el[i].offsetLeft <= el[i - 1].offsetLeft) {
							m = 0;
							n++;
						}

						if (!this.pages[m]) {
							this.pages[m] = [];
						}

						x = Math.max(-el[i].offsetLeft, this.maxScrollX);
						y = Math.max(-el[i].offsetTop, this.maxScrollY);
						cx = x - Math.round(el[i].offsetWidth / 2);
						cy = y - Math.round(el[i].offsetHeight / 2);

						this.pages[m][n] = {
							x: x,
							y: y,
							width: el[i].offsetWidth,
							height: el[i].offsetHeight,
							cx: cx,
							cy: cy
						};

						if (x > this.maxScrollX) {
							m++;
						}
					}
				}

				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

				if (this.options.snapThreshold % 1 === 0) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});

			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.x - this.startX), 1000), Math.min(Math.abs(this.y - this.startY), 1000)), 300);

				this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, time);
			});
		},

		_nearestSnap: function _nearestSnap(x, y) {
			if (!this.pages.length) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}

			var i = 0,
			    l = this.pages.length,
			    m = 0;

			if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
				return this.currentPage;
			}

			if (x > 0) {
				x = 0;
			} else if (x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (y > 0) {
				y = 0;
			} else if (y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			for (; i < l; i++) {
				if (x >= this.pages[i][0].cx) {
					x = this.pages[i][0].x;
					break;
				}
			}

			l = this.pages[i].length;

			for (; m < l; m++) {
				if (y >= this.pages[0][m].cy) {
					y = this.pages[0][m].y;
					break;
				}
			}

			if (i == this.currentPage.pageX) {
				i += this.directionX;

				if (i < 0) {
					i = 0;
				} else if (i >= this.pages.length) {
					i = this.pages.length - 1;
				}

				x = this.pages[i][0].x;
			}

			if (m == this.currentPage.pageY) {
				m += this.directionY;

				if (m < 0) {
					m = 0;
				} else if (m >= this.pages[0].length) {
					m = this.pages[0].length - 1;
				}

				y = this.pages[0][m].y;
			}

			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},

		goToPage: function goToPage(x, y, time, easing) {
			easing = easing || this.options.bounceEasing;

			if (x >= this.pages.length) {
				x = this.pages.length - 1;
			} else if (x < 0) {
				x = 0;
			}

			if (y >= this.pages[x].length) {
				y = this.pages[x].length - 1;
			} else if (y < 0) {
				y = 0;
			}

			var posX = this.pages[x][y].x,
			    posY = this.pages[x][y].y;

			time = time === undefined ? this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};

			this.scrollTo(posX, posY, time, easing);
		},

		next: function next(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x++;

			if (x >= this.pages.length && this.hasVerticalScroll) {
				x = 0;
				y++;
			}

			this.goToPage(x, y, time, easing);
		},

		prev: function prev(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x--;

			if (x < 0 && this.hasVerticalScroll) {
				x = 0;
				y--;
			}

			this.goToPage(x, y, time, easing);
		},

		_initKeys: function _initKeys(e) {
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;

			if (_typeof(this.options.keyBindings) == 'object') {
				for (i in this.options.keyBindings) {
					if (typeof this.options.keyBindings[i] == 'string') {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}

			for (i in keys) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}

			utils.addEvent(window, 'keydown', this);

			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},

		_key: function _key(e) {
			if (!this.enabled) {
				return;
			}

			var snap = this.options.snap,
			    newX = snap ? this.currentPage.pageX : this.x,
			    newY = snap ? this.currentPage.pageY : this.y,
			    now = utils.getTime(),
			    prevTime = this.keyTime || 0,
			    acceleration = 0.250,
			    pos;

			if (this.options.useTransition && this.isInTransition) {
				pos = this.getComputedPosition();

				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}

			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

			switch (e.keyCode) {
				case this.options.keyBindings.pageUp:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length - 1 : this.maxScrollX;
					newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				default:
					return;
			}

			if (snap) {
				this.goToPage(newX, newY);
				return;
			}

			if (newX > 0) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}

			if (newY > 0) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}

			this.scrollTo(newX, newY, 0);

			this.keyTime = now;
		},

		_animate: function _animate(destX, destY, duration, easingFn) {
			var that = this,
			    startX = this.x,
			    startY = this.y,
			    startTime = utils.getTime(),
			    destTime = startTime + duration;

			function step() {
				var now = utils.getTime(),
				    newX,
				    newY,
				    easing;

				if (now >= destTime) {
					that.isAnimating = false;
					that._translate(destX, destY);

					if (!that.resetPosition(that.options.bounceTime)) {
						that._execEvent('scrollEnd');
					}

					return;
				}

				now = (now - startTime) / duration;
				easing = easingFn(now);
				newX = (destX - startX) * easing + startX;
				newY = (destY - startY) * easing + startY;
				that._translate(newX, newY);

				if (that.isAnimating) {
					rAF(step);
				}

				if (that.options.probeType == 3) {
					that._execEvent('scroll');
				}
			}

			this.isAnimating = true;
			step();
		},

		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if (this.enabled && !e._constructed) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar(direction, interactive, type) {
		var scrollbar = document.createElement('div'),
		    indicator = document.createElement('div');

		if (type === true) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}

		indicator.className = 'iScrollIndicator';

		if (direction == 'h') {
			if (type === true) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if (type === true) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}

		scrollbar.style.cssText += ';overflow:hidden';

		if (!interactive) {
			scrollbar.style.pointerEvents = 'none';
		}

		scrollbar.appendChild(indicator);

		return scrollbar;
	}

	function Indicator(scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;

		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;

		if (this.options.interactive) {
			if (!this.options.disableTouch) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}

		if (this.options.fade) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';

			var self = this;
			if (utils.isBadAndroid) {
				rAF(function () {
					if (self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}

	Indicator.prototype = {
		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},

		destroy: function destroy() {
			if (this.options.fadeScrollbars) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if (this.options.interactive) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);

				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);

				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}

			if (this.options.defaultScrollbars) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},

		_start: function _start(e) {
			var point = e.touches ? e.touches[0] : e;

			e.preventDefault();
			e.stopPropagation();

			this.transitionTime();

			this.initiated = true;
			this.moved = false;
			this.lastPointX = point.pageX;
			this.lastPointY = point.pageY;

			this.startTime = utils.getTime();

			if (!this.options.disableTouch) {
				utils.addEvent(window, 'touchmove', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(window, 'mousemove', this);
			}

			this.scroller._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			var point = e.touches ? e.touches[0] : e,
			    deltaX,
			    deltaY,
			    newX,
			    newY,
			    timestamp = utils.getTime();

			if (!this.moved) {
				this.scroller._execEvent('scrollStart');
			}

			this.moved = true;

			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;

			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			this._pos(newX, newY);

			if (this.scroller.options.probeType == 1 && timestamp - this.startTime > 300) {
				this.startTime = timestamp;
				this.scroller._execEvent('scroll');
			} else if (this.scroller.options.probeType > 1) {
				this.scroller._execEvent('scroll');
			}

			e.preventDefault();
			e.stopPropagation();
		},

		_end: function _end(e) {
			if (!this.initiated) {
				return;
			}

			this.initiated = false;

			e.preventDefault();
			e.stopPropagation();

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			if (this.scroller.options.snap) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

				if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}

			if (this.moved) {
				this.scroller._execEvent('scrollEnd');
			}
		},

		transitionTime: function transitionTime(time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			this.indicatorStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.indicatorStyle[durationProp] = '0.0001ms';

				var self = this;
				rAF(function () {
					if (self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},

		transitionTimingFunction: function transitionTimingFunction(easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},

		refresh: function refresh() {
			this.transitionTime();

			if (this.options.listenX && !this.options.listenY) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if (this.options.listenY && !this.options.listenX) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}

			if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}

			var r = this.wrapper.offsetHeight;

			if (this.options.listenX) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if (this.options.resize) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}

				this.maxPosX = this.wrapperWidth - this.indicatorWidth;

				if (this.options.shrink == 'clip') {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}

				this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX;
			}

			if (this.options.listenY) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if (this.options.resize) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;

				if (this.options.shrink == 'clip') {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY;
			}

			this.updatePosition();
		},

		updatePosition: function updatePosition() {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			    y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

			if (!this.options.ignoreBoundaries) {
				if (x < this.minBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if (x > this.maxBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}

				if (y < this.minBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if (y > this.maxBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}

			this.x = x;
			this.y = y;

			if (this.scroller.options.useTransform) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},

		_pos: function _pos(x, y) {
			if (x < 0) {
				x = 0;
			} else if (x > this.maxPosX) {
				x = this.maxPosX;
			}

			if (y < 0) {
				y = 0;
			} else if (y > this.maxPosY) {
				y = this.maxPosY;
			}

			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

			this.scroller.scrollTo(x, y);
		},

		fade: function fade(val, hold) {
			if (hold && !this.visible) {
				return;
			}

			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;

			var time = val ? 250 : 500,
			    delay = val ? 0 : 300;

			val = val ? '1' : '0';

			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

			this.fadeTimeout = setTimeout(function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}.bind(this, val), delay);
		}
	};

	IScroll.utils = utils;

	if (typeof module != 'undefined' && module.exports) {
		module.exports = IScroll;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return IScroll;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
})(window, document, Math);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function isPM(input) {
            return (/^nm$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: '\'n paar sekondes',
            m: '\'n minuut',
            mm: '%d minute',
            h: '\'n uur',
            hh: '%d ure',
            d: '\'n dag',
            dd: '%d dae',
            M: '\'n maand',
            MM: '%d maande',
            y: '\'n jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return af;
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    };
    var numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };
    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    };
    var plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    };
    var pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    };
    var months = ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6,
            doy: 12 }
    });

    return ar;
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var arDz = moment.defineLocale('ar-dz', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0,
            doy: 4 }
    });

    return arDz;
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0,
            doy: 12 }
    });

    return arKw;
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    };
    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    };
    var plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    };
    var pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    };
    var months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/\u200f/g, '').replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6,
            doy: 12 }
    });

    return arLy;
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 6,
            doy: 12 }
    });

    return arMa;
});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    };
    var numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return arSa;
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return arTn;
});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'birneçə saniyyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function isPM(input) {
            return (/^(gündüz|axşam)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return az;
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function nextWeek() {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function isPM(input) {
            return (/^(дня|вечара)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return be;
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дни',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return bg;
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    };
    var numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return bn;
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    };
    var numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ'
        },
        preparse: function preparse(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return bo;
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h[e]mm A',
            LTS: 'h[e]mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warc\'hoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Dec\'h da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s \'zo',
            s: 'un nebeud segondennoù',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return br;
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return bs;
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: '[el] D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: '[el] D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: '[el] dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function nextDay() {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'd\'aquí %s',
            past: 'fa %s',
            s: 'uns segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return ca;
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
    var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'm':
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsParse: function (months, monthsShort) {
            var i,
                _monthsParse = [];
            for (i = 0; i < 12; i++) {
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort),
        shortMonthsParse: function (monthsShort) {
            var i,
                _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort),
        longMonthsParse: function (months) {
            var i,
                _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months),
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return cs;
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1,
            doy: 7 }
    });

    return cv;
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,

        ordinal: function ordinal(number) {
            var b = number,
                output = '',
                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed'];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed';
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return cy;
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return da;
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return de;
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return deAt;
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH.mm',
            LLLL: 'dddd, D. MMMM YYYY HH.mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return deCh;
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'];
    var weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {

            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM: function isPM(input) {
            return 'މފ' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7,
            doy: 12 }
    });

    return dv;
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) {
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function isPM(input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L'
        },
        calendar: function calendar(key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1,
            doy: 4 }
    });

    return el;
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return enAu;
});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return enGb;
});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return enIe;
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return enNz;
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D[-a de] MMMM, YYYY',
            LLL: 'D[-a de] MMMM, YYYY HH:mm',
            LLLL: 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function isPM(input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd [je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasinta] dddd [je] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'sekundoj',
            m: 'minuto',
            mm: '%d minutoj',
            h: 'horo',
            hh: '%d horoj',
            d: 'tago',
            dd: '%d tagoj',
            M: 'monato',
            MM: '%d monatoj',
            y: 'jaro',
            yy: '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1,
            doy: 7 }
    });

    return eo;
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return es;
});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return esDo;
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'm': ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h': ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd': ['ühe päeva', 'üks päev'],
            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y': ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return et;
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return eu;
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    };
    var numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function isPM(input) {
            return (/بعد از ظهر/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6,
            doy: 12 }
    });

    return fa;
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
    var numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return fi;
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            m: 'ein minutt',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaði',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return fo;
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return fr;
});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return frCh;
});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return fy;
});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return gd;
});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function lastDay() {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return gl;
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' hor'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 4 },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function hh(number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function dd(number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function MM(number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function yy(number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function isPM(input) {
            return (/^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;
});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return hi;
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return hr;
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number,
            suffix;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function isPM(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function nextWeek() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function lastWeek() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return hu;
});

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function nextWeek() {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function lastWeek() {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function isPM(input) {
            return (/^(ցերեկվա|երեկոյան)$/.test(input)
            );
        },
        meridiem: function meridiem(hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return hyAm;
});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return id;
});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return is;
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: 'un\'ora',
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return it;
});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ja = moment.defineLocale('ja', {
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 HH:mm dddd',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日 HH:mm dddd'
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(input) {
            return input === '午後';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: '[来週]dddd LT',
            lastDay: '[昨日] LT',
            lastWeek: '[前週]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年'
        }
    });

    return ja;
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return jv;
});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ka = moment.defineLocale('ka', {
        months: {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში'
                );
            },
            past: function past(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის უკან');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის უკან');
                }
            },
            s: 'რამდენიმე წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7
        }
    });

    return ka;
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return kk;
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return km;
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    };
    var numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ'
        },
        preparse: function preparse(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function ordinal(number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return kn;
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년'
        },
        dayOfMonthOrdinalParse: /\d{1,2}일/,
        ordinal: '%d일',
        meridiemParse: /오전|오후/,
        isPM: function isPM(token) {
            return token === '오후';
        },
        meridiem: function meridiem(hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;
});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кече саат] LT',
            lastWeek: '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return ky;
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }

    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            return true;
        } else if (number < 10) {
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return lb;
});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function isPM(input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function ordinal(number) {
            return 'ທີ່' + number;
        }
    });

    return lo;
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var units = {
        'm': 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h': 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd': 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M': 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y': 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function ordinal(number) {
            return number + '-oji';
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return lt;
});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var units = {
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };

    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return lv;
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var translator = {
        words: {
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return me;
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return mi;
});

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'после %s',
            past: 'пред %s',
            s: 'неколку секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            M: 'месец',
            MM: '%d месеци',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return mk;
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;
});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';break;
                case 'm':
                    output = 'एक मिनिट';break;
                case 'mm':
                    output = '%d मिनिटे';break;
                case 'h':
                    output = 'एक तास';break;
                case 'hh':
                    output = '%d तास';break;
                case 'd':
                    output = 'एक दिवस';break;
                case 'dd':
                    output = '%d दिवस';break;
                case 'M':
                    output = 'एक महिना';break;
                case 'MM':
                    output = '%d महिने';break;
                case 'y':
                    output = 'एक वर्ष';break;
                case 'yy':
                    output = '%d वर्षे';break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';break;
                case 'm':
                    output = 'एका मिनिटा';break;
                case 'mm':
                    output = '%d मिनिटां';break;
                case 'h':
                    output = 'एका तासा';break;
                case 'hh':
                    output = '%d तासां';break;
                case 'd':
                    output = 'एका दिवसा';break;
                case 'dd':
                    output = '%d दिवसां';break;
                case 'M':
                    output = 'एका महिन्या';break;
                case 'MM':
                    output = '%d महिन्यां';break;
                case 'y':
                    output = 'एका वर्षा';break;
                case 'yy':
                    output = '%d वर्षां';break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return mr;
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return ms;
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return msMy;
});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    };
    var numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function preparse(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return my;
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return nb;
});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष'
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return ne;
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return nl;
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return nlBe;
});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return nn;
});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    };
    var numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ'
        },
        preparse: function preparse(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return paIn;
});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
    var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: '[W] dddd [o] LT',
            lastDay: '[Wczoraj o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return pl;
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var pt = moment.defineLocale('pt', {
        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : '[Última] dddd [às] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1,
            doy: 4 }
    });

    return pt;
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ptBr = moment.defineLocale('pt-br', {
        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : '[Última] dddd [às] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: '%s atrás',
            s: 'poucos segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº'
    });

    return ptBr;
});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
            separator = ' ';
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return ro;
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort: {
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сегодня в] LT',
            nextDay: '[Завтра в] LT',
            lastDay: '[Вчера в] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            lastWeek: function lastWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(input) {
            return (/^(дня|вечера)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return ru;
});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'];
    var days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return sd;
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return se;
});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function ordinal(number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function isPM(input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;
});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
    var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'm':
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy':
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return sk;
});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return sl;
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function isPM(input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return sq;
});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var translator = {
        words: {
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return sr;
});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var translator = {
        words: {
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 7 }
    });

    return srCyrl;
});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1,
            doy: 4 }
    });

    return ss;
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return sv;
});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'masiku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return sw;
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    };
    var numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function ordinal(number) {
            return number + 'வது';
        },
        preparse: function preparse(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';
            } else if (hour < 10) {
                return ' காலை';
            } else if (hour < 14) {
                return ' நண்பகல்';
            } else if (hour < 18) {
                return ' எற்பாடு';
            } else if (hour < 22) {
                return ' மாலை';
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return ta;
});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0,
            doy: 6 }
    });

    return te;
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'minutu balun',
            m: 'minutu ida',
            mm: 'minutus %d',
            h: 'horas ida',
            hh: 'horas %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return tet;
});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function isPM(input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี'
        }
    });

    return th;
});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return tlPh;
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100),
            ten = Math.floor(number % 100 / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    return tlh;
});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[haftaya] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen hafta] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl'
        },
        dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number + '\'ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return tr;
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function isPM(input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4 }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }

    return tzl;
});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week: {
            dow: 6,
            doy: 12 }
    });

    return tzm;
});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
        },
        week: {
            dow: 6,
            doy: 12 }
    });

    return tzmLatn;
});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural
        },

        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(input) {
            return (/^(дня|вечора)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return uk;
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'];
    var days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return ur;
});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return uz;
});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
        },
        week: {
            dow: 1,
            doy: 7 }
    });

    return uzLatn;
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function isPM(input) {
            return (/^ch$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return vi;
});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return xPseudo;
});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d'
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1,
            doy: 4 }
    });

    return yo;
});

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日Ah点mm分',
            LLLL: 'YYYY年MMMD日ddddAh点mm分',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s内',
            past: '%s前',
            s: '几秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
        },
        week: {
            dow: 1,
            doy: 4 }
    });

    return zhCn;
});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日 HH:mm',
            LLLL: 'YYYY年MMMD日dddd HH:mm',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhHk;
});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日 HH:mm',
            LLLL: 'YYYY年MMMD日dddd HH:mm',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhTw;
});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;

  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v === 'undefined' ? 'undefined' : _typeof(v)) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _app = __webpack_require__(136);

var _app2 = _interopRequireDefault(_app);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _log = __webpack_require__(12);

var _log2 = _interopRequireDefault(_log);

var _lang = __webpack_require__(299);

var _lang2 = _interopRequireDefault(_lang);

var _assets = __webpack_require__(300);

__webpack_require__(301);

var _mockConfig2 = __webpack_require__(302);

var _mockConfig3 = _interopRequireDefault(_mockConfig2);

var _formatappconfig = __webpack_require__(303);

var _eventbus = __webpack_require__(9);

var _eventbus2 = _interopRequireDefault(_eventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mebot = function (_events) {
  _inherits(Mebot, _events);

  function Mebot(options) {
    _classCallCheck(this, Mebot);

    var _this = _possibleConstructorReturn(this, (Mebot.__proto__ || Object.getPrototypeOf(Mebot)).call(this, options));

    _this.qs = _util2.default.queryString.parse(location.search.substring(1));
    _this.options = options;

    _this.model = _this.initModel(options);
    (0, _assets.getScript)('//g.alicdn.com/crm/alicare-animation/0.0.3/AlicareAni.js', function () {});
    return _this;
  }

  _createClass(Mebot, [{
    key: 'start',
    value: function start() {
      var config = (0, _formatappconfig.appConfigFormat)(this.options.config);
      this.appConfig = config;
      this.initApp(config);
    }
  }, {
    key: 'initApp',
    value: function initApp(config) {
      var _this2 = this;

      _util2.default.lang.resetLang(this.options.lang || _lang2.default);
      var app = new _app2.default({
        param: this.options.param,
        log: _log2.default,
        model: this.model,
        appConfig: config,
        env: _util2.default.getEnvironment(),
        container: this.options.container ? this.options.container : document.body,
        essentials: this.options,
        lang: this.options.lang
      });

      this.app = app;

      app.start();

      _eventbus2.default.emit('ready', config);

      _eventbus2.default.on('login', function (e) {
        _this2.emit('login', e);
        _log2.default.send({
          c: 'event',
          d: 'login'
        });
      });

      _eventbus2.default.on('liveAgent', function (e) {
        _this2.emit('liveAgent', { imSid: app.param.imSid || config.get('base').imsid });
        _log2.default.liveAgent(e);
      });

      _eventbus2.default.on('sessionExpired', function () {
        _this2.emit('sessionExpired');
        _log2.default.send({
          c: 'event',
          d: 'sessionExpired'
        });
      });

      _eventbus2.default.on('cancelResult', function (e) {
        _this2.emit('cancelResult', e);
        _log2.default.send({
          c: 'event',
          d: 'cancelResult'
        });
      });

      _eventbus2.default.on('bankTransfer', function (e) {
        _this2.emit('bankTransfer', e);
        _log2.default.send({
          c: 'event',
          d: 'bankTransfer'
        });
      });

      if (!_util2.default.isPC()) {
        this.initLog(config);
      }
    }
  }, {
    key: 'mockConfig',
    value: function mockConfig() {
      return new Promise(function (resolve) {
        resolve((0, _formatappconfig.appConfigFormat)(_mockConfig3.default));
      });
    }
  }, {
    key: 'initModel',
    value: function initModel(options) {
      var qs = this.qs;
      var model = options.model;

      if (qs.portalType === 'guest') {
        model.authCode = qs.authCode;
      }

      return model;
    }
  }, {
    key: 'feedback',
    value: function feedback(e) {
      this.app.sendMsg({ q: 'test', ext: { botJson: JSON.stringify(e.action) } }, 'text', false);
    }
  }, {
    key: 'robotMock',
    value: function robotMock(msg) {
      this.app.appendMessage({
        type: 'robot',
        body: {
          text: msg || 'What else can I help you with?'
        }
      });
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.app.view.body.scrollToBottom();
    }
  }, {
    key: 'initLog',
    value: function initLog(config) {
      var defaultConfig = {
        from: config.get('base').from || 'lazada',
        userId: config.get('user').userId,
        memberType: config.get('user').memberType,
        imsid: config.get('base').imsid,
        type: 'dingding_channel',
        robotCode: config.get('robot').robotCode
      };
      _log2.default.setLog(defaultConfig);
      _log2.default.send({
        c: 'mebot',
        d: 'show',
        ext: defaultConfig
      }, true);
    }
  }, {
    key: 'pvLog',
    value: function pvLog() {
      var config = this.appConfig;
      var defaultConfig = {
        from: config.get('base').from || 'lazada',
        userId: config.get('user').userId,
        memberType: config.get('user').memberType,
        imsid: config.get('base').imsid,
        type: 'dingding_channel',
        robotCode: config.get('robot').robotCode
      };
      _log2.default.setLog(defaultConfig);
      _log2.default.send({
        c: 'mebot',
        d: 'show',
        ext: defaultConfig
      }, true);
    }
  }]);

  return Mebot;
}(_events3.default);

exports.default = Mebot;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _pipeline = __webpack_require__(137);

var _pipeline2 = _interopRequireDefault(_pipeline);

var _channel = __webpack_require__(143);

var _channel2 = _interopRequireDefault(_channel);

var _context = __webpack_require__(156);

var _context2 = _interopRequireDefault(_context);

var _view = __webpack_require__(157);

var _view2 = _interopRequireDefault(_view);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _app_events = __webpack_require__(198);

var _app_events2 = _interopRequireDefault(_app_events);

var _eventbus = __webpack_require__(9);

var _eventbus2 = _interopRequireDefault(_eventbus);

var _module = __webpack_require__(199);

var _module2 = _interopRequireDefault(_module);

var _shortcuts = __webpack_require__(200);

var _shortcuts2 = _interopRequireDefault(_shortcuts);

var _customUI = __webpack_require__(205);

var _customUI2 = _interopRequireDefault(_customUI);

var _index = __webpack_require__(208);

var _index2 = _interopRequireDefault(_index);

var _snap = __webpack_require__(213);

var _snap2 = _interopRequireDefault(_snap);

var _index3 = __webpack_require__(217);

var _index4 = _interopRequireDefault(_index3);

var _extension = __webpack_require__(228);

var _extension2 = _interopRequireDefault(_extension);

__webpack_require__(295);

__webpack_require__(297);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APP = function (_events) {
  _inherits(APP, _events);

  function APP(config) {
    _classCallCheck(this, APP);

    var _this = _possibleConstructorReturn(this, (APP.__proto__ || Object.getPrototypeOf(APP)).call(this, config));

    _this.model = config.model;

    _this.env = config.env;

    _this.isWebp = _util2.default.detectWebp();

    _this.bridge = config.bridge;

    _this.log = config.log;

    _this.appConfig = config.appConfig;

    _this.param = config.param;

    _this.listeners = [];

    _this.essentials = config.essentials;

    _this.view = _this.initView();

    _this.channel = _this.channel();

    _this.eventBus = _eventbus2.default;

    _this.chatUuid = null;

    _this.liveAgent = {};

    (0, _context2.default)(_this);
    (0, _module2.default)(_this);
    (0, _extension2.default)(_this);
    return _this;
  }

  _createClass(APP, [{
    key: 'register',
    value: function register(key, fn) {
      _pipeline2.default.register(key, fn);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(data) {
      return _pipeline2.default.push(data, this);
    }
  }, {
    key: 'initView',
    value: function initView() {
      var isExternalUI = true;
      var view = new _view2.default({
        isExternalUI: isExternalUI,
        log: this.log,
        bridge: this.bridge,
        container: this.essentials.container,
        appConfig: this.param
      });

      this.isExternalUI = isExternalUI;

      this.emit(this.events.AFTER_VIEW_READY);
      view.on('pull', function () {});
      return view;
    }
  }, {
    key: 'channel',
    value: function channel() {
      var _this2 = this;

      var channel = new _channel2.default(this);

      this.on(this.events.CHANNEL_OCS_OFFLINE, function (data) {
        if (data.closeReasonType === '0' || String(data.closeReasonType) === '2' && String(data.closeReasonDetail) === '10') {
          var appConfig = _this2.appConfig;

          var _appConfig$get = appConfig.get('base'),
              appName = _appConfig$get.appName,
              imsid = _appConfig$get.imsid;

          var actionTips = appConfig.get('ocs').actionTips;
          var memberType = appConfig.get('user').memberType;
          var tip = actionTips && actionTips.afterComment && actionTips.afterComment.tip || '';
          _this2.appendMessage({
            type: 'rate',
            body: {
              memberType: memberType,
              appName: appName,
              imsid: imsid,
              tip: tip,
              sid: data.sid,
              serviceUserId: data.serviceUserId,
              servicerName: data.servicerName
            }
          });
        }
        channel.switchToRobot();
      });

      return channel;
    }
  }, {
    key: 'start',
    value: function start() {
      var _this3 = this;

      var tasks = [];

      tasks.push(function (app, done) {
        _this3.welcomeMsg();
        done();
      });

      tasks.push(_snap2.default);

      tasks.push(_customUI2.default);

      if (this.param.greetingType === 'banner') {
        tasks.push(_index2.default);
      }

      tasks.push(_shortcuts2.default);

      tasks.push(_index4.default);

      if (this.appConfig.get('ocs').isNeedResume) {
        tasks.push(function (app, done) {
          app.channel.ocs.resume();
          app.channel.curRole = 'ocs';
          done();
        });
      } else {
        tasks.push(function (app, done) {
          app.channel.switchToRobot();
          done();
        });
      }

      _util2.default.waterfall(tasks, this).then(function () {
        _this3.emit(_this3.events.APP_READY);
      }, function (err) {
        console.log(err);
        console.log('app load fail');
      });

      this.parseMessages();
      this.urlLogic();
      this.bindOperationEvents();
    }
  }, {
    key: 'welcomeMsg',
    value: function welcomeMsg() {
      var appConfig = this.appConfig;
      var qs = appConfig.get('qs');
      var session = appConfig.get('ocs');
      var config = appConfig.get('appConfig');

      if (session.continuedResume) {
        this.appendMessage({
          type: 'robot',
          body: {
            isFollow: false,
            text: this.util.lang.get('OSP:WELCOME:CONTINUE')
          }
        });
      } else if (config.welcomeMsg && !qs.attemptquery && !session.isNeedResume && !qs.bizOrderId && !qs.bizId && !qs.orderId && !qs.ggOrderId && !qs.postorderId) {
        this.appendMessage({
          type: 'welcomemsg',
          body: {
            isFollow: false,
            text: config.welcomeMsg
          }
        });
      }
    }
  }, {
    key: 'parseMessages',
    value: function parseMessages() {
      var _this4 = this;

      var appConfig = this.appConfig;
      var messages = appConfig.get('messages') || [];
      messages.forEach(function (t) {
        _this4.appendMessage({
          type: t.type,
          body: t.data
        });
      });
    }
  }, {
    key: 'urlLogic',
    value: function urlLogic() {
      var appConfig = this.appConfig;
      var qs = appConfig.get('qs');
      var session = appConfig.get('ocs');
      var onedata = appConfig.get('onedata');
      if (qs.type === 'connect') {
        if (qs.bizType) {
          this.channel.robot.bizType = qs.bizType;
        }

        if (qs.bizOrderId || qs.bizId) {
          this.view.footer.submit({
            q: qs.bizOrderId || qs.bizId,
            subType: 'connect'
          });
        } else {
          this.channel.robot.subType = 'connect';
        }
      }

      if (qs.attemptquery && !session.isNeedResume) {
        this.view.footer.submit(_util2.default.htmlEncodeAll(qs.attemptquery));
      }

      if (onedata && onedata.showtype && !session.isNeedResume) {
        this.appendMessage({
          type: 'order',
          body: {
            onedata: onedata
          }
        });
        var d = onedata.params[0];
        this.view.footer.submit(d.idStr || String(d.id), d.type, false);
      }
      if (qs.question) {
        this.view.footer.setTipText(qs.question);
      }
    }
  }, {
    key: 'initOrderFunc',
    value: function initOrderFunc() {}
  }, {
    key: 'bindOperationEvents',
    value: function bindOperationEvents() {
      var _this5 = this;

      var $container = this.view.body.$container;
      var footer = this.view.footer;
      $container.delegate('.J_HookSendText', 'tap', function (ev) {
        var $target = $(ev.currentTarget);
        footer.submit($target.text());
      });
      $container.delegate('.J_HookShare', 'tap', function (ev) {
        var $target = $(ev.currentTarget);
        _this5.bridge.share({
          title: $target.attr('data-title'),
          text: $target.attr('data-text'),
          url: $target.attr('data-url'),
          image: $target.attr('data-image')
        });
      });
      $container.delegate('.J_HookSelectOrder', 'tap', function () {
        _this5.orderList.show({
          source: 'robot'
        });
      });
    }
  }, {
    key: 'addListener',
    value: function addListener(key, fn) {
      this.listeners.push({ key: key, fn: fn });
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _this6 = this;

      var ls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var keys = Object.keys(ls);
      keys.forEach(function (key) {
        _this6.listeners.push({
          key: key,
          fn: ls[key]
        });
      });
    }
  }, {
    key: 'sendMsg',
    value: function sendMsg(data) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
      var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var post = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      this.view.footer.submit(data, type, show, post);
    }
  }, {
    key: 'util',
    get: function get() {
      return _util2.default;
    }
  }, {
    key: 'events',
    get: function get() {
      return _app_events2.default;
    }
  }]);

  return APP;
}(_events3.default);

exports.default = APP;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = __webpack_require__(7);

var _events2 = _interopRequireDefault(_events);

var _plugin = __webpack_require__(138);

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginStatus = {};
var PLUGIN_STATUS_LOAD_FAILED = -1;
var PLUGIN_STATUS_FIRST_LOADING = 1;
var PLUGIN_STATUS_LOADED = 2;
var eventEmitter = new _events2.default();

eventEmitter.setMaxListeners(0);

function getPluginByKey(data, context, resolve, reject) {
  var key = data.type;
  var body = data.body || {};
  if (pluginStatus[key] !== PLUGIN_STATUS_LOADED) {
    pluginStatus[key] = PLUGIN_STATUS_FIRST_LOADING;
  }
  _plugin2.default.getPlugins(key).then(function (plugins) {
    pluginStatus[key] = PLUGIN_STATUS_LOADED;
    eventEmitter.emit('START_LOAD_NEXT_'.concat(key));
    var ret = body;
    for (var i = 0; i < plugins.length; i += 1) {
      try {
        ret = plugins[i].fn.call(context, ret);
      } catch (e) {
        console.warn('插件执行异常', e);
      }
    }
    resolve(ret);
  }, function (err) {
    console.log(err);

    eventEmitter.emit('START_LOAD_NEXT_'.concat(key));
    pluginStatus[key] = PLUGIN_STATUS_LOAD_FAILED;
    reject(err);
  });
}

exports.default = Object.create({
  register: function register(key, fn) {
    _plugin2.default.add(key, fn);
  },
  push: function push(data, context) {
    return new Promise(function (resolve, reject) {
      if (!data || !data.type) {
        reject();
      }
      var key = data.type;
      if (pluginStatus[key] === PLUGIN_STATUS_FIRST_LOADING) {
        eventEmitter.once('START_LOAD_NEXT_'.concat(key), function () {
          getPluginByKey(data, context, resolve, reject);
        });
      } else {
        getPluginByKey(data, context, resolve, reject);
      }
    });
  }
});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginStorage = [];
var regVersion = /^(\d{1,2})\.(\d{1,2})\.(\d{1,2})$/;
var regURL = /\S+/;

exports.default = Object.create({
  add: function add(key, plugin) {
    var k = key;
    var p = plugin;
    var loaded = 1;

    if (_util2.default.isFunction(key)) {
      k = null;
      p = key;
    }

    if (k === null && _util2.default.isString(p)) {
      return;
    }

    var isExistKey = pluginStorage.filter(function (item) {
      var r = item.key === key;
      return r;
    });
    if (isExistKey.length) {
      isExistKey.forEach(function (t) {
        for (var z = 0; z < pluginStorage.length; z += 1) {
          if (pluginStorage[z].key === t.key) {
            pluginStorage[z] = {
              key: k,
              fn: p,
              loaded: 1
            };
          }
        }
      });

      return;
    }

    if (typeof p === 'string' && (regVersion.test(p) || regURL.test(p))) {
      loaded = 0;
    }

    pluginStorage.push({
      key: k,
      fn: p,
      loaded: loaded
    });
  },
  getPlugins: function getPlugins(key) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var plugins = pluginStorage;
      var result = [];

      for (var i = 0; i < plugins.length; i += 1) {
        if (plugins[i].key === key || plugins[i].key === null) {
          result.push(plugins[i]);
        }
      }

      var checkStatus = result.filter(function (item) {
        var r = item.key !== null;
        return r;
      });
      if (!checkStatus.length) {
        reject('\u63D2\u4EF6[' + key + ']\u672A\u6CE8\u518C');
      }

      var hasAsyncPlugin = result.filter(function (item) {
        var r = !item.loaded;
        return r;
      });
      if (!hasAsyncPlugin.length) {
        resolve(result);
      } else {
        _this.getAsyncPlugins(result).then(function (ps) {
          resolve(ps);
        }, function () {
          reject('插件获取异常');
        });
      }
    });
  },
  getAsyncPlugins: function getAsyncPlugins(ds) {
    var _this2 = this;

    var result = ds;

    return new Promise(function (resolve, reject) {
      var async = [];
      for (var i = 0; i < ds.length; i += 1) {
        if (!ds[i].loaded) {
          async.push(_this2.getAsyncPlugin(ds[i]));
        }
      }

      Promise.all(async).then(function (rs) {
        for (var x = 0; x < rs.length; x += 1) {
          for (var y = 0; y < ds.length; y += 1) {
            if (result[y].key === rs[x].key) {
              result[y].fn = rs[x].fn;
            }
          }

          for (var z = 0; z < pluginStorage.length; z += 1) {
            if (pluginStorage[z].key === rs[x].key) {
              pluginStorage[z] = {
                key: rs[x].key,
                fn: rs[x].fn,
                loaded: 1
              };
            }
          }
        }
        resolve(result);
      }, function () {
        reject('获取插件异常');
      });
    });
  },
  getAsyncPlugin: function getAsyncPlugin(d) {
    return new Promise(function (resolve) {
      var fn = d.fn;
      var key = d.key;
      var errReturn = {
        key: key,
        fn: null,
        loaded: 1
      };
      var assetsCDN = null;
      var host = _util2.default.getEnvironment() === 'prod' ? '//g.alicdn.com' : '//g-assets.daily.taobao.net';
      if (regVersion.test(fn)) {
        assetsCDN = host + '/alicare/alicare-plugin-' + key + '/' + fn + '/index-min.js';
      } else if (regURL.test(fn)) {
        assetsCDN = fn;
      }

      if (!assetsCDN) {
        resolve(errReturn);
      }

      _tarzanZepto2.default.ajax({
        type: 'get',
        url: assetsCDN,
        dataType: 'jsonp',
        jsonp: 'callback',
        jsonpCallback: 'AlicarePlugin' + key.replace(/^\w/, function (n) {
          return n.toUpperCase();
        }),
        timeout: 10000,
        success: function success(p) {
          var mod = p() || {};
          if (typeof mod === 'function' || typeof mod.default === 'function') {
            resolve({
              key: key,
              fn: mod.default || mod,
              loaded: 1
            });
          } else {
            resolve(errReturn);
          }
        },
        error: function error() {
          resolve(errReturn);
        }
      });
    });
  }
});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(140);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g = (typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined;

var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

var oldRuntime = hadRuntime && g.regeneratorRuntime;

g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(141);

if (hadRuntime) {
  g.regeneratorRuntime = oldRuntime;
} else {
  try {
    delete g.regeneratorRuntime;
  } catch (e) {
    g.regeneratorRuntime = undefined;
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      module.exports = runtime;
    }

    return;
  }

  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  var ContinueSentinel = {};

  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (_typeof(global.process) === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      context[delegate.resultName] = info.value;

      context.next = delegate.nextLoc;

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      return info;
    }

    context.delegate = null;
    return ContinueSentinel;
  }

  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;

      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}((typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(10)(module)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;

module.exports = co['default'] = co.co = co;

co.wrap = function (fn) {
  createPromise.__generatorFunction__ = fn;
  return createPromise;
  function createPromise() {
    return co.call(this, fn.apply(this, arguments));
  }
};

function co(gen) {
  var ctx = this;
  var args = slice.call(arguments, 1);

  return new Promise(function (resolve, reject) {
    if (typeof gen === 'function') gen = gen.apply(ctx, args);
    if (!gen || typeof gen.next !== 'function') return resolve(gen);

    onFulfilled();

    function onFulfilled(res) {
      var ret;
      try {
        ret = gen.next(res);
      } catch (e) {
        return reject(e);
      }
      next(ret);
    }

    function onRejected(err) {
      var ret;
      try {
        ret = gen.throw(err);
      } catch (e) {
        return reject(e);
      }
      next(ret);
    }

    function next(ret) {
      if (ret.done) return resolve(ret.value);
      var value = toPromise.call(ctx, ret.value);
      if (value && isPromise(value)) return value.then(onFulfilled, onRejected);
      return onRejected(new TypeError('You may only yield a function, promise, generator, array, or object, ' + 'but the following object was passed: "' + String(ret.value) + '"'));
    }
  });
}

function toPromise(obj) {
  if (!obj) return obj;
  if (isPromise(obj)) return obj;
  if (isGeneratorFunction(obj) || isGenerator(obj)) return co.call(this, obj);
  if ('function' == typeof obj) return thunkToPromise.call(this, obj);
  if (Array.isArray(obj)) return arrayToPromise.call(this, obj);
  if (isObject(obj)) return objectToPromise.call(this, obj);
  return obj;
}

function thunkToPromise(fn) {
  var ctx = this;
  return new Promise(function (resolve, reject) {
    fn.call(ctx, function (err, res) {
      if (err) return reject(err);
      if (arguments.length > 2) res = slice.call(arguments, 1);
      resolve(res);
    });
  });
}

function arrayToPromise(obj) {
  return Promise.all(obj.map(toPromise, this));
}

function objectToPromise(obj) {
  var results = new obj.constructor();
  var keys = Object.keys(obj);
  var promises = [];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var promise = toPromise.call(this, obj[key]);
    if (promise && isPromise(promise)) defer(promise, key);else results[key] = obj[key];
  }
  return Promise.all(promises).then(function () {
    return results;
  });

  function defer(promise, key) {
    results[key] = undefined;
    promises.push(promise.then(function (res) {
      results[key] = res;
    }));
  }
}

function isPromise(obj) {
  return 'function' == typeof obj.then;
}

function isGenerator(obj) {
  return 'function' == typeof obj.next && 'function' == typeof obj.throw;
}

function isGeneratorFunction(obj) {
  var constructor = obj.constructor;
  if (!constructor) return false;
  if ('GeneratorFunction' === constructor.name || 'GeneratorFunction' === constructor.displayName) return true;
  return isGenerator(constructor.prototype);
}

function isObject(val) {
  return Object == val.constructor;
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _robot = __webpack_require__(144);

var _robot2 = _interopRequireDefault(_robot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Channel = function () {
  function Channel(app) {
    _classCallCheck(this, Channel);

    this.app = app;
    this.init();
  }

  _createClass(Channel, [{
    key: 'init',
    value: function init() {
      this.curRole = 'robot';
      this.robot = this.initRobot(this.app);
    }
  }, {
    key: 'initRobot',
    value: function initRobot() {
      return new _robot2.default(this.app);
    }
  }, {
    key: 'initOCS',
    value: function initOCS() {}
  }, {
    key: 'switchToRobot',
    value: function switchToRobot(config) {
      this.robot.online(config);
      this.curRole = 'robot';
      this.app.view.header.switchRole('robot');
    }
  }, {
    key: 'switchToOCS',
    value: function switchToOCS() {}
  }]);

  return Channel;
}();

exports.default = Channel;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _message_loading = __webpack_require__(145);

var _message_loading2 = _interopRequireDefault(_message_loading);

var _activity = __webpack_require__(154);

var _activity2 = _interopRequireDefault(_activity);

var _log = __webpack_require__(12);

var _log2 = _interopRequireDefault(_log);

var _parser = __webpack_require__(155);

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Robot = function () {
  function Robot(app) {
    _classCallCheck(this, Robot);

    this.app = app;

    this.encryptedUserId = '';

    this.bizType = null;

    this.chatSequence = 0;

    this.pos = null;

    this.deviceInfo = null;

    this.orderId = 0;

    this.subType = null;

    this.question = '';

    this.questionList = [];

    this.isInSOP = false;

    this.count = 0;

    this.threshhold = this.__getThreshhold();

    var liveAgent = this.app.util.lang.get('LIVE:AGENT');
    this.liveAgentCode = [{ code: 'liveAgent', icon: 'service', text: liveAgent, type: 'text', title: liveAgent, content: liveAgent }];
    this.shortcuts = this.liveAgentCode.concat(app.essentials.config.config.shortcuts || []);
  }

  _createClass(Robot, [{
    key: 'online',
    value: function online() {
      var _this = this;

      var app = this.app;
      app.view.setReceiver(function (data, type, show, post) {
        _this.call(data, type, show, post);
      });
      app.emit(app.events.CHANNEL_ROBOT_ONLINE);
    }
  }, {
    key: 'call',
    value: function call(data, type, show, post) {
      var _this2 = this;

      if (show) {
        this.showConsumerMessage(data, type);
      }

      if ((0, _activity2.default)(this.app, data.q ? data.q : data)) {
        return;
      }

      if (post) {
        setTimeout(function () {
          _this2.showMessageLoading();
        }, 0);
        this.post(data, type);
      }
    }
  }, {
    key: 'post',
    value: function post(data, type) {
      var appId = this.app.param.appId;

      var param = this.getParams(data, type);
      this.getData({
        message: JSON.stringify(param),
        appId: appId
      });
    }
  }, {
    key: 'getParams',
    value: function getParams(data, type) {
      var config = this.app.appConfig;
      var base = config.get('base');
      var appConfig = config.get('appConfig');
      var tenantId = config.get('qs').tenantId || 3;
      var user = config.get('user');

      var _config$get = config.get('robot'),
          robotCode = _config$get.robotCode,
          robotScene = _config$get.robotScene,
          botId = _config$get.botId;

      var q = data;
      var subType = type;

      this.chatSequence += 1;

      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        q = data.q;
        subType = data.subType;

        if (data.encryptedUserId) {
          this.encryptedUserId = data.encryptedUserId;
        }
      }

      if (this.subType) {
        subType = this.subType;

        this.subType = null;
      }

      if (type === 'image') {
        q = JSON.stringify({ url: q });
      }

      this.question = q;
      var param = {
        header: {
          querystring: config.get('qs'),
          memberType: config.get('user').memberType,
          from: base.from,
          imsid: this.app.param.imSid || base.imsid,
          appName: appConfig.appName || 'alixm',
          chatSequence: this.chatSequence,
          msglog: 3,
          sessionId: '',
          bu: config.get('base').bu,
          bizType: this.bizType,
          showType: '',
          sceneCode: robotScene,
          robotCode: robotCode,
          botId: botId,
          qType: subType || 'text',
          encryptedUserId: this.encryptedUserId,
          tenantId: tenantId },
        type: subType || 'text',
        subType: subType,
        body: q,
        fromId: user.userId,
        fromName: user.nick
      };

      if (subType === 'order') {
        this.orderId = q;
      }

      if (this.pos) {
        param.header = Object.assign(param.header, this.pos);
      }

      if (this.deviceInfo) {
        param.header = Object.assign(param.header, this.deviceInfo);
      }

      if (config.code) {
        param.header.code = config.code;
      }

      if (config.isConnect) {
        param.header.orderSelectSource = 'directConnect';
      }

      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        if (data.ext) {
          param.header.ext = data.ext;
        }

        if (data.header) {
          param.header = Object.assign(param.header, data.header);
        }
      }
      return param;
    }
  }, {
    key: 'getData',
    value: function getData(data) {
      var _this3 = this;

      this.__resetUITestClass();

      this.app.model.openair(data).then(function (res) {
        setTimeout(function () {
          _this3.parseOpenair(res);
        }, 200);

        if (res.length < 2) {
          _this3.getDataException();
        }
      }, function (err) {
        _this3.getDataException(data, err);
      });
    }
  }, {
    key: 'getDataException',
    value: function getDataException() {
      this.app.view.body.scrollToBottom();
      this.app.appendSystemMessage(this.app.util.lang.get('ROBOT:EXCEPTION'));
      this.hideMessageLoading();
    }
  }, {
    key: 'showConsumerMessage',
    value: function showConsumerMessage(data, type) {
      var app = this.app;
      var param = {};
      if (!type || type === 'text') {
        var q = data;
        if (app.util.isObject(data)) {
          q = data.q;
        }
        param = {
          type: 'consumer',
          body: {
            userId: 1,
            text: q,
            side: 'right',

            animate: true
          }
        };
      } else {
        param = {
          type: type,
          body: {
            userId: 1,
            text: data,
            side: 'right',

            animate: true
          }
        };
      }
      app.postMessage(param).then(function (ret) {
        $('.m-chatpanel-item').removeClass('T_send');
        ret.body.addClass('T_send');
        app.view.body.append(ret.body);
      });
    }
  }, {
    key: 'lazyMessage',
    value: function lazyMessage(item) {
      var _this4 = this;

      var touched = false;
      var num = 0;
      var app = this.app;
      var limit = (item.body.lazy * 1000 + 300) / 100;

      if (this.lazyed) {
        return;
      }
      $(window).on('touchstart', function () {
        touched = true;
      });
      var timer = setInterval(function () {
        if (num === limit) {
          if (!touched) {
            var param = item.body;
            app.appendMessage({
              type: item.type,
              body: param
            });
            _this4.lazyed = true;
          }
          clearInterval(timer);
        }
        num++;
      }, 100);
    }
  }, {
    key: 'showRobotMessage',
    value: function showRobotMessage(data, showLoading) {
      var _this5 = this;

      var app = this.app;

      if (data.body && data.body.lazy) {
        this.lazyMessage(data);
        return;
      }

      app.postMessage(data).then(function (res) {
        if (res && res.body) {
          switch (res.type) {
            case 'sop':
              _this5.hideMessageLoading();
              app.view.footer.showSlideUp(true);
              break;
            default:
              _this5.loading.load(res.body);
              _this5.__setUITestClass(res.body);
              if (showLoading) {
                _this5.showMessageLoading();
              }
              break;
          }
        } else {
          _this5.hideMessageLoading();
        }
      }, function () {
        _this5.hideMessageLoading();
        app.appendMessage({
          type: 'system',
          body: {
            text: app.util.lang.get('ROBOT:EXCEPTION')
          }
        });
      });
    }
  }, {
    key: 'showMessageLoading',
    value: function showMessageLoading() {
      var app = this.app;
      if (!this.loading) {
        this.loading = new _message_loading2.default(app.view);
      } else {}

      this.loading.init();
    }
  }, {
    key: 'hideMessageLoading',
    value: function hideMessageLoading() {
      var _this6 = this;

      setTimeout(function () {
        _this6.loading.remove();
      }, 0);
    }
  }, {
    key: 'parseOpenair',
    value: function parseOpenair(data) {
      var _this7 = this;

      var len = data.length;
      var shortcutTime = 0;
      data.forEach(function (item, index) {
        (function (t, i) {
          var time = (i - 1) * 1500 + 300;
          if (t.type === 'dynamic_shortcuts' || t.type === 'buttons' || item.lazy) {
            time = Math.ceil((i - 2) * 1500 + 300, 0);

            if (!shortcutTime) {
              shortcutTime = time;
            }
          }
          item.question = _this7.question;
          var d = _parser2.default.run(_this7, item);
          if (d && d.type === 'empty') {
            setTimeout(function () {
              _this7.hideMessageLoading();
            }, 410);
          } else if (d && d.type && d.body) {
            setTimeout(function () {
              d.body.mid = item.id;
              d.body.__question__ = _this7.question;
              var showLoading = i < len - 1;

              if (i < len - 1 && (data[i + 1].type === 'dynamic_shortcuts' || data[i + 1].lazy)) {
                showLoading = false;
              }
              _this7.showRobotMessage(d, showLoading);
              _this7.extraMessage(item);
            }, time);
          }
        })(item, index);
      });

      setTimeout(function () {
        _this7.setShortcuts(data);
      }, shortcutTime);
    }
  }, {
    key: 'extraMessage',
    value: function extraMessage(item) {
      var config = this.app.appConfig;
      var base = config.get('base');
      try {
        if (item.type !== 'ack') {
          var body = JSON.parse(item.body);
          body.__question__ = this.question;

          if (body.showChangeOrderTip) {
            this.app.appendMessage({
              type: 'system',
              body: {
                text: this.app.util.lang.get('KNOWLEDGE:CHANGEORDERTIP')
              }
            });
          }
          if (body.extraParams && body.extraParams.orderSelectSource === 'command') {
            this.orderSelectSource = body.extraParams.orderSelectSource;
            if (body.extraParams.orderSelectSource === 'command' && 'alxm,zzb,fwzs,shezhi,tmall,tmall_mytmall'.indexOf(base.from) >= 0) {
              this.app.appendMessage({
                type: 'buttons',
                body: {
                  list: [{
                    text: '选择订单',
                    icon: 'bag',
                    action: 'selectOrder',
                    params: {
                      code: null,
                      content: null
                    }
                  }]
                }
              });
            }
          }

          if (body.needFeedback) {
            body.originBody = item.body;
            this.app.appendMessage({
              type: 'feedback',
              body: body
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }, {
    key: 'setShortcuts',
    value: function setShortcuts(data) {
      var _this8 = this;

      var manualShortcuts = null;
      var robotShortcuts = null;
      data.forEach(function (item) {
        try {
          if (_this8.__shouldShowGomanual(item)) {
            manualShortcuts = {
              isAdd: false,
              shortcuts: _this8.shortcuts || []
            };
          }
        } catch (e) {}

        if (item.type === 'dynamic_shortcuts') {
          robotShortcuts = JSON.parse(item.body);
        }
      });

      var combinedShortcuts = this.__formatShortcutData(manualShortcuts, robotShortcuts);
      if (combinedShortcuts) {
        this.hideMessageLoading();
        setTimeout(function () {
          _this8.app.shortcuts.push(combinedShortcuts);
        }, 500);
      }
    }
  }, {
    key: '__resetUITestClass',
    value: function __resetUITestClass() {
      $('.bubble-up-from-left').removeClass('T_receive');
    }
  }, {
    key: '__setUITestClass',
    value: function __setUITestClass($node) {
      if ($node) {
        $node.parent('.bubble-up-from-left').addClass('T_receive');
      }
    }
  }, {
    key: '__inputingLogic',
    value: function __inputingLogic() {
      var _this9 = this;

      $(document).on('inputing', function () {
        clearTimeout(_this9.timer);
        _this9.timer = setTimeout(function () {
          if (_this9.questionList.length > 0) {
            _this9.post(_this9.questionList.join('###'), 'text');
            _this9.questionList.length = 0;
          }
        }, 2000);
      });
    }
  }, {
    key: '__formatShortcutData',
    value: function __formatShortcutData(manualShortcuts, robotShortcuts) {
      var res = null;
      if (robotShortcuts && manualShortcuts) {
        res = manualShortcuts;
        res.shortcuts = res.shortcuts.concat(robotShortcuts.shortcuts);
      } else if (robotShortcuts) {
        res = robotShortcuts;
      } else if (manualShortcuts) {
        res = manualShortcuts;
      }
      return res;
    }
  }, {
    key: '__shouldShowGomanual',
    value: function __shouldShowGomanual(item) {
      var shouldShow = false;
      if (item.header && item.header.chatUuid) {
        this.app.chatUuid = item.header.chatUuid;
      }
      if (item.type === 'knowledge' || item.type === 'recommend' || item.type === 'noanswer') {
        this.count += 1;

        if (this.count === 3) {
          shouldShow = true;
          this.app.liveAgent = {
            entry: 'knowledge'
          };
          _log2.default.liveAgent({
            entry: 'knowledge',
            type: 'show',
            chatUuid: item.header.chatUuid,
            intent: ''
          });
        } else if (this.count > 3) {
          this.app.view.footer.showShortcuts();
        }
      }
      return shouldShow;
    }
  }, {
    key: '__getThreshhold',
    value: function __getThreshhold() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

      var threshhold = 0;
      var app = this.app;
      var switches = app.appConfig.get('switches') || {};
      var knowledgeToManual = switches && switches.knowledgeToManual;
      if (knowledgeToManual && knowledgeToManual.enable) {
        if (type === 'default') {
          threshhold = knowledgeToManual.threshhold || 0;
        } else if (type === 'sop') {
          threshhold = knowledgeToManual.sopthreshhold || 0;
        }
      }
      return threshhold;
    }
  }, {
    key: '__getLocation',
    value: function __getLocation() {
      var _this10 = this;

      var pos = {};
      var bridge = this.app.bridge;
      if (bridge.detect('getLocation')) {
        bridge.getLocation().then(function (res) {
          pos.longitude = res.longitude;
          pos.latitude = res.latitude;
          _this10.pos = pos;
        });
      }
    }
  }, {
    key: '__getDeviceInfo',
    value: function __getDeviceInfo() {
      var _this11 = this;

      var deviceInfo = {};
      var bridge = this.app.bridge;
      if (bridge.detect('getDeviceInfo')) {
        bridge.getDeviceInfo().then(function (res) {
          deviceInfo.deviceId = res.deviceID;
          deviceInfo.model = res.model;
          _this11.deviceInfo = deviceInfo;
        });
      }
    }
  }]);

  return Robot;
}();

exports.default = Robot;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(view) {
    _classCallCheck(this, _class);

    this.view = view;
    this.bubbleList = [];
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      var gifSrc = '//gw.alicdn.com/tfs/TB1vpdrRpXXXXb6aXXXXXXXXXXX-134-84.gif';
      var loadingTpl = '<img style="width:2.5em;margin-bottom:-6px;" src="' + gifSrc + '" />';
      var param = {
        name: 'robot',
        content: loadingTpl,
        side: 'left card-loading'
      };

      var $el = (0, _tarzanZepto2.default)(_index2.default.msg(param));
      this.view.body.append($el);

      this.bubbleList.push($el);
    }
  }, {
    key: 'load',
    value: function load($node) {
      var bubbleAmount = this.bubbleList.length;
      if (bubbleAmount === 0) {
        this.init();
      }
      var $el = this.bubbleList.shift();
      this.__appendMsg($el, $node);
    }
  }, {
    key: '__appendMsg',
    value: function __appendMsg($el, $node) {
      var _this = this;

      $el.attr('class', '');

      if (navigator.userAgent.indexOf('Android') === -1) {
        $el.addClass('bubble-up-from-left');
      }

      $el.empty().append($node);

      this.__refreshUI();
      if ($node) {
        $node.find('img').on('load', function () {
          _this.__refreshUI();
        });
      }

      this.__emptyBubbleList();
    }
  }, {
    key: '__emptyBubbleList',
    value: function __emptyBubbleList() {
      var _this2 = this;

      var bubbleAmount = this.bubbleList.length;
      if (bubbleAmount !== 0) {
        this.bubbleList.forEach(function () {
          _this2.remove();
        });
      }
    }
  }, {
    key: '__refreshUI',
    value: function __refreshUI() {
      if (this.view.body.isBottom()) {
        this.view.body.scrollToBottom();
      } else {
        this.view.body.refresh();
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      var $el = this.bubbleList.shift();
      if ($el) {
        $el.addClass('fade-out-to-bottom');
        $el.remove();
        this.view.body.scrollToBottom();
        setTimeout(function () {}, 1500);
      }
    }
  }, {
    key: 'fail',
    value: function fail() {}
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./frame.html"] = __webpack_require__( 149 );




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/index.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./frame.html", false, "src/component/baseui/templates/index.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("frame", t_1);
output += "\n\n\n";
if(runtime.contextOrFrameLookup(context, frame, "type") == "base") {
output += "\n  <div class=\"m-alicare\">\n      ";
output += runtime.suppressValue((lineno = 5, colno = 16, runtime.callWrap(runtime.memberLookup((t_1),"base"), "frame[\"base\"]", context, [])), env.opts.autoescape);
output += "\n  </div> \n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "input") {
output += "\n  <div class=\"m-input-panel\">\n      ";
output += runtime.suppressValue((lineno = 9, colno = 17, runtime.callWrap(runtime.memberLookup((t_1),"input"), "frame[\"input\"]", context, [runtime.contextOrFrameLookup(context, frame, "speech")])), env.opts.autoescape);
output += "\n  </div> \n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "footer") {
output += "\n  <div class=\"m-footer-panel\">\n      ";
output += runtime.suppressValue((lineno = 13, colno = 18, runtime.callWrap(runtime.memberLookup((t_1),"footer"), "frame[\"footer\"]", context, [])), env.opts.autoescape);
output += "\n  </div>  \n";
;
}
;
}
;
}
output += "\n\n  \n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/index.html"] , dependencies)

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1;
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }

        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }

        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        if (currentlyRunningATask) {
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    if ({}.toString.call(global.process) === "[object process]") {
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        installReadyStateChangeImplementation();
    } else {
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(148)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var process = module.exports = {};

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        return setTimeout(fun, 0);
    }

    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        return clearTimeout(marker);
    }

    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = '';
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/frame.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_2 = "";t_2 += "\n      <header class=\"m-alicare-header\">\n        <nav class=\"nav-bar\">\n          <div class=\"J_Back head-back\" role=\"button\" aria-label=\"back\">\n              <span class=\"iconfont icon-arrow\"></span>\n          </div>\n          <section class=\"caption\">\n              LazBot  \n          </section>\n          <div class=\"right-nav\">\n              <span class=\"iconfont icon-close\"></span>\n          </div>\n        </nav>\n      </header>\n      <div class=\"m-alicare-body\">\n          <div class=\"m-alicare-scroller\" tabindex=\"-1\">\n          </div>\n      </div>\n      <div class=\"m-alicare-footer\"></div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("base");
context.setVariable("base", macro_t_1);
output += "\n\n";
var macro_t_3 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_4 = "";t_4 += "\n  <!-- 预置 -->\n  <div class=\"m-footer-slideup J_SlideUp\"></div>\n  <div class=\"J_InputWrap m-input-wrap\">\n      <div class=\"m-shortcuts-wrap J_Shortcuts\">\n      </div>\n      <div class=\"m-input-toolbar J_InputToolbar\">\n          <div class=\"m-input-toolbar-panel\">\n              <!--输入-->\n              <div class=\"m-input-form J_InputForm\">\n              </div>\n          </div>\n      </div>\n      <!--扩展-->\n      <div class=\"m-input-form-ext J_ExtPanel\">\n          <div class=\"plugins J_Plugins\"></div>\n      </div>\n  </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("footer");
context.setVariable("footer", macro_t_3);
output += "\n\n\n";
var macro_t_5 = runtime.makeMacro(
["speech"], 
[], 
function (l_speech, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("speech", l_speech);
var t_6 = "";t_6 += "\n    ";
if(l_speech) {
t_6 += "\n    <!--语音输入-->\n    <div class=\"btn-switch J_BtnSwitch\">\n        <button class=\"btn switch-voice\" aria-label=\"切换到语音输入\">\n             <svg class=\"icon voice\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-mic\"></use>\n             </svg>\n             <svg class=\"icon keyboard\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-keyboard\"></use>\n            </svg>  \n        </button>\n    </div>\n    ";
;
}
t_6 += "\n    <div class=\"panel J_Panel\">\n      <div class=\"m-input-wrap\">\n        <div class=\"keyboard-wrap\">\n            <textarea placeholder=\"\" class=\"textarea J_Field\"></textarea>\n            <textarea class=\"textarea-copy J_InputFieldCopy\"></textarea>\n            <input type=\"number\" class=\"input J_NumberField\">\n            <span class=\"m-emoji-btn J_EmojiBtn\">\n                <i class=\"iconfont icon-emoji\"></i>\n            </span>\n        </div>\n        ";
if(l_speech) {
t_6 += "\n        <!--语音输入-->\n        <div class=\"voice-wrap J_Voice press-speech\">\n            <div class=\"press-text\" role=\"button\" aria-label=\"按住说话\">\n                <svg class=\"icon micc\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-micc\"></use>\n                </svg>\n                <span>按住 说话</span>\n            </div>\n            <div class=\"loosen-text\" role=\"button\" aria-label=\"松开发送\">\n                <svg class=\"icon mic\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-mic\"></use>\n                </svg>\n                <span>松开 发送</span>\n            </div>\n        </div>\n        ";
;
}
t_6 += "\n      </div>\n        \n    </div>\n    <div class=\"m-input-btn J_InputBtn\">\n        <button class=\"btn send-btn J_SendMessageButton\" role=\"button\" aria-label=\"发送\">\n           <i class=\"iconfont icon-send\"></i>\n        </button>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("input");
context.setVariable("input", macro_t_5);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/frame.html"] , dependencies)

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/msg.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"T_";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += " m-chatpanel-item m-chatpanel-item-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "side"), env.opts.autoescape);
output += " m-chatpanel-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "isFollow")) {
output += " follow ";
;
}
output += "\" data-mid=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mid"), env.opts.autoescape);
output += "\"  ";
if(runtime.contextOrFrameLookup(context, frame, "isFirst")) {
output += "tabindex=\"0\" aria-label=\"welcome\"";
;
}
output += ">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "showAvatar") && runtime.contextOrFrameLookup(context, frame, "side") == "left") {
output += "\n    <div class=\"user\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "avatar")) {
output += "\n        <div class=\"avatar\">\n            <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "avatar"), env.opts.autoescape);
output += "\" alt=\"头像\">\n        </div>\n         ";
;
}
output += "\n    </div>\n    ";
;
}
output += "\n    <div class=\"chat clearfix\">\n        <div class=\"J_Body body  ";
if(runtime.contextOrFrameLookup(context, frame, "type")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-body";
;
}
output += "\">\n            <s class=\"arrow\">        \n            </s>\n            <div class=\"J_Content content\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n            </div>\n        </div>\n    </div> \n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/msg.html"] , dependencies)

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/slideup.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-card-popup m-card-popup-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\">\n    <div class=\"popup-mask J_Mask\" role=\"button\" aria-label=\"点击关闭浮层\"></div>\n    <div class=\"popup-list slideUp slide-in-from-bottom\">\n        <div class=\"toggle J_Toggle\" role=\"button\" aria-label=\"点击关闭浮层\">\n            <i class=\"toggle-icon\" aria-hidden=\"true\"></i>\n        </div>\n         <div class=\"list-wrapper\">\n           ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/slideup.html"] , dependencies)

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/orderItem.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-order-item J_Order\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" data-type=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "\" data-json=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "json"), env.opts.autoescape);
output += "\" role=\"option\" tabindex=\"0\" aria-label=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sku"), env.opts.autoescape);
output += "，总价¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "amount"), env.opts.autoescape);
output += "，个数";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buyAmount"), env.opts.autoescape);
output += "，当前状态";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "payStatusStr"), env.opts.autoescape);
output += "\">\n  <div class=\"pic\" aria-hidden=\"true\">\n    <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "picUrl"), env.opts.autoescape);
output += "\" aria-hidden=\"true\"/>\n  </div>\n  <div class=\"info\" aria-hidden=\"true\">\n    <div class=\"title\" aria-label=\"商品标题\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</div>\n    <div class=\"sku\" aria-label=\"商品规格\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sku"), env.opts.autoescape);
output += "</div>\n    <div class=\"price\">\n      <span class=\"truly\" aria-label=\"商品成交价格\">¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "amount"), env.opts.autoescape);
output += "</span>\n      <s class=\"falsely\" aria-label=\"商品原价\">¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "price"), env.opts.autoescape);
output += "</s>\n      <span class=\"count\" aria-label=\"购买数量\">x";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buyAmount"), env.opts.autoescape);
output += "</span>\n      <span class=\"status\" aria-label=\"交易状态\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "payStatusStr"), env.opts.autoescape);
output += "</span>\n    </div>\n  </div>\n  ";
if(runtime.contextOrFrameLookup(context, frame, "showDetail")) {
output += "\n  <button aria-label=\"点击查看详情\">详情</button>\n  ";
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/orderItem.html"] , dependencies)

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/popup.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-footer-popup m-footer-popup-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\">\n  <div class=\"popup-header\">\n    <span aria-label=\"标题\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</span>\n    <svg class=\"icon popup-close J_Close\" role=\"button\" aria-label=\"关闭\">\n        <use xlink:href=\"#icon-close\"></use>\n    </svg>\n  </div>\n  <div class=\"popup-body J_Content\">\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n  </div>\n  <div class=\"popup-footer\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "btnList")) {
output += "\n      <div class=\"popup-btn-group\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "btnList");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <span class=\"popup-btn J_";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += " popup-btn-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((t_4),"active")) {
output += "active";
;
}
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "</span>\n        ";
;
}
}
frame = frame.pop();
output += "\n      </div>\n    ";
;
}
output += "\n  </div>\n</div>\n ";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/popup.html"] , dependencies)

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activity;

var _eventbus = __webpack_require__(9);

var _eventbus2 = _interopRequireDefault(_eventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activity(app, data) {
  if (data === 'lazada_cancel') {
    _eventbus2.default.emit('cancelResult', {
      orderId: '**',
      itemId: '**',
      reason: '**',
      method: '**'
    });
    return true;
  }

  if (data === 'lazada_login') {
    _eventbus2.default.emit('login', {
      action: {},
      email: '**',
      type: 'registered  or guest',
      order_number: '***'
    });
    return true;
  }

  if (data === 'lazada_liveagent') {
    _eventbus2.default.emit('liveAgent', {
      imSid: '***'
    });
    return true;
  }

  if (data === 'eva') {
    app.appendMessage({
      type: 'evaluate',
      body: {
        title: 'Was it helpful?'
      }
    });
    return true;
  }
  return false;
}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventbus = __webpack_require__(9);

var _eventbus2 = _interopRequireDefault(_eventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseElse(context, data) {}

var store = [];
var parser = Object.create({
  push: function push(key, fn) {
    store.push({
      key: key,
      fn: fn
    });
  },
  run: function run(context, data) {
    var type = data.type;
    for (var i = 0; i < store.length; i += 1) {
      if (store[i].key === type) {
        return store[i].fn.call(this, data, context);
      }
    }
    parseElse(context, data);
    return null;
  }
});

parser.push('ack', function (data) {
  $('.mod-chatpanel-consumer').last().attr('data-mid', data.id);
});

parser.push('robot', function (data) {
  var param = JSON.parse(data.body);

  return {
    type: 'robot',
    body: {
      extraParams: param.extraParams,
      lazy: data.lazy,
      text: param.text
    }
  };
});

parser.push('knowledge', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'knowledge',
    body: param
  };
});

parser.push('recommend', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'recommend',
    body: param
  };
});

parser.push('session_availability', function (data) {
  _eventbus2.default.emit('liveAgent', data);
  return {
    type: 'empty'
  };
});

parser.push('noanswer', function (data, context) {
  var autoResponses = context.app.essentials.config.config.auto_responses;
  var autoRep = autoResponses && autoResponses.length > 0 ? autoResponses : [context.app.util.lang.get('ROBOT:NOANSWER')];

  return {
    type: 'robot',
    body: {
      text: autoRep[0]
    }
  };
});

parser.push('error', function (data, context) {
  return {
    type: 'robot',
    body: {
      text: context.app.util.lang.get('ROBOT:EXCEPTION')
    }
  };
});

parser.push('options', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'options',
    body: param
  };
});

parser.push('orderList', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'orderlist',
    body: {
      body: param,
      isRobot: true
    }
  };
});

parser.push('orderDetail', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'orderdetail',
    body: {
      list: param,
      isRobot: true
    }
  };
});

parser.push('cancelItem', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'cancel',
    body: {
      list: param,
      isRobot: true
    }
  };
});

parser.push('text_button', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'option',
    body: {
      list: param,
      isRobot: true
    }
  };
});

parser.push('cancel_event', function (data) {
  var param = JSON.parse(data.body);
  _eventbus2.default.emit('cancelResult', param);
  return {
    type: 'empty'
  };
});

parser.push('login_event', function (data) {
  var param = JSON.parse(data.body);
  _eventbus2.default.emit('login', param);
  return {
    type: 'empty'
  };
});

parser.push('feedback', function (data) {
  var param = JSON.parse(data.body);
  var p = Object.assign({}, param, { chatUuid: data.header.chatUuid || '' });
  return {
    type: 'feedback',
    body: p
  };
});

parser.push('shortcut', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'dynamic_shortcuts',
    body: {
      isAdd: false,
      shortcuts: param
    }
  };
});

parser.push('live_agent_event', function (data) {
  _eventbus2.default.emit('liveAgent', { entry: 'bfw', type: 'click', chatUuid: data.header.chatUuid, intent: '' });
  return {
    type: 'empty'
  };
});

parser.push('bank_transfer_event', function (data) {
  var param = JSON.parse(data.body);
  _eventbus2.default.emit('bankTransfer', param);
  return {
    type: 'empty'
  };
});

parser.push('session_expired', function (data) {
  var param = JSON.parse(data.body);
  _eventbus2.default.emit('sessionExpired', param);
  return {
    type: 'empty'
  };
});

parser.push('text_link', function (data) {
  var param = JSON.parse(data.body);
  return {
    type: 'textlink',
    body: {
      text: param.text,
      link: param.link
    }
  };
});

exports.default = parser;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.$ = _tarzanZepto2.default;
  app.BaseUI = _index2.default;
  Object.assign(app, {
    appendSystemMessage: function appendSystemMessage(text) {
      var _this = this;

      this.postMessage({
        type: 'system',
        body: {
          text: text
        }
      }).then(function (ret) {
        _this.view.body.append(ret.body);
      });
    }
  });

  Object.assign(app, {
    appendMessage: function appendMessage(data) {
      var $container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.view.body;

      this.postMessage(data).then(function (ret) {
        $container.append(ret.body);
      });
    }
  });

  Object.assign(app.util, {
    confirm: function confirm(param) {
      return new Promise(function (resolve) {
        if (window.confirm(param.message)) {
          resolve();
        }
      });
    }
  });

  Object.assign(app.util, {
    openWindow: function openWindow(originUrl, callback) {
      var url = originUrl;
      if (callback) {
        callback();
      }

      if (url.length === 0 || url === '#' || url === 'javascript:;' || url.indexOf('tel:') === 0) {
        return;
      }
      window.open(url);
    }
  });
};

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _body = __webpack_require__(158);

var _body2 = _interopRequireDefault(_body);

var _footer = __webpack_require__(163);

var _footer2 = _interopRequireDefault(_footer);

var _welcome = __webpack_require__(188);

var _welcome2 = _interopRequireDefault(_welcome);

var _index3 = __webpack_require__(191);

var _index4 = _interopRequireDefault(_index3);

var _events4 = __webpack_require__(195);

var _events5 = _interopRequireDefault(_events4);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(196);

var View = function (_events) {
  _inherits(View, _events);

  function View(config) {
    _classCallCheck(this, View);

    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this));

    _this.$container = (0, _tarzanZepto2.default)(config.container);
    _this.log = config.log;
    _this.appConfig = config.appConfig;
    _this.theme = config.theme ? config.theme : null;
    _this.isExternalUI = config.isExternalUI;
    _this.receiver = function () {};
    _this.initWelcome();
    _this.render();
    _this.body = _this.initBody();
    _this.header = _this.initHeader();
    _this.footer = _this.initFooter();
    _this.initPull();
    _this.initCustomLayout();
    _this.bindEvents();
    return _this;
  }

  _createClass(View, [{
    key: 'initCustomLayout',
    value: function initCustomLayout() {
      if (this.appConfig.header) {
        _index2.default.showAvatar = true;
        this.resize();
      } else {
        this.header.hide();
        this.resize();
      }
    }
  }, {
    key: 'initWelcome',
    value: function initWelcome() {
      var fromList = ['alxm', 'zzb', 'fwzs', 'shezhi', 'tmall', 'tmall_mytmall'];
      var hasWelcome = _util2.default.storage.getItem('hasWelcome') || '';

      var _ref = _util2.default.queryString.parse(location.search.substring(1)) || {},
          hideWelcome = _ref.hideWelcome,
          from = _ref.from;

      var allowWelcome = fromList.some(function (f) {
        return f === from;
      });

      if (allowWelcome && hideWelcome !== 'true' && hasWelcome !== 'true') {
        var $welcome = new _welcome2.default({
          container: this.$container,
          app: this
        });
        $welcome.render();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.theme) {
        (0, _tarzanZepto2.default)(this.$container).addClass('skin-' + this.theme);
      }
      this.$container.append(_index2.default.frame({ type: 'base' }));
      this.$frame = this.$container.find('.m-alicare');
      var _appConfig = this.appConfig,
          position = _appConfig.position,
          size = _appConfig.size,
          zIndex = _appConfig.zIndex,
          visible = _appConfig.visible;

      if (position && size && zIndex) {
        (0, _tarzanZepto2.default)('body').css({ overflow: 'auto' });
        this.$frame.css({
          right: position.right,
          bottom: position.bottom,
          width: size.width,
          height: size.height,
          top: 'auto',
          left: 'auto',
          zIndex: zIndex,
          position: 'fixed'
        });
      }

      if (visible) {
        this.$frame.show();
      } else {
        this.$frame.hide();
      }
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.body.resize(this.footer.$container.height(), this.header.$container.height());
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.body.refresh();
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.body.refresh();
      this.body.scrollToBottom();
    }
  }, {
    key: 'append',
    value: function append($node) {
      this.body.append($node);
    }
  }, {
    key: 'addPlugin',
    value: function addPlugin(config) {
      this.footer.addPlugin(config);
    }
  }, {
    key: 'setReceiver',
    value: function setReceiver(fn) {
      if (typeof fn === 'function') {
        this.receiver = fn;
      } else {
        throw new Error('invalid receiver');
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      this.body.$container.on('touchstart', function () {
        _this2.footer.blur();
        _this2.footer.hidePlugin();
      });
    }
  }, {
    key: 'initFooter',
    value: function initFooter() {
      var _this3 = this;

      var f = new _footer2.default({
        log: this.log,
        container: this.$container.find('.m-alicare-footer'),
        size: this.appConfig.size
      });
      var $voiceNode = null;

      f.on('message', function (params) {
        _this3.receiver.apply(null, params);
      });
      f.on('resize', function () {
        _this3.resize();
      });
      f.on('scrollToBottom', function () {
        _this3.body.refresh();
        _this3.body.scrollToBottom();
      });
      f.on('voicestart', function () {
        $voiceNode = (0, _tarzanZepto2.default)(_index2.default.msg({
          name: 'consumer',
          side: 'right',
          content: '<span style="display:inline-block;width: 60px;">&nbsp;</span>'
        }));
        $voiceNode.addClass('m-chatpanel-voiceinput');
        _this3.body.append($voiceNode);
      });
      f.on('voicecancel', function () {
        $voiceNode.remove();
        _this3.refresh();
      });
      f.on('voice', function (data) {
        $voiceNode.find('.J_Content').html(data.text);
        $voiceNode.removeClass('m-chatpanel-voiceinput');
        _this3.scrollToBottom();
      });
      return f;
    }
  }, {
    key: 'initHeader',
    value: function initHeader() {
      var h = new _index4.default({
        log: this.log,
        container: this.$container.find('.m-alicare-header'),
        parentCont: this.$container
      });
      return h;
    }
  }, {
    key: 'initBody',
    value: function initBody() {
      var b = new _body2.default({
        log: this.log,
        container: this.$container.find('.m-alicare-body')
      });
      return b;
    }
  }, {
    key: 'initPull',
    value: function initPull() {
      var _this4 = this;

      _events5.default.on('pull', function () {
        _this4.emit('pull');
      });
      this.body.on('pullDistance', function (e) {
        _this4.header.pullLoading.setDis(e.dis);
      });
    }
  }, {
    key: 'adjust',
    value: function adjust() {
      var _this5 = this;

      window.addEventListener('resize', function () {
        _this5.resize();
      });
    }
  }, {
    key: 'empty',
    value: function empty() {
      (0, _tarzanZepto2.default)('.m-alicare').remove();
    }
  }], [{
    key: 'appLoadFail',
    value: function appLoadFail(message) {
      console.log(message);
    }
  }]);

  return View;
}(_events3.default);

exports.default = View;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _scroll = __webpack_require__(159);

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_events) {
  _inherits(Body, _events);

  function Body(config) {
    _classCallCheck(this, Body);

    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this));

    _this.bridge = config.bridge;
    _this.$container = (0, _tarzanZepto2.default)(config.container);
    _this.__initScroll();
    _this.__imagePreview();
    return _this;
  }

  _createClass(Body, [{
    key: 'resize',
    value: function resize(bottom, top) {
      this.$container.css({
        bottom: bottom,
        top: top
      });
      this.refresh();
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.__scroll.refresh();
    }
  }, {
    key: '__imagePreview',
    value: function __imagePreview() {
      this.$container.delegate('img', 'tap', function () {});
    }
  }, {
    key: '__initScroll',
    value: function __initScroll() {
      var _this2 = this;

      this.__scroll = new _scroll2.default({
        container: this.$container
      });

      this.__scroll.on('pull', function () {
        _this2.emit('pullToRefresh');
      });

      this.__scroll.on('pullEvent', function (e) {
        _this2.emit('pullDistance', e);
      });
      this.append = function (content) {
        return _this2.__scroll.append(content);
      };
      this.prepend = function (content) {
        return _this2.__scroll.prepend(content);
      };
      this.refresh = function () {
        return _this2.__scroll.refresh();
      };
      this.scrollToElement = function (el) {
        return _this2.__scroll.scrollToElement(el);
      };
      this.scrollToTop = function () {
        return _this2.__scroll.scrollToTop();
      };
      this.scrollToBottom = function () {
        return _this2.__scroll.scrollToBottom();
      };
      this.isBottom = function () {
        return _this2.__scroll.isBottom();
      };
      this.addAnimation = function () {
        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        return _this2.__scroll.addAnimation(time);
      };
      this.rmAnimation = function () {
        return _this2.__scroll.rmAnimation();
      };

      this.$scroll = this.__scroll.$el;
    }
  }]);

  return Body;
}(_events3.default);

exports.default = Body;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _iscrollProbe = __webpack_require__(17);

var _iscrollProbe2 = _interopRequireDefault(_iscrollProbe);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _unread = __webpack_require__(160);

var _unread2 = _interopRequireDefault(_unread);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANI_CLASSNAME = 'ani-transform-scroll';
var showTimeInterval = 60000;
var lastShowTime = new Date();

var Scroll = function (_events) {
  _inherits(Scroll, _events);

  function Scroll(config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this));

    _this.$container = (0, _tarzanZepto2.default)(config.container);
    _this.__init();
    _this.iscroll = _this.__initIScroll();
    _this.__bindEvent();
    _this.__initUnRead();
    return _this;
  }

  _createClass(Scroll, [{
    key: '__init',
    value: function __init() {
      this.$chartPanel = (0, _tarzanZepto2.default)('<div class="m-alicare-chartPanel"></div>');
      this.$el = (0, _tarzanZepto2.default)('<div class="m-alicare-scroller"></div>');
      this.$el.append(this.$chartPanel);
      this.$container.html(this.$el);
    }
  }, {
    key: '__initIScroll',
    value: function __initIScroll() {
      return new _iscrollProbe2.default(this.$container[0], {
        probeType: 3,
        useTransition: false,
        mouseWheel: true,
        tap: false,
        click: false,
        scrollY: true,
        scrollX: false,
        lockDirection: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false,
        scrollbars: !!_util2.default.isPC(),
        preventDefaultException: {
          tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|P|DIV)$/
        }
      });
    }
  }, {
    key: '__bindEvent',
    value: function __bindEvent() {
      var _this2 = this;

      this.__pullEvent();
      this.on('resize', _util2.default.buffer(function () {
        _this2.refresh();
      }, 200, this));
    }
  }, {
    key: '__initUnRead',
    value: function __initUnRead() {
      var _this3 = this;

      this.unRead = new _unread2.default({
        container: this.$container
      });

      this.unRead.on('trigger', function (node) {
        if (node) {
          _this3.scrollToElement(node[0]);
        }
      });
    }
  }, {
    key: '__pullEvent',
    value: function __pullEvent() {
      var _this4 = this;

      var iscroll = this.iscroll;
      var scroller = (0, _tarzanZepto2.default)(iscroll.scroller);
      var pullFlag = false;

      iscroll.on('scroll', function () {
        _this4.rmAnimation();
        if (scroller.position().top > 20 && !pullFlag) {
          pullFlag = true;
        }
        if (scroller.position().top > 0) {
          _this4.emit('pullEvent', {
            dis: scroller.position().top
          });
        }
        if (_this4.isBottom()) {}
      });

      iscroll.on('scrollEnd', function () {
        _this4.addAnimation(1000);
        if (pullFlag) {
          _this4.emit('pull');
        }
        pullFlag = false;
      });
    }
  }, {
    key: 'addAnimation',
    value: function addAnimation() {
      var _this5 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      setTimeout(function () {
        _this5.$el.addClass(ANI_CLASSNAME);
      }, time);
    }
  }, {
    key: 'rmAnimation',
    value: function rmAnimation() {
      this.$el.removeClass(ANI_CLASSNAME);
    }
  }, {
    key: '__append',
    value: function __append($content) {
      this.$chartPanel.append($content);
    }
  }, {
    key: '__prepend',
    value: function __prepend($content) {
      this.$chartPanel.prepend($content);
    }
  }, {
    key: 'append',
    value: function append(content) {
      var $el = (0, _tarzanZepto2.default)(content);
      var isBottom = this.isBottom();
      if (!$el || !$el.length) {
        return;
      }

      this.__append($el);
      this.resize();
      if (isBottom) {
        this.scrollToBottom();
        this.unRead.hide();
        this.imageOnScrollToBottom($el);
      } else {}

      this.imageOnLoad($el);
    }
  }, {
    key: 'prepend',
    value: function prepend(content) {
      var $el = (0, _tarzanZepto2.default)(content);
      if (!$el || !$el.length) {
        return;
      }
      this.__prepend($el);
      this.resize();
      this.imageOnLoad($el);
    }
  }, {
    key: 'isBottom',
    value: function isBottom() {
      var iscroll = this.iscroll;
      return Math.abs(iscroll.maxScrollY - iscroll.y) < 5;
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      if (this.iscroll) this.iscroll.refresh();
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.emit('resize');
    }
  }, {
    key: 'scrollToElement',
    value: function scrollToElement(el) {
      this.iscroll.scrollToElement(el);
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      this.iscroll.scrollTo(0, 0);
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      var iscroll = this.iscroll;

      iscroll.refresh();
      iscroll.scrollTo(0, iscroll.wrapperHeight - iscroll.scrollerHeight);
    }
  }, {
    key: 'imageOnLoad',
    value: function imageOnLoad(el) {
      (0, _tarzanZepto2.default)(el).find('img').on('load', this.refresh);
    }
  }, {
    key: 'imageOnScrollToBottom',
    value: function imageOnScrollToBottom(el) {
      var _this6 = this;

      (0, _tarzanZepto2.default)(el).find('img').on('load', function () {
        _this6.scrollToBottom();
      });
    }
  }, {
    key: 'showTime',
    value: function showTime() {
      var now = new Date();
      var nowString = now.toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '/').replace(/\b\d\b/g, '0$&').slice(0, -3);
      if (now - lastShowTime > showTimeInterval) {
        lastShowTime = now;
        this.__append('\n        <div class="m-chatpanel-item m-chatpanel-system">\n          <div class="body">\n          ' + nowString + '\n          </div>\n        </div>\n      ');
      }
    }
  }]);

  return Scroll;
}(_events3.default);

exports.default = Scroll;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

__webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnRead = function (_events) {
  _inherits(UnRead, _events);

  function UnRead(config) {
    _classCallCheck(this, UnRead);

    var _this = _possibleConstructorReturn(this, (UnRead.__proto__ || Object.getPrototypeOf(UnRead)).call(this));

    _this.nodes = [];

    _this.$container = config.container;
    _this.__init();
    _this.__bindEvent();
    return _this;
  }

  _createClass(UnRead, [{
    key: '__init',
    value: function __init() {
      this.$el = (0, _tarzanZepto2.default)('<button class="m-alicare-unread">\n      <svg class="icon" aria-hidden="true">\n          <use xlink:href="#icon-forward"></use>\n        </svg>\n      <span><span class="m-alicare-unread-count">0</span>\u6761\u65B0\u6D88\u606F</span>\n    </button>');
      this.$count = this.$el.find('.m-alicare-unread-count');
      this.$container.append(this.$el);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$el.show();
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.nodes = [];
      this.$el.hide();
    }
  }, {
    key: 'add',
    value: function add(node) {
      this.nodes.push(node);
      this.$count.text('' + this.nodes.length);
      this.show();
    }
  }, {
    key: '__bindEvent',
    value: function __bindEvent() {
      var _this2 = this;

      this.$el.on('tap', function () {
        _this2.emit('trigger', _this2.nodes[0]);
        _this2.hide();
      });
    }
  }]);

  return UnRead;
}(_events3.default);

exports.default = UnRead;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(162);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./index.scss", function() {
			var newContent = require("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-alicare-unread {\n  display: none;\n  position: absolute;\n  bottom: 8px;\n  right: 0;\n  background-color: #fff;\n  height: 36px;\n  border-radius: 18px 0 0 18px;\n  border: 0;\n  width: 120px;\n  font-size: 14px;\n  color: #666; }\n  .m-alicare-unread svg {\n    width: 14px;\n    height: 22px;\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n    color: #FFC940; }\n  .m-alicare-unread svg,\n  .m-alicare-unread > span {\n    vertical-align: middle; }\n", ""]);

// exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(164);

var _index4 = _interopRequireDefault(_index3);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _index5 = __webpack_require__(178);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(186);

var EMOJI_REG = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/gim;
var LOG_C = 'inputpanel';

var PC = _util2.default.isPC();

var InputPanel = function (_events) {
  _inherits(InputPanel, _events);

  function InputPanel(config) {
    _classCallCheck(this, InputPanel);

    var _this = _possibleConstructorReturn(this, (InputPanel.__proto__ || Object.getPrototypeOf(InputPanel)).call(this));

    _this.config = config;

    _this.$container = (0, _tarzanZepto2.default)(config.container);

    _this.log = config.log;

    _this.$plugin = null;

    _this.__$inputToolbar = null;

    _this.$shortcuts = null;

    _this.input = null;

    _this.inputTip = null;

    _this.__render();
    _this.__bindEvt();
    _this.__hack();
    return _this;
  }

  _createClass(InputPanel, [{
    key: '__render',
    value: function __render() {
      var $container = this.$container;
      $container.html(_index2.default.frame({ type: 'footer' }));

      this.__$inputToolbar = $container.find('.J_InputToolbar');
      this.$plugin = $container.find('.J_ExtPanel');
      this.$shortcuts = $container.find('.J_Shortcuts');

      this.input = this.__initInput();

      this.$inputWrap = $container.find('.J_InputWrap');
      this.$sendShortcut = $container.find('.J_OrderSelect');
      this.$sendShortcutInner = $container.find('.J_Orderlist');
      this.$pluginTrigger = $container.find('.J_ShowPluginBoard');
      this.$inputBtn = $container.find('.J_InputBtn');
      this.$slideUp = $container.find('.J_SlideUp');
      this.$emojiBtn = $container.find('.m-emoji-btn');
    }
  }, {
    key: 'submit',
    value: function submit(data) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
      var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var post = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var convertData = data;

      if (post && _util2.default.isString(convertData) && EMOJI_REG.test(convertData)) {
        convertData = data.replace(EMOJI_REG, '[\u8868\u60C5]');
      }
      if (post && _util2.default.isObject(convertData) && EMOJI_REG.test(convertData.q)) {
        convertData.q = convertData.q.replace(EMOJI_REG, '[\u8868\u60C5]');
      }
      this.emit('message', [convertData, type, show, post]);

      if (show) {
        this.scrollToBottom();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      var $container = this.$container;
      if (this.input.field.inputFormat === 'number') {
        $container.find('.J_NumberField').trigger('focus');
      } else {
        $container.find('.J_Field').trigger('focus');
      }
    }
  }, {
    key: 'blur',
    value: function blur() {
      var $container = this.$container;
      if (this.input.field.inputFormat === 'number') {
        $container.find('.J_NumberField').trigger('blur');
      } else {
        $container.find('.J_Field').trigger('blur');
      }
      this.__hackFocus();
    }
  }, {
    key: '__hackFocus',
    value: function __hackFocus() {
      var $$container = (0, _tarzanZepto2.default)('.m-alicare-body');

      $$container.attr('tabindex', 1);

      $$container.trigger('focus');
    }
  }, {
    key: 'setTipText',
    value: function setTipText(text) {
      var _this2 = this;

      this.inputTip = new _index6.default(text, this.$container);
      this.inputTip.on('send', function (ev) {
        _this2.submit(ev.text);
      });
    }
  }, {
    key: 'setPlaceholder',
    value: function setPlaceholder(text) {
      this.input.field.$field.attr('placeholder', text);
    }
  }, {
    key: '__bindEvt',
    value: function __bindEvt() {
      var _this3 = this;

      var $container = this.$container;
      var Action = PC ? 'click' : 'tap';
      this.$inputBtn.on(Action, function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var hasActiveSendBtn = _this3.$inputBtn.hasClass('active');
        if (hasActiveSendBtn) {
          _this3.__sendTextMessage();
          _this3.input.field.adjustTextareaHeight();
        } else {}
      });

      $container.find('.J_Field').on('input', function (ev) {
        var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
        (0, _tarzanZepto2.default)(document).trigger('inputing');
        (0, _index7.smileytip)($target.val(), function (text) {
          _this3.submit(text, 'liveImage');
          $target.val('');
          $target.trigger('change');
        });
      });

      $container.find('.J_Field,.J_NumberField').on('keydown keyup', function (ev) {
        var f = _this3.input.field;
        var val = f.getValue() || '';
        if (ev.keyCode === 13 && val) {
          _this3.__sendTextMessage();
          _this3.input.field.adjustTextareaHeight();
          ev.preventDefault();
          _this3.log.send({
            c: LOG_C,
            d: 'enter'
          });
        }
      });
      $container.find('.J_Field,.J_NumberField').on('focus', function () {
        if (_this3.inputTip) {
          _this3.inputTip.showTip();
        }
        _this3.emit('focus');
        _this3.__scrollIntoView();
      });

      $container.find('.J_Field').on('blur', function () {
        if (_this3.inputTip) {
          _this3.inputTip.hideTip();
        }
        setTimeout(function () {
          _this3.__hackFocus();
        }, 100);
      });

      var startX = 0;
      this.$shortcuts.on('touchstart', function (ev) {
        startX = ev.touches[0].pageX;
      });
      this.$shortcuts.on('touchend', function (ev) {
        var endX = ev.changedTouches[0].pageX;
        if (endX - startX > 10) {
          _this3.log.send({
            c: 'shortcut',
            d: 'swiperight'
          });
        } else if (endX - startX < -10) {
          _this3.log.send({
            c: 'shortcut',
            d: 'swipeleft'
          });
        }
      });
    }
  }, {
    key: 'appendSlideUp',
    value: function appendSlideUp($node) {
      this.$slideUp.html($node);
    }
  }, {
    key: 'showSlideUp',
    value: function showSlideUp(hideInput) {
      this.$slideUp.removeClass('slide-out-to-bottom').addClass('slide-in-from-bottom');
      this.hideShortcuts();
      this.resize();
      this.scrollToBottom();

      if (hideInput) {
        this.hideInputPanel();
      }
    }
  }, {
    key: 'hideSlideUp',
    value: function hideSlideUp() {
      var hideShortcuts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$slideUp.removeClass('slide-in-from-bottom').addClass('slide-out-to-bottom');
      this.$slideUp.html('');

      if (!hideShortcuts) this.showShortcuts();
      this.showInputPanel();
      this.resize();
      this.scrollToBottom();
    }
  }, {
    key: 'showInputPanel',
    value: function showInputPanel() {
      this.$inputWrap.show();
    }
  }, {
    key: 'hideInputPanel',
    value: function hideInputPanel() {
      this.$inputWrap.hide();
    }
  }, {
    key: '__initInput',
    value: function __initInput() {
      var _this4 = this;

      var $container = this.$container;
      var input = new _index4.default({
        log: this.log,
        container: $container.find('.J_InputForm'),
        inputType: this.config.inputType
      });
      var $inputField = input.field.$field;
      var $inputForm = $container.find('.J_InputForm');
      var $toolBar = $container.find('.J_InputToolbar');

      input.on('switch', function (ev) {
        if (ev.inputType === 'keyboard') {
          input.field.focus();
        } else {
          input.field.blur();
        }
        if (!ev.force) {
          _this4.log.send({
            c: LOG_C,
            d: ev.inputType
          });
        }
        _this4.hidePlugin();
        setTimeout(function () {
          $toolBar.height($inputForm.height());
        }, 0);
      });

      input.on('resize', function () {
        _this4.resize();
        _this4.scrollToBottom();
      });

      $inputField.on('focus', _util2.default.buffer(function () {
        if (document.activeElement.tagName === 'TEXTAREA') {
          _this4.hidePlugin();
          _this4.log.send({
            c: LOG_C,
            d: 'focus'
          });
        }
      }, 50));

      $inputField.on('blur', function () {
        _this4.emit('blur');
      });

      $inputField.on('keyup', function () {
        _this4.emit('keyup');
      });

      input.on('voice', function (result) {
        _this4.submit(result, 'text', false, true);
        _this4.emit('voice', {
          text: result
        });
        _this4.showShortcuts();
      });

      input.on('voicestart', function () {
        _this4.emit('voicestart');
        _this4.hideShortcuts();
      });

      input.on('voicecancel', function () {
        _this4.emit('voicecancel');
        _this4.showShortcuts();
      });

      return input;
    }
  }, {
    key: '__sendTextMessage',
    value: function __sendTextMessage() {
      var f = this.input.field;
      var val = f.getValue() || '';

      val = val.replace(/</g, '&lt;').replace(/>/g, '&gt;').trim();

      if (val) {
        this.submit(val);
        f.setValue('');
      }
      f.focus();
    }
  }, {
    key: '__hack',
    value: function __hack() {
      var originWinHeight = (0, _tarzanZepto2.default)(window).height();
      if (_util2.default.UA.isAndroid) {
        window.onresize = function () {
          var nowHeight = (0, _tarzanZepto2.default)(window).height();
          (0, _tarzanZepto2.default)('body').css({
            bottom: nowHeight - originWinHeight,
            height: nowHeight
          });
        };
      }
    }
  }, {
    key: 'hidePlus',
    value: function hidePlus() {
      this.$pluginTrigger.hide();
    }
  }, {
    key: 'addPlugin',
    value: function addPlugin(config) {
      var _this5 = this;

      var Action = PC ? 'click' : 'tap';
      var $el = (0, _tarzanZepto2.default)('<div class="item ' + config.name + '" aria-label="' + config.title + '" role="button">\n      <div class="icon-bg">\n        <svg class="icon" aria-hidden="true">\n          <use xlink:href="#icon-' + config.icon + '"></use>\n        </svg>\n      </div>\n      <span aria-hidden="true">' + config.title + '</span>\n    </div>');

      $el.on(Action, function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        config.action.call(_this5);
      });
      this.$plugin.find('.J_Plugins').append($el);
    }
  }, {
    key: 'hideTargetPlugin',
    value: function hideTargetPlugin(name) {
      this.$plugin.find('.' + name).hide();
    }
  }, {
    key: 'showTargetPlugin',
    value: function showTargetPlugin(name) {
      this.$plugin.find('.' + name).show();
    }
  }, {
    key: 'showPlugin',
    value: function showPlugin() {
      this.input.field.blur();
      this.$pluginTrigger.attr('aria-label', '收起插件');
      this.$pluginTrigger.addClass('rotated');

      this.$plugin.show();
      this.resize();
      this.scrollToBottom();
    }
  }, {
    key: 'hidePlugin',
    value: function hidePlugin() {
      this.emit('hidePlugin');
      this.$pluginTrigger.attr('aria-label', '展开插件');
      this.$pluginTrigger.removeClass('rotated');
      this.$plugin.hide();
      this.resize();
    }
  }, {
    key: 'showShortcuts',
    value: function showShortcuts() {
      var $shortcutsContent = this.$shortcuts.find('.m-shortcuts');
      this.$shortcuts.show();

      $shortcutsContent.scrollLeft(0);
    }
  }, {
    key: 'hideShortcuts',
    value: function hideShortcuts() {
      this.$shortcuts.hide();
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.emit('resize');
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.emit('scrollToBottom');
    }
  }, {
    key: '__scrollIntoView',
    value: function __scrollIntoView() {
      var form = this.$container.find('.J_InputForm')[0];
      setTimeout(function () {
        form.scrollIntoView();
      }, 300);
    }
  }]);

  return InputPanel;
}(_events3.default);

exports.default = InputPanel;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(165);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(170);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(176);

var Input = function (_events) {
  _inherits(Input, _events);

  function Input() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this));

    _this.$container = (0, _tarzanZepto2.default)(config.container);
    _this.log = config.log;
    _this.bridge = config.bridge;
    _this.__current = null;

    _this.supportSpeech = false;
    var html = _index2.default.frame({ type: 'input', speech: _this.supportSpeech });
    _this.$container.append((0, _tarzanZepto2.default)(html));
    _this.field = _this.__initFiled();
    _this.voice = _this.__initVoice();
    _this.__switch();
    _this.__voiceInput();

    var useSpeech = config.inputType === 'voice' && _this.supportSpeech;
    if (useSpeech) {
      _this.useVoice();
    } else {
      _this.useKeyboard();
    }
    return _this;
  }

  _createClass(Input, [{
    key: '__initFiled',
    value: function __initFiled() {
      var _this2 = this;

      var field = new _index4.default({
        $container: this.$container,
        trigger: this.$container.find('.J_Field')
      });

      var $btns = this.$container.find('.m-input-btn');
      field.on('resize', function () {
        _this2.emit('resize');
      });

      field.on('input', function (ev) {
        if (ev.newVal) {
          $btns.addClass('active');
        } else {
          $btns.removeClass('active');
        }
      });

      return field;
    }
  }, {
    key: '__initVoice',
    value: function __initVoice() {
      return new _index6.default({
        log: this.log,
        trigger: this.$container.find('.J_Voice')
      });
    }
  }, {
    key: '__voiceInput',
    value: function __voiceInput() {
      var _this3 = this;

      this.voice.on('input', function (input) {
        if (input.trim().length === 0) {
          _this3.emit('voicecancel');
          _this3.showTip();
        } else {
          _this3.emit('voice', input);
        }
      });

      this.voice.on('voicestart', function () {
        _this3.emit('voicestart');
      });

      this.voice.on('voicecancel', function () {
        _this3.emit('voicecancel');
      });
    }
  }, {
    key: '__switch',
    value: function __switch() {
      var _this4 = this;

      var btn = this.$container.find('.J_BtnSwitch');
      var switchBtn = btn.find('.btn');
      btn.on('tap', function () {
        if (_this4.__current === 'voice') {
          switchBtn.attr('aria-label', '切换到键盘输入');
        } else {
          switchBtn.attr('aria-label', '切换到语音输入');
        }
        _this4.__switchInputType(_this4.__current);
      });
    }
  }, {
    key: 'hideVoice',
    value: function hideVoice() {
      var btn = this.$container.find('.J_BtnSwitch');
      btn.hide();
    }
  }, {
    key: 'useKeyboard',
    value: function useKeyboard() {
      this.__switchInputType('keyboard');
    }
  }, {
    key: 'useVoice',
    value: function useVoice(force) {
      this.__switchInputType('voice', force);
    }
  }, {
    key: '__switchInputType',
    value: function __switchInputType(type, force) {
      var btn = this.$container.find('.J_BtnSwitch');
      var panel = this.$container.find('.J_Panel');

      var k = 'keyboard';
      var v = 'voice';

      if (type === k) {
        btn.removeClass(k).addClass(v);
        panel.removeClass(v).addClass(k);
        this.__current = v;
      } else if (type === v) {
        btn.removeClass(v).addClass(k);
        panel.removeClass(k).addClass(v);
        this.__current = k;
      }

      this.emit('switch', {
        inputType: type,
        force: force
      });
    }
  }, {
    key: 'showTip',
    value: function showTip() {
      var $tipDom = (0, _tarzanZepto2.default)('<div class="m-voice-tip">\n</div>');

      $tipDom.appendTo('body');
      $tipDom.css({
        bottom: 60,
        left: (0, _tarzanZepto2.default)(window).width() / 2 - 70
      }).show();
      setTimeout(function () {
        $tipDom.remove();
      }, 1500);
    }
  }]);

  return Input;
}(_events3.default);

exports.default = Input;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _index = __webpack_require__(166);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Field = function (_events) {
  _inherits(Field, _events);

  function Field(config) {
    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this));

    var $target = (0, _tarzanZepto2.default)(config.trigger);

    _this.$field = $target;
    _this.$container = config.$container;
    _this.$copy = _this.$field.siblings('.J_InputFieldCopy');
    _this.$numberField = _this.$field.siblings('.J_NumberField');
    _this.$wrap = _this.$container.find('.keyboard-wrap');

    _this.inputFormat = 'text';
    _this.textareaHeight = 0;
    _this.__bindEvt();
    _this.__hack();
    return _this;
  }

  _createClass(Field, [{
    key: 'setValue',
    value: function setValue(val) {
      var f = this.$field;
      var old = f.val();
      this.$field.val(val);
      this.$numberField.val(val);
      this.__valueChange(val, old);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.$field.val();
    }
  }, {
    key: 'switchInputFormat',
    value: function switchInputFormat() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'text';

      if (type === 'number') {
        this.$field.hide();
        this.$numberField.show();
      } else {
        this.$numberField.hide();
        this.$field.show();
      }
      this.inputFormat = type;
    }
  }, {
    key: 'insertVal',
    value: function insertVal(text) {
      var el = this.$field[0];
      var val = el.value;
      var endIndex = void 0;
      var range = void 0;

      if (typeof el.selectionStart !== 'undefined' && typeof el.selectionEnd !== 'undefined') {
        endIndex = el.selectionEnd;
        el.value = val.slice(0, el.selectionStart) + text + val.slice(endIndex);
        el.selectionStart = el.selectionEnd = endIndex + text.length;

        this.blur();
      } else if (typeof document.selection !== 'undefined' && typeof document.selection.createRange !== 'undefined') {
        range = document.selection.createRange();
        range.collapse(false);
        range.text = text;
        range.select();
      }
      this.__valueChange(el.value, val);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$field[0].focus();
      }, 200);
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.$field[0].blur();
    }
  }, {
    key: 'adjustTextareaHeight',
    value: function adjustTextareaHeight() {
      var val = this.$field.val();
      var invisibleTextarea = this.$copy;
      invisibleTextarea.val(val);
      var height = invisibleTextarea[0].scrollHeight;
      this.setTextareaHeight(Math.max(height, 35));
    }
  }, {
    key: 'setTextareaHeight',
    value: function setTextareaHeight(height) {
      var $toolBar = (0, _tarzanZepto2.default)('.m-input-toolbar');

      if (height > 120) {
        return;
      }

      if (this.textareaHeight === height) {
        return;
      }
      this.textareaHeight = height;

      $toolBar.height(height + 17);
      $toolBar.find('.keyboard-wrap').height(height);
      this.$field.height(height);
      this.emit('resize');
    }
  }, {
    key: 'setPlaceholder',
    value: function setPlaceholder(text) {
      this.$field.attr('placeholder', text);
    }
  }, {
    key: '__valueChange',
    value: function __valueChange(newVal, oldVal) {
      this.adjustTextareaHeight();
      this.emit('input', {
        newVal: newVal,
        oldVal: oldVal
      });
    }
  }, {
    key: '__bindEvt',
    value: function __bindEvt() {
      var _this3 = this;

      var f = this.$field;
      var text = '';

      this.$numberField.on('keydown keyup change input', _util2.default.buffer(function () {
        _this3.$field.val(_this3.$numberField.val());
        f.trigger('change');
      }, 100));

      f.on('focus', function () {
        _this3.$wrap.addClass('active');
      }).on('blur', function () {
        _this3.$wrap.removeClass('active');
      });

      f.on('keydown keyup change input', _util2.default.buffer(function () {
        var newText = f.val();
        var LIMIT = 300;
        if (newText.trim().length > LIMIT) {
          f.val(newText.trim().substr(0, LIMIT - 1));
          _this3.showTips('Your input exceeds the limit', 3000);
        }
        _this3.__valueChange(f.val(), text);
        text = newText;
      }));
    }
  }, {
    key: '__hack',
    value: function __hack() {
      var $f = this.$field;
      var f = this.$field[0];

      if (_util2.default.UA.ios && f.scrollIntoView) {
        var timer = null;
        $f.on('focus', function () {
          timer = setInterval(function () {
            f.scrollIntoView(false);
          }, 50);
        }).on('blur', function () {
          if (timer) {
            clearInterval(timer);
          }
        });
      }
    }
  }, {
    key: 'showTips',
    value: function showTips(content, time) {
      this.tip = new _index2.default({
        content: content,
        interval: time
      });
    }
  }]);

  return Field;
}(_events3.default);

exports.default = Field;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _tpl = __webpack_require__(167);

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(168);

var Tip = function () {
  function Tip(config) {
    var _this = this;

    _classCallCheck(this, Tip);

    var $root = (0, _tarzanZepto2.default)(_tpl2.default.render({
      content: config.content
    }));

    $root.on('tap', function () {
      _this.hide();
    });

    (0, _tarzanZepto2.default)(document.body).append($root);

    this.$root = $root;
    this.timer = setTimeout(function () {
      _this.hide();
    }, config.interval || 5000);
  }

  _createClass(Tip, [{
    key: 'hide',
    value: function hide() {
      var _this2 = this;

      this.$root.animate({
        opacity: 0
      }, 500, 'ease-out', function () {
        if (_this2.timer) {
          clearTimeout(_this2.timer);
          _this2.$root.unbind('tap', _this2.hide);
          _this2.$root.remove();
        }
      });
    }
  }]);

  return Tip;
}();

exports.default = Tip;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/tip/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"mod-component-tips\">\n    <div>\n        <span class=\"iconfont icon-jiahao\"></span>\n    </div>\n    <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "content"), env.opts.autoescape);
output += "</p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/tip/tpl.html"] , dependencies)

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(169);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".mod-component-tips {\n  position: absolute;\n  z-index: 999;\n  top: 25%;\n  width: 200px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background-color: rgba(103, 111, 108, 0.9);\n  border-radius: 5px; }\n  .mod-component-tips div {\n    text-align: center;\n    padding-top: 15px;\n    color: white;\n    font-size: 44px; }\n  .mod-component-tips p {\n    font-size: 14px;\n    padding: 10px;\n    margin: 0 10px;\n    color: #fff;\n    text-align: center;\n    line-height: 20px; }\n", ""]);

// exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _voiceinput = __webpack_require__(171);

var _voiceinput2 = _interopRequireDefault(_voiceinput);

var _record = __webpack_require__(172);

var _record2 = _interopRequireDefault(_record);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _wave = __webpack_require__(173);

var _wave2 = _interopRequireDefault(_wave);

__webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATUS_RECORDING = 'recording';
var STATUS_CANCEL = 'canceling';

var LOG_C = 'inputpanel';

var VoiceInput = function (_events) {
  _inherits(VoiceInput, _events);

  function VoiceInput(config) {
    _classCallCheck(this, VoiceInput);

    var _this = _possibleConstructorReturn(this, (VoiceInput.__proto__ || Object.getPrototypeOf(VoiceInput)).call(this));

    var $target = (0, _tarzanZepto2.default)(config.trigger);

    _this.log = config.log;

    _this.$record = (0, _tarzanZepto2.default)(_record2.default.render());

    _this.__initWave();

    _this.voice = _this.__voice();

    _this.__bindEvt($target);
    (0, _tarzanZepto2.default)('body').append(_this.$record);
    _this.__status = '';
    _this.$mask = (0, _tarzanZepto2.default)('<div class="m-voice-mask"></div>');
    _this.$mask.appendTo(document.body);
    return _this;
  }

  _createClass(VoiceInput, [{
    key: '__bindEvt',
    value: function __bindEvt($target) {
      var _this2 = this;

      var startY = 0;
      var endY = 0;

      $target.on('touchstart', function (ev) {
        ev.preventDefault();
        $target.removeClass('press-speech').addClass('loosen-speech');
        _this2.voice.start();
        startY = ev.touches[0].pageY;
        _this2.log.send({
          c: LOG_C,
          d: 'voice_press'
        });
      });

      $target.on('touchmove', function (ev) {
        var nowY = ev.touches[0].pageY;

        if (nowY - startY < -60) {
          _this2.setStatusAs(STATUS_CANCEL);
          $target.removeClass('loosen-speech').addClass('press-speech');
        } else {
          _this2.setStatusAs(STATUS_RECORDING);
          $target.removeClass('press-speech').addClass('loosen-speech');
        }
      });

      $target.on('touchend', function (ev) {
        $target.addClass('press-speech').removeClass('loosen-speech');

        endY = ev.changedTouches[0].pageY;

        if (endY - startY > -60) {
          setTimeout(function () {
            _this2.voice.end();
          }, 300);
          _this2.log.send({
            c: LOG_C,
            d: 'voice_loosen'
          });
        } else {
          _this2.voice.cancel();
          _this2.log.send({
            c: LOG_C,
            d: 'voice_cancel'
          });
        }
      });
    }
  }, {
    key: '__voice',
    value: function __voice() {
      var _this3 = this;

      var voice = new _voiceinput2.default();
      var hasCancel = false;

      voice.on('start', function () {
        _this3.showRecord();
        _this3.emit('voicestart');
      });

      voice.on('end', function () {
        _this3.hideRecord();
        hasCancel = false;
      });

      voice.on('cancel', function () {
        _this3.hideRecord();
        _this3.emit('voicecancel');
        hasCancel = true;
      });

      voice.on('startError', function () {
        _this3.hideRecord();
        _this3.emit('voicecancel');
      });

      voice.on('endError', function () {
        _this3.hideRecord();
        _this3.emit('voicecancel');
      });

      voice.on('result', function (ev) {
        if (hasCancel) {
          hasCancel = false;
          return;
        }

        _this3.emit('input', ev);
        _this3.hideRecord();
      });

      voice.on('volume', function (volume) {
        _this3.pushWave(volume);
      });

      return voice;
    }
  }, {
    key: '__initWave',
    value: function __initWave() {
      this.rightWave = new _wave2.default({
        el: this.$record.find('.right-wave')
      });

      this.leftWave = new _wave2.default({
        el: this.$record.find('.left-wave'),
        direction: 'left'
      });
    }
  }, {
    key: 'startWave',
    value: function startWave() {
      this.leftWave.start();
      this.rightWave.start();
    }
  }, {
    key: 'stopWave',
    value: function stopWave() {
      this.leftWave.stop();
      this.rightWave.stop();
    }
  }, {
    key: 'pushWave',
    value: function pushWave(v) {
      this.leftWave.push(v);
      this.rightWave.push(v);
    }
  }, {
    key: 'showRecord',
    value: function showRecord() {
      var _this4 = this;

      this.startWave();
      this.$record.show();
      this.$mask.show();
      _util2.default.later(function () {
        _this4.setStatusAs(STATUS_RECORDING);
      }, 100);
    }
  }, {
    key: 'hideRecord',
    value: function hideRecord() {
      var _this5 = this;

      this.stopWave();
      _util2.default.later(function () {
        _this5.setStatusAs('');
        _this5.$record.hide();
        _this5.$mask.hide();
      }, 100);
    }
  }, {
    key: 'setStatusAs',
    value: function setStatusAs(status) {
      this.$record.removeClass(this.__status).addClass(status);
      this.__status = status;
    }
  }]);

  return VoiceInput;
}(_events3.default);

exports.default = VoiceInput;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var doc = window.document;
var TBVoiceParam = {
  useoldasr: 'true',
  asrkey: 'alicare-demo'
};

function checkApp() {
  var ua = window.navigator.userAgent;
  var app = {};
  var aliApp = ua.match(/AliApp\S+\b\)/ig);
  app.is = !!/(T-UA)|(TBIOS)|(WindVane)|(AliApp)/i.test(ua);
  app.name = aliApp ? aliApp[0].match(/\(\w+\-*\w*/)[0].split('(')[1] : '';
  app.version = aliApp ? aliApp[0].match(/(\d+\.*)+/ig)[0] : '';
  return app;
}

function getClient() {
  var app = checkApp();
  if (app.is && app.name === 'TM') {
    return 'tmall';
  } else if (app.is && app.name === 'TB') {
    return 'taobao';
  } else if (app.is && app.name === 'AP') {
    return 'alipay';
  }
  return '';
}

var AppClient = getClient();

var VoiceInput = function (_events) {
  _inherits(VoiceInput, _events);

  function VoiceInput() {
    _classCallCheck(this, VoiceInput);

    var _this = _possibleConstructorReturn(this, (VoiceInput.__proto__ || Object.getPrototypeOf(VoiceInput)).call(this));

    doc.addEventListener('TBSearchVoice.Event.onRecognizingResult', function (ev) {
      if (ev.param.status === '-2') {
        var text = '';
        if (AppClient === 'taobao') {
          text = '> “手机淘宝” ';
        } else if (AppClient === 'tmall') {
          text = '> “天猫” ';
        }
        _util2.default.beealert('\u4EB2\uFF0C\u8DDF\u5C0F\u871C\u8BF4\u8BDD\uFF0C\u8981\u5148\u524D\u5F80\uFF1A\u4F60\u7684\u624B\u673A\u4E2D\u201C\u8BBE\u7F6E\u201D > \u201C\u9690\u79C1\u201D > \u201C\u9EA6\u514B\u98CE\u201D ' + text + '\u4E2D\u6253\u5F00\u6743\u9650\u54E6');
        _this.emit('cancel');
      } else {
        _this.emit('result', ev.param.asr);
      }
    }, false);

    doc.addEventListener('TBSearchVoice.Event.onVoiceVolume', function (ev) {
      _this.emit('volume', ev.param.volume);
    }, false);

    _this.listening = false;
    return _this;
  }

  _createClass(VoiceInput, [{
    key: 'start',
    value: function start() {
      var _this2 = this;

      if (this.listening) {
        return;
      }
      if (lib && lib.windvane && lib.windvane.isAvailable) {
        lib.windvane.call('TBSearchVoice', 'startVoiceRecognition', TBVoiceParam, function () {}, function () {
          _this2.emit('startError');
        });
        this.emit('start');
        this.listening = true;
      } else {
        this.emit('fatal');
      }
    }
  }, {
    key: 'end',
    value: function end() {
      var _this3 = this;

      if (!this.listening) {
        return;
      }

      if (lib && lib.windvane && lib.windvane.isAvailable) {
        lib.windvane.call('TBSearchVoice', 'stopVoiceRecognition', TBVoiceParam, function () {}, function () {
          _this3.emit('endError');
        });

        this.emit('end');
        this.listening = false;
      }
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      var _this4 = this;

      if (!this.listening) {
        return;
      }
      if (lib && lib.windvane && lib.windvane.isAvailable) {
        lib.windvane.call('TBSearchVoice', 'cancelVoiceRecognition', TBVoiceParam, function () {}, function () {
          _this4.emit('cancelError');
        });
        this.emit('cancel');
        this.listening = false;
      }
    }
  }]);

  return VoiceInput;
}(_events3.default);

exports.default = VoiceInput;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/input/voice/record.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-voice J_Record\">\n  <div class=\"m-voice-status im-avatar-wrap\">\n    <ul class=\"left-wave\">\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n    </ul>\n    <div class=\"im-avatar\">\n      <div class=\"avatar-wrap J_Robot\">\n        <div class=\"avatar-head\"></div>\n        <div class=\"avatar-body\"></div>\n        <div class=\"avatar-tie\"></div>\n      </div>\n    </div>\n    <ul class=\"right-wave\">\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n      <li class=\"wave-item\"></li>\n    </ul>\n  </div>\n  <div class=\"m-voice-msg\">\n      <p class=\"msg-record\">松开发送 上滑取消</p>\n      <p class=\"msg-cancel\">松开手指 取消发送</p>\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/input/voice/record.html"] , dependencies)

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERVAL = 66;

var DIFF_THRESHOLD = 20;

var SMOOTH_STEP = 5;

var MIN_RANGE = _tarzanZepto2.default.ios ? 30 : 0;
var MAX_RANGE = _tarzanZepto2.default.ios ? 80 : 100;
var MIN_VALUE = 5;
var MAX_VALUE = 60;
var STEP = 5;

var Wave = function (_events) {
  _inherits(Wave, _events);

  function Wave(cfg) {
    _classCallCheck(this, Wave);

    var _this = _possibleConstructorReturn(this, (Wave.__proto__ || Object.getPrototypeOf(Wave)).call(this));

    _this.$wrap = (0, _tarzanZepto2.default)(cfg.el);
    _this.$items = _this.$wrap.find('.wave-item');
    _this.direction = cfg.direction || 'right';

    _this.count = _this.$items.length;

    _this.__reset();
    return _this;
  }

  _createClass(Wave, [{
    key: 'start',
    value: function start() {
      this.running = true;
      this.__clock = this.__start = +new Date();
      this.__loop();
      this.__countdown();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.__reset();
      this.__render();
    }
  }, {
    key: 'push',
    value: function push(val) {
      this.__queue.push(val);
    }
  }, {
    key: '__reset',
    value: function __reset() {
      this.running = false;
      this.__start = null;
      this.__queue = [];
      this.__status = [];
      if (this.__counter) clearTimeout(this.__counter);
      this.__timer = null;
      this.__counter = null;
    }
  }, {
    key: '__loop',
    value: function __loop() {
      var _this2 = this;

      if (!this.running) {
        return;
      }

      var now = +new Date();

      if (now - this.__clock > INTERVAL) {
        this.__clock = now;
        var status = this.__status;
        var val = this.__getNewStatus(status);

        status.unshift(val);
        while (status.length < this.count) {
          status.push(0);
        }
        while (status.length > this.count) {
          status.pop();
        }

        _util2.default.requestAnimationFrame(function () {
          _this2.__render(status);
        });
      }

      this.__timer = _util2.default.requestAnimationFrame(function () {
        _this2.__loop();
      });
    }
  }, {
    key: '__getNewStatus',
    value: function __getNewStatus(status) {
      var queue = this.__queue;
      var lastValue = 1 * status[0] || 0;
      var val = queue.pop() * 1;
      queue.length = 0;

      if (!val) {
        val = lastValue === 0 ? 0 : Math.abs(lastValue - SMOOTH_STEP);
      }

      while (Math.abs(val - lastValue) > DIFF_THRESHOLD) {
        val = Math.floor((val + lastValue) / 2);
      }

      return val;
    }
  }, {
    key: '__render',
    value: function __render() {
      var _this3 = this;

      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var statusBar = status;
      if (this.direction === 'left') {
        statusBar = [].concat(statusBar).reverse();
      }

      this.$items.each(function (idx, item) {
        (0, _tarzanZepto2.default)(item).height(_this3.__calcHeight(statusBar[idx]));
      });
    }
  }, {
    key: '__calcHeight',
    value: function __calcHeight() {
      var volume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (volume < MIN_RANGE) {
        return MIN_VALUE;
      } else if (volume >= MAX_RANGE) {
        return MAX_VALUE;
      }

      return MIN_VALUE + (volume - MIN_RANGE) / ((MAX_VALUE - MIN_VALUE) / STEP) * STEP;
    }
  }, {
    key: '__countdown',
    value: function __countdown() {
      var _this4 = this;

      var current = +new Date();
      var MAX = 18;
      var cd = Math.floor((current - this.__start) / 1000);
      var remain = Math.floor(MAX - cd);
      if (remain >= 0) {
        this.emit('count', remain);

        this.__counter = setTimeout(function () {
          _this4.__countdown();
        }, 1000);
      } else {
        this.emit('end');
      }
    }
  }]);

  return Wave;
}(_events3.default);

exports.default = Wave;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(175);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-voice {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 2;\n  height: 50px;\n  overflow: hidden;\n  transition: height 0.3s ease;\n  display: none; }\n  .m-voice .m-voice-status {\n    height: 59px;\n    background-color: #ffffff; }\n    .m-voice .m-voice-status:before, .m-voice .m-voice-status:after {\n      content: '';\n      background-color: #fff;\n      display: block;\n      height: 117px;\n      -webkit-box-flex: 1;\n      -ms-flex: 1;\n      flex: 1;\n      overflow: hidden; }\n    .m-voice .m-voice-status .im-avatar {\n      width: 70px;\n      height: 72px;\n      background: #fff;\n      border-radius: 72px;\n      margin: 0 auto;\n      position: relative; }\n      .m-voice .m-voice-status .im-avatar .xiaomi {\n        width: 70px;\n        height: 74px;\n        background-color: #fff; }\n  .m-voice.canceling, .m-voice.recording {\n    height: 100px;\n    border-bottom: 1px solid #DADADA; }\n  .m-voice p {\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n    color: #aaa;\n    font-weight: 300; }\n  .m-voice-status {\n    height: 75px !important; }\n    .m-voice-status:after, .m-voice-status:before {\n      height: 75px !important; }\n    .m-voice-status .left-wave,\n    .m-voice-status .right-wave {\n      position: absolute;\n      list-style: none;\n      top: 0;\n      height: 75px;\n      padding: 0;\n      margin: 0;\n      width: 50%;\n      display: -webkit-box;\n      /* OLD - iOS 6-, Safari 3.1-6 */\n      /* OLD - Firefox 19- (buggy but mostly works) */\n      display: -ms-flexbox;\n      /* TWEENER - IE 10 */\n      /* NEW - Chrome */\n      display: flex;\n      /* NEW, Spec - Opera 12.1, Firefox 20+ */\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      -ms-flex-pack: distribute;\n      justify-content: space-around;\n      -webkit-box-pack: justify;\n      -moz-box-pack: justify;\n      box-sizing: border-box;\n      z-index: 1; }\n    .m-voice-status .right-wave {\n      right: 0;\n      padding-left: 35px;\n      padding-right: 5px; }\n    .m-voice-status .left-wave {\n      left: 0;\n      padding-right: 35px;\n      padding-left: 5px; }\n    .m-voice-status .wave-item {\n      display: inline-block;\n      display: -webkit-box;\n      width: 5px;\n      height: 5px;\n      vertical-align: middle;\n      border-radius: 5px;\n      background-color: #FFCE59;\n      max-height: 60px !important; }\n    .m-voice-status .count-down {\n      line-height: 60px;\n      text-align: center;\n      display: block;\n      font-size: 24px;\n      background-color: #D2691E;\n      color: #fff;\n      width: 60px;\n      height: 60px;\n      border-radius: 30px;\n      margin: 5px;\n      margin-top: 11px; }\n  .m-voice-msg {\n    margin: 0 auto;\n    text-align: center;\n    background-color: #fff;\n    height: 25px; }\n    .m-voice-msg .msg-cancel {\n      display: none;\n      color: #FF5000;\n      font-weight: 500; }\n  .m-voice.canceling .msg-record {\n    display: none; }\n  .m-voice.canceling .msg-cancel {\n    display: block; }\n  .m-voice.canceling .wave-item {\n    background-color: #FF5000; }\n\n.m-voice-mask {\n  display: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.3); }\n", ""]);

// exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(177);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-input-panel {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding: 8px 0;\n  box-sizing: border-box; }\n  .m-input-panel .btn-switch,\n  .m-input-panel .m-input-btn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    overflow: hidden; }\n  .m-input-panel .btn-switch {\n    padding-left: 5px; }\n    .m-input-panel .btn-switch .btn {\n      display: block;\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      background-color: #fff;\n      color: #aaa;\n      padding: 0;\n      font-size: 28px; }\n      .m-input-panel .btn-switch .btn .icon {\n        color: #666E71;\n        font-size: 22px;\n        vertical-align: 0; }\n    .m-input-panel .btn-switch.keyboard .voice {\n      display: none; }\n    .m-input-panel .btn-switch.voice .keyboard {\n      display: none; }\n  .m-input-panel .panel {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding: 0 8px;\n    margin-right: 40px; }\n    .m-input-panel .panel.voice .keyboard-wrap {\n      display: none; }\n    .m-input-panel .panel.voice .voice-wrap {\n      display: block; }\n    .m-input-panel .panel.keyboard .keyboard-wrap {\n      display: block; }\n    .m-input-panel .panel.keyboard .voice-wrap {\n      display: none; }\n    .m-input-panel .panel .keyboard-wrap, .m-input-panel .panel .voice-wrap {\n      height: 35px;\n      border-radius: 6px;\n      box-sizing: border-box;\n      padding: 0 1px;\n      position: relative;\n      line-height: 35px; }\n    .m-input-panel .panel .keyboard-wrap {\n      transition: height 200ms linear;\n      background-color: #ffffff;\n      border: 1px solid #DADADA; }\n      .m-input-panel .panel .keyboard-wrap.active {\n        border: 1px solid #1A9CB7; }\n      .m-input-panel .panel .keyboard-wrap .textarea:focus {\n        outline: 0; }\n      .m-input-panel .panel .keyboard-wrap .textarea, .m-input-panel .panel .keyboard-wrap .textarea-copy, .m-input-panel .panel .keyboard-wrap .input {\n        width: 90%;\n        height: 35px;\n        padding: 7px 5px;\n        line-height: 19px;\n        box-sizing: border-box;\n        border-width: 0;\n        background-color: transparent;\n        resize: none;\n        outline: none;\n        font-size: 16px;\n        overflow: auto;\n        color: #333333;\n        -webkit-touch-callout: default;\n        word-break: break-all; }\n        .m-input-panel .panel .keyboard-wrap .textarea::-webkit-input-placeholder, .m-input-panel .panel .keyboard-wrap .textarea-copy::-webkit-input-placeholder, .m-input-panel .panel .keyboard-wrap .input::-webkit-input-placeholder {\n          color: #ccc; }\n        .m-input-panel .panel .keyboard-wrap .textarea::-webkit-scrollbar, .m-input-panel .panel .keyboard-wrap .textarea-copy::-webkit-scrollbar, .m-input-panel .panel .keyboard-wrap .input::-webkit-scrollbar {\n          display: none; }\n      .m-input-panel .panel .keyboard-wrap .m-emoji-btn {\n        display: inline-block;\n        height: 35px;\n        line-height: 35px;\n        position: absolute;\n        right: 10px; }\n        .m-input-panel .panel .keyboard-wrap .m-emoji-btn i {\n          font-size: 20px;\n          color: #999; }\n      .m-input-panel .panel .keyboard-wrap .textarea-copy {\n        opacity: 0;\n        visibility: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1; }\n      .m-input-panel .panel .keyboard-wrap .input {\n        display: none; }\n    .m-input-panel .panel .voice-wrap {\n      display: none;\n      text-align: center;\n      background: #fff;\n      color: #666;\n      font-size: 14px;\n      margin-left: 5px;\n      border: 1px solid #E9ECEE;\n      z-index: 6; }\n      .m-input-panel .panel .voice-wrap .icon {\n        width: 20px;\n        height: 20px;\n        vertical-align: middle; }\n    .m-input-panel .panel .loosen-speech {\n      color: #ffffff;\n      border-color: #FFCE59;\n      background-color: #FFCE59; }\n      .m-input-panel .panel .loosen-speech .loosen-text {\n        display: inline; }\n        .m-input-panel .panel .loosen-speech .loosen-text .icon {\n          color: #fff; }\n      .m-input-panel .panel .loosen-speech .press-text {\n        display: none; }\n    .m-input-panel .panel .press-speech .press-text {\n      display: inline; }\n    .m-input-panel .panel .press-speech .loosen-text {\n      display: none; }\n  .m-input-panel .m-input-btn .btn {\n    display: block;\n    width: 32px;\n    height: 32px;\n    line-height: 32px;\n    background-color: transparent;\n    color: #a0a0a0;\n    padding: 0;\n    margin-right: 8px;\n    transition: opacity 260ms cubic-bezier(0.42, 0, 1, 1);\n    -webkit-transform: rotate(30deg);\n    transform: rotate(30deg); }\n  .m-input-panel .m-input-btn .send-btn {\n    position: absolute;\n    right: 2px;\n    top: 8px; }\n    .m-input-panel .m-input-btn .send-btn .iconfont {\n      font-size: 36px;\n      margin-top: 5px; }\n  .m-input-panel .m-input-btn .plug-btn {\n    position: absolute;\n    right: 5px;\n    bottom: 6px;\n    -webkit-transform: rotate(45deg) scale(0.9);\n    transform: rotate(45deg) scale(0.9);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    transition: -webkit-transform 200ms cubic-bezier(0.42, 0, 1, 1);\n    transition: transform 200ms cubic-bezier(0.42, 0, 1, 1);\n    transition: transform 200ms cubic-bezier(0.42, 0, 1, 1), -webkit-transform 200ms cubic-bezier(0.42, 0, 1, 1); }\n    .m-input-panel .m-input-btn .plug-btn.rotated {\n      right: 2px;\n      bottom: 4px;\n      -webkit-transform: rotate(0deg) scale(1);\n      transform: rotate(0deg) scale(1); }\n    .m-input-panel .m-input-btn .plug-btn .icon {\n      font-size: 20px;\n      color: #666E71; }\n  .m-input-panel .m-input-btn.active .send-btn .iconfont {\n    color: #1A9CB7; }\n  .m-input-panel .m-input-btn.active .plug-btn {\n    opacity: 0; }\n", ""]);

// exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tpl = __webpack_require__(179);

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(180);

var InputTip = function (_events) {
  _inherits(InputTip, _events);

  function InputTip(text, $wrap) {
    _classCallCheck(this, InputTip);

    var _this = _possibleConstructorReturn(this, (InputTip.__proto__ || Object.getPrototypeOf(InputTip)).call(this));

    _this.showed = false;
    var q = '';
    if (/\\u(\S{4})/g.test(text)) {
      text.replace(/\\u(\S{4})/g, function (a, b) {
        q += String.fromCharCode(parseInt(b, 16));
      });
    } else {
      q = text;
    }
    _this.text = q;
    _this.$node = (0, _tarzanZepto2.default)(_tpl2.default.render({
      text: q
    }));
    $wrap.append(_this.$node);
    _this.__bindEvent(_this.$node);
    return _this;
  }

  _createClass(InputTip, [{
    key: 'hideTip',
    value: function hideTip() {
      this.$node.hide();
    }
  }, {
    key: 'showTip',
    value: function showTip() {
      var self = this;
      if (!this.showed) {
        this.$node.show();
        this.showed = true;
        setTimeout(function () {
          self.hideTip();
        }, 6000);
      }
    }
  }, {
    key: '__bindEvent',
    value: function __bindEvent($node) {
      var _this2 = this;

      $node.on('tap', function () {
        _this2.emit('send', { text: _this2.text });
        _this2.hideTip();
      });
    }
  }]);

  return InputTip;
}(_events3.default);

exports.default = InputTip;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/inputtip/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-send-tip\">\n    <i class=\"arrow-ico\"></i>\n    <p class=\"tip-title\">是这个问题吗？</p>\n    <div class=\"tip-text\">\n        <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "</span>\n        <span class=\"send-btn\">\n            <i class=\"iconfont icon-yinyongjiantou\"></i>\n        </span>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/inputtip/tpl.html"] , dependencies)

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(181);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-send-tip {\n  max-width: 220px;\n  background: #ffface;\n  border-radius: 5px;\n  box-shadow: 1px 1px 1px -1px #b0afae, 1px -1px 1px -1px #b0afae, -1px 1px 1px -1px #b0afae, -1px -1px 1px -1px #b0afae;\n  position: absolute;\n  bottom: 48px;\n  left: 47px;\n  padding: 5px 10px;\n  line-height: 1.4;\n  z-index: 9;\n  display: none;\n  word-break: break-all; }\n  .m-send-tip .arrow-ico {\n    position: absolute;\n    right: auto;\n    bottom: -7px;\n    left: 10px;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 7px solid #b0afae; }\n    .m-send-tip .arrow-ico:after {\n      content: ' ';\n      position: absolute;\n      height: 0;\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-top: 6px solid #ffface;\n      bottom: 1px;\n      left: -4px; }\n  .m-send-tip .tip-title {\n    color: #f9a33a;\n    font-size: 12px;\n    margin: 5px 0; }\n  .m-send-tip .tip-text {\n    color: #757575;\n    font-size: 16px; }\n    .m-send-tip .tip-text .send-btn {\n      padding-left: 10px;\n      font-size: 12px; }\n", ""]);

// exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destorySmileytip = exports.smileytip = undefined;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _tarzanSmiley = __webpack_require__(13);

var _tarzanSmiley2 = _interopRequireDefault(_tarzanSmiley);

var _tpl = __webpack_require__(183);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $node = null;
var timer = null;

function getPicByText(text) {
  var pic = null;
  _tarzanSmiley2.default.XIAO_MI.forEach(function (t) {
    if (t[0] === text) {
      pic = t[1];
    }
  });
  return pic;
}

function destorySmileytip() {
  if ($node) {
    $node.remove();
    $node = null;
    clearTimeout(timer);
  }
}

function bindEvent(text, onClickSmiley) {
  $node.on('tap', function (ev) {
    onClickSmiley('[xm:' + text + ']');
    destorySmileytip();
    ev.stopPropagation();
  });

  (0, _tarzanZepto2.default)('body').off('tap').on('tap', function () {
    destorySmileytip();
  });
}

function smileytip(text, onClickSmiley) {
  destorySmileytip();

  var pic = getPicByText(text);

  if (pic) {
    var data = {
      pic: pic,
      text: text
    };
    $node = (0, _tarzanZepto2.default)(_tpl2.default.render(data));
    (0, _tarzanZepto2.default)('body').append($node);

    timer = setTimeout(function () {
      destorySmileytip();
    }, 5000);

    bindEvent(text, onClickSmiley);
  }
}

exports.smileytip = smileytip;
exports.destorySmileytip = destorySmileytip;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/smileytip/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-smiley-tip\">\n\t<div class=\"smiley-wrap\">\n\t\t<img src=\"";
output += runtime.suppressValue((lineno = 2, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pic")),"replace"), "pic[\"replace\"]", context, [".png","@2x.gif"])), env.opts.autoescape);
output += "\" alt=\"\">\n\t</div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/smileytip/tpl.html"] , dependencies)

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(185);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-smiley-tip {\n  position: absolute;\n  bottom: 100px;\n  right: 12px;\n  background-color: #FFDB80;\n  border-radius: 20px 20px 4px 20px;\n  padding: 2px;\n  z-index: 9; }\n  .m-smiley-tip .smiley-wrap {\n    background: #fff;\n    border-radius: 20px 20px 4px 20px; }\n    .m-smiley-tip .smiley-wrap img {\n      width: 100px;\n      height: 100px; }\n", ""]);

// exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-shortcuts-wrap {\n  margin: 0 0 5px 0; }\n\n.m-footer-slideup {\n  position: relative;\n  width: 100%;\n  bottom: 0;\n  background: #fff;\n  border-radius: 12px 12px 0 0;\n  overflow: hidden;\n  -webkit-transform: translate3d(0, 100%, 0);\n  transform: translate3d(0, 100%, 0);\n  box-shadow: rgba(135, 147, 150, 0.1) 0 -2px 15px; }\n\n.m-input-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 52px;\n  overflow: hidden;\n  background: #E9E9E9;\n  box-shadow: #dadada 0 -1px 1px; }\n  .m-input-toolbar button {\n    outline: none;\n    border: none; }\n  .m-input-toolbar .m-input-toolbar-panel {\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1; }\n    .m-input-toolbar .m-input-toolbar-panel .m-input-form {\n      position: absolute;\n      width: 100%;\n      box-sizing: content-box;\n      overflow: hidden; }\n\n.m-input-form-ext {\n  border-top: 1px solid #DEDEDE;\n  overflow: hidden;\n  clear: both;\n  background: #fff;\n  display: none; }\n  .m-input-form-ext .plugins {\n    padding: 0;\n    margin: 0 10px;\n    padding-top: 5px;\n    padding-bottom: 20px;\n    overflow: hidden; }\n    .m-input-form-ext .plugins .item {\n      float: left;\n      width: 25%;\n      text-align: center;\n      margin: 10px 0 0 0;\n      color: #999;\n      font-size: 12px; }\n      .m-input-form-ext .plugins .item .icon-bg {\n        width: 56px;\n        height: 56px;\n        line-height: 56px;\n        background: #F0F4F5;\n        border-radius: 56px;\n        display: inline-block;\n        margin-bottom: 5px; }\n        .m-input-form-ext .plugins .item .icon-bg .icon {\n          font-size: 40px;\n          margin-top: 8px; }\n      .m-input-form-ext .plugins .item span {\n        display: block;\n        color: #666; }\n", ""]);

// exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(189);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOG_C = 'welcome';
var WELCOME_TEXT = ['欢迎体验小蜜<i>3.0</i>', '你想找我聊什么？', '有问题 找小蜜'];
var FLY_TEXT = ['今天天气如何', '查看购物攻略', '小蜜叫我起床', '买火车票', '聊个五块钱', '买飞机票', '充话费', '退货退款', '催发货', '挑好货', '退款去向', '福利社'];

var Welcome = function () {
  function Welcome(config) {
    _classCallCheck(this, Welcome);

    this.container = config.container;
    this.app = config.app;
  }

  _createClass(Welcome, [{
    key: 'render',
    value: function render() {
      var tpl = '\n      <section class="m-alicare-welcome J_Welcome">\n        <span class="welcome-skip">\u8DF3\u8FC7</span>\n        <div class="welcome-avatar">\n          <svg width="90px" height="105px" viewBox="0 0 90 105" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n              <title>\u5934\u50CF</title>\n              <defs></defs>\n              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                  <g transform="translate(-288.000000, -402.000000)">\n                      <g transform="translate(288.000000, 402.000000)">\n                          <path d="M26.7707165,90.3733347 C26.3243453,91.019251 26.0087375,91.8171798 25.8228656,92.7116475 C25.6421407,93.5813467 25.5756206,94.57313 25.613457,95.6295899 C9.66389872,88.5809315 0,72.791813 0,54.4444444 C0,29.5302657 17.043738,9.33333333 45,9.33333333 C72.956262,9.33333333 90,29.5302657 90,54.4444444 C90,72.791813 80.3361013,88.5809315 64.386543,95.6295899 C64.4243794,94.57313 64.3578593,93.5813467 64.1771344,92.7116475 C63.9912625,91.8171798 63.6756547,91.019251 63.2292835,90.3733347 C75.4652436,83.94835 83.7931034,71.4821809 83.7931034,58.3413277 C83.7931034,54.0082662 83.2598699,50.5875476 82.1349234,47.8874091 C79.5628962,38.709214 70.5338752,31.8888889 59.7875731,31.8888889 C54.3370253,31.8888889 49.1234579,34.4639474 45,37.6201476 C40.8765421,34.4201113 35.6155786,31.8888889 30.2124269,31.8888889 C19.5145588,31.8888889 10.4640133,38.6984079 7.87418683,47.8655872 C6.74300823,50.5691158 6.20689655,53.9965881 6.20689655,58.3413277 C6.20689655,71.4821809 14.5347564,83.94835 26.7707165,90.3733347 Z M54.3103448,56.716139 C54.3103448,54.7865505 55.8774122,53.2223099 57.8017241,53.2223099 C59.7299597,53.2223099 61.2931034,54.7800123 61.2931034,56.716139 L61.2931034,59.8395919 C61.2931034,61.7691805 59.7260361,63.333421 57.8017241,63.333421 C55.8734886,63.333421 54.3103448,61.7757187 54.3103448,59.8395919 L54.3103448,56.716139 Z M29.4827586,56.716139 C29.4827586,54.7865505 31.049826,53.2223099 32.9741379,53.2223099 C34.9023735,53.2223099 36.4655172,54.7800123 36.4655172,56.716139 L36.4655172,59.8395919 C36.4655172,61.7691805 34.8984499,63.333421 32.9741379,63.333421 C31.0459024,63.333421 29.4827586,61.7757187 29.4827586,59.8395919 L29.4827586,56.716139 Z M38.7931034,68.997076 C38.7931034,66.1145372 41.1207876,63.7777778 44.0060044,63.7777778 L46.7698577,63.7777778 C49.6488634,63.7777778 51.9827586,66.1204026 51.9827586,68.997076 C51.9827586,71.8796148 49.6550745,74.2163743 46.7698577,74.2163743 L44.0060044,74.2163743 C41.1269987,74.2163743 38.7931034,71.8737495 38.7931034,68.997076 Z M18.6401783,66.3568741 C18.5047815,65.5085544 19.0810258,64.7108235 19.9272561,64.5750924 C20.7734864,64.4393612 21.5692524,65.0170284 21.7046493,65.8653481 C21.7227848,65.9789751 21.7711765,66.2248088 21.8570719,66.58359 C22.0046802,67.2001431 22.2042832,67.8919638 22.4628924,68.6397939 C23.2043042,70.7837626 24.2656074,72.9287701 25.6989326,74.9244149 C29.7793784,80.605694 36.0095184,84 45,84 C53.9904816,84 60.2206216,80.605694 64.3010674,74.9244149 C65.7343926,72.9287701 66.7956958,70.7837626 67.5371076,68.6397939 C67.7957168,67.8919638 67.9953198,67.2001431 68.1429281,66.58359 C68.2288235,66.2248088 68.2772152,65.9789751 68.2953507,65.8653481 C68.4307476,65.0170284 69.2265136,64.4393612 70.0727439,64.5750924 C70.9189742,64.7108235 71.4952185,65.5085544 71.3598217,66.3568741 C71.2492771,67.0494834 70.9738281,68.2000217 70.4693579,69.6588172 C69.6347999,72.0721402 68.441254,74.4844244 66.8196223,76.7422518 C62.1716198,83.2137504 55.018139,87.1111111 45,87.1111111 C34.981861,87.1111111 27.8283802,83.2137504 23.1803777,76.7422518 C21.558746,74.4844244 20.3652001,72.0721402 19.5306421,69.6588172 C19.0261719,68.2000217 18.7507229,67.0494834 18.6401783,66.3568741 Z" id="\u8138" fill="#FFBF44"></path>\n                          <path d="M48.7487751,94.5559488 C48.7487751,94.5559488 55.8656894,91.0172414 59.9986967,91.0172414 C64.1317039,91.0172414 61.5374338,104.982759 57.4044265,104.982759 C53.2714192,104.982759 47.9716415,99.4388814 47.9716415,99.4388814 C46.1166821,97.7896019 46.4873794,95.5751113 48.7487751,94.5559488 Z M41.2512249,94.5559488 C43.5126206,95.5751113 43.8833179,97.7896019 42.0283585,99.4388814 C42.0283585,99.4388814 36.7285808,104.982759 32.5955735,104.982759 C28.4625662,104.982759 25.8682961,91.0172414 30.0013033,91.0172414 C34.1343106,91.0172414 41.2512249,94.5559488 41.2512249,94.5559488 Z" id="\u9886\u7ED3" fill="#FFA000"></path>\n                          <path d="M64.4231476,9.82037754 C62.2613977,9.82245654 58.3003627,9.52165059 57.9194035,9.08232506 C57.2491414,8.3093729 58.6444522,5.85597066 61.5922285,3.28718076 C64.5400048,0.718390849 70.1806944,-1.03785864 72.9446785,1.55016735 C75.2985516,3.75419038 74.5013616,7.72716427 70.9239257,9.10907951 C69.3798096,9.70555073 66.5848974,9.81829853 64.4231476,9.82037754 Z M25.6030204,9.82037754 C23.4412705,9.81829853 20.6463584,9.70555073 19.1022423,9.10907951 C15.5248064,7.72716427 14.7276164,3.75419038 17.0814894,1.55016735 C19.8454735,-1.03785864 25.4861631,0.718390849 28.4339394,3.28718076 C31.3817157,5.85597066 32.7770265,8.3093729 32.1067645,9.08232506 C31.7258052,9.52165059 27.7647702,9.82245654 25.6030204,9.82037754 Z" id="\u89E6\u89D2" fill="#666E70" fill-rule="nonzero"></path>\n                      </g>\n                  </g>\n              </g>\n          </svg>\n        </div>\n        <span class="welcome-text"></span>\n        <div class="welcome-danmu-container"></div>\n        <div class="welcome-brand">\n          <svg width="120px" height="40px" viewBox="0 0 120 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n          <title>Alime Assistant</title>\n          <defs>\n              <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">\n                  <stop stop-color="#FFBF44" offset="0%"></stop>\n                  <stop stop-color="#FFA000" offset="100%"></stop>\n              </linearGradient>\n          </defs>\n          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n              <g transform="translate(-255.000000, -1184.000000)">\n                  <g id="Group" transform="translate(255.000000, 1184.000000)">\n                      <path d="M11.1227045,37.8916013 L14.8828444,37.8899661 C15.4889663,37.8899661 15.926357,38.4688123 15.760356,39.0503837 L15.6549673,39.4177493 L9.10229826,39.4177493 L11.2865213,30.6969036 L11.7566753,30.6969036 C12.3496918,30.6969036 12.7854443,31.2539476 12.6412856,31.8284333 L11.1227045,37.8916013 Z M29.3063064,30.6971761 L30.3225162,30.6971761 C30.9160788,30.6971761 31.3512852,31.253675 31.2071265,31.8281608 L29.47886,38.72853 C29.3772937,39.1335042 29.0125284,39.4180218 28.5942497,39.4180218 L27.6681392,39.4180218 L29.1424897,33.5314509 L26.3029998,37.409502 C26.1315383,37.6444198 25.8579644,37.7828633 25.5669167,37.7828633 L24.1187768,37.7828633 L23.2287059,33.1619051 L21.8340795,38.72853 C21.7325132,39.1335042 21.3677479,39.4180218 20.9494692,39.4180218 L20.0233587,39.4180218 L22.2075817,30.6971761 L23.6387938,30.6971761 C24.0756384,30.6971761 24.4513248,31.0067661 24.5343252,31.4357227 L25.4156592,36.0114415 L29.3063064,30.6971761 Z M30.9444737,39.4180218 L33.1286967,30.6971761 L39.0594082,30.6971761 C39.6529708,30.6971761 40.0881772,31.253675 39.9440185,31.8281608 L39.8451824,32.2233241 L34.3846249,32.2233241 L33.865872,34.294525 L38.1584162,34.294525 C38.7519788,34.294525 39.1871852,34.8510239 39.0430265,35.4255096 L38.9441904,35.820673 L33.4836329,35.820673 L32.96488,37.8918738 L37.2574242,37.8918738 C37.8509868,37.8918738 38.2861933,38.4483728 38.1420345,39.0228585 L38.0431984,39.4180218 L30.9444737,39.4180218 Z M18.9312472,30.6971761 L19.4014012,30.6971761 C19.9949638,30.6971761 20.4301702,31.253675 20.2860115,31.8281608 L18.557745,38.72853 C18.4561787,39.1335042 18.0914134,39.4180218 17.6731347,39.4180218 L16.7470242,39.4180218 L18.9312472,30.6971761 Z M6.56955928,37.1287283 L2.80064946,37.1287283 L2.03792636,38.8729519 C1.89290538,39.2038094 1.5652452,39.4180218 1.20378314,39.4180218 L0,39.4180218 L3.81634149,30.6969036 L8.72306626,30.6969036 C9.27698097,30.6969036 9.68314874,31.2174453 9.5490316,31.7543391 L7.80496354,38.7285084 C7.70355789,39.1340404 7.33936988,39.4180218 6.92175308,39.4180218 L5.99710806,39.4180218 L6.56955928,37.1287283 Z M6.95119343,35.6025326 L7.71173577,32.5615877 C7.75480591,32.3898906 7.62450511,32.2230993 7.44731782,32.2230993 L4.94761415,32.2230993 L3.46850922,35.6025326 L6.95119343,35.6025326 Z M50.1751507,37.1287283 L46.4062409,37.1287283 L45.6435178,38.8729519 C45.4984968,39.2038094 45.1708366,39.4180218 44.8093746,39.4180218 L43.6055914,39.4180218 L47.4219329,30.6969036 L52.3286577,30.6969036 C52.8825724,30.6969036 53.2887402,31.2174453 53.154623,31.7543391 L51.410555,38.7285084 C51.3091493,39.1340404 50.9449613,39.4180218 50.5273445,39.4180218 L49.6026995,39.4180218 L50.1751507,37.1287283 Z M94.507502,37.1287283 L90.7385922,37.1287283 L89.7370751,39.4180218 L87.9379427,39.4180218 L91.7542842,30.6969036 L96.661009,30.6969036 C97.2149237,30.6969036 97.6210915,31.2174453 97.4869743,31.7543391 L95.7429062,38.7285084 C95.6415006,39.1340404 95.2773126,39.4180218 94.8596958,39.4180218 L93.9350508,39.4180218 L94.507502,37.1287283 Z M104.200716,39.4180218 L103.382929,39.4180218 L100.607358,33.0755886 L99.1936763,38.7285084 C99.0922707,39.1334954 98.7280827,39.4180218 98.3104659,39.4180218 L97.3858208,39.4180218 L99.5665874,30.6969036 L100.606813,30.6969036 C100.968275,30.6969036 101.295935,30.911116 101.440956,31.2425185 L103.977733,37.0393368 L105.563695,30.6969036 L106.108887,30.6969036 C106.662802,30.6969036 107.06897,31.2174453 106.934852,31.7543391 L105.190784,38.7285084 C105.089379,39.1334954 104.725191,39.4180218 104.307574,39.4180218 L104.200716,39.4180218 Z M58.7073999,37.8918261 L59.1980724,35.9290295 L53.746156,35.9301196 L55.0546159,30.6969036 L61.051724,30.6969036 C61.6056387,30.6969036 62.0118064,31.2174453 61.8776893,31.7543391 L61.7604731,32.2230993 L56.3085567,32.2230993 L55.763365,34.4033788 L60.1248982,34.4033788 C60.6788129,34.4033788 61.0849806,34.9233755 60.9508635,35.4608144 L60.1336212,38.7285084 C60.0322156,39.1334954 59.6680276,39.4180218 59.2504108,39.4180218 L52.8738493,39.4180218 L53.2554835,37.8918261 L58.7073999,37.8918261 Z M67.6081384,37.8918261 L68.0988109,35.9290295 L62.6468945,35.9301196 L63.9553544,30.6969036 L69.9524625,30.6969036 C70.5063772,30.6969036 70.912545,31.2174453 70.7784278,31.7543391 L70.6612116,32.2230993 L65.2092952,32.2230993 L64.6641036,34.4033788 L68.949855,34.4033788 C69.5424784,34.4033788 69.9769961,34.9598952 69.8330655,35.5343988 L69.0343597,38.7285084 C68.9329541,39.1334954 68.5687661,39.4180218 68.1511493,39.4180218 L61.7745879,39.4180218 L62.156222,37.8918261 L67.6081384,37.8918261 Z M79.2362961,37.8918261 L79.7269686,35.9290295 L74.2750522,35.9301196 L75.5835121,30.6969036 L81.5806202,30.6969036 C82.1345349,30.6969036 82.5407027,31.2174453 82.4065855,31.7543391 L82.2893693,32.2230993 L76.8374529,32.2230993 L76.2922613,34.4033788 L80.5780128,34.4033788 C81.1706361,34.4033788 81.6051538,34.9598952 81.4612232,35.5343988 L80.6625175,38.7285084 C80.5611118,39.1334954 80.1969238,39.4180218 79.779307,39.4180218 L73.4027456,39.4180218 L73.7843797,37.8918261 L79.2362961,37.8918261 Z M87.4869334,32.2225542 L85.8600816,38.7285084 C85.7586759,39.1340404 85.3944879,39.4180218 84.9768711,39.4180218 L84.0522261,39.4180218 L85.8513585,32.2225542 L82.8506237,32.2230993 L83.2344386,30.6969036 L89.7751027,30.6969036 C90.3295626,30.6969036 90.7357304,31.2179904 90.6005229,31.7554293 L90.4833067,32.2220091 L87.4869334,32.2225542 Z M72.5007484,30.6969036 L73.0459401,30.6969036 C73.5998548,30.6969036 74.0060225,31.2174453 73.8719054,31.7543391 L72.1278373,38.7285084 C72.0264317,39.1334954 71.6622437,39.4180218 71.2446269,39.4180218 L70.3199819,39.4180218 L72.5007484,30.6969036 Z M112.196769,32.2225542 L110.569917,38.7285084 C110.468511,39.1340404 110.104323,39.4180218 109.686706,39.4180218 L108.762061,39.4180218 L110.561194,32.2225542 L107.560459,32.2230993 L107.944274,30.6969036 L114.484938,30.6969036 C115.039398,30.6969036 115.445566,31.2179904 115.310358,31.7554293 L115.193142,32.2220091 L112.196769,32.2225542 Z M50.5567849,35.6025326 L51.3173272,32.5615877 C51.3603973,32.3898906 51.2300965,32.2230993 51.0529092,32.2230993 L48.5532056,32.2230993 L47.0741006,35.6025326 L50.5567849,35.6025326 Z M95.0544262,35.5298566 L95.8149685,32.4889117 C95.8580387,32.3172147 95.7277379,32.1504233 95.5505506,32.1504233 L93.0508469,32.1504233 L91.571742,35.5298566 L95.0544262,35.5298566 Z" id="Combined-Shape" fill="#666E70"></path>\n                      <path d="M20.1165982,7.51460106 L18.2306241,7.51460106 L16.1574292,16.0340677 L18.3779228,16.0340677 C18.6945462,16.0340677 18.9712475,15.8166431 19.0469618,15.5083956 L20.7856372,8.36503401 C20.8902606,7.93156091 20.5626242,7.51460106 20.1165982,7.51460106 L20.1165982,7.51460106 Z M22.0218451,4.68257676 L22.2200788,4.68395287 C23.7054555,4.69771392 24.7916114,6.09033228 24.4391958,7.53386653 L22.1071957,17.1156864 C21.8566503,18.145013 20.9356892,18.8702204 19.8756891,18.8757248 L18.2251176,18.8812292 L15.0988058,18.8688443 L12.0110395,18.8812292 L15.4691175,4.67844845 L16.4974552,4.68808118 L16.4988318,4.67844845 L22.0218451,4.67844845 L22.0218451,4.68257676 Z M28.1312999,0.424907575 L28.1409362,0.424907575 C29.6304428,0.424907575 30.726235,1.82027815 30.3738194,3.26656461 L25.9713777,21.3513379 C25.7194556,22.3834167 24.7943647,23.1100002 23.7316114,23.1100002 L22.2641308,23.1100002 L15.8779747,23.1100002 L16.1409098,22.0297577 C16.3914552,20.999055 17.3137929,20.2752237 18.3751696,20.2752237 L22.2407282,20.2752237 C22.5573516,20.2752237 22.8340529,20.0577991 22.9097672,19.7495515 L26.716131,4.11149314 C26.822131,3.67939614 26.493118,3.26106019 26.047092,3.26106019 L14.8427539,3.26106019 L15.1056889,2.18081769 C15.3562344,1.15011496 16.2785721,0.424907575 17.3385721,0.424907575 L28.1312999,0.424907575 Z M11.3901823,0.424907575 C12.9719226,0.424907575 14.136546,1.90697277 13.7621045,3.44270606 L10.1815069,18.1491413 C9.88140301,19.3821315 8.77735101,20.2490777 7.50810421,20.2504538 L6.21820805,20.2504538 L10.137455,4.1527763 C10.137455,4.1527763 10.2530913,3.74544919 10.1278186,3.54178563 C10.0589874,3.42894501 9.91719521,3.35050702 9.81945495,3.30509555 C9.71207832,3.25555577 9.48218221,3.26106019 9.48218221,3.26106019 L8.2831432,3.26106019 L3.87794821,21.3554662 C3.62740275,22.3861689 2.70506505,23.1100002 1.645065,23.1100002 L0,23.1100002 L5.52163659,0.424907575 L11.3901823,0.424907575 Z M41.7457068,20.2748108 L42.0912393,18.8574226 L32.4259662,18.8574226 L33.1156545,16.02127 L42.7809277,16.02127 L43.1264601,14.6038817 L33.8067195,14.6038817 L33.8080961,14.5997534 L33.8067195,14.5997534 L37.2579145,0.425870848 L57.8040192,0.425870848 C59.2935258,0.425870848 60.3906946,1.81986532 60.038279,3.26752788 L57.7035257,12.8548521 C57.4529802,13.886931 56.5265126,14.6107622 55.465136,14.6066339 L46.5776551,14.6038817 L46.2334992,16.02127 L54.5662009,16.02127 C56.0529542,16.02127 57.1473698,17.4125122 56.7963308,18.8574226 L45.5424343,18.8574226 L45.1969018,20.2748108 L54.3597074,20.2748108 C55.8464607,20.2748108 56.9394997,21.6660531 56.5884607,23.1109635 L30.7685116,23.1109635 L31.4595766,20.2748108 L41.7457068,20.2748108 Z M71.9284652,23.110413 L68.3038157,23.110413 L68.4827767,22.3755729 C68.7828806,21.1425827 69.8883092,20.2742604 71.157556,20.2742604 L71.5595301,20.2742604 C71.8775301,20.2742604 72.1542314,20.0582119 72.2285691,19.7499644 L76.933868,0.425320406 L77.1403615,0.425320406 C78.7923096,0.425320406 80.0092447,1.97206254 79.6182837,3.5779772 L75.3369848,21.1646004 C75.0589068,22.3067676 74.034699,23.110413 72.8590626,23.110413 L71.9284652,23.110413 Z M61.7455816,21.6710071 L67.9541533,1.84270866 C69.6680495,1.85509361 70.8822314,3.51880468 70.3701274,5.15361754 L65.7556857,19.8903271 C65.4225428,20.9568085 64.4313739,21.6820159 63.3121791,21.6778876 L61.7455816,21.6710071 Z M81.0761279,21.6710071 L84.5218163,1.84270866 L84.958206,1.84683698 C86.5344398,1.85646971 87.7238424,3.27936239 87.4540242,4.83160894 L84.8935047,19.5641902 C84.680128,20.7889237 83.6146215,21.6820159 82.3701539,21.6765115 L81.0761279,21.6710071 Z M93.7759063,8.52934096 C92.7269192,8.12614217 92.4942698,6.96333336 93.1853348,6.31656396 C93.9975426,5.55833005 95.652244,6.07161725 96.5167635,6.82159453 C97.381283,7.57294792 97.7901402,8.29127478 97.593283,8.51695602 C97.4803999,8.6463099 96.3185297,8.73575673 95.6839063,8.73575673 C95.0492829,8.73575673 94.2288154,8.70410631 93.7759063,8.52934096 Z M113.923754,6.82228258 C114.788273,6.0709292 116.442975,5.5590181 117.255183,6.31725201 C117.946248,6.9626453 117.713598,8.12545412 116.664611,8.53002902 C116.211702,8.70341826 115.391234,8.73644478 114.756611,8.73506868 C114.121988,8.73506868 112.960117,8.64699795 112.847234,8.51764407 C112.650377,8.29058673 113.059234,7.57363597 113.923754,6.82228258 Z M106.93505,6.11276279 C106.93505,6.11276279 106.545465,7.47510684 104.821933,8.33654864 C103.099777,7.47510684 103.617387,5.96964786 103.617387,5.96964786 C103.819751,5.15361754 104.538348,4.63620202 105.379465,4.63620202 C106.219205,4.63620202 107.13879,5.29673247 106.93505,6.11276279 Z M118.044125,1.13442737 C119.07384,1.13442737 119.830983,2.09770094 119.58732,3.09812935 L119.028411,5.39760097 L115.573086,5.40860981 L115.776827,4.57606623 C115.776827,4.57606623 115.841528,4.2182789 115.651554,4.00085429 C115.410645,3.72700938 115.094021,3.72288106 115.094021,3.72288106 L96.6541505,3.72288106 L96.5013453,4.35038499 C96.5013453,4.35038499 96.414618,4.84027841 96.1269037,5.10449058 C95.7951375,5.40860981 95.2169557,5.39897708 95.2169557,5.39897708 L92.7913452,5.40860981 L93.8320725,1.13442737 L104.94693,1.13442737 L105.223631,0.000516761444 L106.400644,0.000516761444 C106.400644,0.000516761444 107.07519,-0.0311336559 107.70293,0.400963346 C108.190255,0.738109096 108.399502,1.13442737 108.399502,1.13442737 L118.044125,1.13442737 Z M116.200414,20.5410872 L115.830102,22.0603072 C115.678673,22.6768023 115.126647,23.1102754 114.492024,23.1102754 L89.3397372,23.1102754 L89.9688541,20.5231978 L101.462283,20.5231978 L101.734855,19.5654287 L92.1012438,19.5654287 L92.1012438,19.5626764 L90.9971918,19.5654287 L92.6257374,12.9023278 L114.490647,12.9023278 C115.520362,12.9023278 116.278881,13.8683535 116.032466,14.8687819 L115.180336,18.3475756 C115.005505,19.059022 114.366751,19.5585481 113.634388,19.5599242 L105.042881,19.5654287 L104.810231,20.5231978 L112.751972,20.5231978 L112.952959,19.6975347 L115.528621,19.6892781 C115.976024,19.687902 116.305037,20.106238 116.200414,20.5410872 Z M114.655842,9.3573434 C115.685557,9.3573434 116.442699,10.320617 116.199037,11.3210454 L116.047608,11.9457971 L92.8515036,11.9457971 L93.4819971,9.3573434 L98.5658675,9.3573434 L99.6010883,5.10380253 L101.0314,5.10380253 C102.059738,5.10380253 102.818257,6.0670761 102.574595,7.06750451 L102.017062,9.3573434 L106.272205,9.3573434 L109.931271,5.39691292 L111.42766,5.39691292 C112.59779,5.39691292 112.906154,6.09597431 112.115972,6.96154442 L109.927141,9.3573434 L114.655842,9.3573434 Z M54.6446684,11.242057 L56.3805906,4.11245642 C56.4865906,3.67898331 56.1575776,3.26064736 55.7115516,3.26064736 L49.3391617,3.26064736 L48.6494734,6.09679997 L51.5982008,6.09679997 C53.0849541,6.09679997 54.1779931,7.48804223 53.8269541,8.93295259 L47.9584084,8.93295259 L47.2687201,11.7677291 L53.9756294,11.7677291 C54.2936294,11.7677291 54.5689541,11.5503045 54.6446684,11.242057 Z M37.9476028,11.7677291 L43.8161485,11.7677291 L44.5072135,8.93295259 L38.6386678,8.93295259 L37.9476028,11.7677291 Z M39.3283561,6.09679997 L45.1969018,6.09679997 L45.8879668,3.26064736 L40.0194211,3.26064736 L39.3283561,6.09679997 Z M102.469972,16.9783511 L102.892595,15.4907815 L95.4409323,15.4907815 L95.0788803,16.9783511 L102.469972,16.9783511 Z M106.035426,15.4907815 L105.673374,16.9783511 L112.060907,16.9783511 L112.422959,15.4907815 L106.035426,15.4907815 Z" id="\u963F\u91CC\u5C0F\u871C" fill="url(#linearGradient-1)"></path>\n                  </g>\n              </g>\n          </g>\n      </svg>\n        </div>\n      </section>\n    ';
      this.container.append(tpl);
      this.$node = this.container.find('.J_Welcome');
      this.activeAnimation();
      this.setLocalStorage();
      this.app.log.send({
        c: LOG_C,
        d: 'show_animation'
      });
    }
  }, {
    key: 'genDanmu',
    value: function genDanmu($container) {
      var danmuTplArr = [];
      FLY_TEXT.forEach(function (text, index) {
        danmuTplArr.push('<span class="welcome-danmu-item ' + (index % 3 === 0 ? 'shine' : '') + '">' + text + '</span>');
      });
      $container.html('<div class="welcome-danmu-section">' + danmuTplArr.join('') + '</div>');
      $container.addClass('active');
      $container.append('<div class="welcome-danmu-section">' + danmuTplArr.join('') + '</div>');
    }
  }, {
    key: 'activeAnimation',
    value: function activeAnimation() {
      var _this = this;

      var i = 0;
      var $text = this.$node.find('.welcome-text');
      var $danmuContainer = this.$node.find('.welcome-danmu-container');
      var timeInterval = setInterval(function () {
        if (i === 80) {
          clearInterval(timeInterval);
        }
        switch (i) {
          case 0:
            $text.html(WELCOME_TEXT[0]);
            break;
          case 4:
            $text.animate({
              opacity: 0
            }, 200);
            break;
          case 6:
            $text.html(WELCOME_TEXT[1]).animate({
              opacity: 1
            }, 400);
            _this.genDanmu($danmuContainer);
            _this.bindEvent();
            break;
          case 72:
            $text.animate({
              opacity: 0
            }, 200);
            break;
          case 74:
            $text.html(WELCOME_TEXT[2]).animate({
              opacity: 1
            }, 400);
            break;
          case 78:
            _this.activeUI();
            break;
          default:
            break;
        }
        i++;
      }, 200);
    }
  }, {
    key: 'bindEvent',
    value: function bindEvent() {
      var _this2 = this;

      var $danmuContainer = this.$node.find('.welcome-danmu-container');
      this.$node.find('.welcome-danmu-item').one('tap', function (ev) {
        var $target = $(ev.target);
        $target.addClass('selected');
        $danmuContainer.addClass('fade-out');
        _this2.activeUI($target.html());
        _this2.app.log.send({
          c: LOG_C,
          d: 'click_danmu'
        });
      });
      this.$node.find('.welcome-skip').on('tap', function () {
        _this2.activeUI();
        _this2.app.log.send({
          c: LOG_C,
          d: 'skip_animation'
        });
      });
    }
  }, {
    key: 'activeUI',
    value: function activeUI() {
      var _this3 = this;

      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var i = 0;
      var $avatar = this.$node.find('.welcome-avatar');
      var timeInterval = setInterval(function () {
        if (i === 1) {
          clearInterval(timeInterval);
        }
        switch (i) {
          case 0:
            $avatar.animate({
              top: '20px',
              transform: 'translateX(-50%) scale(.8)'
            }, 600);
            _this3.$node.animate({
              opacity: '0'
            }, 500);
            break;
          case 1:
            _this3.$node.remove();
            break;
          default:
            break;
        }
        i++;
      }, 500);

      if (text) {
        setTimeout(function () {
          _this3.app.footer.submit(text);
        }, 700);
      }
    }
  }, {
    key: 'setLocalStorage',
    value: function setLocalStorage() {
      _util2.default.storage.setItem('hasWelcome', 'true');
    }
  }]);

  return Welcome;
}();

exports.default = Welcome;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(190);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "@-webkit-keyframes text-animation {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes text-animation {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes fly-animation {\n  0% {\n    -webkit-transform: translateX(30%);\n    transform: translateX(30%); }\n  100% {\n    -webkit-transform: translateX(-180%);\n    transform: translateX(-180%); } }\n\n@keyframes fly-animation {\n  0% {\n    -webkit-transform: translateX(30%);\n    transform: translateX(30%); }\n  100% {\n    -webkit-transform: translateX(-180%);\n    transform: translateX(-180%); } }\n\n@-webkit-keyframes tap-animation {\n  0% {\n    box-shadow: 0 0 0 5px RGBA(251, 187, 65, 0); }\n  35% {\n    box-shadow: 0 0 3px 5px RGBA(251, 187, 65, 0.5); }\n  70% {\n    box-shadow: 0 0 3px 7px RGBA(251, 187, 65, 0.3); }\n  100% {\n    box-shadow: 0 0 15px 7px RGBA(251, 187, 65, 0); } }\n\n@keyframes tap-animation {\n  0% {\n    box-shadow: 0 0 0 5px RGBA(251, 187, 65, 0); }\n  35% {\n    box-shadow: 0 0 3px 5px RGBA(251, 187, 65, 0.5); }\n  70% {\n    box-shadow: 0 0 3px 7px RGBA(251, 187, 65, 0.3); }\n  100% {\n    box-shadow: 0 0 15px 7px RGBA(251, 187, 65, 0); } }\n\n.m-alicare-welcome {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: #FFF;\n  background-repeat: no-repeat;\n  background-size: cover;\n  z-index: 9;\n  text-align: center;\n  overflow: hidden; }\n  .m-alicare-welcome .welcome-avatar {\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    height: 100px;\n    width: 90px;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    transition: all 500ms ease-in; }\n  .m-alicare-welcome .welcome-brand {\n    position: absolute;\n    bottom: 45px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 130px; }\n  .m-alicare-welcome .welcome-danmu-container {\n    position: absolute;\n    top: 56%;\n    width: 330%;\n    -webkit-transform: translateX(30%);\n    transform: translateX(30%); }\n    .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section {\n      display: inline-block;\n      width: 50%; }\n      .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item {\n        width: 85px;\n        padding: 9px 15px;\n        margin: 9px 15px;\n        font-size: 14px;\n        display: inline-block;\n        background-color: #FFCD59;\n        color: #FFF;\n        border-radius: 20px 20px 4px 20px;\n        opacity: 1;\n        transition: all 650ms linear; }\n        .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item.shine {\n          box-shadow: 0 0 0 5px RGBA(251, 187, 65, 0);\n          -webkit-animation: tap-animation 1000ms linear both infinite;\n          animation: tap-animation 1000ms linear both infinite; }\n        .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(2), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(12) {\n          background-color: #FFA000; }\n        .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(5), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(6), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(7), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(8) {\n          position: relative;\n          left: 45px; }\n        .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(9), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(10), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(11), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(12), .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item:nth-child(13) {\n          position: relative;\n          left: 15px; }\n    .m-alicare-welcome .welcome-danmu-container.active {\n      -webkit-animation: fly-animation 20s linear both infinite;\n      animation: fly-animation 20s linear both infinite; }\n    .m-alicare-welcome .welcome-danmu-container.fade-out {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused; }\n      .m-alicare-welcome .welcome-danmu-container.fade-out .welcome-danmu-item {\n        opacity: 0; }\n        .m-alicare-welcome .welcome-danmu-container.fade-out .welcome-danmu-item.selected {\n          opacity: 1; }\n  .m-alicare-welcome .welcome-skip {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    font-size: 12px;\n    padding: 2px 10px;\n    border-radius: 24px;\n    color: #808080;\n    background: rgba(0, 0, 0, 0.2); }\n  .m-alicare-welcome .welcome-text {\n    position: absolute;\n    top: 48%;\n    left: 50%;\n    -webkit-transform: translateX(-45%);\n    transform: translateX(-45%);\n    letter-spacing: 5px;\n    font-size: 16px;\n    color: #666E70; }\n    .m-alicare-welcome .welcome-text .animate {\n      -webkit-animation: text-animation 400ms linear both;\n      animation: text-animation 400ms linear both; }\n    .m-alicare-welcome .welcome-text i {\n      letter-spacing: 0;\n      font-style: normal; }\n\n@media (max-width: 320px) {\n  .m-alicare-welcome .welcome-text {\n    top: 51%;\n    font-size: 14px; }\n  .m-alicare-welcome .welcome-danmu-container {\n    width: 330%;\n    top: 58%; }\n    .m-alicare-welcome .welcome-danmu-container .welcome-danmu-section .welcome-danmu-item {\n      width: 75px;\n      padding: 5px 12px;\n      margin: 5px 12px;\n      font-size: 12px; } }\n", ""]);

// exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _pulloading = __webpack_require__(192);

var _pulloading2 = _interopRequireDefault(_pulloading);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPC = _util2.default.isPC();

__webpack_require__(193);

var HeadPanel = function (_events) {
  _inherits(HeadPanel, _events);

  function HeadPanel(cfg) {
    _classCallCheck(this, HeadPanel);

    var _this = _possibleConstructorReturn(this, (HeadPanel.__proto__ || Object.getPrototypeOf(HeadPanel)).call(this));

    _this.$container = cfg.container;
    _this.$frame = cfg.parentCont;
    _this.log = cfg.log;
    _this.useNative = null;
    _this.items = [];
    _this.pullLoading = new _pulloading2.default();
    _this.init();
    return _this;
  }

  _createClass(HeadPanel, [{
    key: 'init',
    value: function init() {
      var $container = this.$container;
      this.$back = $container.find('.head-back');
      this.$title = $container.find('.caption');
      this.$close = $container.find('.right-nav');
      this.$menu = $container.find('.more-menu');
      this.$list = $container.find('.J_MoreMenu');
      this.$avatar = $container.find('.im-avatar-wrap');
      this.$rightnav = $container.find('.right-nav');
      this.$notify = $container.find('.J_Notify');
      this.$notifyList = $container.find('.J_NotifyList');
      this.$notifyTip = $container.find('.J_NotifyTip');
      this.$notifyNew = $container.find('.J_NotifyNew');
      this.$remind = $container.find('.J_Remind');
      this.$service = $container.find('.J_Service');
      var richAvatar = '<div class="im-avatar">\n                          <div class="avatar-wrap J_Robot">\n                            <div class="avatar-head"></div>\n                            <div class="avatar-body"></div>\n                            <div class="avatar-tie"></div>\n                          </div>\n                          <div class="J_OCS">\n                            <div class="avatar-head"></div>\n                            <img src="" />\n                          </div>\n                        </div>';
      this.$avatar.html(richAvatar);
      this.pullLoading.init(this.$avatar.find('.im-avatar'));
      if (isPC) {
        this.$back.hide();
        this.$title.css({ textAlign: 'left' });
      } else {
        this.$close.hide();
      }
      this.bindEvent();
      if (this.items.length) {
        this.addMenus(this.items);
      }
    }
  }, {
    key: 'getQueryString',
    value: function getQueryString() {}
  }, {
    key: 'hideNavbar',
    value: function hideNavbar() {}
  }, {
    key: 'hack',
    value: function hack() {
      var $container = this.$container;
      $container.find('.J_Back').hide();
      $container.find('.J_MoreMenu').hide();
    }
  }, {
    key: 'bindEvent',
    value: function bindEvent() {
      this.$back.on('tap', function () {
        history.back();
      });

      this.$close.on('click', function () {
        $('.m-alicare').hide();
      });
    }
  }, {
    key: 'setCustomedAvatar',
    value: function setCustomedAvatar(config) {
      if (config.tie) {
        this.$container.find('.avatar-tie').css({
          'background-image': 'url(' + config.tie + ')'
        });
      }
      if (config.face) {
        this.$container.find('.avatar-body').css({
          'background-image': 'url(' + config.face + ')'
        });
      }
    }
  }, {
    key: 'addNotifyList',
    value: function addNotifyList() {}
  }, {
    key: 'showNotifyList',
    value: function showNotifyList() {}
  }, {
    key: 'hideNotifyList',
    value: function hideNotifyList() {}
  }, {
    key: 'showNotifyTip',
    value: function showNotifyTip() {
      var _this2 = this;

      this.$notifyTip.show();
      setTimeout(function () {
        _this2.$notifyTip.fadeOut();
      }, 2000);
    }
  }, {
    key: 'showNotifyNew',
    value: function showNotifyNew() {
      this.$notifyNew.show();
    }
  }, {
    key: 'hideNotifyNew',
    value: function hideNotifyNew() {
      this.$notifyNew.hide();
    }
  }, {
    key: 'addMenus',
    value: function addMenus() {}
  }, {
    key: 'showMenu',
    value: function showMenu() {}
  }, {
    key: 'hideMenu',
    value: function hideMenu() {}
  }, {
    key: 'showRemind',
    value: function showRemind() {}
  }, {
    key: 'showService',
    value: function showService() {}
  }, {
    key: 'setTitle',
    value: function setTitle() {}
  }, {
    key: 'switchRole',
    value: function switchRole() {}
  }, {
    key: 'setOcsAvatar',
    value: function setOcsAvatar() {}
  }, {
    key: 'hide',
    value: function hide() {
      this.$container.hide();
    }
  }]);

  return HeadPanel;
}(_events3.default);

exports.default = HeadPanel;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PullLoading = function () {
  function PullLoading() {
    _classCallCheck(this, PullLoading);
  }

  _createClass(PullLoading, [{
    key: 'init',
    value: function init(cont) {
      this.$container = (0, _tarzanZepto2.default)(cont).find('.avatar-wrap');
      this.$tie = this.$container.find('.avatar-tie');
    }
  }, {
    key: '__transform',
    value: function __transform($ele, arg) {
      var vendors = ['t', '-webkit-', '-Moz-', '-ms-', '-O-'];
      var transform = void 0;
      var i = 0;
      var l = vendors.length;
      for (; i < l; i++) {
        transform = vendors[i] + 'ransform';
        $ele.css(transform, arg);
      }
    }
  }, {
    key: 'setDis',
    value: function setDis(dis) {
      this.__transform(this.$container, 'translate(0,' + (dis < 12 ? dis : 12) + 'px )');
      this.__transform(this.$tie, 'translate(0,' + (dis < 6 ? dis : 6) + 'px) rotate(' + (dis < 12 ? -dis : -12) + 'deg)');
      if (dis > 20) {
        this.$tie.addClass('loading');
      }
    }
  }, {
    key: 'clearLoading',
    value: function clearLoading() {
      this.$tie.removeClass('loading');
    }
  }]);

  return PullLoading;
}();

exports.default = PullLoading;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-alicare-header .nav-bar {\n  display: block;\n  width: 100%;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  background-color: #183546; }\n\n.m-alicare-header .head-back {\n  width: 38px;\n  line-height: 58px;\n  font-size: 21px;\n  text-align: left;\n  color: #fff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2; }\n  .m-alicare-header .head-back .iconfont {\n    color: white;\n    font-size: 30px;\n    display: inline-block;\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg); }\n\n.m-alicare-header .caption {\n  margin: 0;\n  padding: 0;\n  line-height: 58px;\n  width: 100%;\n  height: 58px;\n  color: #ffffff;\n  padding: 0 12px; }\n\n.m-alicare-header .right-nav {\n  line-height: 50px;\n  font-size: 30px;\n  position: absolute;\n  right: 12px;\n  top: 0;\n  z-index: 3;\n  color: #fff; }\n  .m-alicare-header .right-nav span {\n    font-size: 24px; }\n", ""]);

// exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = __webpack_require__(7);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Object.create(_events2.default.prototype);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "html {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none; }\n\nbody {\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n  padding: 0px; }\n\n.m-alicare {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: #F2F4F5;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  overflow: hidden; }\n\n.m-alicare-header, .m-alicare-body, .m-alicare-footer, .m-alicare-options {\n  position: absolute;\n  left: 0;\n  width: 100%; }\n\n.m-alicare-header {\n  z-index: 2;\n  top: 0;\n  box-shadow: rgba(150, 198, 214, 0.15) 0 0 15px; }\n\n.m-alicare-body {\n  z-index: 1;\n  top: 59px;\n  bottom: 47.5px;\n  outline: none; }\n  .m-alicare-body .m-alicare-chartPanel {\n    padding: 12px;\n    box-sizing: border-box;\n    min-height: 300px; }\n\n.m-alicare-options {\n  z-index: 3;\n  bottom: 47.5px; }\n\n.m-alicare-footer {\n  z-index: 2;\n  bottom: 0px; }\n\n.icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden; }\n", ""]);

// exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CHANNEL_ROBOT_ONLINE: 'CHANNEL_ROBOT_ONLINE',

  CHANNEL_ROBOT_OFFLINE: 'CHANNEL_ROBOT_OFFLINE',

  CHANNEL_OCS_ONLINE: 'CHANNEL_OCS_ONLINE',

  CHANNEL_OCS_OFFLINE: 'CHANNEL_OCS_OFFLINE',

  VIEW_READY: 'VIEW_READY',

  APP_READY: 'APP_READY',

  ORDER_SELECT: 'ORDER_SELECT',

  BEFORE_VIEW_READY: 'BEFORE_VIEW_READY',

  AFTER_VIEW_READY: 'AFTER_VIEW_READY',

  BEFORE_HISTORY: 'BEFORE_HISTORY',

  AFTER_HISTORY: 'AFTER_HISTORY'
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app, done) {
  var shortcuts = new _shortcuts2.default(app);
  Object.assign(app, {
    shortcuts: shortcuts
  });
  shortcuts.on('load', function () {
    done();
  });
};

var _shortcuts = __webpack_require__(201);

var _shortcuts2 = _interopRequireDefault(_shortcuts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tpl = __webpack_require__(202);

var _tpl2 = _interopRequireDefault(_tpl);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STORAGE_SHORTCUT = 'shortcut-clicked';
var LOG_C = 'shortcut';
var clickType = _util2.default.click();
var isPC = _util2.default.isPC();

var Shortcuts = function (_events) {
  _inherits(Shortcuts, _events);

  function Shortcuts(app) {
    _classCallCheck(this, Shortcuts);

    var _this = _possibleConstructorReturn(this, (Shortcuts.__proto__ || Object.getPrototypeOf(Shortcuts)).call(this));

    _this.app = app;
    _this.$wrap = app.view.footer.$shortcuts;

    _this.shortcuts = [];

    _this.init();
    _this.bindEvents();
    return _this;
  }

  _createClass(Shortcuts, [{
    key: 'init',
    value: function init() {
      var appConfig = this.app.appConfig;
      var shortcuts = appConfig.get('appConfig').shortcuts || [];

      if (shortcuts.length === 0) return;
      this.render({
        shortcuts: shortcuts
      });
    }
  }, {
    key: 'push',
    value: function push(data) {
      var _this2 = this;

      var list = data.shortcuts;

      if (data.isAdd) {
        list = data.shortcuts.concat(this.shortcuts);
        var isDispatchExist = false;
        list.forEach(function (t, i) {
          if (t.code === 'dispatch') {
            if (isDispatchExist) {
              list.splice(i, 1);
            } else {
              isDispatchExist = true;
            }
          }
        });
      }
      data.shortcuts = list;
      setTimeout(function () {
        _this2.render(data);
      });
    }
  }, {
    key: 'render',
    value: function render(data) {
      data.shortcuts.forEach(function (t) {
        t.isNew = false;

        t.source = t.source || 1;
      });
      var $node = (0, _tarzanZepto2.default)(_tpl2.default.render(data));
      this.$wrap.empty().append($node);
      this.shortcuts = data.shortcuts.concat([]);
      this.app.view.footer.showShortcuts();
      this.app.view.resize();
      if (isPC) {
        (0, _tarzanZepto2.default)('.m-shortcuts').css('height', 46);
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this3 = this;

      var app = this.app;

      app.on(app.events.CHANNEL_OCS_ONLINE, function () {
        app.view.footer.hideShortcuts();
      });

      app.on(app.events.CHANNEL_ROBOT_ONLINE, function () {
        app.view.footer.showShortcuts();
      });
      this.$wrap.delegate('.J_Item', clickType, function (ev) {
        return _this3.onClickShortcut(ev);
      });
      this.$wrap.delegate('.m-shortcut-close', clickType, function () {
        app.view.footer.hideShortcuts();
      });
    }
  }, {
    key: 'onClickShortcut',
    value: function onClickShortcut(ev) {
      var app = this.app;
      var footer = app.view.footer;
      var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
      var type = $target.attr('data-type');
      var q = $target.attr('data-means');

      var code = $target.attr('data-code');
      if (type === 'text') {
        if (code === 'liveAgent') {
          this.app.emit('liveAgent', { entry: this.app.liveAgent.entry, type: 'click', chatUuid: this.app.chatUuid, intent: '' });
        }
        footer.submit({
          q: q,
          header: {
            originContent: q
          }
        });
      } else if (type === 'link') {
        var link = document.createElement('a');
        link.href = q;
        link.target = '_blank';
        link.click();
        (0, _tarzanZepto2.default)(link).remove();
      } else if (type === 'dispatch') {
        this.__dispatch(q, $target);
      } else if (type === 'url') {
        app.util.openWindow(q);
      } else if (type === 'card') {
        var d = JSON.parse(q);
        var body = null;

        if (d.header && d.header.contentType !== 'req') {
          body = {
            data: d
          };
        } else {
          body = {
            cardId: d.header.styleId,
            parameters: d.header.parameters
          };
        }
        app.appendMessage({
          type: 'card',
          body: body
        });
      }

      if ($target.hasClass('light')) {
        var clicked = _util2.default.storage.getItem(STORAGE_SHORTCUT);
        var clickedList = (clicked ? JSON.parse(clicked) : []) || [];
        $target.removeClass('light');
        clickedList.push(code);
        _util2.default.storage.setItem(STORAGE_SHORTCUT, JSON.stringify(clickedList));
      }
      this.__log($target);
    }
  }, {
    key: '__log',
    value: function __log($el) {
      var app = this.app;
      var log = app.log;
      var id = $el.attr('data-code');
      var text = $el.text().trim();
      var chatUuid = $el.attr('data-chatUuid');
      var source = parseInt($el.attr('data-source'), 10);
      var isNew = $el.hasClass('light') ? 'Y' : 'N';
      var path = $el.attr('data-path');
      var position = this.$wrap.index($el);

      log.send({
        c: LOG_C,
        d: 'shortcuts',
        c3: id,
        c4: text,
        c5: isNew,
        c6: position,
        c7: path,
        c8: source,
        chatUuid: chatUuid
      });
    }
  }, {
    key: '__refreshView',
    value: function __refreshView() {
      var $shortcuts = this.$wrap.find('.m-shortcuts');
      $shortcuts.scrollLeft(0);
    }
  }, {
    key: '__dispatch',
    value: function __dispatch() {
      this.app.emit('liveAgent');
    }
  }]);

  return Shortcuts;
}(_events3.default);

exports.default = Shortcuts;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/shortcuts/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-shortcuts shortcuts\">\n  ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "shortcuts");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <div class=\"item J_Item shortcuts-item ";
if(runtime.memberLookup((t_4),"isNew")) {
output += "light";
;
}
output += " ";
if(runtime.memberLookup((t_4),"isHighlight")) {
output += "highlight";
;
}
output += "\" data-type=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "\" data-means=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"content"), env.opts.autoescape);
output += "\" data-code=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"code"), env.opts.autoescape);
output += "\" aria-label=\"快捷短语：";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "，双击发送\" role=\"button\">\n      <span class=\"outer\" aria-hidden=\"true\"> \n        <span class=\"inner\">\n          ";
if(runtime.memberLookup((t_4),"icon")) {
output += "\n          <svg class=\"icon icon-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"icon"), env.opts.autoescape);
output += "\" aria-hidden=\"true\">\n            <use xlink:href=\"#icon-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"icon"), env.opts.autoescape);
output += "\"></use>\n          </svg>\n          ";
;
}
output += "\n          ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_4),"title")), env.opts.autoescape);
output += "\n          </span>\n      </span>\n      ";
if(runtime.memberLookup((t_4),"isNew")) {
output += "\n      <i class=\"icon-new\"></i>\n      ";
;
}
output += "\n    </div>\n  ";
;
}
}
frame = frame.pop();
output += "\n</div>\n<div class=\"m-shortcut-close\">\n   <span class=\"iconfont icon-close\"></span>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/shortcuts/tpl.html"] , dependencies)

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-shortcuts-wrap {\n  margin: 0px; }\n  .m-shortcuts-wrap .m-shortcuts {\n    height: 38px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    white-space: nowrap;\n    padding-left: 10px;\n    transition: all 300ms linear;\n    background-color: #F1F1F1;\n    line-height: 38px;\n    box-shadow: 0 -1px 2px #dadada; }\n    .m-shortcuts-wrap .m-shortcuts .item {\n      color: #1A9CB7;\n      font-size: 14px;\n      display: inline-block;\n      position: relative;\n      background: #fff;\n      height: 24px;\n      line-height: 24px;\n      padding: 0 8px;\n      border-radius: 32px;\n      margin-right: 8px;\n      white-space: nowrap;\n      box-shadow: rgba(150, 198, 214, 0.15) 0 0 15px;\n      box-sizing: border-box; }\n      .m-shortcuts-wrap .m-shortcuts .item img {\n        width: 20px;\n        height: 20px;\n        vertical-align: middle; }\n      .m-shortcuts-wrap .m-shortcuts .item .icon-new {\n        display: none;\n        position: absolute;\n        right: 0px;\n        top: 1px;\n        width: 8px;\n        height: 8px;\n        background-color: #F56262;\n        overflow: hidden;\n        border-radius: 8px; }\n      .m-shortcuts-wrap .m-shortcuts .item.light .icon-new {\n        display: block; }\n      .m-shortcuts-wrap .m-shortcuts .item.highlight {\n        border: 1px solid #FFCD59;\n        line-height: 30px; }\n      .m-shortcuts-wrap .m-shortcuts .item .icon-right {\n        color: #00BE91; }\n      .m-shortcuts-wrap .m-shortcuts .item .icon-wrong {\n        color: #FF5300; }\n  .m-shortcuts-wrap .m-shortcut-close {\n    position: absolute;\n    top: 8px;\n    right: 10px;\n    color: #c0c0c0; }\n", ""]);

// exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = taphold;

__webpack_require__(206);

function taphold(app, done) {

  var appConfig = app.appConfig;
  var config = appConfig.get('appConfig');

  app.view.footer.setPlaceholder(config.inputTip);

  if (config.headerTitle) {}

  if (config.hideVoice) {
    app.view.footer.input.hideVoice();
  }

  if (config.theme) {
    var theme = config.theme;
    app.util.setCss(theme.name, theme.url);

    if (theme.icon) {
      app.util.setIconfont(theme.icon);
    }
  }

  if (config.robotAvatar) {
    app.view.header.setCustomedAvatar(config.robotAvatar);
  }
  done();
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app, done) {
  var firstmsg = new _firstmessage2.default(app);
  firstmsg.on('load', function () {
    done();
  });
  window.alicare_firstmessage = firstmsg;
};

var _firstmessage = __webpack_require__(209);

var _firstmessage2 = _interopRequireDefault(_firstmessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _iscroll = __webpack_require__(14);

var _iscroll2 = _interopRequireDefault(_iscroll);

var _tpl = __webpack_require__(210);

var _tpl2 = _interopRequireDefault(_tpl);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPC = _util2.default.isPC();

var FirstMessage = function (_events) {
  _inherits(FirstMessage, _events);

  function FirstMessage(app) {
    _classCallCheck(this, FirstMessage);

    var _this2 = _possibleConstructorReturn(this, (FirstMessage.__proto__ || Object.getPrototypeOf(FirstMessage)).call(this));

    _this2.app = app;
    _this2.init();
    return _this2;
  }

  _createClass(FirstMessage, [{
    key: 'init',
    value: function init() {
      var config = this.app.appConfig;
      var recommendData = config.get('recommend');
      this.emit('done');
      this.config = config;

      if (!recommendData) {
        return;
      }
      this.render();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      this.renderLoading().then(function () {
        _this3.renderBoard();
      });
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      var _this4 = this;

      var gifSrc = '//gw.alicdn.com/tfs/TB1FcUBQXXXXXXYXpXXXXXXXXXX-134-84.gif';
      var loadingTpl = '<img style="width:2.5em;margin-bottom:-6px;" src="' + gifSrc + '" />';

      return new Promise(function (resolve) {
        _this4.app.postMessage({
          type: 'robot',
          body: {
            text: loadingTpl
          }
        }).then(function (res) {
          _this4.app.view.body.append(res.body);
          setTimeout(function () {
            res.body.remove();
            resolve();
          }, 2500);
        });
      });
    }
  }, {
    key: 'renderBoard',
    value: function renderBoard() {
      var config = this.app.appConfig;
      var data = config.get('recommend');

      var $node = (0, _tarzanZepto2.default)(_tpl2.default.render(data));
      this.$node = $node;
      if (data.list && data.list.length === 0) {
        $node.find('.J_Bannerlist').addClass('banner-only');
      }
      this.app.view.body.append($node);

      if (data.banner && data.banner.length > 0) {
        this.initScroller(data, $node);

        this.bannerScroller.scrollIntervalId = this.setAutoScroll();
      }
      this.bindEvents($node);

      this.app.view.scrollToBottom();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents($node) {
      var _this5 = this;

      var tap = isPC ? 'click' : 'tap';
      $node.find('.J_Category').on(tap, function (ev) {
        return _this5.toggleCategory($node, ev);
      });
      $node.find('.J_Blank').on(tap, function (ev) {
        return _this5.openLink($node, ev);
      });
      $node.find('.J_SendText').on(tap, function (ev) {
        return _this5.sendText($node, ev);
      });
      $node.find('.J_Banner ').on(tap, function (ev) {
        return _this5.openBanner($node, ev);
      });

      this.pauseAutoScroller($node);
    }
  }, {
    key: 'openBanner',
    value: function openBanner($node, ev) {
      var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
      var href = $target.attr('href');
      if (href) {
        var link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        (0, _tarzanZepto2.default)(link).trigger('click');
        setTimeout(function () {
          (0, _tarzanZepto2.default)(link).remove();
        }, 10);
      }
    }
  }, {
    key: 'pauseAutoScroller',
    value: function pauseAutoScroller($node) {
      var _this = this;
      if (this.bannerScroller) {
        $node.find('.J_Bannerlist').on('touchend', function () {
          if (_this.bannerScroller.scrollIntervalId) {
            window.clearInterval(_this.bannerScroller.scrollIntervalId);
          }
          _this.bannerScroller.scrollIntervalId = _this.setAutoScroll();
        });
      }
    }
  }, {
    key: 'toggleCategory',
    value: function toggleCategory($node, ev) {
      var view = this.app.view;
      var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
      var $li = $target.parent();
      var ext = {};

      if ($li.hasClass('alime-expand')) {
        $li.removeClass('alime-expand');
      } else {
        $node.find('.alime-expand').removeClass('alime-expand');
        $li.addClass('alime-expand');
      }
      $li.find('li').toggleClass('list-unfold');
      setTimeout(function () {
        if (view.body.isBottom()) {
          view.body.refresh();
        }
      }, 100);
      ext.id = $target.attr('data-cid');
      ext.position = $node.find('.J_Category').index($target);
    }
  }, {
    key: 'openLink',
    value: function openLink($node, ev) {
      var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
      var href = $target.attr('href');
      if (href) {
        var link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        (0, _tarzanZepto2.default)(link).trigger('click');
        setTimeout(function () {
          (0, _tarzanZepto2.default)(link).remove();
        }, 10);
      }
    }
  }, {
    key: 'sendText',
    value: function sendText($node, ev) {
      var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
      var text = $target.attr('data-text');
      this.app.view.footer.submit(text);
    }
  }, {
    key: 'setAutoScroll',
    value: function setAutoScroll() {
      var id = 0;
      var slideTime = this.app.param.slideTime || 6000;
      var bannerScroller = this.bannerScroller;
      var pageLength = bannerScroller.pages.length;
      if (pageLength > 1) {
        id = setInterval(function () {
          var currentPage = bannerScroller.currentPage.pageX;
          bannerScroller.next();
          if (currentPage >= pageLength - 1) {
            bannerScroller.goToPage(0, 0, 0);
          }
        }, slideTime);
      }
      return id;
    }
  }, {
    key: 'initScroller',
    value: function initScroller(data, $node) {
      var num = data.banner.length;
      var pageWidth = $node.width();
      $node.find('.J_Banner').css({
        width: pageWidth,
        height: 110
      });
      $node.find('.J_Scroller').css('width', pageWidth * num);
      $node.find('.J_Indicator').css('width', 12 * (num - 1) + 6);

      this.bannerScroller = new _iscroll2.default($node.find('.J_Bannerlist')[0], {
        scrollX: true,
        scrollY: false,
        momentum: false,
        snap: true,
        indicators: {
          el: $node.find('.J_Indicator')[0],
          resize: false
        }
      });

      if (num === 1) {
        $node.find('.J_Indicator').hide();
      }
    }
  }, {
    key: 'resize',
    value: function resize() {
      var $node = this.$node;
      var config = this.app.appConfig;
      var data = config.get('recommend');
      var pageWidth = $node.width();
      var num = data.banner.length;
      $node.find('.J_Banner').css({
        width: pageWidth,
        height: 110
      });
      $node.find('.J_Scroller').css('width', pageWidth * num);
      $node.find('.J_Indicator').css('width', 12 * (num - 1) + 6);
      if (data.banner && data.banner.length > 0) {
        this.initScroller(data, $node);

        this.bannerScroller.scrollIntervalId = this.setAutoScroll();
      }
      this.bannerScroller.refresh();
    }
  }]);

  return FirstMessage;
}(_events3.default);

exports.default = FirstMessage;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/firstmessage/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"fade-in-from-bottom\">\n  <div class=\"m-chatpanel-firstmessage T_firstmessage\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "banner")) {
output += "\n    <div class=\"top J_Bannerlist\">\n      <div class=\"J_Scroller banner-scroller\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "banner");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <div class=\"J_Banner J_Blank banner\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "\" data-bid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\n          <div class=\"item\">\n            <img class=\"J_DisableZoomIn lib-img\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"cover"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "\">\n          </div>\n        </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n      </div>\n      <div class=\"indicator J_Indicator\">\n        <div class=\"dot\"></div>\n      </div>\n    </div>\n    ";
;
}
output += "\n\n    <ul class=\"list\" role=\"tree\">\n      ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "list");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n          ";
if(runtime.memberLookup((t_8),"subContent") && runtime.memberLookup((runtime.memberLookup((t_8),"subContent")),"length") > 0) {
output += "\n            <li class=\"li\" role=\"treeitem\">\n              <a href=\"javascript:;\" class=\"J_Category\">\n                <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                <svg class=\"icon icon-down\" aria-hidden=\"true\">\n                  <use xlink:href=\"#icon-arrow\"></use>\n                </svg>\n              </a>\n              <ul role=\"group\">\n                ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"subContent");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("q", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                <li class=\"sub-list-item\" role=\"treeitem\">\n                  ";
if(runtime.memberLookup((t_12),"type") == "link") {
output += "\n                  <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\" class=\"J_Blank\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\">\n                    <span>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</span>\n                    <svg class=\"icon icon-right\" aria-hidden=\"true\">\n                      <use xlink:href=\"#icon-arrow\"></use>\n                    </svg>\n                  </a>\n                  ";
;
}
else {
output += "\n                  <a href=\"javascript:;\" class=\"J_SendText\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\">\n                    <span>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</span>\n                    <svg class=\"icon\" aria-hidden=\"true\">\n                      <use xlink:href=\"#icon-ssend\"></use>\n                    </svg>\n                  </a>\n                  ";
;
}
output += "\n                </li>\n                ";
;
}
}
frame = frame.pop();
output += "\n              </ul>\n            </li>\n          ";
;
}
else {
if(runtime.memberLookup((t_8),"type") == "link") {
output += "\n            <li class=\"li\" role=\"treeitem\">\n              <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"content"), env.opts.autoescape);
output += "\" data-aid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" class=\"J_Blank\">\n                <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                <svg class=\"icon icon-right\" aria-hidden=\"true\">\n                  <use xlink:href=\"#icon-arrow\"></use>\n                </svg>\n              </a>\n            </li>\n          ";
;
}
else {
output += "\n            <li class=\"li\" role=\"treeitem\">\n              <a data-aid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"content"), env.opts.autoescape);
output += "\" class=\"J_SendText\">\n                <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                <svg class=\"icon\" aria-hidden=\"true\">\n                  <use xlink:href=\"#icon-ssend\"></use>\n                </svg>\n              </a>\n            </li>\n          ";
;
}
;
}
output += "\n        ";
;
}
output += "\n      ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/firstmessage/tpl.html"] , dependencies)

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(212);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-firstmessage {\n  margin-top: 16px;\n  background: #FFFFFF;\n  border-radius: 12px;\n  overflow: hidden;\n  font-size: 14px;\n  box-shadow: 0px 1px 3px #dadada; }\n  .m-chatpanel-firstmessage .top {\n    overflow: hidden;\n    position: relative;\n    max-height: 140px; }\n    .m-chatpanel-firstmessage .top .banner-scroller {\n      width: 100%; }\n      .m-chatpanel-firstmessage .top .banner-scroller .banner {\n        float: left;\n        display: block; }\n        .m-chatpanel-firstmessage .top .banner-scroller .banner .item {\n          width: 100%;\n          text-align: center; }\n          .m-chatpanel-firstmessage .top .banner-scroller .banner .item img {\n            width: 351px;\n            text-align: center;\n            border-radius: 12px 12px 0 0; }\n    .m-chatpanel-firstmessage .top .indicator {\n      position: absolute;\n      bottom: 5px;\n      right: 10px;\n      width: 15px;\n      height: 6px;\n      background: url(https://gw.alicdn.com/tfs/TB1jxDyQXXXXXX2aXXXXXXXXXXX-40-20.png);\n      background-size: auto 100%; }\n      .m-chatpanel-firstmessage .top .indicator .dot {\n        position: absolute;\n        width: 6px;\n        height: 6px;\n        border-radius: 6px;\n        background: #FFDD8C; }\n    .m-chatpanel-firstmessage .top.banner-only .banner-scroller .banner .item img {\n      border-radius: 12px; }\n  .m-chatpanel-firstmessage ul {\n    list-style: none;\n    margin: 0;\n    padding: 0; }\n    .m-chatpanel-firstmessage ul li {\n      margin: 0; }\n      .m-chatpanel-firstmessage ul li .icon {\n        float: right; }\n      .m-chatpanel-firstmessage ul li .icon-right {\n        -webkit-transform: rotate(90deg);\n        transform: rotate(90deg); }\n      .m-chatpanel-firstmessage ul li .icon-down {\n        -webkit-transform: rotate(-180deg);\n        transform: rotate(-180deg);\n        transition: -webkit-transform .3s; }\n      .m-chatpanel-firstmessage ul li a {\n        display: block;\n        color: #000;\n        padding: 14px 17px 14px 0;\n        margin: 0 10px;\n        line-height: 1.2;\n        position: relative;\n        box-shadow: 0 -1px 1px -1px #aaa;\n        text-decoration: none; }\n        .m-chatpanel-firstmessage ul li a .icon {\n          position: absolute;\n          top: 15px;\n          right: 0;\n          opacity: 0.5;\n          font-size: 12px; }\n      .m-chatpanel-firstmessage ul li ul {\n        display: none;\n        background: #FAFAFA; }\n        .m-chatpanel-firstmessage ul li ul li a {\n          box-shadow: 0 -1px 1px -1px #aaa; }\n      .m-chatpanel-firstmessage ul li.alime-expand ul {\n        display: block; }\n      .m-chatpanel-firstmessage ul li.alime-expand .icon-down {\n        -webkit-transform: rotate(0);\n        transform: rotate(0); }\n      .m-chatpanel-firstmessage ul li:first-child > a {\n        box-shadow: none; }\n", ""]);

// exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = snap;

var _tpl = __webpack_require__(214);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tip(app) {
  var config = app.appConfig;
  var autoWord = config.get('appConfig').autoWord;
  var touched = false;
  var num = 0;
  if (!autoWord) {
    return;
  }
  $(window).on('touchstart', function () {
    touched = true;
  });
  var timer = setInterval(function () {
    if (num === 30) {
      if (!touched) {
        app.appendMessage({
          type: 'robot',
          body: {
            text: autoWord
          }
        });
      }
      clearInterval(timer);
    }
    num++;
  }, 100);
}

function card(d, app) {
  var config = app.appConfig;
  var nick = config.get('user').nick;
  var data = d.cardInfo;

  app.appendMessage({
    type: 'card',
    body: {
      __scroll__: true,
      userNick: nick,
      parameters: data.parameters,
      cardId: data.styleId,
      ampTaskId: d.ampTaskId,
      onSuccess: function onSuccess() {
        tip(app);
      }
    }
  });
}

function recommend(d, app) {
  var $node = $(_tpl2.default.render(d));
  var LOG_C = 'firstmsg';
  var view = app.view;
  var ampTaskId = d.ampTaskId;
  setTimeout(function () {
    app.view.body.append($node);
    tip(app);
  }, 0);

  $node.find('.J_Category').on('tap', function (ev) {
    var $target = $(ev.currentTarget);
    var $li = $target.parent();
    var ext = {};

    if ($li.hasClass('expand')) {
      $li.removeClass('expand');
    } else {
      $node.find('.expand').removeClass('expand');
      $li.addClass('expand');
    }
    $li.find('li').toggleClass('list-unfold');
    setTimeout(function () {
      if (view.body.isBottom()) {
        view.body.refresh();
        view.body.scrollToBottom();
      }
    }, 100);
    ext.id = $target.attr('data-cid');
    ext.position = $node.find('.J_Category').index($target);
    ext.ampTaskId = ampTaskId;
    console.log(ampTaskId);
    app.log.send({
      c: LOG_C,
      d: 'category',
      ext: ext
    });
  });

  $node.find('.J_SendText').on('tap', function (ev) {
    var $target = $(ev.currentTarget);
    var $li = $target.parent();
    var $ul = $li.parent();
    var $parentLi = $ul.parent();
    var text = $target.find('span').text();
    app.view.footer.submit(text);
    app.log.send({
      c: LOG_C,
      d: 'text',
      ext: {
        ampTaskId: ampTaskId,
        text: text,
        position: $ul.find('li').index($li),
        parentPosition: $node.find('.li').index($parentLi)
      }
    });
  });
}

function snap(app, done) {
  var config = app.appConfig;
  var msgbox = config.get('msgbox');
  if (!msgbox) {
    done();
    return;
  }
  var type = msgbox.type;

  if (type === 'card') {
    card(msgbox, app);
  } else if (type === 'recommend') {
    recommend(msgbox, app);
  }
  done();
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/snap/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-chatpanel-firstmessage T_firstmessage\">\n    <ul class=\"list\" role=\"tree\">\n      ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "suggestions");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n          <li class=\"li\" role=\"treeitem\">\n            <a href=\"javascript:;\" class=\"J_Category\" data-cid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"categoryId"), env.opts.autoescape);
output += "\">\n              <span>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"category"), env.opts.autoescape);
output += "</span>\n              <svg class=\"icon icon-down\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-arrow\"></use>\n              </svg>\n            </a>\n            <ul role=\"group\">\n              ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"questions");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("q", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n              <li class=\"sub-list-item\" role=\"treeitem\">\n                <a href=\"javascript:;\" class=\"J_SendText\" data-kid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\">\n                  <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                  <svg class=\"icon\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-ssend\"></use>\n                  </svg>\n                </a>\n              </li>\n              ";
;
}
}
frame = frame.pop();
output += "\n            </ul>\n          </li>\n        ";
;
}
output += "\n      ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/snap/tpl.html"] , dependencies)

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(216);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app, done) {
  var plugin = new _repo2.default(app);
  plugin.on('load', function () {
    done();
  });
};

var _repo = __webpack_require__(218);

var _repo2 = _interopRequireDefault(_repo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(7);

var _events2 = _interopRequireDefault(_events);

var _index = __webpack_require__(219);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(224);

var _index4 = _interopRequireDefault(_index3);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOG_C = 'inputplugin';
var isPC = _util2.default.isPC();

var Plugins = function (_Events) {
  _inherits(Plugins, _Events);

  function Plugins(app) {
    _classCallCheck(this, Plugins);

    var _this = _possibleConstructorReturn(this, (Plugins.__proto__ || Object.getPrototypeOf(Plugins)).call(this));

    _this.app = app;
    _this.log = app.log;
    _this.view = app.view;
    _this.pluginConfig = _this.app.appConfig.get('plugin') || {};
    _this.init();
    _this.bindEvents();
    return _this;
  }

  _createClass(Plugins, [{
    key: 'init',
    value: function init() {
      var param = this.pluginConfig;

      if (!param.hideExpression) this.smiley();

      if (!param.hideEndService) this.closeSession();

      if (param.hidePlus) this.view.footer.hidePlus();

      if (param.hideVoice) {
        this.app.view.footer.input.useKeyboard();
        this.app.view.footer.input.hideVoice();
        this.emit('load');
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      var app = this.app;

      app.on(app.events.CHANNEL_OCS_ONLINE, function () {
        _this2.view.footer.showTargetPlugin('closeSession');
      });

      app.on(app.events.CHANNEL_ROBOT_ONLINE, function () {
        _this2.view.footer.hideTargetPlugin('closeSession');
      });
    }
  }, {
    key: 'selectOrder',
    value: function selectOrder() {
      var _this3 = this;

      var inputPanel = this.view.footer;
      var baseConfig = this.app.appConfig.get('base');
      var order = new _index4.default({
        from: baseConfig.from,
        app: this.app,
        inputPanel: inputPanel,
        container: inputPanel.$plugin
      });

      order.on('message', function () {
        order.hide();
        _this3.view.footer.resize();
      });

      var $pluginBoard = inputPanel.$plugin.find('.J_Plugins');

      inputPanel.on('hidePlugin', function () {
        order.hide();
      });

      order.on('show', function () {
        $pluginBoard.hide();
        _this3.view.footer.resize();
      });

      order.on('hide', function () {
        $pluginBoard.show();
        _this3.view.footer.resize();
      });

      order.on('render', function () {
        _this3.view.resize();
        _this3.view.scrollToBottom();
      });

      this.view.addPlugin({
        title: '选择宝贝',
        name: 'selectOrder',
        icon: 'commodi',
        action: function action() {
          order.show();
          _this3.log.send({
            c: LOG_C,
            d: 'order'
          });
        }
      });
    }
  }, {
    key: 'camera',
    value: function camera() {
      var _this4 = this;

      this.view.addPlugin({
        title: '拍照',
        name: 'camera',
        icon: 'camera',
        action: function action() {
          _this4.__photo('camera');
          _this4.log.send({
            c: LOG_C,
            d: 'camera'
          });
        }
      });
    }
  }, {
    key: 'selectPhoto',
    value: function selectPhoto() {
      var _this5 = this;

      this.view.addPlugin({
        title: '图片',
        name: 'selectphoto',
        icon: 'photo',
        action: function action() {
          _this5.__photo('photo');
          _this5.log.send({
            c: LOG_C,
            d: 'photo'
          });
        }
      });
    }
  }, {
    key: '__photo',
    value: function __photo(type) {
      var _this6 = this;

      var bridge = this.app.bridge;
      var $image = null;
      bridge.photo({
        type: type,
        bizCode: 'alxm',
        onSelected: function onSelected(d) {
          _this6.app.postMessage({
            type: 'image',
            body: {
              side: 'right',
              text: '<img src="' + d.url + '" class="base64-img" >'
            }
          }).then(function (ret) {
            $image = ret.body;
            _this6.app.view.body.append($image);
          });
        }
      }).then(function (res) {
        var url = res.url;
        $image.find('img').attr('cdn-src', url);
        _this6.app.view.footer.submit(url, 'image', false, true);
      }, function (err) {
        if (err === 'NO_PERMISSION') {
          bridge.toast('\u8BF7\u5F00\u542F' + (type === 'camera' ? '拍照' : '访问相册') + '\u6743\u9650\u54E6');
        }
      });
    }
  }, {
    key: 'smiley',
    value: function smiley() {
      var _this7 = this;

      var inputPanel = this.view.footer;
      var size = this.app.param.size || { width: window.innerWidth };
      var smiley = new _index2.default({
        log: this.log,
        container: inputPanel.$plugin,
        size: size
      });

      this.app.view.smiley = smiley;

      smiley.on('message', function (ev) {
        inputPanel.submit(ev.text, ev.type);
      });

      inputPanel.on('hidePlugin', function () {
        smiley.hide();
      });

      var $pluginBoard = inputPanel.$plugin.find('.J_Plugins');
      smiley.on('show', function () {
        $pluginBoard.hide();
        _this7.view.resize();
        _this7.view.scrollToBottom();
      });

      smiley.on('hide', function () {
        $pluginBoard.show();
        _this7.view.resize();
        _this7.view.scrollToBottom();
      });

      this.view.addPlugin({
        title: 'Emoji',
        name: 'smiley',
        icon: 'face',
        action: function action() {
          smiley.show();
          _this7.log.send({
            c: LOG_C,
            d: 'smiley'
          });
        }
      });
      inputPanel.$emojiBtn.on(isPC ? 'click' : 'tap', function () {
        inputPanel.showPlugin();
        smiley.show();
      });
    }
  }, {
    key: 'closeSession',
    value: function closeSession() {
      var _this8 = this;

      this.view.addPlugin({
        title: '结束服务',
        name: 'closeSession',
        icon: 'exit',
        action: function action() {
          _this8.app.channel.ocs.offline();
          _this8.log.send({
            c: LOG_C,
            d: 'close_session'
          });
        }
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.view.addPlugin({
        title: 'Refresh',
        name: 'refresh',
        icon: 'roll',
        action: function action() {
          location.reload();
        }
      });
    }
  }]);

  return Plugins;
}(_events2.default);

exports.default = Plugins;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _tarzanSmiley = __webpack_require__(13);

var _tarzanSmiley2 = _interopRequireDefault(_tarzanSmiley);

var _iscrollProbe = __webpack_require__(17);

var _iscrollProbe2 = _interopRequireDefault(_iscrollProbe);

var _config = __webpack_require__(220);

var _config2 = _interopRequireDefault(_config);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _tpl = __webpack_require__(221);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var w = (0, _tarzanZepto2.default)('.m-alicare').width();
var TAP = _util2.default.isPC() ? 'click' : 'tap';

var LOG_C = 'smiley';

var Smiley = function (_events) {
  _inherits(Smiley, _events);

  function Smiley(config) {
    _classCallCheck(this, Smiley);

    var _this = _possibleConstructorReturn(this, (Smiley.__proto__ || Object.getPrototypeOf(Smiley)).call(this));

    _this.__show = false;
    _this.$container = null;
    _this.config = config;
    _this.width = config.size.width;
    _this.log = config.log;
    _this.scrollerList = [];
    _this.smileyList = [{
      type: 'default',
      icon: 'https://gw.alicdn.com/tps/TB1sHe9PpXXXXXfXVXXXXXXXXXX-36-36.png',
      data: _config2.default.WWSmiley
    }];
    return _this;
  }

  _createClass(Smiley, [{
    key: 'addCustomSmiley',
    value: function addCustomSmiley(list) {
      var _this2 = this;

      list.forEach(function (t) {
        t.data = _tarzanSmiley2.default[t.name];
        _this2.smileyList.push(t);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var $node = (0, _tarzanZepto2.default)(_tpl2.default.render({
        data: this.smileyList
      }));

      $node.find('.J_Wrapper').width(this.width);
      var $items = $node.find('.J_SmileyItem');
      $items.each(function (idx, item) {
        (0, _tarzanZepto2.default)(item).width(_this3.width);
      });
      $node.find('.mod-smiley-item').each(function (index, t) {
        var $scroller = (0, _tarzanZepto2.default)(t).find('.J_Scroller');
        var $indicator = (0, _tarzanZepto2.default)(t).find('.indicator');
        var len = (0, _tarzanZepto2.default)(t).find('.J_SmileyItem').length;
        $scroller.width(len * _this3.width);

        $indicator.width(len * 6 + (len - 1) * 3);
      });

      (0, _tarzanZepto2.default)(this.config.container).append($node);

      this.$container = $node;
    }
  }, {
    key: 'slider',
    value: function slider() {
      var _this4 = this;

      var $wrapperList = this.$container.find('.mod-smiley-item');
      $wrapperList.each(function (index, t) {
        var $t = (0, _tarzanZepto2.default)(t);
        var scroller = new _iscrollProbe2.default($t.find('.J_Wrapper')[0], {
          scrollX: true,
          scrollY: false,
          momentum: false,
          snap: true,
          snapSpeed: _this4.width,
          disablePointer: true,
          disableTouch: false,
          disableMouse: false,
          indicators: {
            el: $t.find('.indicator')[0],
            resize: false
          }
        });
        scroller.refresh();
        _this4.scrollerList.push(scroller);
      });
    }
  }, {
    key: 'bindEvt',
    value: function bindEvt() {
      var _this5 = this;

      var $previewDom = null;
      this.$container.delegate('li', TAP, function (ev) {
        var index = (0, _tarzanZepto2.default)(ev.currentTarget).attr('data-id');
        var type = (0, _tarzanZepto2.default)(ev.currentTarget).attr('type');
        _this5.emit('message', {
          text: index,
          type: type
        });
        _this5.log.send({
          c: LOG_C,
          d: 'send'
        });
      });

      this.$container.delegate('li', 'longTap', function (ev) {
        var $tar = (0, _tarzanZepto2.default)(ev.currentTarget);

        var index = _this5.$container.find('.mod-smiley-item').index($tar.parents('.mod-smiley-item'));
        if ($tar.attr('type') === 'liveImage') {
          var gif = $tar.attr('data-gif');
          $tar.addClass('active');
          gif = gif.replace('.gif', '@2x.gif');
          gif = gif.replace('.png', '@2x.png');
          $previewDom = (0, _tarzanZepto2.default)('<div class="liveImagePreview"><img src="' + gif + '" alt="" /></div>');

          var left = $tar[0].offsetLeft + _this5.scrollerList[index].x;

          if (left < 5) {
            left = 5;
          }
          if (left > w - 105) {
            left = w - 105;
          }
          $previewDom.css({
            left: left,
            bottom: 140 - $tar[0].offsetTop + 70
          });
          (0, _tarzanZepto2.default)('body').append($previewDom);
          _this5.log.send({
            c: LOG_C,
            d: 'preview'
          });
        }
      });

      this.$container.delegate('li', 'touchend', function (ev) {
        var $tar = (0, _tarzanZepto2.default)(ev.currentTarget);
        if ($previewDom) $previewDom.remove();
        $tar.removeClass('active');
      });

      this.$container.delegate('.J_Tab', TAP, function (ev) {
        var $tab = (0, _tarzanZepto2.default)(ev.currentTarget);
        var index = _this5.$container.find('.J_Tab').index($tab);
        $tab.siblings().removeClass('selected');
        $tab.addClass('selected');
        _this5.$container.find('.mod-smiley-item').hide();
        _this5.$container.find('.mod-smiley-item').eq(index).show();

        _this5.scrollerList[index].refresh();
        _this5.log.send({
          c: LOG_C,
          d: 'tab',
          ext: {
            position: index
          }
        });
      });
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.__show) {
        this.render();
        this.slider();
        this.bindEvt();
        this.__show = true;
      }
      this.$container.show();
      this.emit('show');
      this.scrollerList.forEach(function (t) {
        t.refresh();
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.scrollerList.forEach(function (t) {
        t.refresh();
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.$container) {
        this.$container.hide();
        this.emit('hide');
      }
    }
  }]);

  return Smiley;
}(_events3.default);

exports.default = Smiley;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var APPConfig = {
  appName: 'alixm',
  WWSmiley: ['[smile_emoji]', '[shy_emoji]', '[tongue_emoji]', '[snicker_emoji]', '[love_emoji]', '[laughing_emoji]', '[dancing_emoji]', '[air_kiss_emoji]', '[comfort_emoji]', '[hug_emoji]', '[come_on_emoji]', '[victory_emoji]', '[good_emoji]', '[kiss_emoji]', '[anthomaniac_emoji]', '[toothy_laugh_emoji]', '[search_emoji]', '[calling_emoji]', '[afterwards_emoji]', '[miser_emoji]', '[good_idea_emoji]', '[grimace_emoji]', '[angel_emoji]', '[goodbye_emoji]', '[slobber_emoji]', '[enjoying_emoji]', '[erotic_emoji]', '[transfixed_emoji]', '[thinking_emoji]', '[confused_emoji]', '[wondering_emoji]', '[no_money_emoji]', '[boring_emoji]', '[doubt_emoji]', '[shhh_emoji]', '[wronged_emoji]', '[shaking_head_emoji]', '[cold_emoji]', '[awkward_emoji]', '[giggle_emoji]', '[no_way_emoji]', '[helpless_emoji]', '[sweating_emoji]', '[desolate_emoji]', '[sleepy_emoji]', '[gosh_emoji]', '[sadness_emoji]', '[aggrieved_emoji]', '[sob_emoji]', '[break_into_tears_emoji]', '[cry_emoji]', '[I_give_up_emoji]', '[sorry_emoji]', '[goodbye_with_tears_emoji]', '[frown_emoji]', '[too_tired_emoji]', '[threw_up_emoji]', '[recite_emoji]', '[surprise_emoji]', '[consternation_emoji]', '[shut_up_emoji]', '[owe_flat_emoji]', '[despise_you_emoji]', '[furious_emoji]', '[mad_emoji]', '[Fortuna_emoji]', '[learn_from_Lei_Feng_emoji]', '[Kung_Hei_Fat_Choi_emoji]', '[waiter_emoji]', '[boss_emoji]', '[evil_emoji]', '[solo_emoji]', '[CS_emoji]', '[invisible_man_emoji]', '[bomb_emoji]', '[screaming_emoji]', '[beautiful_lady_emoji]', '[handsome_emoji]', '[Lucky_Cat_emoji]', '[deal_emoji]', '[applaud_emoji]', '[shake_hands_emoji]', '[red_lips_emoji]', '[rose_emoji]', '[residual_flowers_emoji]', '[sweetheart_emoji]', '[heart_breaking_emoji]', '[money_emoji]', '[shopping_emoji]', '[gift_emoji]', '[email_emoji]', '[phone_call_emoji]', '[cheers_emoji]', '[clock_emoji]', '[waiting_emoji]', '[too_late_emoji]', '[airplane_emoji]', '[Alipay_emoji]'],
  WWSmileyPath: '//g.alicdn.com/crm/static/0.1.0/ww/',
  LYSmileyPath: '//g.alicdn.com/crm/static/0.2.0/lw/',
  LYSmiley: {
    '001': '傻笑',
    '002': '苦笑',
    '003': '晕',
    '004': '嘟嘴',
    '005': '红心',
    '006': '害羞',
    '007': '吐舌头',
    '008': '微笑',
    '009': '雷到',
    '010': '扣鼻屎',
    '011': '悲伤',
    '012': '愤怒',
    '013': '大怒',
    '014': '惊悚',
    '015': '吓人',
    '016': '呕吐',
    '017': '鼓掌',
    '018': '财迷',
    '019': '可爱的笑',
    '020': '疑问',
    '021': '满意的笑',
    '022': '装酷',
    '023': '闭嘴',
    '024': '大哭',
    '025': '打盹',
    '026': '欠揍',
    '027': '囧',
    '028': '猪',
    '029': '火星人',
    '030': '奥特曼',
    '031': '钱',
    '032': '心',
    '033': '心碎',
    '034': '乌鸦',
    '035': '骷髅',
    '036': '咖啡',
    '037': '米饭',
    '038': '购物袋',
    '039': '灯泡',
    '040': '赞',
    '041': '弱爆',
    '042': '胜利',
    '043': 'iloveu',
    '044': 'ok',
    '045': '握手',
    '046': '菜刀',
    '047': '大笑',
    '048': '悲',
    '049': '汗',
    '050': '脸红',
    '051': '喜欢',
    '052': '惊讶',
    '053': '生日蛋糕',
    '054': '礼物',
    '055': '太阳',
    '056': '月亮',
    '057': '浮云',
    '058': '下雨',
    '059': '雪花',
    '060': '闪电',
    '061': '雨伞',
    '062': '水果',
    '063': '屎',
    '064': '嘴唇',
    '065': '红包'
  }
};

exports.default = APPConfig;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/smiley/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"mod-plugin-smiley\">\n    <div class=\"mod-smiley-list\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("t", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <div class=\"mod-smiley-item\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") > 1) {
output += "style=\"display:none;\"";
;
}
output += ">\n            <div class=\"J_Wrapper wrapper\">\n                <div class=\"J_Scroller scroller\">\n                    ";
if(runtime.memberLookup((t_4),"type") == "default") {
output += "\n                    <div class=\"J_SmileyItem item\">\n                        <ul>\n                            ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"data");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("value", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") != 98) {
output += "\n                                    <li  data-id=\"";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "\">\n                                        <div class=\"smiley\" style=\"background-position: 0px -";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") - 1) * 32, env.opts.autoescape);
output += "px\"></div>\n                                    </li>\n                                ";
;
}
output += "\n                            ";
output += "\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 24 == 0) {
output += "\n                        </ul>\n                    </div>\n                    <div class=\"J_SmileyItem item\">\n                        <ul>\n                            ";
;
}
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </ul>\n                    </div>\n                    ";
;
}
else {
output += "\n                    <div class=\"J_SmileyItem item gif-item ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "-item\">\n                        <ul>\n                            ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_4),"data");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("value", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                            ";
if(runtime.memberLookup((t_4),"type") == "xm") {
output += "\n                            <li data-id=\"[";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "]\" type=\"liveImage\" data-gif=\"";
output += runtime.suppressValue((lineno = 32, colno = 103, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_12),1)),"replace"), "value[\"1\"][\"replace\"]", context, ["png","gif"])), env.opts.autoescape);
output += "\">\n                            ";
;
}
else {
output += "\n                            <li data-id=\"[";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "]\" type=\"liveImage\" data-gif=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),1), env.opts.autoescape);
output += "\">\n                            ";
;
}
output += "\n                                <div class=\"smiley\" style=\"background-position: 0px -";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") - 1) * 57, env.opts.autoescape);
output += "px\"></div>\n                                <p>";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "</p>\n                            </li>\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 8 == 0 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < runtime.memberLookup((runtime.memberLookup((t_4),"data")),"length")) {
output += "\n                        </ul>\n                    </div>\n                    <div class=\"J_SmileyItem item gif-item ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "-item\">\n                        <ul>\n                            ";
;
}
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </ul>\n                    </div>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            <div id=\"mod-plugin-smiley-indicator\" class=\"indicator\">\n                <div class=\"dotty\"></div>\n            </div>\n            \n        </div>\n\n        \n        ";
;
}
}
frame = frame.pop();
output += "\n        \n\n    </div>\n    <div class=\"mod-smiley-tab\">\n        ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("t", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n        <div class=\"item ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 1) {
output += "selected";
;
}
output += " J_Tab\">\n            <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_16),"icon"), env.opts.autoescape);
output += "\" alt=\"\">\n        </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n\n        \n    </div>\n    \n\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/smiley/tpl.html"] , dependencies)

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(223);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".mod-plugin-smiley {\n  display: none;\n  margin: 0 auto; }\n  .mod-plugin-smiley .mod-smiley-tab {\n    background: #fff;\n    height: 36px;\n    width: 100%; }\n    .mod-plugin-smiley .mod-smiley-tab .item {\n      width: 40px;\n      text-align: center;\n      line-height: 36px;\n      float: left;\n      position: relative; }\n      .mod-plugin-smiley .mod-smiley-tab .item::after {\n        content: ' ';\n        position: absolute;\n        top: 8px;\n        bottom: 8px;\n        right: 0;\n        width: 1px;\n        background: #E8ECED; }\n      .mod-plugin-smiley .mod-smiley-tab .item img {\n        height: 18px;\n        position: relative;\n        top: 4px; }\n    .mod-plugin-smiley .mod-smiley-tab .selected {\n      background: #F0F4F5; }\n  .mod-plugin-smiley .mod-smiley-list {\n    height: 170px;\n    background: #FAFAFA; }\n    .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper {\n      height: 140px; }\n      .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller {\n        position: absolute;\n        z-index: 1;\n        -webkit-tap-highlight-color: transparent;\n        -webkit-transform: translateZ(0);\n        transform: translateZ(0);\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        -webkit-text-size-adjust: none;\n        -ms-text-size-adjust: none;\n        -o-text-size-adjust: none;\n        text-size-adjust: none;\n        height: 140px; }\n        .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .item {\n          float: left; }\n          .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .item ul {\n            list-style: none;\n            margin: 0px auto;\n            padding: 0px;\n            width: 100%;\n            padding-top: 10px; }\n            .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .item ul li {\n              float: left;\n              width: 12.5%;\n              text-align: center;\n              margin-bottom: 10px; }\n              .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .item ul li .smiley {\n                width: 32px;\n                height: 32px;\n                background-image: url(\"//gw.alicdn.com/tps/TB1hkqILVXXXXahXXXXXXXXXXXX-64-6272.png\");\n                background-size: 100%;\n                display: inline-block; }\n        .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .gif-item ul {\n          padding-top: 5px; }\n          .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .gif-item ul li {\n            width: 25%;\n            margin: 0;\n            position: relative; }\n            .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .gif-item ul li .smiley {\n              width: 57px;\n              height: 57px;\n              background-image: url(\"https://gw.alicdn.com/tps/TB1fFDlPpXXXXcpXFXXXXXXXXXX-114-1368.png\"); }\n            .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .gif-item ul li p {\n              color: #999;\n              font-size: 12px;\n              text-align: center;\n              margin: 0;\n              margin-top: -5px; }\n          .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .gif-item ul li.active .smiley {\n            background-color: #F2F4F5;\n            border-radius: 4px; }\n        .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .wrapper .scroller .wx-item ul li .smiley {\n          background-image: url(\"https://gtms04.alicdn.com/tfs/TB1uZj1QFXXXXaSaXXXXXXXXXXX-114-2736.png\"); }\n    .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .indicator {\n      z-index: 2;\n      position: relative;\n      width: 42px;\n      height: 6px;\n      margin: 0 auto;\n      margin-top: 15px;\n      background: url(https://gw.alicdn.com/tps/TB1SWoxKpXXXXcXXFXXXXXXXXXX-30-20.png);\n      background-size: auto 100%; }\n    .mod-plugin-smiley .mod-smiley-list .mod-smiley-item .dotty {\n      position: absolute;\n      width: 6px;\n      height: 6px;\n      border-radius: 6px;\n      background: #777; }\n\n.ww-smiley {\n  width: 32px;\n  height: 32px;\n  margin: -5px 0;\n  background-image: url(\"//gw.alicdn.com/tps/TB1hkqILVXXXXahXXXXXXXXXXXX-64-6272.png\");\n  background-size: 100%;\n  display: inline-block; }\n\n.liveImagePreview {\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: #8A9599 0 0 15px;\n  z-index: 5; }\n  .liveImagePreview img {\n    width: 100%; }\n", ""]);

// exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events2 = __webpack_require__(7);

var _events3 = _interopRequireDefault(_events2);

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(225);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOG_C = 'recommendorder';

var TopOrder = function (_events) {
  _inherits(TopOrder, _events);

  function TopOrder(config) {
    _classCallCheck(this, TopOrder);

    var _this = _possibleConstructorReturn(this, (TopOrder.__proto__ || Object.getPrototypeOf(TopOrder)).call(this));

    _this.app = config.app;
    _this.selfShow = false;
    _this.$container = null;
    _this.config = config;
    _this.selfConfig = null;
    return _this;
  }

  _createClass(TopOrder, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var $n = this.$container = (0, _tarzanZepto2.default)('<div class="m-chatpanel-toporder-asyn"><div class="card-loading"></div></div>');
      (0, _tarzanZepto2.default)(this.config.container).append($n);
      var $cardLoading = $n.find('.card-loading');
      $cardLoading.addClass('loading');
      this.app.model.getTopOrder({
        from: this.config.from || 'unknown'
      }).then(function (data) {
        var $no = (0, _tarzanZepto2.default)(_tpl2.default.render({
          list: data
        }));
        $cardLoading.removeClass('loading');
        $n.append($no);
        var $container = $n.find('.order-container');
        for (var i = 0; i < data.length; i++) {
          _this2.orderConventer(data[i]);
          var $node = _index2.default.orderItem(data[i]);
          $container.append($node);
        }
        _this2.bindEvt();
      }, function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'htmlEncode',
    value: function htmlEncode(str) {
      var s = '';
      if (!str) return null;
      if (str.length === 0) return null;
      s = str.replace(/&amp;/g, '&');
      s = s.replace(/&lt;/g, '<');
      s = s.replace(/&gt;/g, '>');
      s = s.replace(/&nbsp;/g, ' ');
      s = s.replace(/&#39;/g, '\'');
      s = s.replace(/&quot;/g, '\"');
      s = s.replace(/&mdash;/g, '—');
      return s;
    }
  }, {
    key: 'formatSKU',
    value: function formatSKU(option) {
      var d = option;
      var sku = d.split('|')[1];
      var skus = sku.split(';');
      var formatedSKU = [];
      for (var i = 0; i < skus.length; i++) {
        var key = skus[i].split(':')[0];

        if (key.indexOf('颜色') >= 0 || key === '尺寸') {
          formatedSKU.push(skus[i]);
        }
      }
      return formatedSKU.join(';');
    }
  }, {
    key: 'orderConventer',
    value: function orderConventer(item) {
      item.title = this.htmlEncode(item.title);
      if (item.attributes && item.attributes.sku) {
        item.attributes.sku = this.formatSKU(item.attributes.sku);
      }
      item.json = JSON.stringify(item);
    }
  }, {
    key: 'updateConfig',
    value: function updateConfig(data) {
      this.selfConfig = data;
    }
  }, {
    key: 'bindEvt',
    value: function bindEvt() {
      var _this3 = this;

      var app = this.app;

      this.$container.on('swipeUp', function () {
        app.orderList.show({
          source: 'toporder'
        });
        _this3.app.log.send({
          c: LOG_C,
          d: 'swipeall'
        });
      });

      this.$container.find('.J_Order').on('tap', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var id = (0, _tarzanZepto2.default)(ev.currentTarget).attr('data-id');
        var json = (0, _tarzanZepto2.default)(ev.currentTarget).attr('data-json');
        var index = _this3.$container.find('.J_Item').index((0, _tarzanZepto2.default)(ev.currentTarget));

        app.emit(app.events.ORDER_SELECT, {
          id: id,
          source: 'toporder',
          order: JSON.parse(json)
        });
        _this3.config.inputPanel.resize();
        var ext = {};
        ext.position = index;
        _this3.app.log.send({
          c: LOG_C,
          d: 'order',
          ext: JSON.stringify(ext)
        });
      });

      this.$container.find('.J_AllItem').on('tap', function () {
        app.orderList.show({
          source: 'toporder'
        });
        _this3.app.log.send({
          c: LOG_C,
          d: 'all'
        });
      });
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.selfShow) {
        this.render();
        this.selfShow = true;
      } else {
        this.$container.show();
      }
      this.emit('show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.$container) {
        this.emit('hide');
        this.$container.hide();
      }
    }
  }]);

  return TopOrder;
}(_events3.default);

exports.default = TopOrder;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/topOrder/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-plugin-toporder\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "list")),"length")) {
output += "\n    <div class=\"order-container\"></div>\n    <div class=\"btn\">\n      <a href=\"#\" data-action=\"listOrderMore\" class=\"J_AllItem listOrderMore\">\n        全部宝贝\n        <svg class=\"icon\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-arrow_next\"></use>\n        </svg>\n      </a>\n    </div>\n    ";
;
}
else {
output += "\n    <div class=\"no-order\">\n      <img src=\"//gw.alicdn.com/tps/TB1SjpmMpXXXXcRXpXXXXXXXXXX-249-280.png\" alt=\"\" class=\"bee\">\n      <div class=\"text\">\n        亲，你还没有宝贝哦～\n        <svg class=\"icon\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-arrow_next\"></use>\n        </svg>\n      </div>\n    </div>\n    ";
;
}
output += "\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/topOrder/tpl.html"] , dependencies)

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(227);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-toporder-asyn {\n  height: 231px; }\n  .m-chatpanel-toporder-asyn .m-plugin-toporder .btn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    display: -webkit-flex;\n    -ms-flex-pack: distribute;\n    justify-content: space-around;\n    -webkit-justify-content: space-around;\n    box-shadow: 0px -1px 1px -1px #ABABAB; }\n    .m-chatpanel-toporder-asyn .m-plugin-toporder .btn a {\n      display: block;\n      height: 44px;\n      line-height: 44px;\n      width: 100%;\n      box-sizing: border-box;\n      text-align: center;\n      text-decoration: none;\n      color: #444444;\n      font-size: 14px;\n      -webkit-tap-highlight-color: transparent; }\n      .m-chatpanel-toporder-asyn .m-plugin-toporder .btn a span {\n        color: #999;\n        font-size: 12px; }\n    .m-chatpanel-toporder-asyn .m-plugin-toporder .btn i {\n      display: inline-block;\n      width: 1px;\n      height: 12px;\n      margin-top: 14px;\n      background-color: #ABABAB; }\n  .m-chatpanel-toporder-asyn .m-plugin-toporder .no-order {\n    height: 225px;\n    width: 100%;\n    text-align: center;\n    position: relative;\n    color: #999;\n    font-size: 14px; }\n    .m-chatpanel-toporder-asyn .m-plugin-toporder .no-order img.bee {\n      width: 125px;\n      margin-top: 27px;\n      margin-bottom: 7px; }\n  .m-chatpanel-toporder-asyn .card-loading {\n    background-image: url(https://gw.alicdn.com/tfs/TB1sUHOQFXXXXc_XXXXXXXXXXXX-45-18.png);\n    background-repeat: no-repeat;\n    background-color: transparent;\n    background-position: center 9px;\n    background-size: 22px 9px;\n    height: 34px;\n    display: none; }\n    .m-chatpanel-toporder-asyn .card-loading.loading {\n      -webkit-animation: rotate 0.5s linear infinite;\n      animation: rotate 0.5s linear infinite;\n      -webkit-transform-origin: 50%;\n      transform-origin: 50%;\n      display: block; }\n\n@-webkit-keyframes rotate {\n  from {\n    -webkit-transform: rotate(0);\n    transform: rotate(0); }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes rotate {\n  from {\n    -webkit-transform: rotate(0);\n    transform: rotate(0); }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n", ""]);

// exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = attachment;

var _format = __webpack_require__(229);

var _format2 = _interopRequireDefault(_format);

var _system = __webpack_require__(230);

var _system2 = _interopRequireDefault(_system);

var _consumer = __webpack_require__(233);

var _consumer2 = _interopRequireDefault(_consumer);

var _robot = __webpack_require__(236);

var _robot2 = _interopRequireDefault(_robot);

var _knowledge = __webpack_require__(239);

var _knowledge2 = _interopRequireDefault(_knowledge);

var _recommend = __webpack_require__(243);

var _recommend2 = _interopRequireDefault(_recommend);

var _knowledgerate = __webpack_require__(247);

var _knowledgerate2 = _interopRequireDefault(_knowledgerate);

var _buttons = __webpack_require__(251);

var _buttons2 = _interopRequireDefault(_buttons);

var _shortcuts = __webpack_require__(255);

var _shortcuts2 = _interopRequireDefault(_shortcuts);

var _welcomemsg = __webpack_require__(256);

var _welcomemsg2 = _interopRequireDefault(_welcomemsg);

var _orderlist = __webpack_require__(260);

var _orderlist2 = _interopRequireDefault(_orderlist);

var _orderdetail = __webpack_require__(266);

var _orderdetail2 = _interopRequireDefault(_orderdetail);

var _option = __webpack_require__(273);

var _option2 = _interopRequireDefault(_option);

var _express = __webpack_require__(277);

var _express2 = _interopRequireDefault(_express);

var _cancelitems = __webpack_require__(281);

var _cancelitems2 = _interopRequireDefault(_cancelitems);

var _evaluate = __webpack_require__(285);

var _evaluate2 = _interopRequireDefault(_evaluate);

var _textlink = __webpack_require__(289);

var _textlink2 = _interopRequireDefault(_textlink);

__webpack_require__(293);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function attachment(app) {
  app.register(_format2.default);
  app.register('notice', function (data) {
    console.log(data);
  });
  app.register('consumer', _consumer2.default);
  app.register('robot', _robot2.default);
  app.register('knowledge', _knowledge2.default);
  app.register('recommend', _recommend2.default);
  app.register('knowledgerate', _knowledgerate2.default);
  app.register('system', _system2.default);
  app.register('buttons', _buttons2.default);
  app.register('dynamic_shortcuts', _shortcuts2.default);

  app.register('welcomemsg', _welcomemsg2.default);
  app.register('orderlist', _orderlist2.default);
  app.register('option', _option2.default);
  app.register('orderdetail', _orderdetail2.default);
  app.register('express', _express2.default);
  app.register('cancel', _cancelitems2.default);
  app.register('feedback', _evaluate2.default);
  app.register('textlink', _textlink2.default);
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _tarzanSmiley = __webpack_require__(13);

var _tarzanSmiley2 = _interopRequireDefault(_tarzanSmiley);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegLink = /\<link[^\>]+\>/igm;
var RegScript = /\<script.*\<\/script\>/g;
var SXM_SMILEY = {
  '[Chuckle]': 'https://gw.alicdn.com/tfs/TB1rG5qQVXXXXcLXXXXXXXXXXXX-34-34.png',
  '[Clap]': 'https://gw.alicdn.com/tfs/TB1RPuxQVXXXXX1XXXXXXXXXXXX-34-34.png',
  '[Drool]': 'https://gw.alicdn.com/tfs/TB1V8KsQVXXXXbJXXXXXXXXXXXX-34-34.png',
  '[NosePick]': 'https://gw.alicdn.com/tfs/TB11MB1QVXXXXcPXFXXXXXXXXXX-34-34.png',
  '[Shrunken]': 'https://gw.alicdn.com/tfs/TB1JwxMQVXXXXaNaXXXXXXXXXXX-34-34.png',
  '[Smug]': 'https://gw.alicdn.com/tfs/TB1r.t5QVXXXXX1XFXXXXXXXXXX-34-34.png',
  '[Wrath]': 'https://gw.alicdn.com/tfs/TB1ZDCoQVXXXXcOXXXXXXXXXXXX-34-34.png',
  '[Yawn]': 'https://gw.alicdn.com/tfs/TB166OsQVXXXXbBXXXXXXXXXXXX-34-34.png'
};

function sxmSmiley(text) {
  var message = text;

  for (var k in SXM_SMILEY) {
    if (message.indexOf(k) >= 0) {
      message = message.replace(k, '<img src="' + SXM_SMILEY[k] + '" class="smiley" alt="" />');
    }
  }
  return message;
}

function format(data) {
  var res = Object.assign({}, data);

  if (res && res.text && _util2.default.isString(res.text)) {
    var text = res.text;

    text = _tarzanSmiley2.default.toImage(text, 'large');

    text = text.replace(RegLink, '');

    text = text.replace(RegScript, '');

    text = sxmSmiley(text);

    res.text = text;
  }
  return res;
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = system;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function system(data) {
  var aniStyle = '';

  if (data.isWide) {
    aniStyle = 'board';
  } else {
    aniStyle = data.position || 'center';
  }
  var aniClass = data.removeAni ? '' : 'bubble-up-from-' + aniStyle;
  var param = {
    name: 'system',
    side: 'center ' + aniClass,
    mid: data.mid,
    content: data.text
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  if (data.isEm) {
    $node.addClass('m-chatpanel-system-em');
  }

  if (data.position) {
    $node.addClass('m-chatpanel-system-' + data.position);
  }

  if (data.isWide) {
    $node.addClass('m-chatpanel-system-wide');
  }
  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-system {\n  margin: 12px 60px; }\n  .m-chatpanel-item.m-chatpanel-system .chat .body {\n    padding: 0;\n    display: block;\n    float: none;\n    background: transparent;\n    margin: 0;\n    text-align: center; }\n    .m-chatpanel-item.m-chatpanel-system .chat .body .arrow {\n      display: none; }\n    .m-chatpanel-item.m-chatpanel-system .chat .body .content {\n      font-size: 12px;\n      color: #BBC4C7; }\n      .m-chatpanel-item.m-chatpanel-system .chat .body .content a {\n        color: #00BAEB;\n        padding-left: 5px;\n        text-decoration: none; }\n  .m-chatpanel-item.m-chatpanel-system.m-chatpanel-system-left {\n    margin: 8px 0 0;\n    display: inline-block; }\n    .m-chatpanel-item.m-chatpanel-system.m-chatpanel-system-left .body {\n      line-height: 24px;\n      padding: 0 10px; }\n  .m-chatpanel-item.m-chatpanel-system.m-chatpanel-system-em .body {\n    background: #E8ECED; }\n    .m-chatpanel-item.m-chatpanel-system.m-chatpanel-system-em .body .content {\n      color: #333; }\n  .m-chatpanel-item.m-chatpanel-system.m-chatpanel-system-wide .body {\n    padding: 8px 10px; }\n\n/*\n.m-chatpanel-item{\n  &.m-chatpanel-system{\n    margin: 12px 60px;\n    text-align: center;\n    display: block;\n    .body{\n      display: inline-block;\n      font-size: 12px;\n      color:#BBC4C7;      \n      border-radius: 12px;\n      line-height: 18px;\n      a{\n        color:#00BAEB;\n        padding-left: 5px;\n        text-decoration: none;\n      }\n    }\n  }\n  &.m-chatpanel-system-left{\n    margin: 8px 0 0;\n    display: inline-block;\n    .body{\n      line-height: 24px;\n      padding: 0 10px;\n    }\n  }\n  &.m-chatpanel-system-em{\n    .body{\n      color: #333;\n      background: #E8ECED;\n    }\n  }\n  &.m-chatpanel-system-wide{\n    .body{\n      padding: 8px 10px;\n    }\n  }\n}\n*/\n", ""]);

// exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = consumer;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function consumer(data) {
  var aniClass = data.removeAni ? '' : 'bubble-up-from-right';
  var param = {
    name: 'consumer',
    mid: data.mid,
    content: data.text,
    side: 'right ' + aniClass,
    type: data.type
  };

  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));
  return {
    body: $node,

    callback: function callback() {
      console.log('1');
    }
  };
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(235);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-consumer .chat .body {\n  border-radius: 10px; }\n", ""]);

// exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = robot;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function robot(data) {
  var _this = this;

  var param = {
    name: 'robot',
    mid: data.mid,
    isFollow: data.isFollow,
    content: data.text
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  if (data.extraParams && data.extraParams.orderSelectSource === 'command') {}

  $node.find('a').on('tap', function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    _this.util.openWindow($target.attr('href'));
  });

  this.view.body.scrollToBottom();

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(238);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-robot .chat .body {\n  border-radius: 10px; }\n", ""]);

// exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = knowledge;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _baseui = __webpack_require__(8);

var _baseui2 = _interopRequireDefault(_baseui);

var _tpl = __webpack_require__(240);

var _tpl2 = _interopRequireDefault(_tpl);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickType = _util2.default.isPC() ? 'click' : 'tap';

var LOG_C = 'knowledge';
var app = null;

var MAX_HEIGHT = 105;


function shouldShowMore($node) {
  var showmore = false;

  if ($node.find('img').length > 1) {
    showmore = true;
  } else {
    var $nodeCopy = $node.clone();
    var $wrap = (0, _tarzanZepto2.default)('<div class="m-knowledge-calheight-layer"></div>');
    $wrap.append($nodeCopy);
    (0, _tarzanZepto2.default)('.m-alicare').append($wrap);

    var $knowledge = $nodeCopy.find('.knowledge');
    if ($knowledge.height() > MAX_HEIGHT) {
      showmore = true;
    }
    $wrap.remove();
  }
  return showmore;
}

function toggleKnowledge($dom) {
  var param = {
    name: 'knowledge',
    content: $dom.find('.knowledge').html()
  };
  var $node = (0, _tarzanZepto2.default)(_baseui2.default.slideUp(param));
  (0, _tarzanZepto2.default)('.m-alicare').append($node);
  app.log.send({
    c: LOG_C,
    d: 'more'
  });

  function removeKnowledge() {
    app.log.send({
      c: LOG_C,
      d: 'hide'
    });
    $node.find('.J_Mask').hide().parent().addClass('slide-out-to-bottom');
    setTimeout(function () {
      $node.remove();
    }, 500);
  }

  $node.find('.J_Toggle').on(clickType, removeKnowledge);
  $node.find('.J_Mask').on('touchmove', function (ev) {
    ev.preventDefault();
  });
  $node.find('.J_Mask').on('swipeDown', removeKnowledge);
  $node.find('.J_Mask').on(clickType, removeKnowledge);

  $node.find('.J_Sub').on(clickType, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var text = $target.text();
    app.view.footer.submit(text);
    removeKnowledge();
  });
}

function showRate(data, FEEDBACK) {
  app.appendMessage({
    type: 'feedback',
    body: Object.assign({}, FEEDBACK, { chatUuid: data.chatUuid })
  });
}

function bindEvents(data, $node) {
  $node.find('.J_More').on(clickType, function () {
    return toggleKnowledge($node, data);
  });
  $node.find('a').on(clickType, function (ev) {
    ev.preventDefault();
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    app.util.openWindow($target.attr('href'));
    app.log.send({
      c: LOG_C,
      d: 'link'
    });
  });
  $node.find('.J_Sub').on(clickType, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var text = $target.text();
    app.view.footer.submit(text);
  });
}

function knowledge(data) {
  app = this;
  var FEEDBACK = { button: [{ action: { intentId: '487', source: 'event' } }, { action: { intentId: '445', source: 'event' } }], text: app.util.lang.get('FEEDBACK:QUESTION'), isKnowledge: true };
  if (data.text) {
    data.text = data.text.replace(/&nbsp;/ig, ' ');
  }

  data.more = app.util.lang.get('BUTTON:MORE');
  data.suggest = app.util.lang.get('ROBOT:RECOMMEND');
  var param = {
    name: 'knowledge',
    type: 'text',
    mid: data.mid,
    content: _tpl2.default.render(data)
  };
  var $node = (0, _tarzanZepto2.default)(_baseui2.default.msg(param));

  var showMore = shouldShowMore($node);
  if (showMore) {
    $node.find('.J_More').css('display', 'inline-block');
  }

  showRate(data, FEEDBACK);
  bindEvents(data, $node);
  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/knowledge/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"knowledge\">\n  ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "text")), env.opts.autoescape);
output += "\n  ";
if(runtime.contextOrFrameLookup(context, frame, "childKnowledges")) {
output += "\n    <p class=\"sub-title\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "suggest"), env.opts.autoescape);
output += "</p>\n    <ul class=\"sub-knowledge\">\n      ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "childKnowledges");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n      <li><a href=\"javascript:;\" class=\"J_Sub\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"showTitle"), env.opts.autoescape);
output += "</a></li>\n      ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n  ";
;
}
output += "\n</div>\n<div class=\"J_More more\">\n  ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "more"), env.opts.autoescape);
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/knowledge/tpl.html"] , dependencies)

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(242);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge {\n  line-height: 1.5;\n  max-height: 105px;\n  overflow: hidden; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge ol, .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge ul {\n    margin: 0; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge table {\n    width: 100% !important; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge img {\n    max-width: 100%;\n    height: auto; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge .sub-title {\n    margin-top: 20px; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge .sub-knowledge {\n    padding-left: 20px; }\n    .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge .sub-knowledge li {\n      margin: 5px 0; }\n\n.m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .more {\n  display: none;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  color: #999;\n  background: #FAFAFA;\n  font-size: 12px;\n  margin-top: 5px;\n  border-radius: 24px;\n  padding: 0 10px; }\n  .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .more .icon {\n    -webkit-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n    transition: -webkit-transform .3s; }\n\n.m-knowledge-calheight-layer {\n  position: absolute;\n  padding: 12px;\n  opacity: 0; }\n  .m-knowledge-calheight-layer .m-chatpanel-item.m-chatpanel-knowledge .chat .body .content .knowledge {\n    max-height: none; }\n\n.m-card-popup-knowledge .list-wrapper {\n  font-size: 14px;\n  color: #333;\n  line-height: 1.5;\n  position: absolute; }\n  .m-card-popup-knowledge .list-wrapper p, .m-card-popup-knowledge .list-wrapper h2, .m-card-popup-knowledge .list-wrapper h3, .m-card-popup-knowledge .list-wrapper h4 {\n    margin: 0; }\n  .m-card-popup-knowledge .list-wrapper a {\n    color: #00ACE6; }\n  .m-card-popup-knowledge .list-wrapper img {\n    width: 100% !important;\n    margin: 0 !important;\n    height: auto; }\n  .m-card-popup-knowledge .list-wrapper table {\n    width: 100% !important; }\n  .m-card-popup-knowledge .list-wrapper .sub-title {\n    margin-top: 20px; }\n  .m-card-popup-knowledge .list-wrapper .sub-knowledge {\n    padding-left: 20px; }\n    .m-card-popup-knowledge .list-wrapper .sub-knowledge li {\n      margin: 5px 0; }\n", ""]);

// exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = recommend;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(244);

var _tpl2 = _interopRequireDefault(_tpl);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickType = _util2.default.isPC() ? 'click' : 'tap';

var LOG_C = 'recommend';
var app = null;

function recommend(data) {
  var _this = this;

  app = this;
  var $wrap = (0, _tarzanZepto2.default)('<div class="m-recommend-wrap"></div>');
  data.suggestRobot = app.util.lang.get('ROBOT:RECOMMEND:RELATED');
  var param = {
    name: 'recommend',
    mid: data.mid,
    type: 'text',
    content: _tpl2.default.render(data)
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  $wrap.append($node);

  $node.find('.J_Recommend').on(clickType, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var text = $target.find('a').text();
    var position = $node.find('.J_Recommend').index($target);
    var knowledgeId = $target.attr('data-kid');
    _this.view.footer.submit(text);
    _this.log.send({
      c: LOG_C,
      d: 'knowledge',
      chatUuid: data.chatUuid,
      ext: {
        position: position,
        knowledgeId: knowledgeId,
        title: text
      }
    });
  });

  return {
    body: $wrap,

    callback: function callback() {}
  };
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/recommend/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-chatpanel-recommend\">\n    <div class=\"recommend-text\">\n      <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "suggestRobot"), env.opts.autoescape);
output += "</span>\n    </div>\n    <div class=\"recommend-list\">\n      <ul>\n          ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "recommends");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n          <li class=\"J_Recommend\" data-kid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"knowledgeId"), env.opts.autoescape);
output += "\">\n            <a href=\"javascript:;\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "</a>\n          </li>\n          ";
;
}
}
frame = frame.pop();
output += "\n      </ul>  \n    </div> \n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/recommend/tpl.html"] , dependencies)

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(246);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-recommend .chat .body {\n  padding: 10px 12px; }\n  .m-chatpanel-item.m-chatpanel-recommend .chat .body .content ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    padding: 0 24px; }\n    .m-chatpanel-item.m-chatpanel-recommend .chat .body .content ul li {\n      position: relative;\n      margin: 0;\n      padding: 10px 0;\n      border-bottom: 1px solid #E5E5E5; }\n      .m-chatpanel-item.m-chatpanel-recommend .chat .body .content ul li a {\n        color: #1A9CB7;\n        display: inline-block;\n        word-break: break-word;\n        font-size: 13px;\n        line-height: 1.3; }\n      .m-chatpanel-item.m-chatpanel-recommend .chat .body .content ul li .icon {\n        position: absolute;\n        right: 0;\n        top: 12px; }\n      .m-chatpanel-item.m-chatpanel-recommend .chat .body .content ul li:last-child {\n        border: none;\n        padding-bottom: 0px; }\n", ""]);

// exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = knowledgerate;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _tpl = __webpack_require__(248);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG_C = 'knowledge';
var app = null;
var TAP = _util2.default.isPC() ? 'click' : 'tap';

function sendAndSaveMessage(text) {
  var user = app.appConfig.get('user');
  app.postMessage({
    type: 'robot',
    body: {
      text: text
    }
  }).then(function (res) {
    app.view.body.append(res.body);
  });
  app.model.saveMessageLog({
    content: text,
    type: 'MSG',
    senderId: 119,
    senderName: 'robot',
    senderType: 4,
    userId: user.userId
  });
}

function saveFeedback(data) {
  app.view.setReceiver(function (d, type, show, post) {
    var text = app.util.isObject(d) ? d.q : d;
    var user = app.appConfig.get('user');
    if (show) {
      app.appendMessage({
        type: 'consumer',
        body: {
          type: type,
          text: text,
          userId: 1
        }
      });
    }

    if (post) {
      app.model.robotRate({
        chatUuid: data.chatUuid,
        suggestion: text
      });
      app.model.saveMessageLog({
        content: text,
        type: 'MSG',
        senderId: user.userId,
        senderName: user.nick,
        senderType: 1,
        userId: user.userId
      });
    }
    sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:FEEDBACK'));

    app.shortcuts.push({
      isAdd: true,
      shortcuts: [{
        code: 'dispatch',
        icon: 'service',
        means: {
          type: 'dispatch',
          content: JSON.stringify({
            skillGroupId: data.skillGroup,
            question: data.question
          })
        },
        name: app.util.lang.get('SHORTCUT:DISPATCH')
      }]
    });

    app.channel.robot.online();
  });
}

function onClickRate(ev, data) {
  var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
  var switches = app.appConfig.get('switches');
  var rate = $target.hasClass('good') ? 'good' : 'bad';
  var showManual = data.skillGroup && !switches.hideCommentManualEntrance;

  if ($target.hasClass('rated')) {
    return;
  }
  app.log.send({
    c: LOG_C,
    d: rate
  });

  app.model.robotRate({
    value: rate === 'good' ? 1 : 0,
    chatUuid: data.chatUuid
  });
  $target.addClass('rated');

  $target.siblings().remove();
  $target.find('use').attr('xlink:href', '#icon-f' + rate);

  if (rate === 'bad') {
    if (showManual) {
      sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:ASK'));

      saveFeedback(data);
    } else {
      sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:BAD'));
    }
  } else {
    sendAndSaveMessage(app.util.lang.get('KNOWLEDGE:RATE:GOOD'));
  }
}

function bindEvents(data, $node) {
  $node.find('.J_Btn').on(TAP, function (ev) {
    return onClickRate(ev, data);
  });
}

function knowledgerate(data) {
  app = this;
  var $node = (0, _tarzanZepto2.default)(_tpl2.default.render(data));
  bindEvents(data, $node);
  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/knowledgerate/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-knowledge-rate\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "feedback") == "UNSATISFIED") {
output += "\n  <span class=\"button rated bad\">\n    <svg class=\"icon\" aria-hidden=\"true\">\n      <use xlink:href=\"#icon-fbad\"></use>\n    </svg>\n  </span>\n  ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "feedback") == "SATISFIED") {
output += "\n  <span class=\"button rated good\">\n    <svg class=\"icon\" aria-hidden=\"true\">\n      <use xlink:href=\"#icon-fgood\"></use>\n    </svg>\n  </span>\n\n  ";
;
}
else {
output += "\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "__history__")) {
output += "\n    <span class=\"button good J_Btn\">\n      <svg class=\"icon\" aria-hidden=\"true\">\n        <use xlink:href=\"#icon-good\"></use>\n      </svg>\n    </span>\n    <span class=\"button bad J_Btn\">\n      <svg class=\"icon\" aria-hidden=\"true\">\n        <use xlink:href=\"#icon-bad\"></use>\n      </svg>\n    </span>\n    ";
;
}
output += "\n  ";
;
}
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/knowledgerate/tpl.html"] , dependencies)

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(250);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-knowledge-rate {\n  position: absolute;\n  bottom: 0;\n  right: -40px; }\n  .m-knowledge-rate .button {\n    display: block;\n    background: #fff;\n    width: 32px;\n    height: 32px;\n    border-radius: 32px;\n    text-align: center;\n    line-height: 32px;\n    font-size: 17px;\n    margin-top: 6px; }\n", ""]);

// exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buttons;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _tpl = __webpack_require__(252);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG_C = 'buttons';
var app = null;

function actionRoute(action, params, $node, $btn) {
  if (action === 'send') {
    if (params.header) {
      var show = true;
      if (params.header.msglog === 2) {
        show = false;
      }
      app.view.footer.submit({
        q: params.content,
        header: params.header
      }, 'text', show);
    } else {
      app.view.footer.submit(params.content);
    }

    $node.remove();
  } else if (action === 'photo' || action === 'camera') {
    app.bridge.photo({
      type: action,
      bizCode: 'alxm'
    }).then(function (res) {
      var url = res.url;
      app.appendMessage({
        type: 'image',
        body: {
          side: 'right',
          text: '<img src="' + url + '" >'
        }
      });
      app.view.footer.submit(url, 'image', false, true);

      $node.remove();
    }, function (err) {
      if (err === 'NO_PERMISSION') {
        app.bridge.toast('\u8BF7\u5F00\u542F' + (action === 'camera' ? '拍照' : '访问相册') + '\u6743\u9650\u54E6');
      }
    });
  } else if (action === 'writewish') {
    $btn.addClass('disabled');
    $btn.siblings().addClass('disabled');
  } else if (action === 'share') {
    app.bridge.share(params);
  } else if (action === 'selectOrder') {
    app.orderList.show({
      source: 'buttons'
    });
  }
}

function onClickBtn(ev, $node) {
  var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
  var action = $target.attr('data-action');
  var params = JSON.parse($target.attr('data-params'));
  if ($target.hasClass('disabled')) {
    return;
  }
  actionRoute(action, params, $node, $target);
  app.log.send({
    c: LOG_C,
    d: 'btn',
    ext: {
      action: action
    }
  });
}

function bindEvents($node) {
  $node.find('.J_Btn').on('tap', function (ev) {
    return onClickBtn(ev, $node);
  });
}

function buttons(data) {
  app = this;
  data.list.forEach(function (t) {
    t.param = JSON.stringify(t.params);

    if (data.__history__ && !t.permanent) {
      t.show = false;
    } else {
      t.show = true;
    }
  });
  var $node = (0, _tarzanZepto2.default)(_tpl2.default.render(data));

  bindEvents($node);

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/buttons/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-chatpanel-buttons\">\n    <div class=\"buttons\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "list");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n          ";
if(runtime.memberLookup((t_4),"show")) {
output += "\n          <div class=\"btn J_Btn\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"action"), env.opts.autoescape);
output += "\" data-params=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"param"), env.opts.autoescape);
output += "\">\n              ";
if(runtime.memberLookup((t_4),"icon")) {
output += "\n                <svg class=\"icon\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"icon"), env.opts.autoescape);
output += "\"></use>\n                </svg>\n              ";
;
}
output += "\n              ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"text"), env.opts.autoescape);
output += "\n          </div>\n          ";
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/buttons/tpl.html"] , dependencies)

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(254);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-buttons .buttons {\n  margin-top: 6px; }\n  .m-chatpanel-buttons .buttons .btn {\n    height: 24px;\n    line-height: 24px;\n    padding: 0 12px;\n    color: #00ACE6;\n    background: #fff;\n    border-radius: 12px;\n    display: inline-block;\n    font-size: 12px;\n    margin-right: 2px; }\n    .m-chatpanel-buttons .buttons .btn.disabled {\n      color: rgba(0, 172, 230, 0.5); }\n", ""]);

// exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shortcuts;
function shortcuts(data) {
  this.shortcuts.push(data);
  return {
    body: null
  };
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = robot;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(257);

var _tpl2 = _interopRequireDefault(_tpl);

var _eventbus = __webpack_require__(9);

var _eventbus2 = _interopRequireDefault(_eventbus);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickType = _util2.default.isPC() ? 'click' : 'tap';

function robot(data) {
  var _this = this;

  data.buttons = this.appConfig.get('recommend').list || [];
  data.buttonOrder = this.util.lang.get('ORDER:STATUS');
  data.buttonCancel = this.util.lang.get('CANCEL:ITEM');
  data.qa = this.util.lang.get('ROBOT:WELCOME');
  data.liveagent = this.util.lang.get('ROBOT:LIVEAGENT');
  data.showLiveAgent = this.param.showLiveAgent;
  var param = {
    name: 'welcomemsg',
    mid: data.mid,
    isFollow: data.isFollow,
    content: _tpl2.default.render({ data: data })
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  $node.find('.m-chatpanel-option-button').on(clickType, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var text = $target.attr('data-value');
    _this.view.footer.submit(text);
  });

  $node.find('.welcomemsg-liveagent').on(clickType, function () {
    _this.liveAgent.entry = 'welcomeCard';
    _eventbus2.default.emit('liveAgent', { entry: 'welcomeCard', type: 'click', chatUuid: '', intent: '' });
  });

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/welcomemsg/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"welcomemsg-body\">   \n    <div class=\"welcomemsg-avatar\">\n        <img src=\"//gw.alicdn.com/tfs/TB1UziCSVXXXXbNXpXXXXXXXXXX-480-480.png\" alt=\"avatar\">\n    </div>\n    <div class=\"welcomemsg-text\">\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"welcomemsg-actions\">\n        ";
output += "\n    </div>\n    ";
output += "\n</div>\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"showLiveAgent")) {
output += "\n";
output += "\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/welcomemsg/tpl.html"] , dependencies)

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(259);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-welcomemsg .chat .body {\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-body {\n    color: #202020;\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-body .welcomemsg-avatar {\n      text-align: center; }\n      .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-body .welcomemsg-avatar img {\n        width: 64px;\n        height: 68px; }\n    .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-body .welcomemsg-text {\n      margin-top: 10px;\n      margin-bottom: 15px; }\n    .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-body .welcomemsg-actions .m-chatpanel-option-button {\n      margin: auto;\n      margin-bottom: 12px;\n      width: 190px; }\n  .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-liveagent {\n    height: 42px;\n    background-color: #F6F6F6;\n    font-size: 12px;\n    color: #585858;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px; }\n    .m-chatpanel-item.m-chatpanel-welcomemsg .chat .body .welcomemsg-liveagent .iconfont {\n      margin-left: 10px;\n      font-size: 12px; }\n\n.m-chatpanel-option-button {\n  width: 210px;\n  padding: 0 10px;\n  min-height: 32px;\n  line-height: 32px;\n  text-align: center;\n  border: 1px solid #1A9CB7;\n  color: #1A9CB7;\n  font-size: 14px;\n  background-color: rgba(42, 179, 207, 0.05);\n  border-radius: 15px; }\n  .m-chatpanel-option-button.disabled {\n    border-color: #DADADA;\n    background-color: #F6F6F6;\n    color: #808080; }\n", ""]);

// exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = orderlist;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _iscroll = __webpack_require__(14);

var _iscroll2 = _interopRequireDefault(_iscroll);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(262);

var _tpl2 = _interopRequireDefault(_tpl);

var _list = __webpack_require__(263);

var _list2 = _interopRequireDefault(_list);

__webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = null;

var TAP = _util2.default.isPC() ? 'click' : 'tap';

function __show($node, cb) {
  setTimeout(function () {
    $node.find('.layer-body').addClass('slideUp');
    setTimeout(function () {
      cb();
    }, 350);
  }, 10);
}

function __hide($node) {
  $node.find('.J_Layer').removeClass('slideUp');
  setTimeout(function () {
    $node.remove();
  }, 320);
}

function __bindEvent($node) {
  $node.find('.layer-mask').on(TAP, function () {
    __hide($node);
  });
  $node.find('.layer-close').on(TAP, function () {
    __hide($node);
  });
}

function popUp(list) {
  list.title = App.util.lang.get('packageOrder')(list.sortIndex, list.sortLength);
  var $node = (0, _tarzanZepto2.default)(_list2.default.render(list));
  (0, _tarzanZepto2.default)('.m-alicare').append($node);
  $node.find('.layer-mask').animate({
    opacity: 1
  }, 300);
  $node.find('.layer-mask').on(TAP, function (ev) {
    ev.preventDefault();
  });
  __show($node, function () {
    __bindEvent($node);
  });
}

function initScroll(data, $node) {
  var num = data.list.length;
  var prev = $node.find('.prev');
  var next = $node.find('.next');
  var order = $node.find('.m-chatpanel-option-button');
  var pics = $node.find('.order-items');

  if (num === 1) {
    next.hide();
  }

  $node.find('.J_Orderlist').css({
    width: 274,
    maxHeight: 198
  });

  $node.find('.J_Order').css({
    width: 218
  });

  $node.find('.J_Scroller').css({ width: 230 * num });

  var scroller = new _iscroll2.default($node.find('.J_Orderlist')[0], {
    scrollX: true,
    scrollY: false,
    momentum: false,
    snap: 'div.J_Order'
  });

  scroller.on('scrollEnd', function () {
    var len = scroller.pages.length;
    var index = scroller.currentPage.pageX;
    if (index === 0) {
      prev.hide();
      next.show();
    } else if (index === len - 1) {
      next.hide();
      prev.show();
    } else {
      prev.show();
      next.show();
    }
  });

  next.on(TAP, function () {
    scroller.next();
  });
  prev.on(TAP, function () {
    scroller.prev();
  });
  order.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var value = $target.attr('data-value');
    var action = $target.attr('data-action');

    App.view.footer.submit({ q: value, ext: { botJson: action } });
  });

  pics.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var i = $target.attr('data-index');
    data.list[i - 1].sortIndex = i;
    data.list[i - 1].sortLength = data.list.length;
    popUp(data.list[i - 1]);
  });
}

function orderlist(data) {
  var _this = this;

  App = this;
  var orderList = data.body.list;
  orderList.map(function (item, index) {
    item.button.action = JSON.stringify(item.button.action);
    item.date = (0, _moment2.default)(item.date).format('MMM Do');
    item.langOrder = _this.util.lang.get('indexOrder')(index + 1, orderList.length);
    item.langOrderDetail = _this.util.lang.get('orderDetail')(item.number, item.date, item.items.length);
    return item;
  });
  var $wrap = (0, _tarzanZepto2.default)('<div class="m-chapanel-orderwrap"></div>');
  var tem = _tpl2.default.render({ list: orderList,
    openOrder: this.util.lang.get('openOrder')(orderList.length),
    showAll: this.util.lang.get('SHOW:ALLORDERS') });
  var param = {
    name: 'orderlist',
    mid: '11',
    content: tem
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  setTimeout(function () {
    $wrap.append($node);
    if (orderList.length === 0) {
      _this.view.body.scrollToBottom();
    } else {
      initScroll(data.body, $wrap);
      _this.view.body.scrollToBottom();
    }
  }, 0);

  $node.find('.orderlist-showall').on(TAP, function () {
    var link = document.createElement('a');
    link.href = App.param.myOrdersLink || data.body.redirectLink;
    link.target = '_blank';
    link.click();
    (0, _tarzanZepto2.default)(link).remove();
  });

  return {
    body: $wrap,
    callback: function callback() {}
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 18,
	"./af.js": 18,
	"./ar": 19,
	"./ar-dz": 20,
	"./ar-dz.js": 20,
	"./ar-kw": 21,
	"./ar-kw.js": 21,
	"./ar-ly": 22,
	"./ar-ly.js": 22,
	"./ar-ma": 23,
	"./ar-ma.js": 23,
	"./ar-sa": 24,
	"./ar-sa.js": 24,
	"./ar-tn": 25,
	"./ar-tn.js": 25,
	"./ar.js": 19,
	"./az": 26,
	"./az.js": 26,
	"./be": 27,
	"./be.js": 27,
	"./bg": 28,
	"./bg.js": 28,
	"./bn": 29,
	"./bn.js": 29,
	"./bo": 30,
	"./bo.js": 30,
	"./br": 31,
	"./br.js": 31,
	"./bs": 32,
	"./bs.js": 32,
	"./ca": 33,
	"./ca.js": 33,
	"./cs": 34,
	"./cs.js": 34,
	"./cv": 35,
	"./cv.js": 35,
	"./cy": 36,
	"./cy.js": 36,
	"./da": 37,
	"./da.js": 37,
	"./de": 38,
	"./de-at": 39,
	"./de-at.js": 39,
	"./de-ch": 40,
	"./de-ch.js": 40,
	"./de.js": 38,
	"./dv": 41,
	"./dv.js": 41,
	"./el": 42,
	"./el.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-nz": 47,
	"./en-nz.js": 47,
	"./eo": 48,
	"./eo.js": 48,
	"./es": 49,
	"./es-do": 50,
	"./es-do.js": 50,
	"./es.js": 49,
	"./et": 51,
	"./et.js": 51,
	"./eu": 52,
	"./eu.js": 52,
	"./fa": 53,
	"./fa.js": 53,
	"./fi": 54,
	"./fi.js": 54,
	"./fo": 55,
	"./fo.js": 55,
	"./fr": 56,
	"./fr-ca": 57,
	"./fr-ca.js": 57,
	"./fr-ch": 58,
	"./fr-ch.js": 58,
	"./fr.js": 56,
	"./fy": 59,
	"./fy.js": 59,
	"./gd": 60,
	"./gd.js": 60,
	"./gl": 61,
	"./gl.js": 61,
	"./gom-latn": 62,
	"./gom-latn.js": 62,
	"./he": 63,
	"./he.js": 63,
	"./hi": 64,
	"./hi.js": 64,
	"./hr": 65,
	"./hr.js": 65,
	"./hu": 66,
	"./hu.js": 66,
	"./hy-am": 67,
	"./hy-am.js": 67,
	"./id": 68,
	"./id.js": 68,
	"./is": 69,
	"./is.js": 69,
	"./it": 70,
	"./it.js": 70,
	"./ja": 71,
	"./ja.js": 71,
	"./jv": 72,
	"./jv.js": 72,
	"./ka": 73,
	"./ka.js": 73,
	"./kk": 74,
	"./kk.js": 74,
	"./km": 75,
	"./km.js": 75,
	"./kn": 76,
	"./kn.js": 76,
	"./ko": 77,
	"./ko.js": 77,
	"./ky": 78,
	"./ky.js": 78,
	"./lb": 79,
	"./lb.js": 79,
	"./lo": 80,
	"./lo.js": 80,
	"./lt": 81,
	"./lt.js": 81,
	"./lv": 82,
	"./lv.js": 82,
	"./me": 83,
	"./me.js": 83,
	"./mi": 84,
	"./mi.js": 84,
	"./mk": 85,
	"./mk.js": 85,
	"./ml": 86,
	"./ml.js": 86,
	"./mr": 87,
	"./mr.js": 87,
	"./ms": 88,
	"./ms-my": 89,
	"./ms-my.js": 89,
	"./ms.js": 88,
	"./my": 90,
	"./my.js": 90,
	"./nb": 91,
	"./nb.js": 91,
	"./ne": 92,
	"./ne.js": 92,
	"./nl": 93,
	"./nl-be": 94,
	"./nl-be.js": 94,
	"./nl.js": 93,
	"./nn": 95,
	"./nn.js": 95,
	"./pa-in": 96,
	"./pa-in.js": 96,
	"./pl": 97,
	"./pl.js": 97,
	"./pt": 98,
	"./pt-br": 99,
	"./pt-br.js": 99,
	"./pt.js": 98,
	"./ro": 100,
	"./ro.js": 100,
	"./ru": 101,
	"./ru.js": 101,
	"./sd": 102,
	"./sd.js": 102,
	"./se": 103,
	"./se.js": 103,
	"./si": 104,
	"./si.js": 104,
	"./sk": 105,
	"./sk.js": 105,
	"./sl": 106,
	"./sl.js": 106,
	"./sq": 107,
	"./sq.js": 107,
	"./sr": 108,
	"./sr-cyrl": 109,
	"./sr-cyrl.js": 109,
	"./sr.js": 108,
	"./ss": 110,
	"./ss.js": 110,
	"./sv": 111,
	"./sv.js": 111,
	"./sw": 112,
	"./sw.js": 112,
	"./ta": 113,
	"./ta.js": 113,
	"./te": 114,
	"./te.js": 114,
	"./tet": 115,
	"./tet.js": 115,
	"./th": 116,
	"./th.js": 116,
	"./tl-ph": 117,
	"./tl-ph.js": 117,
	"./tlh": 118,
	"./tlh.js": 118,
	"./tr": 119,
	"./tr.js": 119,
	"./tzl": 120,
	"./tzl.js": 120,
	"./tzm": 121,
	"./tzm-latn": 122,
	"./tzm-latn.js": 122,
	"./tzm.js": 121,
	"./uk": 123,
	"./uk.js": 123,
	"./ur": 124,
	"./ur.js": 124,
	"./uz": 125,
	"./uz-latn": 126,
	"./uz-latn.js": 126,
	"./uz.js": 125,
	"./vi": 127,
	"./vi.js": 127,
	"./x-pseudo": 128,
	"./x-pseudo.js": 128,
	"./yo": 129,
	"./yo.js": 129,
	"./zh-cn": 130,
	"./zh-cn.js": 130,
	"./zh-hk": 131,
	"./zh-hk.js": 131,
	"./zh-tw": 132,
	"./zh-tw.js": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/orderlist/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"orderlist-body\">\n    <div class=\"order-text\">\n        <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "openOrder"), env.opts.autoescape);
output += "</span>\n    </div>\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "list")),"length") > 0) {
output += "\n    <div class=\"order-list-wrap\">\n        <div class=\"top J_Orderlist\">\n            <div class=\"J_Scroller order-scroller\">\n                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "list");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                <div class=\"J_Order J_Blank order\"  data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"number"), env.opts.autoescape);
output += "\">\n                   <div class=\"order-index\">\n                       ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"langOrder"), env.opts.autoescape);
output += "\n                   </div>\n                   <div class=\"order-summary\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"langOrderDetail"), env.opts.autoescape);
output += "\n                   </div>\n                   <div class=\"order-items\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\">\n                       ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"items");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("o", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                           ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n                           <div class=\"img-wrap\">\n                                <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_8),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                           </div> \n                           ";
;
}
output += "\n                       ";
;
}
}
frame = frame.pop();
output += "\n                       ";
if(runtime.memberLookup((runtime.memberLookup((t_4),"items")),"length") > 3) {
output += "\n                          <div class=\"extra-items\">\n                            + ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"items")),"length") - 3, env.opts.autoescape);
output += "\n                          </div>\n                       ";
;
}
output += "\n                   </div>\n                   <div class=\"actions\">\n                        <div class=\"m-chatpanel-option-button\" data-value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"value"), env.opts.autoescape);
output += "\" data-label=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"label"), env.opts.autoescape);
output += "\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"action"), env.opts.autoescape);
output += "\">\n                            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"label"), env.opts.autoescape);
output += "</span>\n                        </div>\n                   </div>\n                </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        </div>\n        <div class=\"view-control\">\n                <div class=\"next\">\n                    <span class=\"iconfont icon-arrow\"></span>\n                </div>\n        </div>\n        <div class=\"view-control right\">\n                <div class=\"prev\" style=\"display:none\">\n                    <span class=\"iconfont icon-arrow\"></span>\n                </div>\n        </div>\n    </div>\n    ";
;
}
output += "\n</div>\n<div class=\"orderlist-showall\">\n        <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "showAll"), env.opts.autoescape);
output += "</span>\n        <span class=\"iconfont icon-externallink\"></span>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/orderlist/tpl.html"] , dependencies)

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/orderlist/list.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-orderdetail-popup\">\n    <div class=\"layer-mask\"></div>\n    <div class=\"layer-body\">\n       <div class=\"layer-close\">\n           <i class=\"iconfont icon-close\"></i>\n       </div>\n       <div class=\"layer-list\">\n               <div class=\"list-package-index\">\n                  ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "\n               </div>\n                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                    <div class=\"normal-item\">\n                        <div class=\"item-body\">\n                            <div class=\"img-wrap\">\n                                <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_4),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                            </div>\n                            <div class=\"info-wrap\">\n                                <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</div>\n                                <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"formatted_price"), env.opts.autoescape);
output += "</div>\n                            </div>\n                            <div class=\"quantity\">\n                                <span>× ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"quantity"), env.opts.autoescape);
output += "</span>\n                            </div>\n                        </div>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n       </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/orderlist/list.html"] , dependencies)

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(265);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-orderlist .chat .body {\n  padding: 0px;\n  min-width: 286px; }\n  .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body {\n    padding: 0px 0px 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-text {\n      color: #202020;\n      padding: 12px 0px;\n      overflow: hidden;\n      padding-right: 10px;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap {\n      position: relative; }\n      .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist {\n        overflow: hidden;\n        width: 266px;\n        position: relative; }\n        .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order {\n          float: left;\n          margin-right: 10px;\n          border: 1px solid #C5C5C5;\n          box-shadow: 1px 1px 2px #DADADA;\n          border-radius: 10px;\n          min-height: 196px; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-summary {\n            padding: 0 12px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical; }\n            .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-summary .bolder {\n              font-weight: bolder; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-index {\n            padding: 12px;\n            color: #202020;\n            font-size: 13px;\n            font-weight: bolder; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-items {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            padding: 12px;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center; }\n            .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-items .extra-items {\n              font-size: 16px;\n              color: #1A9CB7;\n              padding: 0px 5px; }\n            .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .order-items .img {\n              width: 48px;\n              height: 48px;\n              background-size: cover;\n              border-width: 0;\n              border: none; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .J_Orderlist .order .actions .m-chatpanel-option-button {\n            width: 170px;\n            margin: auto;\n            border-radius: 15px;\n            min-height: 32px; }\n      .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control {\n        height: 198px;\n        width: 60px;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0), white);\n        position: absolute;\n        z-index: 3;\n        right: 0px;\n        top: 0px; }\n        .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control.right {\n          background: transparent;\n          left: -28px; }\n        .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control .next {\n          position: absolute;\n          top: 81px;\n          right: -16px;\n          width: 34px;\n          height: 34px;\n          border: 1px solid #BDBDBD;\n          line-height: 34px;\n          text-align: center;\n          border-radius: 50%;\n          background-color: white; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control .next .iconfont {\n            font-size: 22px; }\n        .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control .prev {\n          position: absolute;\n          top: 81px;\n          right: -16px;\n          width: 34px;\n          height: 34px;\n          border: 1px solid #BDBDBD;\n          line-height: 34px;\n          text-align: center;\n          border-radius: 50%;\n          background-color: white; }\n          .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-body .order-list-wrap .view-control .prev .iconfont {\n            font-size: 22px;\n            display: inline-block;\n            -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-showall {\n    height: 42px;\n    background-color: #F6F6F6;\n    font-size: 12px;\n    color: #585858;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px; }\n    .m-chatpanel-item.m-chatpanel-orderlist .chat .body .orderlist-showall .iconfont {\n      margin-left: 8px;\n      font-size: 12px; }\n", ""]);

// exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = orderdetail;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _iscroll = __webpack_require__(14);

var _iscroll2 = _interopRequireDefault(_iscroll);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(267);

var _tpl2 = _interopRequireDefault(_tpl);

var _list = __webpack_require__(268);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(269);
__webpack_require__(271);

var app = null;

var TAP = _util2.default.isPC() ? 'click' : 'tap';

function convert(list) {
  var con = [];
  var bundles = list.bundles || [];
  var items = list.items;

  bundles.map(function (item) {
    con = con.concat(item.items);
    return item;
  });
  con = con.concat(items);

  return con;
}

function __show($node, cb) {
  setTimeout(function () {
    $node.find('.layer-body').addClass('slideUp');
    setTimeout(function () {
      cb();
    }, 350);
  }, 10);
}

function __hide($node) {
  $node.find('.J_Layer').removeClass('slideUp');
  setTimeout(function () {
    $node.remove();
  }, 320);
}
function __bindEvent($node) {
  $node.find('.layer-mask').on(TAP, function () {
    __hide($node);
  });
  $node.find('.layer-close').on(TAP, function () {
    __hide($node);
  });
}

function popUp(list) {
  list.title = app.util.lang.get('packageOrder')(list.sortIndex, list.sortLength);
  var $node = (0, _tarzanZepto2.default)(_list2.default.render(list));
  (0, _tarzanZepto2.default)('.m-alicare').append($node);
  $node.find('.layer-mask').animate({
    opacity: 1
  }, 300);
  $node.find('.layer-mask').on('touchmove', function (ev) {
    ev.preventDefault();
  });
  __show($node, function () {
    __bindEvent($node);
  });
}

function initScroll(data, $node) {
  var num = data.list.shipments.length;
  var prev = $node.find('.prev');
  var next = $node.find('.next');
  var order = $node.find('.m-chatpanel-option-button');
  var pics = $node.find('.package-items');

  if (num === 1) {
    next.hide();
  }

  $node.find('.J_Packagelist').css({
    width: 274
  });

  $node.find('.J_Package').css({
    width: 218
  });

  $node.find('.J_Scroller').css({ width: 230 * num });

  var scroller = new _iscroll2.default($node.find('.J_Packagelist')[0], {
    scrollX: true,
    scrollY: false,
    momentum: false,
    snap: 'div.J_Package'
  });

  scroller.on('scrollEnd', function () {
    var len = scroller.pages.length;
    var index = scroller.currentPage.pageX;
    if (index === 0) {
      prev.hide();
      next.show();
    } else if (index === len - 1) {
      next.hide();
      prev.show();
    } else {
      prev.show();
      next.show();
    }
  });

  next.on(TAP, function () {
    scroller.next();
  });
  prev.on(TAP, function () {
    scroller.prev();
  });
  order.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var i = $target.attr('data-index');
    var item = data.list.shipments[i - 1];

    var param = {
      address: data.list.address_shipping,
      index: i,
      number: data.list.number,
      status: item.status,
      status_history: item.status_history ? item.status_history : [],
      date: '' + (item.date_label ? item.date_label : ''),
      commentId: data.list.commentId
    };

    app.appendMessage({
      type: 'express',
      body: param
    });
  });

  pics.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var i = $target.attr('data-index');
    data.list.shipments[i - 1].sortIndex = i;
    data.list.shipments[i - 1].sortLength = data.list.shipments.length;
    popUp(data.list.shipments[i - 1]);
  });
}

function orderdetail(data) {
  var _this = this;

  app = this;

  data.list.shipments.map(function (item, index) {
    item.langPackage = app.util.lang.get('packageOrder')(index + 1, data.list.shipments.length);
    item.showList = convert(item);
    item.date_interval_from = (0, _moment2.default)(item.date_interval_from).format('Do MMM');
    item.date_interval_to = (0, _moment2.default)(item.date_interval_to).format('Do MMM');
    return item;
  });
  data.list.langTotal = this.util.lang.get('packageDetail')(data.list.number, data.list.shipments.length);
  data.list.langTrack = this.util.lang.get('TRACKING:DETAIL');
  var tem = _tpl2.default.render(data.list);
  var param = {
    name: 'orderdetail',
    mid: '11',
    content: tem
  };

  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  setTimeout(function () {
    if (data.list.shipments === 0) return;
    initScroll(data, $node);
    _this.view.body.scrollToBottom();
  }, 0);

  return {
    body: $node,
    callback: function callback() {}
  };
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/orderdetail/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"orderdetail-body\">\n    <div class=\"package-text\">\n        <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "langTotal"), env.opts.autoescape);
output += "</span>\n    </div>\n    <div class=\"package-list-wrap\">\n        <div class=\"top J_Packagelist\">\n            <div class=\"J_Scroller package-scroller\">\n                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "shipments");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                <div class=\"J_Package J_Blank package\" >\n                   <div class=\"package-index\">\n                       ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"langPackage"), env.opts.autoescape);
output += "\n                   </div>\n                    <div class=\"package-items\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\">\n                       ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"showList");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("o", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                           ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n                           <div class=\"img-wrap\">\n                                <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_8),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                           </div> \n                           ";
;
}
output += "\n                       ";
;
}
}
frame = frame.pop();
output += "\n                       ";
if(runtime.memberLookup((runtime.memberLookup((t_4),"showList")),"length") > 3) {
output += "\n                          <div class=\"extra-items\">\n                            + ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"showList")),"length") - 3, env.opts.autoescape);
output += "\n                          </div>\n                       ";
;
}
output += "\n                   </div>\n                   <div class=\"package-summary\">\n                       <div class=\"interval\">\n                           ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"date_label"), env.opts.autoescape);
output += "\n                       </div>\n                       <div class=\"method\">\n                           ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"latest_history"), env.opts.autoescape);
output += "\n                       </div>\n                   </div>\n                   <div class=\"actions\">\n                        <div class=\"m-chatpanel-option-button\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\">\n                            <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "langTrack"), env.opts.autoescape);
output += "</span>\n                        </div>\n                   </div>\n                </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        </div>\n        <div class=\"view-control\">\n                <div class=\"next\">\n                    <span class=\"iconfont icon-arrow\"></span>\n                </div>\n        </div>\n        <div class=\"view-control right\">\n             <div class=\"prev\" style=\"display:none\">\n                    <span class=\"iconfont icon-arrow\"></span>\n             </div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/orderdetail/tpl.html"] , dependencies)

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/orderdetail/list.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-orderdetail-popup\">\n    <div class=\"layer-mask\"></div>\n    <div class=\"layer-body\">\n       <div class=\"layer-close\">\n           <i class=\"iconfont icon-close\"></i>\n       </div>\n       <div class=\"layer-list\">\n               <div class=\"list-package-index\">\n                  ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "\n               </div>\n              ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "bundles");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("pack", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                <div class=\"list-package-item\">\n                    <div class=\"package-head\">\n                       ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "\n                    </div>\n                    <div class=\"package-items\">\n                        ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"items");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                            <div class=\"item-body\">\n                                <div class=\"img-wrap\">\n                                    <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_8),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                                </div>\n                                <div class=\"info-wrap\">\n                                    <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += "</div>\n                                    <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"formatted_price"), env.opts.autoescape);
output += "</div>\n                                </div>\n                                <div class=\"quantity\">\n                                    <span>× ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"quantity"), env.opts.autoescape);
output += "</span>\n                                </div>\n                            </div>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n            ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n            <div class=\"normal-item\">\n                <div class=\"item-body\">\n                    <div class=\"img-wrap\">\n                        <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_12),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                    </div>\n                    <div class=\"info-wrap\">\n                        <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</div>\n                        <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"formatted_price"), env.opts.autoescape);
output += "</div>\n                    </div>\n                    <div class=\"quantity\">\n                        <span>×";
output += runtime.suppressValue(runtime.memberLookup((t_12),"quantity"), env.opts.autoescape);
output += "</span>\n                    </div>\n                </div>\n            </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n       </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/orderdetail/list.html"] , dependencies)

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(270);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-orderdetail .chat .body {\n  min-width: 286px;\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body {\n    padding: 0px 0px 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-text {\n      color: #202020;\n      padding: 12px 0px;\n      overflow: hidden;\n      padding-right: 10px;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap {\n      position: relative; }\n      .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist {\n        overflow: hidden;\n        width: 266px;\n        position: relative;\n        font-size: 13px; }\n        .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package {\n          float: left;\n          margin-right: 10px;\n          border: 1px solid #C5C5C5;\n          box-shadow: 1px 1px 2px #DADADA;\n          border-radius: 10px;\n          min-height: 196px; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-summary {\n            padding: 0 12px; }\n            .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-summary .interval {\n              color: #478500;\n              -webkit-font-language-override: 13px;\n              font-language-override: 13px; }\n            .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-summary .method {\n              color: #202020;\n              font-size: 13px;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              display: -webkit-box;\n              -webkit-line-clamp: 2;\n              -webkit-box-orient: vertical; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-index {\n            padding: 0 12px;\n            color: #202020;\n            font-size: 13px;\n            font-weight: bolder;\n            padding-top: 10px; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-items {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            padding: 6px 12px;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center; }\n            .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-items .extra-items {\n              font-size: 16px;\n              color: #1A9CB7;\n              padding: 0px 5px; }\n            .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .package-items .img {\n              width: 48px;\n              height: 48px;\n              background-size: cover; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .actions {\n            padding-top: 12px;\n            padding-bottom: 12px; }\n            .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .J_Packagelist .package .actions .m-chatpanel-option-button {\n              width: 170px;\n              margin: auto;\n              border-radius: 15px;\n              height: 34px; }\n      .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control {\n        height: 198px;\n        width: 60px;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0), white);\n        position: absolute;\n        z-index: 3;\n        right: 0px;\n        top: 0px; }\n        .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control.right {\n          background: transparent;\n          left: -28px; }\n        .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control .next {\n          position: absolute;\n          top: 81px;\n          right: -16px;\n          width: 34px;\n          height: 34px;\n          border: 1px solid #BDBDBD;\n          line-height: 34px;\n          text-align: center;\n          border-radius: 50%;\n          background-color: white; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control .next .iconfont {\n            font-size: 22px; }\n        .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control .prev {\n          position: absolute;\n          top: 81px;\n          right: -16px;\n          width: 34px;\n          height: 34px;\n          border: 1px solid #BDBDBD;\n          line-height: 34px;\n          text-align: center;\n          border-radius: 50%;\n          background-color: white; }\n          .m-chatpanel-item.m-chatpanel-orderdetail .chat .body .orderdetail-body .package-list-wrap .view-control .prev .iconfont {\n            font-size: 22px;\n            display: inline-block;\n            -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n", ""]);

// exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(272);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./list.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-orderdetail-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 3;\n  overflow: hidden; }\n  .m-orderdetail-popup .layer-mask {\n    opacity: 0;\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.3); }\n  .m-orderdetail-popup .layer-body {\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n    transition: all 300ms;\n    position: absolute;\n    background: transparent;\n    left: 24px;\n    right: 24px;\n    bottom: 20%;\n    top: 20%;\n    margin: auto;\n    opacity: 0; }\n    .m-orderdetail-popup .layer-body .layer-close {\n      position: absolute;\n      top: 6px;\n      right: 9px;\n      width: 20px;\n      text-align: center;\n      background-color: white; }\n      .m-orderdetail-popup .layer-body .layer-close i {\n        color: #808080; }\n    .m-orderdetail-popup .layer-body .layer-list {\n      padding-top: 20px;\n      border-radius: 2px;\n      padding: 0 10px;\n      background-color: #ffffff;\n      max-height: 400px;\n      overflow: auto; }\n      .m-orderdetail-popup .layer-body .layer-list .list-package-index {\n        color: #202020;\n        padding: 10px;\n        font-size: 16px;\n        padding-top: 15px;\n        font-weight: bold; }\n      .m-orderdetail-popup .layer-body .layer-list .list-package-item {\n        border: 1px solid #808080;\n        border-radius: 3px;\n        padding: 10px;\n        margin-bottom: 10px; }\n      .m-orderdetail-popup .layer-body .layer-list .package-head, .m-orderdetail-popup .layer-body .layer-list .item-head {\n        font-weight: bolder; }\n      .m-orderdetail-popup .layer-body .layer-list .package-items, .m-orderdetail-popup .layer-body .layer-list .normal-item {\n        border-bottom: 1px solid #DADADA; }\n        .m-orderdetail-popup .layer-body .layer-list .package-items:last-child, .m-orderdetail-popup .layer-body .layer-list .normal-item:last-child {\n          border-color: transparent; }\n      .m-orderdetail-popup .layer-body .layer-list .normal-item {\n        padding: 10px 10px;\n        margin: 0 8px; }\n      .m-orderdetail-popup .layer-body .layer-list .package-items:last-child {\n        border-color: transparent; }\n        .m-orderdetail-popup .layer-body .layer-list .package-items:last-child .item-body {\n          border-color: transparent; }\n      .m-orderdetail-popup .layer-body .layer-list .package-items .item-body {\n        border-bottom: 1px solid #DADADA; }\n      .m-orderdetail-popup .layer-body .layer-list .package-items .m-chatpanel-option-button {\n        margin-top: 15px; }\n      .m-orderdetail-popup .layer-body .layer-list .item-body {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        padding: 10px 0px;\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        align-items: flex-start; }\n        .m-orderdetail-popup .layer-body .layer-list .item-body .img-wrap {\n          margin-right: 8px;\n          margin-left: 8px; }\n          .m-orderdetail-popup .layer-body .layer-list .item-body .img-wrap .img {\n            width: 48px;\n            height: 48px;\n            background-size: cover;\n            border: none; }\n        .m-orderdetail-popup .layer-body .layer-list .item-body .info-wrap {\n          -webkit-box-flex: 1;\n          -ms-flex: 1;\n          flex: 1; }\n          .m-orderdetail-popup .layer-body .layer-list .item-body .info-wrap .info-name {\n            font-size: 13px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            word-break: break-word; }\n          .m-orderdetail-popup .layer-body .layer-list .item-body .info-wrap .info-price {\n            color: #D32329;\n            font-size: 13px; }\n        .m-orderdetail-popup .layer-body .layer-list .item-body .quantity {\n          margin-left: 4px;\n          font-size: 13px; }\n      .m-orderdetail-popup .layer-body .layer-list .m-chatpanel-option-button {\n        margin: auto; }\n  .m-orderdetail-popup .slideUp {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n", ""]);

// exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = option;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(274);

var _tpl2 = _interopRequireDefault(_tpl);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickType = _util2.default.isPC() ? 'click' : 'tap';

function convert(list) {
  var con = Object.assign({}, list);
  var buttons = con.button || [];
  buttons.map(function (item) {
    item.action = JSON.stringify(item.action);
    return item;
  });
  return con;
}

function option(data) {
  var _this = this;

  var param = {
    name: 'option',
    mid: data.mid,
    isFollow: data.isFollow,
    content: _tpl2.default.render(convert(data.list))
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  $node.find('.m-chatpanel-option-button').on(clickType, function (ev) {
    if ($node.find('.option-list').hasClass('disabled')) return;
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var value = $target.attr('data-value');
    var action = $target.attr('data-action');
    _this.view.footer.submit({ q: value, ext: { botJson: action } });
    $node.find('.option-list').addClass('disabled');
  });

  $node.find('.m-chatpanel-option-link').on(clickType, function () {});

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/option/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-chatpanel-option-body\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "image")) {
output += " \n        <div class=\"option-banner\">\n            <image src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
output += "\"></image>\n        </div>\n    ";
;
}
output += "\n    <div class=\"option-text\">\n        <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "</span>\n    </div>\n    <div class=\"option-list\">\n          ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "button");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            <div class=\"m-chatpanel-option-button\" data-label =\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"label"), env.opts.autoescape);
output += "\" data-value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"action"), env.opts.autoescape);
output += "\">\n                <span>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"label"), env.opts.autoescape);
output += "</span>\n                ";
if(runtime.memberLookup((t_4),"isDirect")) {
output += "\n                <span class=\"iconfont icon-externallink\"></span>\n                ";
;
}
output += "\n            </div>\n          ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n</div>\n";
if(runtime.contextOrFrameLookup(context, frame, "link")) {
output += "\n<div class=\"m-chatpanel-option-link\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "link")),"action"), env.opts.autoescape);
output += "\">\n        <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "link")),"text"), env.opts.autoescape);
output += "</span>\n        <span class=\"iconfont icon-externallink\"></span>\n</div>\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/option/tpl.html"] , dependencies)

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(276);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-option .chat .body {\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-body {\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-body .option-list {\n      padding-top: 12px; }\n      .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-body .option-list.disabled .m-chatpanel-option-button {\n        border-color: #DADADA;\n        background-color: #F6F6F6;\n        color: #808080; }\n      .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-body .option-list .m-chatpanel-option-button {\n        margin: auto;\n        margin-bottom: 12px; }\n        .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-body .option-list .m-chatpanel-option-button .iconfont {\n          color: #1A9CB7;\n          font-size: 12px;\n          margin-left: 2px; }\n  .m-chatpanel-item.m-chatpanel-option .chat .body .m-chatpanel-option-link {\n    height: 42px;\n    background-color: #F6F6F6;\n    font-size: 12px;\n    color: #585858;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px; }\n", ""]);

// exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = express;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(278);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function express(data) {
  data.status_current = null;
  data.status.map(function (item, index) {
    if (item.active) {
      item.className = 'current';
      data.status_current = index;
    }
    return item;
  });
  data.status.map(function (item, index) {
    if (index < data.status_current) {
      item.className = '';
    } else if (index > data.status_current) {
      item.className = 'un';
    }
    return item;
  });

  data.shipping = this.util.lang.get('SHIPPING:ADDRESS');
  data.tracking = this.util.lang.get('tracking')(data.index, data.number);
  var param = {
    name: 'express',
    content: _tpl2.default.render(data)
  };
  var action = {
    source: 'event',
    intentId: data.commentId
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));
  this.view.body.scrollToBottom();
  this.view.footer.submit({ q: 'feedback', ext: { botJson: JSON.stringify(action) } }, 'text', false, true);
  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/express/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"express-head\">\n    <span>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "tracking")), env.opts.autoescape);
output += "</span>\n</div>\n<div class=\"express-body\">\n    <div class=\"date\">\n       ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "date"), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"express-body-progress\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "status");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n           ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 1) {
output += "\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n               <i class=\"bar ";
if((runtime.memberLookup((t_4),"className") == "current")) {
output += "un";
;
}
else {
;
}
output += "\"></i>\n           ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 2) {
output += "\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n           ";
;
}
else {
output += "\n               <i class=\"bar ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i> \n           ";
;
}
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"express-body-current\">\n        ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "status");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n           ";
if(runtime.memberLookup((t_8),"active")) {
output += "\n               ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += "\n           ";
;
}
output += "     \n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"express-body-history\">\n        ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "status_history");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n            <div class=\"history-item\">\n                <span class=\"date\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"date_of_change"), env.opts.autoescape);
output += " - </span>\n                <span class=\"label\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_12),"name")), env.opts.autoescape);
output += "</span>\n            </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n</div>\n<div class=\"express-note\">\n    <p class=\"address-label\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "shipping"), env.opts.autoescape);
output += "</p>\n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"first_name"), env.opts.autoescape);
output += "</p> \n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"address1"), env.opts.autoescape);
output += "</p>\n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"phone"), env.opts.autoescape);
output += "</p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/express/tpl.html"] , dependencies)

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(280);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-express .chat .body {\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-express .chat .body .express-head {\n    font-size: 14px;\n    color: #202020;\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-head .bold {\n      font-weight: bolder; }\n  .m-chatpanel-item.m-chatpanel-express .chat .body .express-body {\n    background-color: #F6F6F6;\n    text-align: center;\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .date {\n      color: #478500;\n      font-size: 13px;\n      padding: 10px 0;\n      font-weight: bold; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      -webkit-box-pack: center;\n      -ms-flex-pack: center;\n      justify-content: center; }\n      .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress i.dot {\n        background-color: #478500;\n        width: 11px;\n        height: 11px;\n        display: inline-block;\n        border-radius: 50%; }\n        .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress i.dot.un {\n          background-color: #CCC9C9; }\n        .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress i.dot.current {\n          width: 16px;\n          height: 16px;\n          background-color: #fff;\n          border: 3px solid #478500; }\n      .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress i.bar {\n        width: 80px;\n        display: inline-block;\n        height: 3px;\n        background-color: #478500; }\n        .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-progress i.bar.un {\n          background-color: #CCC9C9; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-body div.express-body-current {\n      text-align: center;\n      font-weight: bolder;\n      padding: 10px 0px; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-history {\n      padding: 10px 0;\n      text-align: left; }\n      .m-chatpanel-item.m-chatpanel-express .chat .body .express-body .express-body-history .date {\n        font-size: 13px;\n        color: #202020;\n        font-weight: bolder; }\n  .m-chatpanel-item.m-chatpanel-express .chat .body .express-note {\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-note .address-label {\n      font-weight: bolder;\n      padding-bottom: 10px; }\n    .m-chatpanel-item.m-chatpanel-express .chat .body .express-note p {\n      padding-bottom: 6px; }\n", ""]);

// exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cancelitems;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _tpl = __webpack_require__(282);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAP = _util2.default.isPC() ? 'click' : 'tap';

function convert(list) {
  var con = Object.assign({}, list);
  var bundles = con.bundles || [];
  var items = con.items;

  bundles.map(function (item) {
    item.button.action = JSON.stringify(item.button.action);
    return item;
  });
  items.map(function (item) {
    item.button.action = JSON.stringify(item.button.action);
    return item;
  });

  return con;
}

function sum(list) {
  var con = Object.assign({}, list);
  var bundles = con.bundles || [];
  var len = 0;
  bundles.map(function (item) {
    len += item.items.length;
    return item;
  });
  return len;
}

function cancelitems(data) {
  var _this = this;

  var list = convert(data.list);
  list.startPoint = sum(list);
  list.itemword = this.util.lang.get('WORD:ITEM');
  var param = {
    name: 'cancelitems',
    mid: data.mid,
    isFollow: data.isFollow,
    content: _tpl2.default.render(list)
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));
  var order = $node.find('.m-chatpanel-option-button');
  var reasonAction = $node.find('.uncancelable-action');

  reasonAction.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    $target.toggleClass('active');
  });

  order.on(TAP, function (ev) {
    var $target = (0, _tarzanZepto2.default)(ev.currentTarget);
    var value = $target.attr('data-value');
    var action = $target.attr('data-action');
    var flag = $target.attr('data-cancelable');
    if ($target.hasClass('disabled')) return;
    order.addClass('disabled');
    if (flag && flag === 'true') {
      _this.postMessage({
        type: 'robot',
        body: {
          text: value
        }
      }).then(function (res) {
        _this.view.body.append(res.body);
        _this.view.body.scrollToBottom();
      });
    } else {
      _this.view.footer.submit({ q: value, ext: { botJson: action } });
    }
  });
  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/cancelitems/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cancelitem-list\">\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "bundles");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("pack", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <div class=\"list-pacakge-item\">\n             <div class=\"package-head\">\n               ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "\n             </div>\n                ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"items");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                   <div class=\"package-items\">\n                    <div class=\"item-head\">\n                        Item ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\n                    </div>\n                    <div class=\"item-body\">\n                        <div class=\"img-wrap\">\n                            <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_8),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                        </div>\n                        <div class=\"info-wrap\">\n                            <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += "</div>\n                            <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"formatted_price"), env.opts.autoescape);
output += "</div>\n                            <div class=\"info-date\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"date_label"), env.opts.autoescape);
output += "</div>\n                        </div>\n                        <div class=\"quantity\">\n                            <span>× ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"quantity"), env.opts.autoescape);
output += "</span>\n                        </div>\n                    </div>\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "\n                        ";
if(runtime.memberLookup((t_4),"is_cancellable")) {
output += "\n                            <div class=\"m-chatpanel-option-button\" data-value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"value"), env.opts.autoescape);
output += "\" data-label=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"label"), env.opts.autoescape);
output += "\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"action"), env.opts.autoescape);
output += "\" data-cancelable=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"flag"), env.opts.autoescape);
output += "\">\n                                <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"button")),"label"), env.opts.autoescape);
output += "</span>\n                            </div>\n                        ";
;
}
output += "\n                    ";
;
}
output += "\n                  </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n    ";
;
}
}
frame = frame.pop();
output += "\n    ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n      <div class=\"normal-item\">\n         <div class=\"item-head\">\n            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "itemword"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") + runtime.contextOrFrameLookup(context, frame, "startPoint"), env.opts.autoescape);
output += "\n        </div>\n        <div class=\"item-body\">\n            <div class=\"img-wrap\">\n                <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_12),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n            </div>\n            <div class=\"info-wrap\">\n                <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</div>\n                <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"formatted_price"), env.opts.autoescape);
output += "</div>\n                <div class=\"info-date\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"date_label"), env.opts.autoescape);
output += "</div>\n                ";
if(!runtime.memberLookup((t_12),"is_cancellable")) {
output += "\n                <div class=\"uncancelable-action\">\n                    <div class=\"title toggle-reason\">\n                        <span class=\"hint\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"label"), env.opts.autoescape);
output += "</span>\n                        <span class=\"iconfont icon-top-arrow\"></span>\n                    </div>\n                    <div class=\"reason-detail\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((t_12),"button")),"value")), env.opts.autoescape);
output += "\n                    </div> \n                </div>     \n                ";
;
}
output += "\n            </div>\n            <div class=\"quantity\">\n                <span>× ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"quantity"), env.opts.autoescape);
output += "</span>\n            </div>\n          \n        </div>\n        ";
if(runtime.memberLookup((t_12),"is_cancellable")) {
output += "\n        <div class=\"m-chatpanel-option-button\" data-value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"value"), env.opts.autoescape);
output += "\" data-label=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"label"), env.opts.autoescape);
output += "\" data-action=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"action"), env.opts.autoescape);
output += "\" data-cancelable=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"flag"), env.opts.autoescape);
output += "\">\n            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"button")),"value"), env.opts.autoescape);
output += "</span>\n        </div>\n        ";
;
}
output += "\n      </div>\n    ";
;
}
}
frame = frame.pop();
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/cancelitems/tpl.html"] , dependencies)

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(284);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .list-pacakge-item {\n  border: 1px solid #808080;\n  border-radius: 3px;\n  padding: 10px;\n  margin-bottom: 10px; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-head {\n  font-size: 14px;\n  color: #202020; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-head {\n  font-weight: bolder; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items, .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .normal-item {\n  border-bottom: 1px solid #DADADA; }\n  .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items:last-child, .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .normal-item:last-child {\n    border-color: transparent; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .normal-item {\n  padding: 10px 10px; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items:last-child .item-body {\n  border-color: transparent; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items .item-head {\n  padding-top: 10px; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items .item-body {\n  border-bottom: 1px solid #DADADA; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .package-items .m-chatpanel-option-button {\n  margin-top: 3px;\n  margin-bottom: 10px;\n  width: 190px; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 0px; }\n  .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .img-wrap {\n    margin-right: 8px; }\n    .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .img-wrap .img {\n      width: 48px;\n      height: 48px;\n      background-size: cover; }\n  .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1; }\n    .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .info-name {\n      font-size: 13px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .info-price {\n      color: #D32329;\n      font-size: 13px; }\n    .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .info-date {\n      color: #579400;\n      font-size: 13px; }\n    .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action {\n      width: 180px; }\n      .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action.active .reason-detail {\n        display: block;\n        color: #808080;\n        font-size: 12px; }\n      .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action.active .iconfont {\n        -webkit-transform: rotate(180deg);\n        transform: rotate(180deg); }\n      .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action .title {\n        font-size: 13px;\n        color: #202020; }\n      .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action .reason-detail {\n        display: none; }\n      .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .info-wrap .uncancelable-action .iconfont {\n        display: inline-block;\n        color: #1A9CB7;\n        margin-left: 5px;\n        font-size: 13px; }\n  .m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .item-body .quantity {\n    margin-left: 4px;\n    font-size: 13px;\n    width: 20px; }\n\n.m-chatpanel-item.m-chatpanel-cancelitems .chat .body .cancelitem-list .m-chatpanel-option-button {\n  margin: auto;\n  margin-top: 3px;\n  margin-bottom: 10px;\n  width: 190px; }\n", ""]);

// exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = evaluate;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _tpl = __webpack_require__(286);

var _tpl2 = _interopRequireDefault(_tpl);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _log = __webpack_require__(12);

var _log2 = _interopRequireDefault(_log);

__webpack_require__(287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clickType = _util2.default.isPC() ? 'click' : 'tap';

function evaluate(data) {
  var _this = this;

  var param = {
    name: 'evaluate',
    side: 'center',
    mid: data.mid,
    content: _tpl2.default.render(data)
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));
  var $text = $node.find('.evaluate-text');
  var goodAction = JSON.stringify(data.button[0].action);
  var badAction = JSON.stringify(data.button[1].action);

  $node.find('.iconfont').on(clickType, function (ev) {
    var $el = (0, _tarzanZepto2.default)(ev.target);

    if ($node.hasClass('evaluated')) return;
    $text.text(_this.util.lang.get('FEEDBACK:THANKS'));
    $el.addClass('active');
    $node.addClass('evaluated');
    if (data.isKnowledge) {
      if ($el.hasClass('good')) {
        _this.appendMessage({
          type: 'robot',
          body: {
            text: _this.util.lang.get('KNOWLEDGE:GOOD')
          }
        });
      } else {
        _this.appendMessage({
          type: 'robot',
          body: {
            text: _this.util.lang.get('KNOWLEDGE:BAD')
          }
        });

        var liveAgent = _this.util.lang.get('LIVE:AGENT');
        _this.appendMessage({
          type: 'dynamic_shortcuts',
          body: {
            isAdd: false,
            shortcuts: [{ code: 'liveAgent', icon: 'service', text: liveAgent, type: 'text', title: liveAgent, content: liveAgent }].concat(_this.essentials.config.config.shortcuts || [])
          }
        });

        _this.liveAgent = {
          entry: 'thumbDown'
        };

        _log2.default.liveAgent({ entry: 'thumbDown', type: 'show', chatUuid: _this.chatUuid, intent: '' });
        setTimeout(function () {
          _this.view.body.scrollToBottom();
        }, 50);
      }
    } else if ($el.hasClass('good')) {
      _this.view.footer.submit({ q: 'good', ext: { botJson: goodAction } }, 'text', false, true);
    } else {
      _this.view.footer.submit({ q: 'bad', ext: { botJson: badAction } }, 'text', false, true);
    }
    _this.model.robotRate({
      feedback: $el.hasClass('good') ? '1' : '2',
      chatUuid: data.chatUuid
    });
  });

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/evaluate/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"evaluate-content\">\n  <span class=\"evaluate-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "</span>\n  <span class=\"iconfont icon-thumb_up good\"></span>\n  <span class=\"iconfont icon-thumb_down bad\"></span>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/evaluate/tpl.html"] , dependencies)

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(288);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-evaluate {\n  margin-right: 60px;\n  margin-top: 12px; }\n  .m-chatpanel-item.m-chatpanel-evaluate .chat .body {\n    padding: 0;\n    display: block;\n    float: none;\n    background: transparent;\n    margin: 0;\n    text-align: center;\n    border: none;\n    box-shadow: none; }\n    .m-chatpanel-item.m-chatpanel-evaluate .chat .body .arrow {\n      display: none; }\n    .m-chatpanel-item.m-chatpanel-evaluate .chat .body .content {\n      font-size: 13px;\n      color: #202020;\n      text-align: right; }\n      .m-chatpanel-item.m-chatpanel-evaluate .chat .body .content .evaluate-content .evaluate-text {\n        margin-right: 10px; }\n      .m-chatpanel-item.m-chatpanel-evaluate .chat .body .content .evaluate-content .iconfont {\n        font-size: 24px;\n        color: #D2D2D2;\n        margin-right: 8px; }\n      .m-chatpanel-item.m-chatpanel-evaluate .chat .body .content .evaluate-content .icon-thumb_up.active {\n        color: #478500; }\n      .m-chatpanel-item.m-chatpanel-evaluate .chat .body .content .evaluate-content .icon-thumb_down.active {\n        color: #808080; }\n", ""]);

// exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = robot;

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _index = __webpack_require__(8);

var _index2 = _interopRequireDefault(_index);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

var _tpl = __webpack_require__(290);

var _tpl2 = _interopRequireDefault(_tpl);

__webpack_require__(291);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAP = _util2.default.isPC() ? 'click' : 'tap';

function robot(data) {
  var param = {
    name: 'textlink',
    mid: data.mid,
    isFollow: data.isFollow,
    content: _tpl2.default.render(data)
  };
  var $node = (0, _tarzanZepto2.default)(_index2.default.msg(param));

  $node.find('.textlink-link').on(TAP, function () {
    var link = document.createElement('a');
    link.href = data.link.link;
    link.target = '_blank';
    link.click();
    (0, _tarzanZepto2.default)(link).remove();
  });

  return {
    body: $node,

    callback: function callback() {}
  };
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var nunjucks = __webpack_require__(5);
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = __webpack_require__(6);


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/textlink/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"textlink-body\">   \n    <div class=\"textlink-text\">\n         ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "text")), env.opts.autoescape);
output += "\n    </div>\n</div>\n<div class=\"textlink-link\">\n    <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "link")),"label"), env.opts.autoescape);
output += "</span>\n    <span class=\"iconfont icon-arrow\"></span>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/textlink/tpl.html"] , dependencies)

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(292);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item.m-chatpanel-textlink .chat .body {\n  padding: 0px; }\n  .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-body {\n    color: #202020;\n    padding: 10px 12px; }\n    .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-body .textlink-text {\n      margin-top: 10px;\n      margin-bottom: 15px; }\n  .m-chatpanel-item.m-chatpanel-textlink .chat .body .textlink-link {\n    height: 42px;\n    background-color: #F6F6F6;\n    font-size: 12px;\n    color: #585858;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px; }\n", ""]);

// exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(294);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./base.scss", function() {
			var newContent = require("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./base.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".m-chatpanel-item {\n  margin-top: 16px;\n  word-break: break-word; }\n  .m-chatpanel-item img {\n    width: 100%; }\n  .m-chatpanel-item img[src^=\"//g.alicdn.com/crm/static/\"], .m-chatpanel-item img[src^=\"http://a.tbcdn.cn/sys/wangwang/smiley\"], .m-chatpanel-item img.smiley {\n    width: 20px;\n    vertical-align: middle; }\n  .m-chatpanel-item .user {\n    width: 32px;\n    position: relative; }\n    .m-chatpanel-item .user .avatar {\n      background: #fff;\n      width: 32px;\n      height: 32px;\n      border-radius: 32px;\n      margin-left: -6px; }\n      .m-chatpanel-item .user .avatar img {\n        width: 30px;\n        margin-left: 1px;\n        margin-top: -1px; }\n  .m-chatpanel-item .chat.clearfix::before, .m-chatpanel-item .chat .clearfix::before {\n    content: \" \";\n    display: table; }\n  .m-chatpanel-item .chat.clearfix::after, .m-chatpanel-item .chat .clearfix::after {\n    content: \" \";\n    display: table;\n    clear: both; }\n  .m-chatpanel-item .chat .body {\n    font-size: 14px;\n    line-height: 1.3;\n    color: #202020;\n    text-align: left;\n    padding: 10px 12px;\n    margin: 0 5px 0 0;\n    background-color: #ffffff;\n    border-radius: 10px;\n    border: 1px solid #DADADA;\n    box-shadow: 0px 1px 3px #dadada;\n    position: relative;\n    margin-right: 50px;\n    float: left; }\n    .m-chatpanel-item .chat .body .arrow {\n      position: absolute;\n      height: 10px;\n      width: 10px;\n      border: 1px solid transparent;\n      border-left-color: #dadada;\n      border-top-color: #dadada;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      top: 12px;\n      left: -6px;\n      right: auto;\n      background-color: #fff; }\n    .m-chatpanel-item .chat .body.full-body {\n      margin-right: 0px !important;\n      float: none; }\n    .m-chatpanel-item .chat .body.full-nopadding-body {\n      padding: 0px;\n      margin-right: 0px !important;\n      float: none;\n      background-color: transparent; }\n    .m-chatpanel-item .chat .body .content {\n      word-break: break-word; }\n      .m-chatpanel-item .chat .body .content p {\n        margin: 0; }\n      .m-chatpanel-item .chat .body .content a {\n        text-decoration: none;\n        color: #00ACE6; }\n  .m-chatpanel-item.follow {\n    margin-top: 4px; }\n\n.m-chatpanel-item-right {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  box-direction: reverse; }\n  .m-chatpanel-item-right .chat .body {\n    padding: 10px;\n    margin: 0 0 0 50px;\n    background-color: #EEFFD6;\n    border: none;\n    box-shadow: none;\n    float: right;\n    border: 1px solid #DADADA;\n    box-shadow: 0px 1px 3px #dadada; }\n    .m-chatpanel-item-right .chat .body .arrow {\n      position: absolute;\n      height: 10px;\n      width: 10px;\n      border: 1px solid transparent;\n      border-right-color: #dadada;\n      border-bottom-color: #dadada;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      top: 12px;\n      right: -6px;\n      left: auto;\n      background-color: #EEFFD6; }\n\n.m-chatpanel-item-center {\n  display: block; }\n  .m-chatpanel-item-center .chat .body {\n    float: none;\n    margin: 0; }\n\n.m-chatpanel-voiceinput {\n  -webkit-animation-delay: 0s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-duration: 2s;\n  -webkit-animation-name: inputing; }\n\n@-webkit-keyframes inputing {\n  0% {\n    opacity: 1; }\n  60% {\n    opacity: 0.5; } }\n\n.m-order-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px; }\n  .m-order-item button {\n    -ms-flex-item-align: start;\n    align-self: flex-start;\n    border: 1px solid #efefef;\n    background-color: #fff;\n    padding: 0;\n    width: 40px;\n    height: 20px;\n    font-size: 12px;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 40px;\n    flex: 0 0 40px;\n    border-radius: 10px;\n    margin-left: 18px; }\n  .m-order-item .pic {\n    width: 70px;\n    height: 70px;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 70px;\n    flex: 0 0 70px;\n    border-radius: 4px;\n    overflow: hidden; }\n    .m-order-item .pic img {\n      width: 70px;\n      height: 70px; }\n  .m-order-item .info {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    margin-left: 10px; }\n    .m-order-item .info .title {\n      font-size: 14px;\n      color: #333;\n      line-height: 16px;\n      height: 32px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .m-order-item .info .sku {\n      color: #999;\n      font-size: 12px;\n      height: 16px;\n      line-height: 16px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical; }\n    .m-order-item .info .price {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center; }\n      .m-order-item .info .price .truly {\n        color: #FF7700;\n        font-size: 14px; }\n      .m-order-item .info .price .falsely {\n        font-size: 12px;\n        color: #ccc;\n        margin: 0 4px; }\n      .m-order-item .info .price .count {\n        color: #999;\n        font-size: 12px;\n        margin-left: 10px; }\n      .m-order-item .info .price .status {\n        margin: 0 0 0 auto;\n        background-color: #FF7700;\n        color: #fff;\n        font-size: 10px;\n        padding: 0 3px;\n        border-radius: 4px; }\n\n.m-card-popup {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: transparent;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  overflow: hidden;\n  z-index: 3; }\n  .m-card-popup .popup-mask {\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    background-color: rgba(102, 99, 93, 0.3);\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    overflow: hidden;\n    position: fixed; }\n  .m-card-popup .popup-list {\n    position: absolute;\n    background: #fff;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    min-height: 70%;\n    max-height: 80%;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n    transition: all 300ms;\n    opacity: 0;\n    border-radius: 16px 16px 0 0; }\n    .m-card-popup .popup-list .toggle {\n      color: #ccc;\n      text-align: center;\n      padding: 12px 0; }\n      .m-card-popup .popup-list .toggle .toggle-icon {\n        display: inline-block;\n        width: 32px;\n        height: 4px;\n        background-color: #D8D8D8;\n        border-radius: 4px; }\n    .m-card-popup .popup-list .list-wrapper {\n      background: #fff;\n      top: 30px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      padding: 10px;\n      overflow-y: scroll;\n      overflow-x: hidden;\n      max-height: 567px;\n      -webkit-overflow-scrolling: touch; }\n  .m-card-popup .slideUp {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0); }\n\n.m-footer-popup {\n  width: 100%;\n  background: #FFF; }\n  .m-footer-popup .popup-header {\n    width: 93%;\n    padding: 10px;\n    color: #999;\n    font-size: 12px;\n    box-sizing: border-box; }\n    .m-footer-popup .popup-header span {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .m-footer-popup .popup-header .popup-close {\n      position: absolute;\n      right: 10px;\n      top: 12px;\n      font-size: 16px; }\n  .m-footer-popup .popup-body {\n    background-color: #FAFAFA; }\n  .m-footer-popup .popup-btn-group {\n    width: 100%;\n    height: 52px;\n    line-height: 52px;\n    overflow: hidden;\n    text-align: center;\n    background: #FFF; }\n    .m-footer-popup .popup-btn-group .popup-btn {\n      display: inline-block;\n      width: 170px;\n      height: 36px;\n      border-radius: 20px;\n      line-height: 36px;\n      text-align: center;\n      font-size: 14px;\n      color: #CCC;\n      box-sizing: border-box;\n      border: 1px solid #E1E1E1; }\n      .m-footer-popup .popup-btn-group .popup-btn.active {\n        color: #333; }\n\n.m-pull-tip {\n  text-align: center;\n  color: #969696;\n  font-size: 12px;\n  margin-top: 10px; }\n\n.m-ext {\n  color: #999;\n  margin-top: 10px;\n  font-size: 12px; }\n  .m-ext i {\n    padding-right: 5px; }\n\n.m-ext.m-ext-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .m-ext.m-ext-left span {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1; }\n", ""]);

// exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./index.scss", function() {
			var newContent = require("!!../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "html {\n  font-family: 'PingFang SC','Lantinghei SC';\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none; }\n\na {\n  text-decoration: none; }\n\n.clearfix::before, .clearfix::after {\n  content: ' ';\n  display: table;\n  clear: both; }\n\n.dotting {\n  display: inline-block;\n  min-width: 2px;\n  min-height: 2px;\n  -webkit-animation: dot 1.6s infinite step-start both;\n  box-shadow: 2px 0 currentColor, 8px 0 currentColor, 14px 0 currentColor;\n  margin-right: 16px; }\n  .dotting::before {\n    content: ''; }\n\n@-webkit-keyframes dot {\n  25% {\n    box-shadow: none; }\n  50% {\n    box-shadow: 2px 0 currentColor; }\n  75% {\n    box-shadow: 2px 0 currentColor, 8px 0 currentColor; } }\n\n@keyframes dot {\n  25% {\n    box-shadow: none; }\n  50% {\n    box-shadow: 2px 0 currentColor; }\n  75% {\n    box-shadow: 2px 0 currentColor, 8px 0 currentColor; } }\n", ""]);

// exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(298);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./iconfont.scss", function() {
			var newContent = require("!!../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./iconfont.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'iconfont';\n  /* project id 325420 */\n  src: url(\"//at.alicdn.com/t/font_325420_6r7mxmv7cwg0hpvi.eot\");\n  src: url(\"//at.alicdn.com/t/font_325420_6r7mxmv7cwg0hpvi.eot?#iefix\") format(\"embedded-opentype\"), url(\"//at.alicdn.com/t/font_325420_6r7mxmv7cwg0hpvi.woff\") format(\"woff\"), url(\"//at.alicdn.com/t/font_325420_6r7mxmv7cwg0hpvi.ttf\") format(\"truetype\"), url(\"//at.alicdn.com/t/font_325420_6r7mxmv7cwg0hpvi.svg#iconfont\") format(\"svg\"); }\n\n.iconfont {\n  font-family: \"iconfont\" !important;\n  font-size: 16px;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.icon-arrow:before {\n  content: \"\\E72D\"; }\n\n.icon-emoji:before {\n  content: \"\\E6E3\"; }\n\n.icon-send:before {\n  content: \"\\E61B\"; }\n\n.icon-close:before {\n  content: \"\\E633\"; }\n\n.icon-thumb_down::before {\n  content: \"\\E605\"; }\n\n.icon-thumb_up::before {\n  content: \"\\E603\"; }\n\n.icon-externallink::before {\n  content: \"\\E831\"; }\n\n.icon-top-arrow::before {\n  content: \"\\E631\"; }\n", ""]);

// exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'WELCOME:NAMECARD': '助理小蜜 进入会话为你服务',
  'WELCOME:MESSAGE': 'Hi，我是你的智能助理小蜜。想问什么尽管问，小蜜一直都在~',
  'WELCOME:BACK': '欢迎回来,继续你和小蜜的聊天吧..',
  'OSP:CONNECT:FAIL': '亲，当前服务繁忙，请稍后再试，或拨打官方热线 <a href="tel:0571-88158198">0571-88158198</a> 进行咨询',
  'OSP:SERVICE:JOIN': '人工小蜜 {{name}} 为您提供服务，愉快聊起来～',
  'OSP:SERVICE:LEAVE': '亲，等你好久没回来，人工小蜜已退出服务，您咨询的问题如果未解决，可以重新发起咨询~',
  'OSP:SERVICE:QUEUE': '人工小蜜正在赶来的路上，稍等哟~',
  'OSP:SERVICE:QUIT': '人工小蜜 已退出服务，很高兴遇见您~',
  'OSP:WELCOME:BACK': '欢迎回来，继续你和人工小蜜的聊天吧..',
  'OSP:WELCOME:CONTINUE': '亲，你刚刚的问题解决了嘛？如果没解决，小蜜可以为你连接刚刚为你服务的人工小蜜哦~',
  'OSP:QUEUE:BEGIN': '收到，小蜜马上变身人工小蜜，为您提供服务…',
  'OSP:QUEUE:COMING': '人工小蜜正在赶来的路上，稍等哟~',
  'OSP:USERLEAVE:LOGINELSE': '您已在其他地方登录',
  'OSP:SWITCH': '人工小蜜 转交了您的服务请求，正在为您连接…',
  'OSP:TIP:SOLVED': '好勒，能为你解决问题是小蜜今天最开心的事啦！小蜜还能为你提供更多服务哦，订机票、充话费、查天气等都可以随时跟我说~',
  'ROBOT:EXCEPTION': 'Uh oh! Something went wrong at our side. Don\'t worry, it\'s not you. Sorry about that.',
  'ROBOT:UNKNOWN': '亲，小蜜瞬间断片了，亲请重新描述您的问题，或提交订单给我，小蜜立马帮你去处理~',
  'ROBOT:NOANSWER': 'Sorry,I can`t understand, you can ask in a different way',
  'ROBOT:TO:OCS': '亲，你遇到什么问题啦？描述你的问题，小蜜帮你找人工~',
  'ROBOT:TO:OCSBUSY': '亲亲，很抱歉，双11活动咨询太火爆了，人工小蜜正在努力赶来的路上，请稍等，你可以先伸个懒腰休息下~',
  'ROBOT:OCS:ENTRY': '小蜜没解决您的问题？<a href="javascript:;" class="J_GoManual">找人工阿里小蜜<i class="iconfont icon-arrow-right"></i></a>',
  'FIRSTMESSAGE:EXCEPTION': '哎呀，小蜜没有找到你可能想了解的内容，亲可以直接向我提问哟，比如【如何申请退款】~',
  'FIRSTMESSAGE:TIP': '<p>小蜜在，亲需要我做什么吗？</p><p>购物问题、订机票、查天气等都可以问我哦～ </p>',
  'FIRSTMESSAGE:ROBOT:ENTRY': '没有我想要的，<a href="javascript:;" class="J_Action">找小蜜聊聊</a>',
  'FIRSTMESSAGE:SHOW': '有问题？<a href="javascript:;" class="J_Action">找我的小蜜</a>',
  'KNOWLEDGE:RATE:GOOD': 'oyeah！谢谢你给小蜜一个大大的赞，么么哒~',
  'KNOWLEDGE:RATE:BAD': '呜呜~小蜜会继续学习，下次为你提供更好的服务~',
  'KNOWLEDGE:RATE:ASK': '呜呜~小蜜回答的不好吗？描述你觉得不好的原因，小蜜会根据你的描述，找合适的人工小蜜为你服务~',
  'KNOWLEDGE:RATE:FEEDBACK': '已收到你的反馈！小蜜要回去好好学习了，你可以召唤人工小蜜~',
  'KNOWLEDGE:CHANGEORDERTIP': '沟通过程中，若需咨询不同订单遇到的问题，请先点击输入区<a href="javascript:;" class="J_HookSelectOrder">‘+’选择订单</a>发给小蜜哦',
  'HISTORY:LOADFAIL': '历史消息加载失败，请稍后再试',
  'HISTORY:NOMORE': '哎呀，消息都被你看完啦，羞涩⁄(•⁄ω⁄•)⁄',
  'CARD:ENTRY': '【人工小蜜】',
  'APP:NAME': '小蜜',
  'SHORTCUT:DISPATCH': '召唤人工小蜜'
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getScript(url, callback) {
  var doc = document;
  var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
  var node = doc.createElement('script');
  node.setAttribute('charset', 'utf-8');
  if ('onload' in node) {
    node.onload = function () {
      callback(1);
    };
    node.onerror = function () {
      callback(0);
    };
  } else {
    node.onreadystatechange = function () {
      if (/loaded|complete/.test(node.readyState)) {
        callback(1);
      }
    };
  }
  node.async = true;
  node.src = url;
  head.appendChild(node);
}

function addStyle(url) {
  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.id = 'alicarecss';
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  link.media = 'all';
  head.appendChild(link);
}

exports.getScript = getScript;
exports.addStyle = addStyle;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (window) {
  var svgSprite = '<svg>' + '' + '<symbol id="icon-camera" viewBox="0 0 1024 1024">' + '' + '<path d="M486.4 216.6912H204.9152c-56.704 0-102.5152 45.824-102.5152 102.3616v460.8768c0 56.6144 45.9008 102.3616 102.5152 102.3616h614.1824c56.704 0 102.5152-45.824 102.5152-102.3616V319.0528c0-56.6144-45.9008-102.3616-102.5152-102.3616H793.6C793.1008 174.7712 758.9376 140.8 716.8768 140.8H563.1232A76.7744 76.7744 0 0 0 486.4 216.6912z" fill="#FFFFFF" ></path>' + '' + '<path d="M819.0848 216.6912H793.6C793.1008 174.7712 758.9376 140.8 716.8768 140.8H563.1232A76.7616 76.7616 0 0 0 486.4 216.6912H204.9024A102.3744 102.3744 0 0 0 102.4 319.0528v460.8768c0 56.6144 45.9008 102.3616 102.5024 102.3616h614.1824c56.704 0 102.5152-45.824 102.5152-102.3616V319.0528c0-56.6144-45.9008-102.3616-102.5152-102.3616z m-614.1824 51.2H537.6V217.6c0-14.1568 11.4304-25.6 25.5232-25.6h153.7408c14.0544 0 25.536 11.4944 25.536 25.6v50.2912h76.6848A51.1872 51.1872 0 0 1 870.4 319.0528V512H153.6V319.0528a51.1616 51.1616 0 0 1 51.3024-51.1616z m614.1824 563.2H204.9024A51.1744 51.1744 0 0 1 153.6 779.9296V563.2h716.8v216.7296a51.1744 51.1744 0 0 1-51.3152 51.1616z" fill="#66635C" ></path>' + '' + '<path d="M224 192h115.2a25.6 25.6 0 1 0 0-51.2h-115.2a25.6 25.6 0 1 0 0 51.2z" fill="#66635C" ></path>' + '' + '<path d="M524.8 716.8c-98.9696 0-179.2-80.2304-179.2-179.2s80.2304-179.2 179.2-179.2 179.2 80.2304 179.2 179.2-80.2304 179.2-179.2 179.2z" fill="#FFDD8C" ></path>' + '' + '<path d="M524.8 665.6c70.6944 0 128-57.3056 128-128s-57.3056-128-128-128-128 57.3056-128 128 57.3056 128 128 128z m0 51.2c-98.9696 0-179.2-80.2304-179.2-179.2s80.2304-179.2 179.2-179.2 179.2 80.2304 179.2 179.2-80.2304 179.2-179.2 179.2z" fill="#66635C" ></path>' + '' + '<path d="M550.4 576a64 64 0 1 1 0-128 64 64 0 0 1 0 128z" fill="#FFFFFF" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-face" viewBox="0 0 1024 1024">' + '' + '<path d="M512 512m-409.6 0a409.6 409.6 0 1 0 819.2 0 409.6 409.6 0 1 0-819.2 0Z" fill="#FFFFFF" ></path>' + '' + '<path d="M512 544m-326.4 0a326.4 326.4 0 1 0 652.8 0 326.4 326.4 0 1 0-652.8 0Z" fill="#FFDD8C" ></path>' + '' + '<path d="M512 870.4c197.9392 0 358.4-160.4608 358.4-358.4S709.9392 153.6 512 153.6 153.6 314.0608 153.6 512s160.4608 358.4 358.4 358.4z m0 51.2C285.7856 921.6 102.4 738.2144 102.4 512S285.7856 102.4 512 102.4s409.6 183.3856 409.6 409.6-183.3856 409.6-409.6 409.6z" fill="#66635C" ></path>' + '' + '<path d="M665.6 435.2m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#66635C" ></path>' + '' + '<path d="M358.4 435.2m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#66635C" ></path>' + '' + '<path d="M756.3776 607.5648c-0.2944 0.896-1.0624 3.0464-2.368 6.2592a245.504 245.504 0 0 1-8.64 18.8928 285.0688 285.0688 0 0 1-39.1936 58.176C660.4288 743.2704 599.104 774.4 518.4 774.4a25.6 25.6 0 1 0 0 51.2c96.3712 0 171.3536-38.0672 226.3296-101.0176a335.1296 335.1296 0 0 0 46.2848-68.6848c7.2192-14.2336 11.7888-25.536 14.0544-32.512a25.6 25.6 0 0 0-48.6912-15.8208z" fill="#66635C" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-commodi" viewBox="0 0 1024 1024">' + '' + '<path d="M230.4 102.4h563.2c70.6944 0 128 57.3056 128 128v563.2c0 70.6944-57.3056 128-128 128H230.4c-70.6944 0-128-57.3056-128-128V230.4c0-70.6944 57.3056-128 128-128z" fill="#FFFFFF" ></path>' + '' + '<path d="M230.4 102.4h563.2c70.6944 0 128 57.3056 128 128s-57.3056 128-128 128H230.4c-70.6944 0-128-57.3056-128-128S159.7056 102.4 230.4 102.4z" fill="#FFFFFF" ></path>' + '' + '<path d="M230.4 204.8h563.2a76.8 76.8 0 1 1 0 153.6H230.4a76.8 76.8 0 1 1 0-153.6z" fill="#FFDD8C" ></path>' + '' + '<path d="M793.6 102.4H230.4C159.68 102.4 102.4 159.7056 102.4 230.4v563.2c0 70.72 57.3056 128 128 128h563.2c70.72 0 128-57.3056 128-128V230.4c0-70.72-57.3056-128-128-128z m-563.2 51.2h563.2a76.8 76.8 0 0 1 76.8 76.8c0 42.432-34.368 76.8-76.8 76.8H230.4a76.8 76.8 0 0 1-76.8-76.8c0-42.432 34.368-76.8 76.8-76.8z m563.2 716.8H230.4c-42.432 0-76.8-34.368-76.8-76.8V332.6336A127.3344 127.3344 0 0 0 230.4 358.4h563.2a127.2704 127.2704 0 0 0 76.8-25.7664V793.6c0 42.432-34.368 76.8-76.8 76.8z" fill="#66635C" ></path>' + '' + '<path d="M716.8 537.6a51.2 51.2 0 0 0-102.4 0c0 18.8928 10.3424 35.2 25.5616 44.0832a131.7632 131.7632 0 0 1-10.0096 35.5712c-17.6 38.9632-53.504 62.08-118.0544 62.3232-64.6656 0.2432-100.2368-22.6432-117.3888-61.5296-5.3504-12.1216-8.2944-24.6912-9.7792-36.736A51.008 51.008 0 0 0 409.6 537.6a51.2 51.2 0 0 0-102.4 0c0 19.0336 10.496 35.4432 25.9072 44.2624a181.9392 181.9392 0 0 0 14.5536 56.832c25.408 57.5872 79.488 92.3904 164.4288 92.0704 84.5312-0.32 138.624-35.1616 164.5184-92.4416a183.6416 183.6416 0 0 0 15.1936-56.96A50.9568 50.9568 0 0 0 716.8 537.6z" fill="#66635C" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-exit" viewBox="0 0 1024 1024">' + '' + '<path d="M704.128 153.6H294.4c-56.448 0-102.4 45.8112-102.4 102.3232v512.1664C192 824.4736 237.8368 870.4 294.3872 870.4h409.728a76.7488 76.7488 0 0 0 76.672-76.7104V736a25.6 25.6 0 1 0-51.2 0v57.6896A25.5232 25.5232 0 0 1 704.128 819.2H294.4c-28.2368 0-51.2-22.9632-51.2-51.1232V255.9232A51.2256 51.2256 0 0 1 294.3872 204.8h409.728a25.472 25.472 0 0 1 25.472 25.5104V288a25.6 25.6 0 1 0 51.2 0v-57.6896A76.672 76.672 0 0 0 704.128 153.6z" fill="#66635C" ></path>' + '' + '<path d="M925.056 492.032l-160-128a25.6 25.6 0 0 0-31.9872 39.9744L836.0576 486.4H454.4a25.6 25.6 0 1 0 0 51.2h381.8496l-102.7584 82.4064a25.6 25.6 0 1 0 32.0384 39.9488l159.552-127.9616a25.6 25.6 0 0 0-0.0256-39.9616z" fill="#66635C" ></path>' + '' + '<path d="M153.6 255.9232v512.1664c0 30.0416 25.6 58.2016 55.5648 61.056l359.232 34.2144c12.1728 1.152 20.4032-6.3232 20.4032-18.4576V179.0976c0-12.1088-8.256-19.6096-20.4032-18.4448l-359.232 34.2144c-30.0288 2.8544-55.5648 30.9376-55.5648 61.056z m-51.2 0c0-56.512 45.6064-106.6624 101.9136-112.0256l359.232-34.2144C605.7728 105.664 640 136.8192 640 179.0976v665.8048c0 42.3552-34.24 73.4336-76.4544 69.4144l-359.232-34.2144C148.032 874.7392 102.4 824.4736 102.4 768.0768V255.9232z" fill="#66635C" ></path>' + '' + '<path d="M102.4 255.9232c0-56.512 45.6064-106.6624 101.9136-112.0256l359.232-34.2144C605.7728 105.664 640 136.8192 640 179.0976v665.8048c0 42.3552-34.24 73.4336-76.4544 69.4144l-359.232-34.2144C148.032 874.7392 102.4 824.4736 102.4 768.0768V255.9232z" fill="#FFDD8C" ></path>' + '' + '<path d="M537.6 147.2v729.6h51.2v-729.6z" fill="#FFFFFF" ></path>' + '' + '<path d="M153.6 255.9232v512.1664c0 30.4896 26.2016 59.968 56.6016 63.5904l359.68 42.816c11.6224 1.3824 18.9184-5.12 18.9184-16.9344V166.4384c0-11.7632-7.3472-18.304-18.9184-16.9216l-359.68 42.816C179.776 195.9552 153.6 225.3824 153.6 255.9232z m-51.2 0c0-56.512 45.6064-107.7504 101.7472-114.432l359.68-42.816C605.9008 93.6576 640 124.032 640 166.4384v691.136c0 42.432-34.0352 72.7808-76.1728 67.7632l-359.68-42.816C147.9552 875.8272 102.4 824.4736 102.4 768.0768V255.9232z" fill="#66635C" ></path>' + '' + '<path d="M448 524.8a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6z m0 51.2a64 64 0 1 1 0.0128-128.0128A64 64 0 0 1 448 576z" fill="#66635C" ></path>' + '' + '<path d="M448 524.8a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6z m0 51.2a64 64 0 1 1 0.0128-128.0128A64 64 0 0 1 448 576z" fill="#66635C" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-photo" viewBox="0 0 1024 1024">' + '' + '<path d="M102.4 204.9152A102.4512 102.4512 0 0 1 204.9152 102.4h639.9872A76.7488 76.7488 0 0 1 921.6 179.0976v665.8048A76.7488 76.7488 0 0 1 844.9024 921.6H204.9152A102.4512 102.4512 0 0 1 102.4 819.0848V204.9152z" fill="#FFFFFF" ></path>' + '' + '<path d="M320 294.4m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#FFDD8C" ></path>' + '' + '<path d="M320 307.2a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6z m0 51.2a64 64 0 1 1 0.0128-128.0128A64 64 0 0 1 320 358.4zM528.2432 566.3104a25.6128 25.6128 0 0 0 33.2928-3.1616l222.0672-231.6928a25.6 25.6 0 0 0-36.9664-35.4304L539.8528 511.7696l-95.552-67.7632a25.6 25.6 0 0 0-32.7808 2.6496L279.0784 577.28a25.6 25.6 0 1 0 35.9552 36.4416l117.1584-115.5584 96.0512 68.1472z" fill="#66635C" ></path>' + '' + '<path d="M102.4 819.2a102.4 102.4 0 0 1 102.5152-102.4H921.6v127.9616C921.6 887.1936 887.1808 921.6 844.9024 921.6H204.9152C148.3008 921.6 102.4 875.6352 102.4 819.2z" fill="#FFDD8C" ></path>' + '' + '<path d="M211.2 838.4h678.4a19.2 19.2 0 0 0 0-38.4h-678.4a19.2 19.2 0 0 0 0 38.4z" fill="#FFFFFF" ></path>' + '' + '<path d="M844.9024 102.4h-640A102.4512 102.4512 0 0 0 102.4 204.9152V819.2a102.464 102.464 0 0 0 102.5024 102.4h639.9872A76.7488 76.7488 0 0 0 921.6 844.9024V179.0976A76.7488 76.7488 0 0 0 844.9024 102.4z m-640 768c-22.6048 0-41.6256-14.7712-48.448-35.0592-1.7152-5.12-2.8544-10.496-2.8672-16.192A51.2128 51.2128 0 0 1 204.9024 768H870.4v76.7616A25.6256 25.6256 0 0 1 844.9024 870.4h-640z m0-153.6A101.9776 101.9776 0 0 0 153.6 730.624V204.9152A51.2512 51.2512 0 0 1 204.9024 153.6h639.9872c14.0544 0 25.5104 11.456 25.5104 25.4976V716.8H204.9024z" fill="#66635C" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-position" viewBox="0 0 1024 1024">' + '' + '<path d="M217.6 393.7792c0 312.1664 294.4 457.4336 294.4 457.4336s294.4-145.28 294.4-457.4336C806.4 232.8704 674.5856 102.4 512 102.4S217.6 232.8704 217.6 393.7792z" fill="#FFFFFF" ></path>' + '' + '<path d="M627.2 396.8a115.2 115.2 0 1 1-230.4 0 115.2 115.2 0 0 1 230.4 0" fill="#FFDD8C" ></path>' + '' + '<path d="M512 435.2a76.8 76.8 0 1 1 0-153.6 76.8 76.8 0 0 1 0 153.6z" fill="#FFFFFF" ></path>' + '' + '<path d="M512 102.4C349.4144 102.4 217.6 232.8704 217.6 393.7792c0 312.1664 294.4 457.4336 294.4 457.4336s294.4-145.28 294.4-457.4336C806.4 232.8704 674.5856 102.4 512 102.4z m110.5792 601.3824A588.1728 588.1728 0 0 1 512 792.3584a589.44 589.44 0 0 1-110.5792-88.576C318.1312 618.5088 268.8 515.712 268.8 393.7792 268.8 261.2608 377.5872 153.6 512 153.6s243.2 107.6608 243.2 240.1792c0 121.9328-49.3312 224.7296-132.6208 310.0032z" fill="#66635C" ></path>' + '' + '<path d="M512 256c-77.76 0-140.8 63.04-140.8 140.8s63.04 140.8 140.8 140.8 140.8-63.04 140.8-140.8-63.04-140.8-140.8-140.8z m0 230.4a89.6 89.6 0 1 1 0.0128-179.2128A89.6 89.6 0 0 1 512 486.4zM569.6 883.2h-115.2a25.6 25.6 0 1 0 0 51.2h115.2a25.6 25.6 0 1 0 0-51.2z" fill="#66635C" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-dalei" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 621.714286c0 90.916571 73.6 164.571429 164.406857 164.571428H365.714286a27.428571 27.428571 0 0 0 0-54.857143h-91.593143A109.622857 109.622857 0 0 1 164.571429 621.714286c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 85.778286-69.686857 155.428571-155.465142 155.428571H658.285714a27.428571 27.428571 0 0 0 0 54.857143h45.677715C819.968 786.285714 914.285714 692.132571 914.285714 576 914.285714 459.830857 820.114286 365.714286 703.963429 365.714286z" fill="#879396" ></path>' + '' + '<path d="M460.233143 889.325714a27.428571 27.428571 0 0 0 48.347428 25.892572l73.837715-137.929143A27.428571 27.428571 0 0 0 558.262857 736.914286h-47.506286l44.342858-88.265143a27.428571 27.428571 0 0 0-49.005715-24.612572l-64.310857 128A27.428571 27.428571 0 0 0 466.285714 791.771429h46.171429l-52.224 97.554285z" fill="#FFCE59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-duoyun" viewBox="0 0 1042 1024">' + '' + '<path d="M429.714286 603.355429A127.981714 127.981714 0 1 1 429.714286 347.428571a127.963429 127.963429 0 0 1 124.690285 99.419429 157.622857 157.622857 0 0 1 37.046858-4.553143c6.144 0 12.178286 0.475429 18.139428 1.152C594.468571 357.723429 519.771429 292.571429 429.714286 292.571429c-100.992 0-182.857143 81.846857-182.857143 182.820571 0 100.973714 81.865143 182.820571 182.857143 182.820571 5.101714 0 10.093714-0.347429 15.085714-0.768a156.617143 156.617143 0 0 1-10.788571-54.308571c-1.444571 0.054857-2.852571 0.219429-4.297143 0.219429z" fill="#FFCE59" ></path>' + '' + '<path d="M100.571429 502.857143h54.857142a27.428571 27.428571 0 0 0 0-54.857143h-54.857142a27.428571 27.428571 0 0 0 0 54.857143zM457.142857 201.142857V146.285714a27.428571 27.428571 0 0 0-54.857143 0v54.857143a27.428571 27.428571 0 0 0 54.857143 0zM166.217143 256.073143l38.784 38.784a27.428571 27.428571 0 1 0 38.784-38.784l-38.784-38.784a27.428571 27.428571 0 1 0-38.784 38.784zM654.427429 294.875429l38.784-38.784a27.428571 27.428571 0 1 0-38.784-38.784l-38.784 38.784a27.428571 27.428571 0 1 0 38.784 38.784zM210.358857 738.925714l38.784-38.784a27.428571 27.428571 0 1 0-38.784-38.784l-38.784 38.784a27.428571 27.428571 0 1 0 38.784 38.784z" fill="#FFCE59" ></path>' + '' + '<path d="M649.490286 841.142857h145.792a128.036571 128.036571 0 0 0 128.146285-128c0-70.692571-57.362286-128-128.146285-128h-55.844572A146.304 146.304 0 1 0 458.971429 659.108571h-29.824a91.008 91.008 0 0 0-90.861715 91.008A91.044571 91.044571 0 0 0 429.147429 841.142857h220.342857z m0 54.857143h-220.342857c-80.475429 0-145.718857-65.481143-145.718858-145.865143a145.956571 145.956571 0 0 1 109.787429-141.385143A172.105143 172.105143 0 0 1 393.142857 603.428571c0-111.085714 90.057143-201.142857 201.142857-201.142857 85.284571 0 158.171429 53.083429 187.428572 128h13.568C896.347429 530.285714 978.285714 612.132571 978.285714 713.142857c0 100.992-81.883429 182.857143-183.003428 182.857143h-145.792z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-longjuanfeng" viewBox="0 0 1024 1024">' + '' + '<path d="M210.285714 329.142857h475.428572a27.428571 27.428571 0 0 1 0 54.857143h-475.428572a27.428571 27.428571 0 0 1 0-54.857143zM283.428571 219.428571h475.428572a27.428571 27.428571 0 0 1 0 54.857143h-475.428572a27.428571 27.428571 0 0 1 0-54.857143zM301.714286 438.857143h475.428571a27.428571 27.428571 0 0 1 0 54.857143h-475.428571a27.428571 27.428571 0 0 1 0-54.857143zM466.285714 548.571429h219.428572a27.428571 27.428571 0 0 1 0 54.857142h-219.428572a27.428571 27.428571 0 0 1 0-54.857142zM411.428571 658.285714h182.857143a27.428571 27.428571 0 0 1 0 54.857143h-182.857143a27.428571 27.428571 0 0 1 0-54.857143zM448 768h73.142857a27.428571 27.428571 0 0 1 0 54.857143h-73.142857a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-dabaoyu" viewBox="0 0 1024 1024">' + '' + '<path d="M722.249143 329.142857h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164572 9.051428A164.681143 164.681143 0 0 0 128 585.142857c0 90.916571 73.6 164.571429 164.406857 164.571429H310.857143a27.428571 27.428571 0 0 0 0-54.857143h-18.450286A109.622857 109.622857 0 0 1 182.857143 585.142857c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739429a177.664 177.664 0 0 1-10.24-59.666285A178.029714 178.029714 0 0 1 487.954286 237.714286c87.497143 0 160.237714 63.104 175.213714 146.285714h59.081143A155.428571 155.428571 0 0 1 877.714286 539.428571c0 85.778286-69.686857 155.428571-155.465143 155.428572H713.142857a27.428571 27.428571 0 0 0 0 54.857143h9.106286C838.253714 749.714286 932.571429 655.561143 932.571429 539.428571 932.571429 423.259429 838.4 329.142857 722.249143 329.142857z" fill="#879396" ></path>' + '' + '<path d="M421.979429 585.618286l-63.616 190.829714a27.428571 27.428571 0 1 0 52.041142 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041142-17.334857zM531.693714 585.618286l-63.616 190.829714a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334857zM641.408 585.618286l-63.616 190.829714a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334857z" fill="#5CC3E6" ></path>' + '' + '<path d="M329.142857 868.571429a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M438.857143 868.571429a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M548.571429 868.571429a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-dayu" viewBox="0 0 1024 1024">' + '' + '<path d="M704 731.428571v54.857143c115.986286-0.018286 210.285714-94.153143 210.285714-210.285714C914.285714 459.830857 820.114286 365.714286 703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 621.714286c0 90.916571 73.6 164.571429 164.406857 164.571428H320v-54.857143h-45.878857A109.622857 109.622857 0 0 1 164.571429 621.714286c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 85.76-69.668571 155.410286-155.428571 155.428571z" fill="#879396" ></path>' + '' + '<path d="M320 758.857143m-27.428571 0a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#879396" ></path>' + '' + '<path d="M704 758.857143m-27.428571 0a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#879396" ></path>' + '' + '<path d="M467.693714 622.189714l-73.142857 219.428572a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428572a27.428571 27.428571 0 1 0-52.041143-17.334857zM577.408 622.189714l-73.142857 219.428572a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428572a27.428571 27.428571 0 1 0-52.041143-17.334857z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-baoyu" viewBox="0 0 1024 1024">' + '' + '<path d="M914.285714 539.428571C914.285714 423.259429 820.114286 329.142857 703.963429 329.142857h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051428A164.681143 164.681143 0 0 0 109.714286 585.142857c0 90.916571 73.6 164.571429 164.406857 164.571429H310.857143a27.428571 27.428571 0 0 0 0-54.857143h-36.736A109.622857 109.622857 0 0 1 164.571429 585.142857c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666285A178.029714 178.029714 0 0 1 469.668571 237.714286c87.497143 0 160.237714 63.104 175.213715 146.285714h59.081143A155.428571 155.428571 0 0 1 859.428571 539.428571c0 82.688-64.804571 150.180571-146.285714 154.971429V694.857143a27.428571 27.428571 0 0 0 0 54.857143c2.596571 0 5.065143-0.475429 7.442286-1.152C828.781714 740.022857 914.285714 649.910857 914.285714 539.428571z" fill="#879396" ></path>' + '' + '<path d="M421.979429 585.618286l-73.142858 219.428571a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428571a27.428571 27.428571 0 1 0-52.041142-17.334857zM531.693714 585.618286l-73.142857 219.428571a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428571a27.428571 27.428571 0 1 0-52.041143-17.334857zM641.408 585.618286l-73.142857 219.428571a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428571a27.428571 27.428571 0 1 0-52.041143-17.334857z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-wu" viewBox="0 0 1024 1024">' + '' + '<path d="M110.848 603.428571H166.217143c8.722286-51.84 53.723429-91.428571 107.904-91.428571h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 9.380571-0.969143 18.505143-2.578285 27.428571h55.424c1.188571-8.996571 2.011429-18.102857 2.011428-27.428571C914.285714 459.830857 820.114286 365.714286 703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.662857 164.662857 0 0 0 110.848 603.428571z" fill="#5CC3E6" ></path>' + '' + '<path d="M128 704h768a27.428571 27.428571 0 0 0 0-54.857143H128a27.428571 27.428571 0 0 0 0 54.857143zM155.428571 749.714286h164.571429a27.428571 27.428571 0 0 1 0 54.857143h-164.571429a27.428571 27.428571 0 0 1 0-54.857143zM411.428571 749.714286h438.857143a27.428571 27.428571 0 0 1 0 54.857143h-438.857143a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-qing" viewBox="0 0 1024 1024">' + '' + '<path d="M512 694.857143c100.992 0 182.857143-81.865143 182.857143-182.857143s-81.865143-182.857143-182.857143-182.857143-182.857143 81.865143-182.857143 182.857143 81.865143 182.857143 182.857143 182.857143z m0 54.857143c-131.291429 0-237.714286-106.422857-237.714286-237.714286s106.422857-237.714286 237.714286-237.714286 237.714286 106.422857 237.714286 237.714286-106.422857 237.714286-237.714286 237.714286z" fill="#FFCE59" ></path>' + '' + '<path d="M118.857143 530.285714h54.857143a27.428571 27.428571 0 0 0 0-54.857143h-54.857143a27.428571 27.428571 0 0 0 0 54.857143zM850.285714 530.285714h54.857143a27.428571 27.428571 0 0 0 0-54.857143h-54.857143a27.428571 27.428571 0 0 0 0 54.857143zM530.285714 173.714286v-54.857143a27.428571 27.428571 0 0 0-54.857143 0v54.857143a27.428571 27.428571 0 0 0 54.857143 0zM530.285714 905.142857v-54.857143a27.428571 27.428571 0 0 0-54.857143 0v54.857143a27.428571 27.428571 0 0 0 54.857143 0zM221.074286 246.930286l38.784 38.784a27.428571 27.428571 0 1 0 38.784-38.784l-38.784-38.784a27.428571 27.428571 0 1 0-38.784 38.784zM738.267429 764.141714l38.784 38.784a27.428571 27.428571 0 1 0 38.784-38.784l-38.784-38.784a27.428571 27.428571 0 1 0-38.784 38.784zM764.141714 285.732571l38.784-38.784a27.428571 27.428571 0 1 0-38.784-38.784l-38.784 38.784a27.428571 27.428571 0 1 0 38.784 38.784zM246.930286 802.925714l38.784-38.784a27.428571 27.428571 0 1 0-38.784-38.784l-38.784 38.784a27.428571 27.428571 0 1 0 38.784 38.784z" fill="#FFCE59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-tedabaoyu" viewBox="0 0 1024 1024">' + '' + '<path d="M722.249143 329.142857h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164572 9.051428A164.681143 164.681143 0 0 0 128 585.142857c0 90.916571 73.6 164.571429 164.406857 164.571429H310.857143a27.428571 27.428571 0 0 0 0-54.857143h-18.450286A109.622857 109.622857 0 0 1 182.857143 585.142857c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739429a177.664 177.664 0 0 1-10.24-59.666285A178.029714 178.029714 0 0 1 487.954286 237.714286c87.497143 0 160.237714 63.104 175.213714 146.285714h59.081143A155.428571 155.428571 0 0 1 877.714286 539.428571c0 85.778286-69.686857 155.428571-155.465143 155.428572H713.142857a27.428571 27.428571 0 0 0 0 54.857143h9.106286C838.253714 749.714286 932.571429 655.561143 932.571429 539.428571 932.571429 423.259429 838.4 329.142857 722.249143 329.142857z" fill="#879396" ></path>' + '' + '<path d="M341.394286 822.454857C314.550857 805.668571 285.860571 795.428571 256 795.428571a27.428571 27.428571 0 0 0 0 54.857143c18.139429 0 37.449143 6.893714 56.32 18.688 6.875429 4.297143 13.165714 8.923429 18.688 13.531429 3.181714 2.651429 5.302857 4.608 6.162286 5.467428a27.428571 27.428571 0 0 0 45.421714-10.715428l91.428571-274.285714a27.428571 27.428571 0 1 0-52.041142-17.334858l-79.232 237.696-1.353143-0.877714zM531.693714 585.618286l-63.616 190.829714a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334857zM693.449143 602.953143a27.428571 27.428571 0 1 0-52.041143-17.334857l-91.428571 274.285714c-8.393143 25.197714 20.352 46.427429 41.965714 30.994286a314.514286 314.514286 0 0 1 35.181714-20.644572c18.194286-9.106286 35.876571-15.597714 51.693714-18.432 5.723429-1.024 11.081143-1.536 16.036572-1.536a27.428571 27.428571 0 0 0 0-54.857143 145.554286 145.554286 0 0 0-25.673143 2.395429c-14.811429 2.651429-29.933714 7.314286-45.220571 13.604571l69.485714-208.475428z" fill="#5CC3E6" ></path>' + '' + '<path d="M146.285714 822.857143a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M438.857143 868.571429a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M749.714286 822.857143a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-xiaoxue" viewBox="0 0 1024 1024">' + '' + '<path d="M525.824 676.571429h178.139429C789.741714 676.571429 859.428571 606.921143 859.428571 521.142857a155.428571 155.428571 0 0 0-155.465142-155.428571h-59.081143c-14.976-83.181714-87.734857-146.285714-175.213715-146.285715a178.029714 178.029714 0 0 0-178.048 178.048c0 20.937143 3.602286 41.014857 10.24 59.666286h-27.739428C213.705143 457.142857 164.571429 506.294857 164.571429 566.857143c0 60.617143 49.042286 109.714286 109.549714 109.714286h251.702857z m0 54.857142H274.121143C183.314286 731.428571 109.714286 657.773714 109.714286 566.857143a164.662857 164.662857 0 0 1 127.213714-160.329143 247.552 247.552 0 0 1-0.164571-9.051429C236.745143 268.836571 341.028571 164.571429 469.650286 164.571429c98.011429 0 181.888 60.544 216.265143 146.285714h18.048C820.114286 310.857143 914.285714 404.973714 914.285714 521.142857 914.285714 637.275429 819.968 731.428571 703.963429 731.428571h-178.139429z" fill="#879396" ></path>' + '' + '<path d="M374.857143 813.714286a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M484.571429 813.714286a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M594.285714 813.714286a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-xiaoyu" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 621.714286c0 90.916571 73.6 164.571429 164.406857 164.571428H384a27.428571 27.428571 0 0 0 0-54.857143h-109.878857A109.622857 109.622857 0 0 1 164.571429 621.714286c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 85.778286-69.686857 155.428571-155.465142 155.428571H640a27.428571 27.428571 0 0 0 0 54.857143h63.963429C819.968 786.285714 914.285714 692.132571 914.285714 576 914.285714 459.830857 820.114286 365.714286 703.963429 365.714286z" fill="#879396" ></path>' + '' + '<path d="M473.197714 735.030857L512 694.857143l38.802286 40.173714c21.412571 22.198857 21.412571 58.148571 0 80.329143a53.522286 53.522286 0 0 1-77.586286 0 58.24 58.24 0 0 1-0.018286-80.329143z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-wumai" viewBox="0 0 1024 1024">' + '' + '<path d="M283.428571 329.142857h365.714286a27.428571 27.428571 0 0 1 0 54.857143h-365.714286a27.428571 27.428571 0 0 1 0-54.857143zM393.142857 219.428571H530.285714a27.428571 27.428571 0 0 1 0 54.857143h-137.142857a27.428571 27.428571 0 0 1 0-54.857143zM246.857143 438.857143h292.571428a27.428571 27.428571 0 0 1 0 54.857143h-292.571428a27.428571 27.428571 0 0 1 0-54.857143zM630.857143 438.857143h201.142857a27.428571 27.428571 0 0 1 0 54.857143h-201.142857a27.428571 27.428571 0 0 1 0-54.857143zM685.714286 658.285714h201.142857a27.428571 27.428571 0 0 1 0 54.857143h-201.142857a27.428571 27.428571 0 0 1 0-54.857143zM137.142857 548.571429h164.571429a27.428571 27.428571 0 0 1 0 54.857142h-164.571429a27.428571 27.428571 0 0 1 0-54.857142zM393.142857 548.571429h512a27.428571 27.428571 0 0 1 0 54.857142h-512a27.428571 27.428571 0 0 1 0-54.857142zM118.857143 658.285714h475.428571a27.428571 27.428571 0 0 1 0 54.857143h-475.428571a27.428571 27.428571 0 0 1 0-54.857143zM192 768h621.714286a27.428571 27.428571 0 0 1 0 54.857143h-621.714286a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-yin" viewBox="0 0 1024 1024">' + '' + '<path d="M525.824 731.428571h178.139429C789.741714 731.428571 859.428571 661.778286 859.428571 576a155.428571 155.428571 0 0 0-155.465142-155.428571h-59.081143c-14.976-83.181714-87.734857-146.285714-175.213715-146.285715a178.029714 178.029714 0 0 0-178.048 178.048c0 20.937143 3.602286 41.014857 10.24 59.666286h-27.739428C213.705143 512 164.571429 561.152 164.571429 621.714286c0 60.617143 49.042286 109.714286 109.549714 109.714285h251.702857z m0 54.857143H274.121143C183.314286 786.285714 109.714286 712.630857 109.714286 621.714286a164.662857 164.662857 0 0 1 127.213714-160.329143 247.552 247.552 0 0 1-0.164571-9.051429C236.745143 323.693714 341.028571 219.428571 469.650286 219.428571c98.011429 0 181.888 60.544 216.265143 146.285715h18.048C820.114286 365.714286 914.285714 459.830857 914.285714 576 914.285714 692.132571 819.968 786.285714 703.963429 786.285714h-178.139429z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-zhongyu" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 621.714286c0 90.916571 73.6 164.571429 164.406857 164.571428H384a27.428571 27.428571 0 0 0 0-54.857143h-109.878857A109.622857 109.622857 0 0 1 164.571429 621.714286c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 85.778286-69.686857 155.428571-155.465142 155.428571H603.428571a27.428571 27.428571 0 0 0 0 54.857143h100.534858C819.968 786.285714 914.285714 692.132571 914.285714 576 914.285714 459.830857 820.114286 365.714286 703.963429 365.714286z" fill="#879396" ></path>' + '' + '<path d="M513.408 622.189714l-73.142857 219.428572a27.428571 27.428571 0 1 0 52.041143 17.334857l73.142857-219.428572a27.428571 27.428571 0 1 0-52.041143-17.334857z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fgood" viewBox="0 0 1024 1024">' + '' + '<path d="M256.03192 511.99984c68.511979 0 95.99997-27.263991 95.99997-95.99997V127.99996c0-66.143979 132.095959-132.415959 245.727923-70.431978 67.359979 38.367988 101.471968 100.575969 101.471969 202.847937 0 37.279988-6.975998 101.407968-13.887996 155.583951h178.975944c88.191972 0 146.751954 70.335978 130.719959 157.375951l-71.455978 387.871879C917.215713 995.903689 883.455724 1023.99968 847.903735 1023.99968H224.15993A63.99998 63.99998 0 0 1 160.03195 960.1917V575.80782A63.99998 63.99998 0 0 1 224.28793 511.99984H256.03192z" fill="#FFECBF" ></path>' + '' + '<path d="M916.383714 558.015826l-70.975978 385.151879H240.031925v-351.99989H256.03192c113.503965 0 175.999945-62.49598 175.999945-175.999945V134.943958c8.287997-8.447997 33.695989-22.943993 68.863978-22.943993 20.671994 0 40.383987 5.023998 57.311983 14.207996 31.71199 18.079994 61.055981 46.751985 61.05598 133.343958 0 26.719992-4.735999 78.367976-13.247995 145.503954l-11.519997 90.111972h269.823916c18.463994 0 33.727989 6.079998 42.943986 17.151995 9.279997 11.135997 12.479996 27.359991 9.119998 45.695986m-52.063984-142.879956h-178.943944c6.879998-54.175983 13.887996-118.303963 13.887995-155.583951 0-102.239968-34.143989-164.479949-101.471968-202.847937C484.127849-5.279998 352.03189 61.023981 352.03189 127.13596v287.99991c0 68.767979-27.487991 95.99997-95.99997 95.99997h-31.74399A63.99998 63.99998 0 0 0 160.03195 574.97582v384.35188a63.99998 63.99998 0 0 0 64.12798 63.80798h623.775805c35.551989 0 69.279978-28.095991 75.679976-62.75198l71.455978-387.871879c16.031995-87.039973-42.527987-157.375951-130.751959-157.375951M0.032 575.16782v383.99988a39.999988 39.999988 0 0 0 79.999975 0v-383.99988a39.999988 39.999988 0 0 0-79.999975 0" fill="#FFCE59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fbad" viewBox="0 0 1024 1024">' + '' + '<path d="M256 512c68.512 0 96 27.264 96 96v288c0 66.144 132.096 132.416 245.728 70.432 67.36-38.368 101.472-100.576 101.472-202.848 0-37.28-6.976-101.408-13.888-155.584h178.976c88.192 0 146.752-70.336 130.72-157.376l-71.456-387.84C917.184 28.096 883.424 0 847.872 0H224.128A64 64 0 0 0 160 63.808v384.384A64 64 0 0 0 224.256 512H256z" fill="#BFEFFF" ></path>' + '' + '<path d="M916.352 465.12L845.376 79.968H240v352H256c113.504 0 176 62.496 176 176v280.224c8.288 8.448 33.696 22.944 68.864 22.944 20.672 0 40.384-5.024 57.312-14.208 31.712-18.08 61.056-46.752 61.056-133.344 0-26.72-4.736-78.368-13.248-145.504l-11.52-90.112h269.824c18.464 0 33.728-6.08 42.944-17.152 9.28-11.136 12.48-27.36 9.12-45.696M864.288 608h-178.944c6.88 54.176 13.888 118.304 13.888 155.584 0 102.24-34.144 164.48-101.472 202.848C484.096 1028.416 352 962.112 352 896v-288c0-68.768-27.488-96-96-96h-31.744A64 64 0 0 1 160 448.16V63.808A64 64 0 0 1 224.128 0h623.776c35.552 0 69.28 28.096 75.68 62.752l71.456 387.872c16.032 87.04-42.528 157.376-130.752 157.376M6.4 448V64a40 40 0 0 1 80 0v384a40 40 0 0 1-80 0z" fill="#46C2EB" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-dafeng" viewBox="0 0 1024 1024">' + '' + '<path d="M320 676.571429h375.296c26.733714 0 38.765714 9.984 38.765714 32.621714 0 22.070857-12.928 32.621714-38.765714 32.621714a27.428571 27.428571 0 0 0 0 54.857143c53.942857 0 93.622857-32.365714 93.622857-87.478857 0-55.442286-38.637714-87.478857-93.622857-87.478857H320a27.428571 27.428571 0 0 0 0 54.857143zM411.428571 577.225143h392.448c65.042286 0 120.850286-51.072 120.850286-118.985143 0-69.12-52.754286-118.985143-120.850286-118.985143-65.316571 0-117.284571 50.742857-117.284571 118.985143a27.428571 27.428571 0 0 0 54.857143 0c0-37.650286 27.117714-64.128 62.427428-64.128 38.473143 0 65.993143 26.020571 65.993143 64.128 0 36.48-30.208 64.128-65.993143 64.128H411.428571a27.428571 27.428571 0 0 0 0 54.857143z" fill="#879397" ></path>' + '' + '<path d="M283.428571 467.510857h264.448c65.042286 0 120.850286-51.072 120.850286-118.985143 0-69.12-52.754286-118.985143-120.850286-118.985143-65.316571 0-117.284571 50.742857-117.284571 118.985143a27.428571 27.428571 0 0 0 54.857143 0c0-37.650286 27.117714-64.128 62.427428-64.128 38.473143 0 65.993143 26.020571 65.993143 64.128 0 36.48-30.208 64.128-65.993143 64.128H283.428571a27.428571 27.428571 0 0 0 0 54.857143zM338.285714 521.142857H126.409143a27.428571 27.428571 0 0 0 0 54.857143H338.285714a27.428571 27.428571 0 0 0 0-54.857143z" fill="#879397" ></path>' + '' + '<path d="M210.285714 438.857143m-27.428571 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#879397" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-weizhitianqi" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 365.714286h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285715-128.621714 0-232.905143 104.265143-232.905143 232.905143 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 621.714286c0 90.916571 73.6 164.571429 164.406857 164.571428H384a27.428571 27.428571 0 0 0 0-54.857143h-109.878857A109.622857 109.622857 0 0 1 164.571429 621.714286c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 274.285714c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 576c0 85.778286-69.686857 155.428571-155.465142 155.428571H585.142857a27.428571 27.428571 0 0 0 0 54.857143h118.820572C819.968 786.285714 914.285714 692.132571 914.285714 576 914.285714 459.830857 820.114286 365.714286 703.963429 365.714286z" fill="#879396" ></path>' + '' + '<path d="M484.571429 424.722286c-61.513143 0-109.714286 48.201143-109.714286 109.714285a27.428571 27.428571 0 1 0 54.857143 0c0-36.022857 27.593143-54.857143 54.857143-54.857142 29.732571 0 54.857143 25.124571 54.857142 54.857142 0 30.774857-24.100571 54.857143-54.857142 54.857143a27.428571 27.428571 0 0 0-27.428572 27.428572V676.571429a27.428571 27.428571 0 1 0 54.857143 0v-35.876572a109.933714 109.933714 0 0 0 82.285714-106.258286c0-60.489143-49.206857-109.714286-109.714285-109.714285z" fill="#5CC3E6" ></path>' + '' + '<path d="M484.571429 758.857143m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fuchen" viewBox="0 0 1024 1024">' + '' + '<path d="M393.142857 329.142857h365.714286a27.428571 27.428571 0 0 1 0 54.857143h-365.714286a27.428571 27.428571 0 0 1 0-54.857143zM393.142857 219.428571H530.285714a27.428571 27.428571 0 0 1 0 54.857143h-137.142857a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '<path d="M630.857143 246.857143m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M301.714286 356.571429m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M192 795.428571m-27.428571 0a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M246.857143 438.857143h292.571428a27.428571 27.428571 0 0 1 0 54.857143h-292.571428a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '<path d="M630.857143 438.857143h201.142857a27.428571 27.428571 0 0 1 0 54.857143h-201.142857a27.428571 27.428571 0 0 1 0-54.857143zM685.714286 658.285714h201.142857a27.428571 27.428571 0 0 1 0 54.857143h-201.142857a27.428571 27.428571 0 0 1 0-54.857143zM137.142857 548.571429h164.571429a27.428571 27.428571 0 0 1 0 54.857142h-164.571429a27.428571 27.428571 0 0 1 0-54.857142z" fill="#FFCE59" ></path>' + '' + '<path d="M393.142857 548.571429h512a27.428571 27.428571 0 0 1 0 54.857142h-512a27.428571 27.428571 0 0 1 0-54.857142zM118.857143 658.285714h475.428571a27.428571 27.428571 0 0 1 0 54.857143h-475.428571a27.428571 27.428571 0 0 1 0-54.857143zM283.428571 768h530.285715a27.428571 27.428571 0 0 1 0 54.857143h-530.285715a27.428571 27.428571 0 0 1 0-54.857143z" fill="#879397" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-dongyu" viewBox="0 0 1024 1024">' + '' + '<path d="M274.285714 676.571429h-0.164571A109.622857 109.622857 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 82.706286-64.786286 150.4-146.285714 155.154286v54.930286c111.762286-4.809143 201.142857-97.024 201.142857-210.084572C914.285714 404.973714 820.114286 310.857143 703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 90.916571 73.6 164.571429 164.406857 164.571428H274.285714v-54.857142z" fill="#879396" ></path>' + '' + '<path d="M342.930286 873.161143c5.595429 8.393143 14.628571 8.429714 20.260571 0l23.405714-35.108572c5.595429-8.393143 2.066286-15.195429-8.173714-15.195428h-50.706286c-10.112 0-13.805714 6.765714-8.173714 15.195428l23.387429 35.108572zM452.644571 873.161143c5.595429 8.393143 14.628571 8.429714 20.260572 0l23.405714-35.108572c5.595429-8.393143 2.066286-15.195429-8.173714-15.195428h-50.706286c-10.112 0-13.805714 6.765714-8.173714 15.195428l23.387428 35.108572zM562.358857 873.161143c5.595429 8.393143 14.628571 8.429714 20.260572 0l23.405714-35.108572c5.595429-8.393143 2.066286-15.195429-8.173714-15.195428h-50.706286c-10.112 0-13.805714 6.765714-8.173714 15.195428l23.387428 35.108572zM403.693714 567.332571l-63.616 190.829715a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334858zM513.408 567.332571l-63.616 190.829715a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334858zM623.122286 567.332571l-63.616 190.829715a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334858z" fill="#5CC3E6" ></path>' + '' + '<path d="M274.285714 704m-27.428571 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#879396" ></path>' + '' + '<path d="M713.142857 704m-27.428571 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#879396" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-yangchen" viewBox="0 0 1024 1024">' + '' + '<path d="M320 676.571429h375.296c26.733714 0 38.765714 9.984 38.765714 32.621714 0 22.070857-12.928 32.621714-38.765714 32.621714a27.428571 27.428571 0 0 0 0 54.857143c53.942857 0 93.622857-32.365714 93.622857-87.478857 0-55.442286-38.637714-87.478857-93.622857-87.478857H320a27.428571 27.428571 0 0 0 0 54.857143zM411.428571 577.225143h392.448c65.042286 0 120.850286-51.072 120.850286-118.985143 0-69.12-52.754286-118.985143-120.850286-118.985143-65.316571 0-117.284571 50.742857-117.284571 118.985143a27.428571 27.428571 0 0 0 54.857143 0c0-37.650286 27.117714-64.128 62.427428-64.128 38.473143 0 65.993143 26.020571 65.993143 64.128 0 36.48-30.208 64.128-65.993143 64.128H411.428571a27.428571 27.428571 0 0 0 0 54.857143z" fill="#879397" ></path>' + '' + '<path d="M283.428571 467.510857h264.448c65.042286 0 120.850286-51.072 120.850286-118.985143 0-69.12-52.754286-118.985143-120.850286-118.985143-65.316571 0-117.284571 50.742857-117.284571 118.985143a27.428571 27.428571 0 0 0 54.857143 0c0-37.650286 27.117714-64.128 62.427428-64.128 38.473143 0 65.993143 26.020571 65.993143 64.128 0 36.48-30.208 64.128-65.993143 64.128H283.428571a27.428571 27.428571 0 0 0 0 54.857143z" fill="#879397" ></path>' + '' + '<path d="M338.285714 521.142857H126.409143a27.428571 27.428571 0 0 0 0 54.857143H338.285714a27.428571 27.428571 0 0 0 0-54.857143z" fill="#FFCD59" ></path>' + '' + '<path d="M228.571429 649.142857m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M612.571429 768m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M374.857143 347.428571m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M850.285714 649.142857m-27.428571 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M722.285714 283.428571m-27.428571 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-qiangshachenbao" viewBox="0 0 1024 1024">' + '' + '<path d="M173.714286 329.142857h475.428571a27.428571 27.428571 0 0 1 0 54.857143h-475.428571a27.428571 27.428571 0 0 1 0-54.857143zM338.285714 219.428571h475.428572a27.428571 27.428571 0 0 1 0 54.857143h-475.428572a27.428571 27.428571 0 0 1 0-54.857143z" fill="#FFCD59" ></path>' + '' + '<path d="M246.857143 246.857143m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M740.571429 356.571429m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M374.857143 576m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#FFCD59" ></path>' + '' + '<path d="M301.714286 438.857143h475.428571a27.428571 27.428571 0 0 1 0 54.857143h-475.428571a27.428571 27.428571 0 0 1 0-54.857143zM466.285714 548.571429h219.428572a27.428571 27.428571 0 0 1 0 54.857142h-219.428572a27.428571 27.428571 0 0 1 0-54.857142zM411.428571 658.285714h182.857143a27.428571 27.428571 0 0 1 0 54.857143h-182.857143a27.428571 27.428571 0 0 1 0-54.857143zM448 768h73.142857a27.428571 27.428571 0 0 1 0 54.857143h-73.142857a27.428571 27.428571 0 0 1 0-54.857143z" fill="#FFCD59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-yujiaxue" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 90.916571 73.6 164.571429 164.406857 164.571428H274.285714a27.428571 27.428571 0 0 0 0-54.857142h-0.164571A109.622857 109.622857 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 82.706286-64.786286 150.4-146.285714 155.154286V676.571429a27.428571 27.428571 0 0 0 0 54.857142c2.139429 0 4.205714-0.310857 6.217143-0.768C828.178286 722.742857 914.285714 632.082286 914.285714 521.142857 914.285714 404.973714 820.114286 310.857143 703.963429 310.857143z" fill="#879396" ></path>' + '' + '<path d="M513.883429 567.332571l-46.262858 138.770286a27.428571 27.428571 0 1 0 52.041143 17.334857l46.262857-138.770285a27.428571 27.428571 0 1 0-52.041142-17.334858zM385.408 567.332571l-63.616 190.829715a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334858z" fill="#5CC3E6" ></path>' + '' + '<path d="M292.571429 850.285714a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M641.408 567.332571l-63.616 190.829715a27.428571 27.428571 0 1 0 52.041143 17.334857l63.616-190.829714a27.428571 27.428571 0 1 0-52.041143-17.334858z" fill="#5CC3E6" ></path>' + '' + '<path d="M548.571429 850.285714a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M418.761143 797.878857l20.096 11.593143V786.285714a18.285714 18.285714 0 0 1 36.608 0v23.186286l20.096-11.593143a18.285714 18.285714 0 1 1 18.285714 31.670857l-20.114286 11.593143 20.096 11.593143a18.285714 18.285714 0 0 1-18.285714 31.670857l-20.096-11.593143V896a18.285714 18.285714 0 1 1-36.608 0v-23.186286l-20.096 11.593143a18.285714 18.285714 0 0 1-18.285714-31.670857L420.553143 841.142857l-20.077714-11.593143a18.285714 18.285714 0 0 1 18.285714-31.670857z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-leiyubingbao" viewBox="0 0 1024 1024">' + '' + '<path d="M616.356571 765.787429l25.856 25.856a18.267429 18.267429 0 0 1 0 25.856l-25.856 25.856a18.267429 18.267429 0 0 1-25.856 0l-25.856-25.856a18.267429 18.267429 0 0 1 0-25.856l25.856-25.856a18.267429 18.267429 0 0 1 25.856 0zM323.785143 765.787429l25.856 25.856a18.267429 18.267429 0 0 1 0 25.856l-25.856 25.856a18.267429 18.267429 0 0 1-25.856 0l-25.856-25.856a18.267429 18.267429 0 0 1 0-25.856l25.856-25.856a18.267429 18.267429 0 0 1 25.856 0zM660.242286 558.189714l-46.262857 138.770286a27.428571 27.428571 0 1 0 52.041142 17.334857l46.262858-138.770286a27.428571 27.428571 0 1 0-52.041143-17.334857zM349.385143 558.189714l-46.262857 138.770286a27.428571 27.428571 0 1 0 52.041143 17.334857l46.262857-138.770286a27.428571 27.428571 0 1 0-52.041143-17.334857z" fill="#5CC3E6" ></path>' + '' + '<path d="M703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 68.937143 42.459429 127.707429 102.528 152.192l12.672 3.236571a27.428571 27.428571 0 0 0 27.428571-27.428571 27.794286 27.794286 0 0 0-14.866286-24.704A109.641143 109.641143 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 69.741714-46.134857 128.658286-109.458285 148.315429l0.164571 0.402285a27.355429 27.355429 0 0 0 11.830857 52.077715c3.017143 0 5.851429-0.603429 8.557715-1.499429l2.267428-0.731428C855.04 691.145143 914.285714 613.12 914.285714 521.142857 914.285714 404.973714 820.114286 310.857143 703.963429 310.857143z" fill="#879396" ></path>' + '' + '<path d="M432.804571 816.182857a27.428571 27.428571 0 0 0 48.347429 25.892572l73.837714-137.929143a27.428571 27.428571 0 0 0-24.173714-40.374857h-47.488l44.342857-88.265143a27.428571 27.428571 0 0 0-49.024-24.630857l-64.310857 128A27.428571 27.428571 0 0 0 438.857143 718.628571h46.171428l-52.224 97.554286z" fill="#FFCE59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-daxue1" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 90.916571 73.6 164.571429 164.406857 164.571428H310.857143a27.428571 27.428571 0 0 0 0-54.857142h-36.736A109.622857 109.622857 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 85.778286-69.686857 155.428571-155.465142 155.428572H676.571429a27.428571 27.428571 0 0 0 0 54.857142h27.392C819.968 731.428571 914.285714 637.275429 914.285714 521.142857 914.285714 404.973714 820.114286 310.857143 703.963429 310.857143z" fill="#879396" ></path>' + '' + '<path d="M398.665143 649.142857a27.428571 27.428571 0 0 1 37.467428-10.038857l30.134858 17.389714V621.714286a27.428571 27.428571 0 0 1 54.893714 0v34.779428l30.134857-17.389714a27.428571 27.428571 0 1 1 27.428571 47.506286l-30.134857 17.389714 30.134857 17.389714a27.428571 27.428571 0 0 1-27.428571 47.506286l-30.134857-17.389714V786.285714a27.428571 27.428571 0 0 1-54.893714 0v-34.761143l-30.134858 17.389715a27.428571 27.428571 0 0 1-27.428571-47.506286l30.116571-17.389714-30.116571-17.389715a27.428571 27.428571 0 0 1-10.038857-37.485714z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-baoxue" viewBox="0 0 1024 1024">' + '' + '<path d="M703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 90.916571 73.6 164.571429 164.406857 164.571428H274.285714a27.428571 27.428571 0 0 0 0-54.857142h-0.164571A109.622857 109.622857 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 82.706286-64.786286 150.4-146.285714 155.154286V676.571429a27.428571 27.428571 0 0 0 0 54.857142c2.139429 0 4.205714-0.310857 6.217143-0.768C828.178286 722.742857 914.285714 632.082286 914.285714 521.142857 914.285714 404.973714 820.114286 310.857143 703.963429 310.857143z" fill="#879396" ></path>' + '' + '<path d="M338.285714 704a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M594.285714 704a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M466.285714 832a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M276.736 786.285714a18.285714 18.285714 0 0 1 24.978286-6.692571l20.096 11.593143V768a18.285714 18.285714 0 0 1 36.608 0v23.186286l20.096-11.593143a18.285714 18.285714 0 1 1 18.285714 31.670857L376.704 822.857143l20.096 11.593143a18.285714 18.285714 0 0 1-18.285714 31.670857l-20.096-11.593143V877.714286a18.285714 18.285714 0 1 1-36.608 0v-23.186286l-20.096 11.593143a18.285714 18.285714 0 0 1-18.285715-31.670857L303.524571 822.857143l-20.077714-11.593143A18.285714 18.285714 0 0 1 276.736 786.285714zM432.164571 603.428571A18.285714 18.285714 0 0 1 457.142857 596.736l20.096 11.593143V585.142857a18.285714 18.285714 0 0 1 36.608 0v23.186286l20.096-11.593143a18.285714 18.285714 0 1 1 18.285714 31.670857L532.132571 640l20.096 11.593143a18.285714 18.285714 0 0 1-18.285714 31.670857l-20.096-11.593143V694.857143a18.285714 18.285714 0 1 1-36.608 0v-23.186286L457.142857 683.264a18.285714 18.285714 0 0 1-18.285714-31.670857L458.953143 640l-20.077714-11.593143A18.285714 18.285714 0 0 1 432.164571 603.428571zM612.589714 779.593143l20.096 11.593143V768a18.285714 18.285714 0 0 1 36.608 0v23.186286l20.096-11.593143a18.285714 18.285714 0 1 1 18.285715 31.670857l-20.114286 11.593143 20.096 11.593143a18.285714 18.285714 0 0 1-18.285714 31.670857l-20.096-11.593143V877.714286a18.285714 18.285714 0 1 1-36.608 0v-23.186286l-20.096 11.593143a18.285714 18.285714 0 0 1-18.285715-31.670857L614.381714 822.857143l-20.077714-11.593143a18.285714 18.285714 0 0 1 18.285714-31.670857z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-zhenxue" viewBox="0 0 1024 1024">' + '' + '<path d="M300.854857 511.652571C204.525714 506.459429 128 426.715429 128 329.106286 128 228.132571 209.865143 146.285714 310.857143 146.285714c81.974857 0 151.369143 53.942857 174.573714 128.274286a182.893714 182.893714 0 0 0-56.265143 5.632A128.036571 128.036571 0 0 0 182.857143 329.106286a128 128 0 0 0 109.714286 126.665143v1.334857c0 18.998857 2.907429 37.321143 8.283428 54.546285z" fill="#FFCE59" ></path>' + '' + '<path d="M530.633143 694.857143h145.792A128.036571 128.036571 0 0 0 804.571429 566.857143c0-70.692571-57.362286-128-128.146286-128h-55.844572A146.304 146.304 0 1 0 340.114286 512.822857h-29.824A91.008 91.008 0 0 0 219.428571 603.830857 91.044571 91.044571 0 0 0 310.290286 694.857143h220.342857z m0 54.857143h-220.342857C229.814857 749.714286 164.571429 684.233143 164.571429 603.849143a145.956571 145.956571 0 0 1 109.787428-141.385143A172.105143 172.105143 0 0 1 274.285714 457.142857c0-111.085714 90.057143-201.142857 201.142857-201.142857 85.284571 0 158.171429 53.083429 187.428572 128h13.568C777.490286 384 859.428571 465.846857 859.428571 566.857143c0 100.992-81.883429 182.857143-183.003428 182.857143h-145.792z" fill="#879396" ></path>' + '' + '<path d="M310.857143 676.571429h365.714286v219.428571H310.857143z" fill="#FFFFFF" ></path>' + '' + '<path d="M310.857143 722.285714m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#879396" ></path>' + '' + '<path d="M676.571429 722.285714m-27.428572 0a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#879396" ></path>' + '' + '<path d="M374.857143 722.285714a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M466.285714 722.285714a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M557.714286 722.285714a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M420.571429 649.142857a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M512 649.142857a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M420.571429 795.428571a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M512 795.428571a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-zhongxue" viewBox="0 0 1024 1024">' + '' + '<path d="M914.285714 521.142857C914.285714 404.973714 820.114286 310.857143 703.963429 310.857143h-18.048c-34.377143-85.741714-118.253714-146.285714-216.265143-146.285714-128.621714 0-232.905143 104.265143-232.905143 232.905142 0 3.035429 0.054857 6.052571 0.164571 9.051429A164.681143 164.681143 0 0 0 109.714286 566.857143c0 90.916571 73.6 164.571429 164.406857 164.571428H310.857143a27.428571 27.428571 0 0 0 0-54.857142h-36.736A109.622857 109.622857 0 0 1 164.571429 566.857143c0-60.562286 49.133714-109.714286 109.549714-109.714286h27.739428a177.664 177.664 0 0 1-10.24-59.666286A178.029714 178.029714 0 0 1 469.668571 219.428571c87.497143 0 160.237714 63.104 175.213715 146.285715h59.081143A155.428571 155.428571 0 0 1 859.428571 521.142857c0 82.688-64.804571 150.180571-146.285714 154.971429V676.571429a27.428571 27.428571 0 0 0 0 54.857142c2.596571 0 5.065143-0.475429 7.442286-1.152C828.781714 721.737143 914.285714 631.625143 914.285714 521.142857z" fill="#879396" ></path>' + '' + '<path d="M374.857143 704a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M484.571429 704a27.428571 27.428571 0 1 0 54.857142 0 27.428571 27.428571 0 1 0-54.857142 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M594.285714 704a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M429.714286 612.571429a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M539.428571 612.571429a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M429.714286 795.428571a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '<path d="M539.428571 795.428571a27.428571 27.428571 0 1 0 54.857143 0 27.428571 27.428571 0 1 0-54.857143 0Z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-zhenyu" viewBox="0 0 1024 1024">' + '' + '<path d="M239.542857 528.457143c16.457143-12.8 32.914286-20.114286 53.028572-25.6v-5.485714-5.485715c-53.028571-16.457143-91.428571-64-91.428572-122.514285 0-71.314286 56.685714-128 128-128 47.542857 0 87.771429 25.6 109.714286 62.171428 18.285714-5.485714 36.571429-7.314286 54.857143-7.314286h3.657143c-27.428571-64-93.257143-109.714286-168.228572-109.714285-100.571429 0-182.857143 82.285714-182.857143 182.857143 0 67.657143 38.4 128 93.257143 159.085714z" fill="#FFCE59" ></path>' + '' + '<path d="M694.857143 424.228571h-12.8c-31.085714-74.971429-102.4-128-188.342857-128-111.542857 0-201.142857 89.6-201.142857 201.142858v5.485714c-62.171429 16.457143-109.714286 73.142857-109.714286 140.8 0 80.457143 65.828571 146.285714 146.285714 146.285714h73.142857c14.628571 0 27.428571-12.8 27.428572-27.428571s-12.8-27.428571-27.428572-27.428572h-73.142857c-49.371429 0-91.428571-40.228571-91.428571-91.428571 0-42.057143 27.428571-78.628571 67.657143-87.771429l42.057142-10.971428v-43.885715-3.657142c0-80.457143 65.828571-146.285714 146.285715-146.285715 60.342857 0 113.371429 36.571429 137.142857 93.257143l12.8 34.742857H694.857143c71.314286 0 128 56.685714 128 128s-56.685714 128-128 128h-36.571429c-14.628571 0-27.428571 12.8-27.428571 27.428572s12.8 27.428571 27.428571 27.428571h36.571429c100.571429 0 182.857143-82.285714 182.857143-182.857143s-82.285714-182.857143-182.857143-182.857143z" fill="#879396" ></path>' + '' + '<path d="M491.885714 738.742857l38.4-40.228571 38.4 40.228571c21.942857 21.942857 21.942857 58.514286 0 80.457143-21.942857 21.942857-56.685714 21.942857-76.8 0-21.942857-20.114286-21.942857-58.514286 0-80.457143z" fill="#5CC3E6" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-leizhenyu" viewBox="0 0 1024 1024">' + '' + '<path d="M221.257143 488.228571c14.628571-12.8 32.914286-20.114286 53.028571-25.6V457.142857v-5.485714c-53.028571-16.457143-91.428571-64-91.428571-122.514286 0-71.314286 56.685714-128 128-128 47.542857 0 87.771429 25.6 109.714286 62.171429 18.285714-5.485714 36.571429-7.314286 54.857142-7.314286h3.657143c-27.428571-64-93.257143-109.714286-168.228571-109.714286-100.571429 0-182.857143 82.285714-182.857143 182.857143 0 67.657143 38.4 128 93.257143 159.085714z" fill="#FFCE59" ></path>' + '' + '<path d="M859.428571 566.857143c0-100.571429-82.285714-182.857143-182.857142-182.857143h-12.8c-29.257143-74.971429-102.4-128-188.342858-128-111.542857 0-201.142857 89.6-201.142857 201.142857v5.485714c-62.171429 16.457143-109.714286 73.142857-109.714285 140.8 0 64 40.228571 117.028571 96.914285 137.142858 1.828571 0 3.657143 1.828571 5.485715 1.828571 1.828571 0 5.485714 1.828571 7.314285 1.828571 14.628571 0 27.428571-12.8 27.428572-27.428571 0-12.8-7.314286-21.942857-20.114286-25.6-36.571429-10.971429-62.171429-45.714286-62.171429-85.942857 0-42.057143 27.428571-78.628571 67.657143-87.771429l42.057143-10.971428v-45.714286-3.657143c0-80.457143 65.828571-146.285714 146.285714-146.285714 60.342857 0 113.371429 36.571429 137.142858 93.257143l12.8 34.742857H676.571429c71.314286 0 128 56.685714 128 128 0 53.028571-31.085714 96.914286-76.8 117.028571-10.971429 3.657143-20.114286 14.628571-20.114286 25.6 0 14.628571 12.8 27.428571 27.428571 27.428572 1.828571 0 5.485714 0 7.314286-1.828572 1.828571 0 5.485714-1.828571 7.314286-3.657143 64-25.6 109.714286-89.6 109.714285-164.571428z" fill="#879396" ></path>' + '' + '<path d="M612.571429 859.428571c-3.657143 0-5.485714 0-9.142858-1.828571-14.628571-5.485714-21.942857-20.114286-16.457142-34.742857l73.142857-219.428572c5.485714-14.628571 20.114286-21.942857 34.742857-16.457142 14.628571 5.485714 21.942857 20.114286 16.457143 34.742857l-73.142857 219.428571c-3.657143 10.971429-14.628571 18.285714-25.6 18.285714zM320 859.428571c-3.657143 0-5.485714 0-9.142857-1.828571-14.628571-5.485714-21.942857-20.114286-16.457143-34.742857l73.142857-219.428572c5.485714-14.628571 20.114286-21.942857 34.742857-16.457142 14.628571 5.485714 21.942857 20.114286 16.457143 34.742857l-73.142857 219.428571c-3.657143 10.971429-14.628571 18.285714-25.6 18.285714z" fill="#5CC3E6" ></path>' + '' + '<path d="M475.428571 896c-3.657143 0-9.142857-1.828571-12.8-3.657143-12.8-7.314286-18.285714-23.771429-10.971428-36.571428l53.028571-96.914286H457.142857c-9.142857 0-18.285714-5.485714-23.771428-12.8-5.485714-7.314286-5.485714-18.285714-1.828572-27.428572l64-128c7.314286-12.8 23.771429-18.285714 36.571429-12.8 12.8 7.314286 18.285714 23.771429 12.8 36.571429l-43.885715 87.771429H548.571429c9.142857 0 18.285714 5.485714 23.771428 12.8 5.485714 9.142857 5.485714 18.285714 0 27.428571l-73.142857 137.142857c-5.485714 12.8-14.628571 16.457143-23.771429 16.457143z" fill="#FFCE59" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-tmall" viewBox="0 0 1024 1024">' + '' + '<path d="M815.488 841.12h45.696a21.28 21.28 0 0 0 20.896-20.864V776.32h-66.592v64.8zM725.536 841.12h45.216V776.32h-66.592v43.904c0 11.04 9.728 20.896 21.376 20.896z" fill="#C90408" ></path>' + '' + '<path d="M969.824 448H53.952C24.32 448 0 472 0 501.28v373.696C0 904 24.32 928 53.952 928h915.872c29.664 0 53.952-24 53.952-53.28v-373.44A53.952 53.952 0 0 0 969.824 448z m-309.664 71.52h41.312v-28.096h44.224v28.096h93.568v-28.096h44.224v28.096h42.528v43.2H883.52v34.56h-44.224v-34.56h-93.568v34.56h-44.224v-34.56H660.16v-43.2zM464.736 881.92c-59.552-32.896-104.288-66.24-135.392-102.24a245.44 245.44 0 0 1-37.44-56.16c-36.704 75.584-112.288 125.28-172.832 158.4l-21.376-37.44c98.208-54.016 151.904-108.96 167.232-174.24h-165.76v-43.2h170.88v-90.944H116.672v-43.2h350.752v43.2H314.272v90.944h171.104v43.2H319.136c16.032 65.024 69.024 120.256 167.232 174.24l-21.632 37.44z m170.4-189.824v74.176c0 19.68-9.472 44.64-22.848 60.96-25.76 31.904-66.592 54.72-68.8 55.68L521.6 845.44c0.256-0.256 35.008-19.68 55.648-45.12 7.04-8.896 12.896-24.256 12.896-34.336V729.28l-45.696 26.656-22.848-36.96 68.8-40.096v-47.776l-45.952 27.136-22.848-36.96 68.8-40.096v-14.88c-0.256-13.92-5.6-18.496-7.04-20.416-11.168-10.816-38.176-10.336-52.736-10.08h-6.56v-43.424h5.824c20.672-0.256 59.552-0.96 84.096 22.56 13.376 12.704 20.416 29.76 20.416 50.88 1.216 32.416 1.216 77.76 0.736 126.272z m291.168 128.16c0 35.04-29.664 64.096-65.632 64.096h-135.136c-35.744 0-65.632-28.8-65.632-64.096v-194.176h266.4v194.176z" fill="#C90408" ></path>' + '' + '<path d="M815.232 669.28h66.592v64.32h-66.592zM704.16 669.28h66.592v64.32h-66.592z" fill="#C90408" ></path>' + '' + '<path d="M959.456 336.224V448h-87.424a97.28 97.28 0 0 0 11.168-45.792c0-53.6-41.792-98.112-93.792-100.736a12.576 12.576 0 0 0-5.408-1.312c-2.24 0-3.2 0.32-5.44 1.312-52 2.592-93.472 47.104-93.472 100.736 0 16.576 3.52 31.84 10.848 45.792H327.168a97.28 97.28 0 0 0 11.168-45.792c0-53.6-41.472-98.112-93.792-100.736a8.32 8.32 0 0 0-5.088-1.312 12.8 12.8 0 0 0-5.44 1.312c-52 2.592-93.792 47.104-93.792 100.736 0 16.576 4.16 31.84 10.848 45.792H64V266.368c0-1.632 0-2.592 0.32-2.912 0.96-38.656 7.008-99.104 38.592-117.312 36.384-21.088 69.888 17.248 76.576 25.376 47.52 54.24 98.56 122.496 191.712 122.496h281.056c92.832 0 144.192-68.256 191.392-122.496 6.368-7.488 40.832-47.104 76.576-25.344 31.904 18.528 37.952 78.304 38.912 117.312v72.768l0.32-0.032z m-419.488 57.504c5.44-6.816 1.28-12.992-9.888-12.992h-36.672c-10.528 0-15.296 6.176-10.208 12.992l10.528 14.944c4.16 6.176 8.608 12.672 12.128 16.896 0.96 0.992 1.6 2.272 5.728 2.272 4.16 0 5.088-1.312 6.048-2.272 2.88-4.224 7.328-10.72 12.128-16.896l10.208-14.944zM239.776 301.472h4.8c15.296 7.808 27.104 50.016 27.104 101.056 0 16.576-1.28 31.84-3.84 45.472H210.432a285.248 285.248 0 0 1-3.52-45.472c0-51.008 11.808-93.248 27.104-101.056h5.76z m544.224 0h5.408c15.008 7.808 26.816 50.368 26.816 101.056 0 16.576-1.28 31.52-3.52 45.472h-57.408c-2.24-13.984-3.2-28.928-3.2-45.472 0-51.008 11.168-93.248 26.464-101.056h5.44z" fill="" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-back1" viewBox="0 0 1024 1024">' + '' + '<path d="M672 896c-8.53504 0-17.06496-2.13504-21.33504-8.53504l-362.66496-352c-6.4-6.4-10.66496-14.93504-10.66496-23.46496s4.26496-17.06496 10.66496-23.46496l364.8-352c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8L356.26496 512l339.2 328.53504c12.8 12.8 12.8 32 0 44.8-6.4 8.52992-14.92992 10.66496-23.46496 10.66496z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-home" viewBox="0 0 1024 1024">' + '' + '<path d="M96 480c-9.6 0-19.2-3.2-25.6-12.8-12.8-12.8-9.6-35.2 3.2-44.8l377.6-310.4c35.2-25.6 86.4-25.6 118.4 0l377.6 307.2c12.8 9.6 16 32 3.2 44.8s-32 16-44.8 3.2L531.2 166.4c-9.6-6.4-28.8-6.4-38.4 0l-377.6 307.2c-6.4 6.4-12.8 6.4-19.2 6.4z m720 448H608c-19.2 0-32-12.8-32-32v-150.4c0-22.4-38.4-44.8-67.2-44.8s-64 19.2-64 44.8V896c0 19.2-12.8 32-32 32H211.2c-48 0-83.2-35.2-83.2-80V544c0-19.2 12.8-32 32-32s32 12.8 32 32v304c0 9.6 6.4 16 19.2 16H384v-118.4c0-64 67.2-108.8 128-108.8s131.2 44.8 131.2 108.8v118.4H819.2c9.6 0 16 0 16-19.2v-300.8c0-19.2 12.8-32 32-32s32 12.8 32 32v304C896 896 864 928 816 928z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-more_light2" viewBox="0 0 1024 1024">' + '' + '<path d="M224 597.33504c-40.53504 0-74.66496-34.13504-74.66496-74.66496S183.46496 448 224 448s74.66496 34.13504 74.66496 74.66496-32 74.67008-74.66496 74.67008z m288 0c-40.53504 0-74.66496-34.13504-74.66496-74.66496S471.46496 448 512 448s74.66496 34.13504 74.66496 74.66496-32 74.67008-74.66496 74.67008z m288 0c-40.53504 0-74.66496-34.13504-74.66496-74.66496S759.46496 448 800 448s74.66496 34.13504 74.66496 74.66496-32 74.67008-74.66496 74.67008z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-down" viewBox="0 0 1024 1024">' + '' + '<path d="M792.832 485.85728a31.98464 31.98464 0 0 0-45.24544-0.03072l-203.58144 203.16672V128c0-17.664-14.336-32-32-32s-32 14.336-32 32v563.04128L245.94944 455.58272a31.90272 31.90272 0 0 0-45.24544-0.128 31.96416 31.96416 0 0 0-0.128 45.25056l287.51872 289.24928a32.2048 32.2048 0 0 0 10.81856 7.13728c3.99872 1.792 8.38144 2.91328 13.08672 2.91328 11.29472 0 20.70528-6.17472 26.39872-14.976l254.36672-253.952c12.54912-12.45184 12.54912-32.70656 0.06656-45.21984zM864 928H160c-17.664 0-32-14.30528-32-32s14.336-32 32-32h704c17.69472 0 32 14.30528 32 32s-14.30528 32-32 32z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-favor_forbid" viewBox="0 0 1024 1024">' + '' + '<path d="M434.944 333.1072l76.47744-161.90464 99.2 212.38272a32.06656 32.06656 0 0 0 24.13056 18.07872l225.664 34.816-153.04704 156.38016 46.29504 44.14464 196.02944-200.29952a32.0768 32.0768 0 0 0 7.48544-32.48128 32.03584 32.03584 0 0 0-25.50272-21.504l-270.336-41.728-120.80128-258.62656a32.01536 32.01536 0 0 0-28.928-18.46272h-0.06656a32.0512 32.0512 0 0 0-28.928 18.33472L386.11968 286.55104l48.82432 46.55616z m352.26624 518.46656l-76.5696-73.00608 14.4128 89.40032-199.168-110.464a31.87712 31.87712 0 0 0-30.94528-0.06656l-199.61344 109.824 38.81472-235.67872a32.08192 32.08192 0 0 0-8.64256-27.48928L160.15872 434.01728l167.25504-20.85376-59.1872-56.43264-178.7904 24.45312a32.03072 32.03072 0 0 0-25.02656 21.632 31.94368 31.94368 0 0 0 7.45472 32.19456l196.44928 202.08128-46.87872 284.73344a32.0256 32.0256 0 0 0 47.00672 33.24928l241.82272-133.02272 241.31072 133.85728c4.74624 2.64192 10.0864 4.02944 15.51872 4.02944a31.3344 31.3344 0 0 0 18.36544-5.85728 32.0512 32.0512 0 0 0 13.21472-31.29344l-11.46368-71.21408zM171.25376 126.6176c-12.8-12.19072-33.05472-11.74528-45.24544 1.024-12.22144 12.76928-11.776 33.024 6.11328 45.24544l736 704c1.09056 5.91872 9.02144 8.86272 16.99328 8.86272 8.448 0 16.82944-3.328 23.13728-9.88672 12.22656-12.76928 11.74528-33.024-0.99328-45.24544L171.25376 126.6176z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-post" viewBox="0 0 1024 1024">' + '' + '<path d="M800 960H224c-52.93056 0-96-43.07456-96-96v-640C128 171.06944 171.06944 128 224 128h448c17.69472 0 32 14.336 32 32s-14.30528 32-32 32h-448a32.0512 32.0512 0 0 0-32 32v640c0 17.664 14.36672 32 32 32h576c17.664 0 32-14.336 32-32v-512c0-17.664 14.30528-32 32-32s32 14.336 32 32v512c0 52.92544-43.07456 96-96 96z"  ></path>' + '' + '<path d="M511.68256 542.72a31.84128 31.84128 0 0 1-22.75328-9.50272 31.98976 31.98976 0 0 1 0.256-45.24544l418.304-413.72672a31.98976 31.98976 0 0 1 45.24544 0.256 31.96416 31.96416 0 0 1-0.256 45.24544l-418.304 413.72672A31.86688 31.86688 0 0 1 511.68256 542.72z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-time_light1" viewBox="0 0 1024 1024">' + '' + '<path d="M512 64c-247.04 0-448 200.96-448 448s200.96 448 448 448 448-200.96 448-448-200.96-448-448-448z m0 831.71328c-211.584 0-383.71328-172.16-383.71328-383.71328 0-211.584 172.12928-383.71328 383.71328-383.71328 211.55328 0 383.71328 172.12928 383.71328 383.71328 0 211.55328-172.16 383.71328-383.71328 383.71328z"  ></path>' + '' + '<path d="M671.96928 512H512V288.06656c0-17.76128-14.23872-32.128-32-32.128S448 270.336 448 288.06656v255.93344a31.90784 31.90784 0 0 0 32 32h191.96928c17.76128 0 32.128-14.23872 32.128-32s-14.36672-32-32.128-32z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-notice" viewBox="0 0 1024 1024">' + '' + '<path d="M889.91744 749.72672c-1.18272-1.63328-119.22944-166.144-119.22944-287.39072 0-168.448-76.16-254.78144-162.688-287.00672V160c0-52.93056-43.06944-96-96-96s-96 43.06944-96 96v16.57344c-10.78272 7.90528-16.09728 21.79072-11.80672 35.23072 5.376 16.82944 23.424 26.04544 40.22272 20.736 17.76128-5.66272 36.93056-8.54528 56.89344-8.54528h21.376c115.23072 0 184.00256 89.088 184.00256 238.30528 0 108.032 72.89344 235.392 110.17728 293.504-57.37472 26.17856-183.04 76.19584-304.86528 76.19584-121.50272 0-247.424-50.37056-304.82944-76.64128 37.30944-57.984 110.14144-185.02656 110.14144-293.05344 0-62.43328 11.61728-114.20672 34.52928-153.91744a32.01024 32.01024 0 0 0-11.70944-43.71456 31.96416 31.96416 0 0 0-43.71456 11.71456c-28.60544 49.536-43.10528 112.09728-43.10528 185.91744 0 121.216-118.016 285.24544-119.19872 286.87872a32.11264 32.11264 0 0 0-5.30944 25.95328 31.91808 31.91808 0 0 0 16 21.02272c5.66272 3.072 107.392 57.28256 233.53344 84.51072C399.744 947.072 452.15744 992 512 992s112.256-44.928 133.632-111.29344c126.11072-27.10528 227.84-80.99328 233.50272-84.03456a31.95904 31.95904 0 0 0 16.06656-21.02272c2.048-8.99584 0.128-18.432-5.28384-25.92256z m-345.91744-588.8a251.54048 251.54048 0 0 0-21.30944-0.92672h-21.376c-7.26528 0-14.208 0.99328-21.30944 1.56672v-1.56672c0-17.63328 14.36672-32 32-32s32 14.36672 32 32v0.92672zM512 928c-22.33344 0-43.136-13.40928-57.984-35.29728 19.2 2.01728 38.59456 3.29728 57.984 3.29728s38.784-1.28 57.984-3.29728c-14.848 21.92384-35.68128 35.29728-57.984 35.29728z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-share_light1" viewBox="0 0 1024 1024">' + '' + '<path d="M768.70144 703.616c-35.65056 0-67.90144 14.72-91.136 38.30272l-309.15072-171.71456c9.05728-17.56672 14.68928-37.18656 14.68928-58.27072 0-12.57472-2.37056-24.47872-5.76-35.93728l304.60928-189.15328c22.68672 20.41856 52.38272 33.18272 85.21728 33.18272 70.58944 0 128-57.40544 128-128s-57.41056-128-128-128-128 57.41056-128 128c0 14.56128 2.97472 28.35456 7.45472 41.41056l-301.824 187.392c-23.13728-22.784-54.784-36.93056-89.728-36.93056-70.59456 0-128 57.41056-128 128s57.40544 128 128 128c25.66144 0 49.50528-7.74656 69.56544-20.79744l321.21856 178.40128c-3.04128 10.94144-5.18656 22.20544-5.18656 34.07872 0 70.58944 57.40544 128 128 128 70.58944 0 128-57.41056 128-128s-57.344-127.96416-127.96928-127.96416z m-1.50016-575.58528c35.29728 0 64 28.70272 64 64s-28.70272 64-64 64-64-28.70272-64-64 28.70272-64 64-64zM191.13472 511.93856c0-35.29728 28.70272-64 64-64s64 28.70272 64 64-28.70272 64-64 64-64-28.70784-64-64z m577.56672 383.67744c-35.29728 0-64-28.70272-64-64s28.70272-64 64-64 64 28.70272 64 64-28.70272 64-64 64z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-shop" viewBox="0 0 1024 1024">' + '' + '<path d="M88 656v175.68c0 57.6 46.592 104.32 104.16 104.32h639.68c57.6 0 104.16-46.496 104.16-104.32V656a40 40 0 0 0-80 0v175.68c0 13.632-10.688 24.32-24.16 24.32H192.16a24.224 24.224 0 0 1-24.16-24.32V656a40 40 0 0 0-80 0z"  ></path>' + '' + '<path d="M801.152 542.272c-31.424 0-61.536-13.44-82.56-36.864-15.552-17.312-37.984-28.128-61.12-26.528a79.712 79.712 0 0 0-60.032 28.96A110.592 110.592 0 0 1 512 548.064a110.592 110.592 0 0 1-85.44-40.224 79.712 79.712 0 0 0-60.032-28.96l-1.6-0.032c-22.688 0-44.352 9.632-59.52 26.56a111.136 111.136 0 0 1-82.56 36.864 110.976 110.976 0 0 1-94.272-169.216c1.984-3.168 3.712-6.4 5.216-9.792l78.08-175.648c2.464-4.48 12.608-11.104 17.184-11.616H794.56c5.12 0.448 15.136 7.008 17.472 11.232l78.24 176.032c1.472 3.36 3.232 6.592 5.152 9.728a110.976 110.976 0 0 1-94.24 169.28m162.176-211.488L885.12 154.752C870.592 122.08 830.304 96 794.944 96H229.056c-35.104 0-75.744 26.304-90.144 58.752l-78.24 176.032a190.848 190.848 0 0 0 304.256 228.064A190.496 190.496 0 0 0 512 628.064a190.496 190.496 0 0 0 147.072-69.216 190.848 190.848 0 0 0 304.256-228.064"  ></path>' + '' + '<path d="M224 424h576a40 40 0 0 0 0-80H224a40 40 0 1 0 0 80z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-arrow" viewBox="0 0 1024 1024">' + '' + '<path d="M908.501333 755.498667a42.666667 42.666667 0 0 0 60.330667-60.330667l-426.666667-426.666667a42.666667 42.666667 0 0 0-60.330666 0l-426.666667 426.666667a42.666667 42.666667 0 0 0 60.330667 60.330667L512 358.997333l396.501333 396.501334z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-add" viewBox="0 0 1024 1024">' + '' + '<path d="M550.4 550.4H870.4a38.4 38.4 0 0 0 0-76.8H550.4V153.6a38.4 38.4 0 0 0-76.8 0v320H153.6a38.4 38.4 0 0 0 0 76.8h320V870.4a38.4 38.4 0 0 0 76.8 0V550.4z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-awkward" viewBox="0 0 1024 1024">' + '' + '<path d="M810.666667 234.666667a85.333333 85.333333 0 1 1 0-170.666667 85.333333 85.333333 0 0 1 0 170.666667z m-597.333334 0a85.333333 85.333333 0 1 1 0-170.666667 85.333333 85.333333 0 0 1 0 170.666667z"  ></path>' + '' + '<path d="M136.533333 877.397333c52.266667-158.037333 227.029333-223.018667 343.125334-73.002666 167.125333 216.021333 394.24 147.114667 489.301333-83.072a42.666667 42.666667 0 1 0-78.848-32.597334c-72.533333 175.701333-221.226667 220.8-342.997333 63.445334-164.266667-212.309333-420.266667-117.162667-491.605334 98.432a42.666667 42.666667 0 0 0 80.981334 26.794666z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-bad" viewBox="0 0 1024 1024">' + '' + '<path d="M0 448V64a40 40 0 0 1 80 0v384A40 40 0 0 1 0 448M916.352 465.12L845.376 80H240v352H256c113.504 0 176 62.496 176 176v280.224c8.288 8.448 33.696 22.944 68.864 22.944 20.672 0 40.384-5.024 57.28-14.208 31.744-18.08 61.088-46.72 61.088-133.344 0-26.72-4.736-78.368-13.248-145.504l-11.52-90.112h269.824c18.464 0 33.728-6.08 42.944-17.152 9.28-11.136 12.48-27.36 9.12-45.696M864.288 608h-178.944c6.88 54.176 13.888 118.304 13.888 155.584 0 102.24-34.144 164.48-101.472 202.88C484.096 1028.384 352 962.08 352 896v-288c0-68.768-27.52-96-96-96h-31.744A64 64 0 0 1 160 448.16V63.84A64 64 0 0 1 224.128 0h623.776c35.52 0 69.28 28.096 75.68 62.752l71.456 387.872c16 87.04-42.56 157.376-130.752 157.376"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-close" viewBox="0 0 1024 1024">' + '' + '<path d="M512 566.2976l228.864 228.864a38.4 38.4 0 0 0 54.272-54.3232L566.3232 512l228.864-228.864a38.4 38.4 0 0 0-54.3232-54.272L512 457.6768l-228.864-228.864a38.4 38.4 0 0 0-54.272 54.3232L457.6768 512l-228.864 228.864a38.4 38.4 0 0 0 54.3232 54.272L512 566.3232z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-doing" viewBox="0 0 1024 1024">' + '' + '<path d="M512 853.333333a341.333333 341.333333 0 1 0 0-682.666666 341.333333 341.333333 0 0 0 0 682.666666z m0 170.666667C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-done" viewBox="0 0 1024 1024">' + '' + '<path d="M512 512m-341.333333 0a341.333333 341.333333 0 1 0 682.666666 0 341.333333 341.333333 0 1 0-682.666666 0Z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fail" viewBox="0 0 1024 1024">' + '' + '<path d="M512 451.669333L328.832 268.501333a42.666667 42.666667 0 0 0-60.330667 60.330667L451.669333 512l-183.168 183.168a42.666667 42.666667 0 0 0 60.330667 60.330667L512 572.330667l183.168 183.168a42.666667 42.666667 0 0 0 60.330667-60.330667L572.330667 512l183.168-183.168a42.666667 42.666667 0 1 0-60.330667-60.330667L512 451.669333zM512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-edit" viewBox="0 0 1024 1024">' + '' + '<path d="M495.914667 42.666667H127.914667A127.957333 127.957333 0 0 0 0 170.24v683.52A127.573333 127.573333 0 0 0 127.616 981.333333H896.426667A127.701333 127.701333 0 0 0 1024 853.504v-335.616a42.666667 42.666667 0 0 0-85.333333 0v335.616a42.368 42.368 0 0 1-42.282667 42.496H127.573333A42.24 42.24 0 0 1 85.333333 853.76V170.24c0-23.125333 19.157333-42.24 42.581334-42.24h368a42.666667 42.666667 0 1 0 0-85.333333z"  ></path>' + '' + '<path d="M702.208 252.586667l-280.746667 280.832a64 64 0 1 0 90.453334 90.453333l280.832-280.746667a64 64 0 1 0-90.538667-90.538666z"  ></path>' + '' + '<path d="M787.541333 167.253333l-280.746666 280.832 90.453333 90.453334 280.832-280.746667zM920.746667 215.125333L968.96 166.826667 878.506667 76.373333 830.208 124.586667z"  ></path>' + '' + '<path d="M963.413333 172.458667l6.016-6.058667A64 64 0 0 0 878.933333 75.946667l-6.058666 6.016c-24.96 25.002667-18.944 53.973333 6.058666 78.933333 25.002667 25.045333 59.477333 36.565333 84.48 11.605333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-forward" viewBox="0 0 1024 1024">' + '' + '<path d="M737.834667 499.498667a42.666667 42.666667 0 0 0 60.330666-60.330667l-256-256a42.666667 42.666667 0 0 0-60.330666 0l-256 256a42.666667 42.666667 0 1 0 60.330666 60.330667L512 273.664l225.834667 225.834667z"  ></path>' + '' + '<path d="M737.834667 798.165333a42.666667 42.666667 0 0 0 60.330666-60.330666l-256-256a42.666667 42.666667 0 0 0-60.330666 0l-256 256a42.666667 42.666667 0 0 0 60.330666 60.330666L512 572.330667l225.834667 225.834666z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fstop" viewBox="0 0 1024 1024">' + '' + '<path d="M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z m192-554.666667H298.666667a42.666667 42.666667 0 0 0 0 85.333334h405.333333a42.666667 42.666667 0 0 0 0-85.333334z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-good" viewBox="0 0 1024 1024">' + '' + '<path d="M0 576v384a40 40 0 0 0 80 0V576A40 40 0 0 0 0 576M916.352 558.88l-70.976 385.152H240v-352H256c113.504 0 176-62.496 176-176V135.808c8.288-8.448 33.696-22.944 68.864-22.944 20.672 0 40.384 5.024 57.312 14.208 31.712 18.08 61.056 46.752 61.056 133.344 0 26.72-4.736 78.368-13.248 145.504l-11.52 90.112h269.824c18.464 0 33.728 6.08 42.944 17.152 9.28 11.136 12.48 27.36 9.12 45.696M864.288 416h-178.944c6.88-54.176 13.888-118.304 13.888-155.584 0-102.24-34.144-164.48-101.472-202.848C484.096-4.416 352 61.888 352 128v288c0 68.768-27.488 96-96 96h-31.744A64 64 0 0 0 160 575.84v384.352A64 64 0 0 0 224.128 1024h623.776c35.552 0 69.28-28.096 75.68-62.752l71.456-387.872c16.032-87.04-42.528-157.376-130.752-157.376"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-heart" viewBox="0 0 1024 1024">' + '' + '<path d="M717.312 85.333333c-50.645333 0-97.664 14.378667-138.112 37.888s-67.157333 57.301333-67.157333 57.301334-27.605333-33.792-67.669334-57.557334A269.397333 269.397333 0 0 0 306.688 85.333333C160.853333 85.333333 42.666667 199.936 42.666667 341.290667 42.666667 749.610667 469.333333 938.666667 512.042667 938.666667 554.666667 938.666667 981.333333 749.610667 981.333333 341.290667 981.333333 199.936 863.146667 85.333333 717.312 85.333333zM512 850.986667c-75.605333-26.624-384-189.909333-384-509.696C128 247.210667 208.170667 170.666667 306.688 170.666667c33.237333 0 65.792 8.874667 94.165333 25.728 25.728 15.232 45.098667 38.101333 45.098667 38.101333 16.213333 19.882667 40.490667 31.36 66.090667 31.36h0.725333a85.248 85.248 0 0 0 66.261333-32.512 184.362667 184.362667 0 0 1 43.050667-36.352A187.733333 187.733333 0 0 1 717.312 170.666667C815.829333 170.666667 896 247.210667 896 341.290667c0 319.701333-308.394667 483.072-384 509.696z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-mic" viewBox="0 0 1024 1024">' + '' + '<path d="M550.4 881.536v81.9456a38.4 38.4 0 1 1-76.8 0V881.408c-208.7936-19.1232-358.4-189.5424-358.4-395.008a38.4 38.4 0 0 1 76.8 0c0 176.4352 134.912 319.5648 320.1024 320C691.3792 806.8096 806.4 670.5664 806.4 486.4a38.4 38.4 0 0 1 76.8 0c0 210.944-129.792 376.96-332.8 395.136zM307.2 230.1696C307.2 117.1968 399.104 25.6 512 25.6c113.1008 0 204.8 91.776 204.8 204.5696V512.256C716.8 625.2032 624.896 716.8 512 716.8c-113.1008 0-204.8-91.776-204.8-204.5696V230.144z m76.8 0V512.256a128 128 0 0 0 256 0V230.144a128 128 0 0 0-256 0z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-keyboard" viewBox="0 0 1024 1024">' + '' + '<path d="M153.6 806.4c0-21.1968 17.024-38.4 38.528-38.4h639.744a38.3744 38.3744 0 1 1 0 76.8H192.128A38.3744 38.3744 0 0 1 153.6 806.4zM435.2 281.6c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8z m256 0c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8zM179.2 537.6c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8z m256 0c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8z m256 0c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8zM179.2 281.6c0-42.4192 34.4832-76.8 76.8-76.8 42.4192 0 76.8 34.4832 76.8 76.8 0 42.4192-34.4832 76.8-76.8 76.8-42.4192 0-76.8-34.4832-76.8-76.8z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-image" viewBox="0 0 1066 1024">' + '' + '<path d="M106.666667 170.24v683.52c0 46.933333 37.973333 84.906667 84.906666 84.906667h683.52c46.933333 0 84.906667-37.973333 84.906667-84.906667V170.24c0-46.933333-37.973333-84.906667-84.906667-84.906667H191.573333c-46.933333 0-84.906667 37.973333-84.906666 84.906667z m-85.333334 0A170.197333 170.197333 0 0 1 191.573333 0h683.52a170.197333 170.197333 0 0 1 170.24 170.24v683.52A170.197333 170.197333 0 0 1 875.093333 1024H191.573333A170.197333 170.197333 0 0 1 21.333333 853.76V170.24z"  ></path>' + '' + '<path d="M298.666667 341.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333z m0 85.333334a128 128 0 1 1 0-256 128 128 0 0 1 0 256zM526.08 756.693333a42.666667 42.666667 0 0 0 55.509333-5.248l323.84-337.92a42.666667 42.666667 0 1 0-61.568-59.050666l-298.410666 311.338666-135.594667-96.170666a42.666667 42.666667 0 0 0-54.656 4.437333L162.048 764.586667a42.666667 42.666667 0 0 0 59.904 60.757333l167.68-165.418667 136.490667 96.768z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-fwarning" viewBox="0 0 1024 1024">' + '' + '<path d="M983.76453 312.704462a510.548695 510.548695 0 0 0-109.695863-162.730463A509.866029 509.866029 0 0 0 711.338204 40.278136 508.330031 508.330031 0 0 0 511.999787 0.000853a510.207362 510.207362 0 0 0-362.026214 149.973146A510.719362 510.719362 0 0 0 0.000427 512.000213a510.548695 510.548695 0 0 0 149.930479 362.026214 509.866029 509.866029 0 0 0 162.730463 109.695863C375.850624 1010.474257 442.879873 1023.999573 511.999787 1023.999573a510.548695 510.548695 0 0 0 362.026214-149.930479 509.866029 509.866029 0 0 0 109.695863-162.730463C1010.47383 648.149376 1023.999147 581.120127 1023.999147 512.000213s-13.525316-136.149163-40.234617-199.295751zM469.333173 234.667227a42.666613 42.666613 0 0 1 85.333227 0v341.332906a42.666613 42.666613 0 0 1-85.333227 0v-341.332906zM511.999787 810.666507a63.99992 63.99992 0 1 1 0.042666-128.042507A63.99992 63.99992 0 0 1 511.999787 810.666507z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-no" viewBox="0 0 1024 1024">' + '' + '<path d="M268.501333 328.832l426.666667 426.666667a42.666667 42.666667 0 0 0 60.330667-60.330667l-426.666667-426.666667a42.666667 42.666667 0 0 0-60.330667 60.330667z"  ></path>' + '' + '<path d="M328.832 755.498667l426.666667-426.666667a42.666667 42.666667 0 1 0-60.330667-60.330667l-426.666667 426.666667a42.666667 42.666667 0 0 0 60.330667 60.330667z"  ></path>' + '' + '<path d="M512 938.666667c235.648 0 426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667z m0 85.333333C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-more" viewBox="0 0 1024 1024">' + '' + '<path d="M426.666667 512a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z"  ></path>' + '' + '<path d="M725.333333 512a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '<path d="M128 512a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-plane" viewBox="0 0 1024 1024">' + '' + '<path d="M85.333333 501.333333C85.333333 601.429333 166.4 682.666667 266.410667 682.666667h629.674666c42.794667 0 42.581333-15.402667 23.722667-45.141334l-4.608-6.869333c-19.114667-27.733333-43.221333-33.322667-61.653333-33.322667H683.093333a85.333333 85.333333 0 0 1-70.101333-36.693333l-143.829333-207.189333c-17.493333-26.282667-35.968-33.28-64-33.28h-8.96l55.466666 164.565333A85.333333 85.333333 0 0 1 370.730667 597.333333H256.426667c-60.373333 0-118.4-41.557333-137.514667-98.858666l-2.133333-6.4C111.744 469.333333 95.701333 469.333333 85.333333 469.333333v32z m285.44 10.666667L304.64 315.733333c-15.104-44.672 10.837333-80.896 58.24-80.896h42.24c47.232 0 107.221333 31.274667 134.101333 69.973334L683.050667 512h170.496c47.018667 0 106.410667 31.914667 132.693333 71.296l4.565333 6.912c65.450667 98.176 22.997333 177.792-94.72 177.792H266.410667A266.538667 266.538667 0 0 1 0 501.333333V426.538667C0 403.072 18.901333 384 43.093333 384H85.333333c47.146667 0 97.450667 36.352 112.341334 81.066667l2.133333 6.4c7.466667 22.4 32.853333 40.533333 56.533333 40.533333H370.773333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-remind" viewBox="0 0 1024 1024">' + '' + '<path d="M512 938.666311a424.959646 424.959646 0 0 0 301.695749-124.970562A424.916979 424.916979 0 0 0 938.666311 512a424.916979 424.916979 0 0 0-124.970562-301.695749A424.916979 424.916979 0 0 0 512 85.333689a424.916979 424.916979 0 0 0-301.695749 124.970562A424.959646 424.959646 0 0 0 85.333689 512a424.916979 424.916979 0 0 0 124.970562 301.695749A424.959646 424.959646 0 0 0 512 938.666311z m0 85.333262a510.292908 510.292908 0 0 1-362.026365-149.973208A510.250241 510.250241 0 0 1 0.000427 512a510.292908 510.292908 0 0 1 149.973208-362.026365A510.250241 510.250241 0 0 1 512 0.000427a510.250241 510.250241 0 0 1 362.026365 149.973208A510.250241 510.250241 0 0 1 1023.999573 512a510.250241 510.250241 0 0 1-149.973208 362.026365A510.292908 510.292908 0 0 1 512 1023.999573z"  ></path>' + '' + '<path d="M512 341.333476a63.999947 63.999947 0 0 1 0-127.999894 63.999947 63.999947 0 1 1 0 127.999894z"  ></path>' + '' + '<path d="M469.333369 448.000053v341.333049a42.666631 42.666631 0 0 0 85.333262 0v-341.333049a42.666631 42.666631 0 0 0-85.333262 0z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-return" viewBox="0 0 1024 1024">' + '' + '<path d="M85.333333 896h559.530667C855.594667 896 981.333333 805.205333 981.333333 576S855.594667 256 644.864 256H89.6a42.666667 42.666667 0 1 0 0 85.333333h555.264C813.312 341.333333 896 401.066667 896 576S813.312 810.666667 644.864 810.666667H85.333333a42.666667 42.666667 0 0 0 0 85.333333z"  ></path>' + '' + '<path d="M225.834667 97.834667l-170.666667 170.666666a42.666667 42.666667 0 1 0 60.330667 60.330667l170.666666-170.666667a42.666667 42.666667 0 0 0-60.330666-60.330666z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-right" viewBox="0 0 1024 1024">' + '' + '<path d="M246.613333 528a42.666667 42.666667 0 1 0-66.56 53.333333l170.666667 213.333334a42.666667 42.666667 0 0 0 61.994667 4.906666l469.333333-426.666666a42.666667 42.666667 0 0 0-57.429333-63.146667L388.906667 705.877333l-142.250667-177.877333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-roll" viewBox="0 0 1066 1024">' + '' + '<path d="M892.416 364.202667c2.474667 5.12 4.864 10.24 7.125333 15.445333 18.389333 42.453333 81.792 29.312 81.792-16.981333V85.333333a42.666667 42.666667 0 0 0-85.333333 0v277.333334l81.792-16.981334A458.581333 458.581333 0 0 0 896 219.349333C809.728 124.629333 682.410667 64 533.333333 64c-232.32 0-423.68 163.029333-447.744 379.306667a42.666667 42.666667 0 1 0 84.821334 9.386666C189.525333 280.618667 343.637333 149.333333 533.333333 149.333333c165.845333 0 297.6 89.301333 359.082667 214.869334zM174.250667 681.130667a370.474667 370.474667 0 0 1-7.125334-15.445334C148.736 623.232 85.333333 636.373333 85.333333 682.666667v277.333333a42.666667 42.666667 0 0 0 85.333334 0v-114.901333-19.114667V682.666667l-81.792 16.981333A458.581333 458.581333 0 0 0 170.666667 825.984C256.938667 920.704 384.256 981.333333 533.333333 981.333333c232.32 0 423.68-163.029333 447.744-379.306666a42.666667 42.666667 0 1 0-84.821333-9.386667C877.141333 764.714667 723.029333 896 533.333333 896c-165.845333 0-297.6-89.301333-359.082666-214.869333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-scarmera" viewBox="0 0 1024 1024">' + '' + '<path d="M85.333333 298.410667v597.845333c0 23.381333 18.986667 42.410667 42.282667 42.410667H896.426667a42.410667 42.410667 0 0 0 42.282666-42.410667V298.410667A42.410667 42.410667 0 0 0 896.384 256H127.573333A42.410667 42.410667 0 0 0 85.333333 298.410667z m-85.333333 0A127.744 127.744 0 0 1 127.616 170.666667H896.426667A127.744 127.744 0 0 1 1024 298.410667v597.845333A127.744 127.744 0 0 1 896.384 1024H127.573333A127.744 127.744 0 0 1 0 896.256V298.410667z"  ></path>' + '' + '<path d="M512 725.333333a128 128 0 1 0 0-256 128 128 0 0 0 0 256z m0 85.333334a213.333333 213.333333 0 1 1 0-426.666667 213.333333 213.333333 0 0 1 0 426.666667zM554.666667 128h256a42.666667 42.666667 0 0 0 0-85.333333h-256a42.666667 42.666667 0 0 0 0 85.333333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-search" viewBox="0 0 1024 1024">' + '' + '<path d="M801.92 747.6224l134.0416 134.016a38.4 38.4 0 0 1-54.3232 54.3232l-134.016-134.0416A407.936 407.936 0 0 1 486.4 896c-226.2272 0-409.6-183.3728-409.6-409.6S260.1728 76.8 486.4 76.8s409.6 183.3728 409.6 409.6c0 99.2768-35.328 190.3104-94.08 261.2224zM486.4 819.2c183.808 0 332.8-148.992 332.8-332.8S670.208 153.6 486.4 153.6 153.6 302.592 153.6 486.4s148.992 332.8 332.8 332.8z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-send" viewBox="0 0 1024 1024">' + '' + '<path d="M505.6 269.4144l-187.648 234.0608a38.4 38.4 0 0 1-59.904-48.0256l254.3872-317.3376c1.3568-1.9712 2.9184-3.84 4.6848-5.5296a38.4 38.4 0 0 1 61.568 9.2928l251.2896 314.1376a38.4 38.4 0 0 1-59.9552 47.9744l-187.6224-234.496V768c0 69.1968-65.2032 134.4-134.4 134.4h-256a38.4 38.4 0 0 1 0-76.8h256c26.8032 0 57.6-30.8224 57.6-57.6V269.4144z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-sad" viewBox="0 0 1024 1024">' + '' + '<path d="M823.652174 200.347826a89.043478 89.043478 0 1 1 0-178.086956 89.043478 89.043478 0 0 1 0 178.086956z m-623.304348 0a89.043478 89.043478 0 1 1 0-178.086956 89.043478 89.043478 0 0 1 0 178.086956z"  ></path>' + '' + '<path d="M990.608696 938.785391C990.608696 666.534957 776.681739 445.217391 512 445.217391S33.391304 666.490435 33.391304 938.785391a44.521739 44.521739 0 0 0 89.043479 0C122.434783 715.063652 297.182609 534.26087 512 534.26087s389.565217 180.758261 389.565217 404.524521a44.521739 44.521739 0 0 0 89.043479 0z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-share" viewBox="0 0 1024 1024">' + '' + '<path d="M810.666667 682.666667c-45.952 0-87.424 18.346667-118.101334 47.872l-236.8-145.706667A211.84 211.84 0 0 0 469.333333 512c0-25.685333-5.248-50.005333-13.610666-72.832l236.586666-145.877333A169.941333 169.941333 0 0 0 810.666667 341.333333a170.666667 170.666667 0 1 0-170.666667-170.666666c0 17.365333 3.370667 33.792 8.192 49.536L411.178667 366.378667A212.096 212.096 0 0 0 256 298.666667a213.333333 213.333333 0 0 0 0 426.666666 212.138667 212.138667 0 0 0 155.178667-67.754666l237.098666 145.877333c-4.906667 15.914667-8.277333 32.426667-8.277333 49.877333a170.666667 170.666667 0 1 0 170.666667-170.666666z m0-597.333334a85.333333 85.333333 0 1 1 0.042666 170.624A85.333333 85.333333 0 0 1 810.666667 85.333333zM256 640a128 128 0 1 1 0-256 128 128 0 0 1 0 256z m554.666667 298.666667a85.333333 85.333333 0 1 1-0.042667-170.624A85.333333 85.333333 0 0 1 810.666667 938.666667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-smell" viewBox="0 0 1024 1024">' + '' + '<path d="M810.666667 234.666667a85.333333 85.333333 0 1 1 0-170.666667 85.333333 85.333333 0 0 1 0 170.666667z m-597.333334 0a85.333333 85.333333 0 1 1 0-170.666667 85.333333 85.333333 0 0 1 0 170.666667z"  ></path>' + '' + '<path d="M896 512c0 220.501333-172.245333 398.72-384 398.72S128 732.501333 128 512a42.666667 42.666667 0 0 0-85.333333 0c0 267.008 209.792 484.053333 469.333333 484.053333S981.333333 779.008 981.333333 512a42.666667 42.666667 0 0 0-85.333333 0z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-ssend" viewBox="0 0 1024 1024">' + '' + '<path d="M291.2 860.586667a42.666667 42.666667 0 1 0 0 85.333333h233.685333l7.850667-0.682667c25.045333-4.693333 59.861333-17.024 95.061333-41.130666 60.245333-41.258667 97.365333-103.552 97.365334-187.050667V425.898667 85.333333a42.666667 42.666667 0 0 0-85.333334 0V717.056c0 53.546667-22.016 90.453333-60.245333 116.650667a191.872 191.872 0 0 1-59.306667 26.88H291.157333z"  ></path>' + '' + '<path d="M652.501333 55.168l-266.666666 266.666667a42.666667 42.666667 0 0 0 60.330666 60.330666l266.666667-266.666666a42.666667 42.666667 0 1 0-60.330667-60.330667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-success" viewBox="0 0 1024 1024">' + '' + '<path d="M943.104 235.690667A511.573333 511.573333 0 0 0 512 0C229.248 0 0 229.248 0 512s229.248 512 512 512 512-229.248 512-512c0-70.4-14.208-137.386667-39.893333-198.442667l-420.608 420.608a42.666667 42.666667 0 0 1-60.330667 0l-192-192a42.666667 42.666667 0 0 1 60.330667-60.330666l161.834666 161.834666 401.493334-401.536c2.56-2.56 5.333333-4.693333 8.277333-6.442666z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-stop" viewBox="0 0 1024 1024">' + '' + '<path d="M512 938.666667c235.648 0 426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667z m0 85.333333C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z"  ></path>' + '' + '<path d="M704 469.333333H298.666667a42.666667 42.666667 0 0 0 0 85.333334h405.333333a42.666667 42.666667 0 0 0 0-85.333334z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-strategy" viewBox="0 0 1024 1024">' + '' + '<path d="M170.666667 170.709333V853.333333A42.538667 42.538667 0 0 0 213.077333 896h597.845334A42.666667 42.666667 0 0 0 853.333333 853.290667V170.666667A42.538667 42.538667 0 0 0 810.922667 128H213.077333A42.666667 42.666667 0 0 0 170.666667 170.709333z m-85.333334 0A128 128 0 0 1 213.077333 42.666667h597.845334A127.872 127.872 0 0 1 938.666667 170.709333V853.333333A128 128 0 0 1 810.922667 981.333333H213.077333A127.872 127.872 0 0 1 85.333333 853.290667V170.666667z"  ></path>' + '' + '<path d="M554.666667 85.333333h170.666666v298.794667c0 23.466667-13.354667 29.184-30.293333 12.202667L640 341.333333l-55.04 55.04c-16.725333 16.725333-30.293333 10.965333-30.293333-12.245333V85.333333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-rule" viewBox="0 0 1024 1024">' + '' + '<path d="M270.08 737.376c-14.56 14.976-26.368 23.136-35.392 24.48-9.056 1.312-18.208-2.24-27.456-10.592-18.112-15.008-16.768-34.848 3.968-59.52 16.32-19.424 30.208-37.632 41.664-54.624 11.488-16.96 20.864-34.176 28.128-51.584 7.264-17.44 12.8-35.84 16.544-55.264 3.744-19.392 6.272-41.472 7.616-66.144h-77.44c-14.08 0-23.584-3.2-28.448-9.6-4.832-6.4-7.264-15.552-7.264-27.456 0-11.936 2.752-20.64 8.256-26.144 5.536-5.504 14.688-8.288 27.488-8.288h78.72V316.576H242.272c-14.08 0-23.584-3.2-28.448-9.6-4.832-6.4-7.264-15.552-7.264-27.456s2.752-20.64 8.256-26.144c5.536-5.504 14.688-8.256 27.456-8.256h64.192V163.744c0-12.8 2.88-21.952 8.608-27.488 5.728-5.504 14.08-8.256 25.12-8.256 11.488 0 20.64 2.432 27.488 7.264 6.816 4.864 10.24 14.336 10.24 28.48V245.12h47.648c14.08 0 23.584 2.752 28.448 8.256 4.832 5.504 7.264 14.24 7.264 26.144 0 11.904-2.208 21.056-6.624 27.456-4.384 6.4-14.08 9.6-29.12 9.6H377.92v76.064h61.536c13.664 0 22.944 2.784 27.776 8.288 4.864 5.504 7.296 14.208 7.296 26.144 0 11.904-2.24 21.056-6.624 27.456-4.416 6.4-13.888 9.6-28.48 9.6H376.64v0.64c10.144 17.216 18.944 32.416 26.464 45.664 7.488 13.216 14.336 25.344 20.48 36.384a1064.96 1064.96 0 0 1 33.088 63.52c5.76 12.352 7.392 23.04 4.992 32.096-2.432 9.024-8.064 16.416-16.896 22.144-13.664 8.384-24.352 10.496-32.064 6.304-7.744-4.192-15.36-15.104-22.848-32.768a278.72 278.72 0 0 0-15.552-33.408 445.76 445.76 0 0 1-15.552-30.752c-8.8 30.88-20.16 59.84-34.048 87.008a331.072 331.072 0 0 1-54.592 76.416z m561.728-105.216c-0.448 26.464-1.888 47.52-4.32 63.2-2.4 15.68-7.584 27.552-15.52 35.712-7.968 8.16-19.424 13.44-34.432 15.904-14.976 2.4-35.52 3.616-61.504 3.616-17.216 0-31.456-1.44-42.688-4.288-11.264-2.88-20.064-7.616-26.464-14.24a55.68 55.68 0 0 1-13.568-25.792c-2.656-10.56-3.968-23.808-3.968-39.68v-83.392a325.056 325.056 0 0 1-62.528 98.592 450.912 450.912 0 0 1-90.976 74.752c-11.456 7.04-22.4 8.832-32.736 5.312-10.368-3.52-17.312-9.696-20.864-18.56-5.28-13.632-5.184-24.576 0.32-32.736 5.536-8.16 13.12-14.88 22.848-20.16 29.12-18.08 53.376-37.184 72.768-57.248a254.144 254.144 0 0 0 46.976-67.488 301.76 301.76 0 0 0 25.152-83.36c4.864-30.656 7.296-65.824 7.296-105.536V296.704c0-14.976 2.528-25.6 7.584-31.744 5.088-6.176 13.792-9.28 26.144-9.28 13.248 0 22.4 3.104 27.456 9.28 5.088 6.176 7.616 16.768 7.616 31.744l-3.328 164.768c13.248 0.448 22.496 3.52 27.808 9.28 5.28 5.696 7.936 16.064 7.936 31.072v161.44c0 4.864 1.664 8.608 4.96 11.264 3.296 2.624 9.824 3.968 19.52 3.968s17.312-0.896 22.816-2.656c5.536-1.76 9.376-4.64 11.584-8.608 2.24-3.968 3.52-8.928 3.968-14.88 0.448-5.952 0.64-13.12 0.64-21.504 0-14.112 2.56-25.376 7.648-33.76 5.056-8.352 14.208-12.544 27.456-12.544 13.664 0 23.04 3.744 28.096 11.232 5.088 7.488 7.168 19.616 6.304 36.384z m-39.68-93.28c0 15.008-3.104 24.928-9.28 29.76-6.176 4.864-14.336 7.296-24.48 7.296-11.488 0-20.16-2.432-26.144-7.296-5.952-4.832-8.928-14.752-8.928-29.76V236.48c0-3.936-0.448-6.464-1.312-7.584-0.896-1.088-3.328-1.664-7.296-1.664h-155.488c-3.52 0-5.6 0.672-6.272 1.984a18.208 18.208 0 0 0-0.992 7.296v303.68c0 15.008-2.976 24.704-8.96 29.12-5.92 4.416-14.4 6.624-25.44 6.624-10.592 0-19.072-2.24-25.472-6.624-6.4-4.416-9.6-14.112-9.6-29.12V230.56c0-14.112 0.544-25.92 1.664-35.392 1.088-9.504 3.744-17.216 7.936-23.168 4.16-5.952 10.24-10.144 18.176-12.576 7.936-2.432 18.752-3.648 32.416-3.648h189.888c11.936 0 21.76 1.216 29.44 3.648 7.744 2.432 13.792 6.624 18.24 12.576 4.384 5.952 7.456 13.76 9.248 23.488 1.76 9.696 2.624 21.824 2.624 36.384v307.008z"  ></path>' + '' + '<path d="M117.984 218.08c-3.648 92.64-2.816 193.44 5.568 287.712 2.88 32.544 6.624 63.232 11.264 91.744 32.896 85.184 95.584 159.84 179.904 223.808a873.728 873.728 0 0 0 145.568 88.8 812.768 812.768 0 0 0 51.712 23.04l3.904-1.6c14.368-5.856 30.432-12.992 47.808-21.44a873.728 873.728 0 0 0 145.568-88.8c84.32-64 147.008-138.624 179.904-223.808 4.64-28.512 8.384-59.2 11.264-91.744 8.384-94.272 9.216-195.072 5.568-287.712-0.288-7.744-0.608-14.88-0.928-21.408a404.896 404.896 0 0 0-10.656-7.168 534.88 534.88 0 0 0-76.416-40.896C732.16 110.784 630.08 88 512 88c-118.08 0-220.16 22.784-306.016 60.608-29.728 13.12-55.232 27.04-76.416 40.896-4.032 2.624-7.584 5.024-10.656 7.168l-0.96 21.408z m55.744-142.688C269.44 33.216 382.432 8 512 8c129.568 0 242.56 25.216 338.24 67.392 58.304 25.696 98.368 51.84 119.84 70.272 8.128 7.008 13.12 16.96 13.824 27.68 0.128 2.048 0.384 5.824 0.64 11.2 0.512 8.864 0.96 19.04 1.44 30.4 3.744 95.744 2.88 199.712-5.856 297.92a1346.24 1346.24 0 0 1-12.672 101.696 40 40 0 0 1-2.016 7.488c-38.4 102.464-111.168 189.728-207.808 263.04a952.736 952.736 0 0 1-158.944 96.992c-18.976 9.248-36.608 17.088-52.544 23.584-9.728 3.968-16.832 6.656-20.928 8.096a40 40 0 0 1-26.432 0c-4.096-1.44-11.2-4.128-20.928-8.096a892.416 892.416 0 0 1-52.544-23.584 952.736 952.736 0 0 1-158.944-96.992c-96.64-73.312-169.408-160.576-207.808-263.04a40 40 0 0 1-2.016-7.488 1346.24 1346.24 0 0 1-12.672-101.696c-8.736-98.208-9.6-202.176-5.856-297.92a2069.888 2069.888 0 0 1 2.08-41.6 40 40 0 0 1 13.824-27.68c21.472-18.432 61.536-44.576 119.808-70.272z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-time" viewBox="0 0 1024 1024">' + '' + '<path d="M512 938.666667c235.648 0 426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667z m0 85.333333C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512z"  ></path>' + '' + '<path d="M554.666667 298.666667a42.666667 42.666667 0 0 0-85.333334 0v213.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h213.333333a42.666667 42.666667 0 0 0 0-85.333334h-170.666666V298.666667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-skip" viewBox="0 0 1024 1024">' + '' + '<path d="M460.373333 908.629333a42.666667 42.666667 0 1 0 60.586667 60.074667l424.533333-428.842667a42.666667 42.666667 0 0 0-0.128-60.202666l-424.533333-424.533334a42.666667 42.666667 0 0 0-60.330667 60.373334l394.496 394.496-394.666666 398.634666z"  ></path>' + '' + '<path d="M469.333333 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '<path d="M85.333333 512a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-tag" viewBox="0 0 1024 1024">' + '' + '<path d="M467.925333 861.653333c0.213333 0.170667 381.44-381.013333 381.44-381.013333 0.64-0.64 5.205333-11.733333 5.205334-12.714667V173.824c0-0.085333-294.229333-0.128-294.229334-0.128-0.981333 0-12.032 4.565333-12.714666 5.248L166.4 560.170667l301.525333 301.482666zM106.24 620.672a85.162667 85.162667 0 0 1-0.256-120.746667L487.253333 118.570667c16.682667-16.682667 49.493333-30.208 73.045334-30.208h294.101333c47.189333 0 85.461333 38.229333 85.461333 85.461333v294.101333c0 23.637333-13.610667 56.405333-30.208 73.045334l-381.354666 381.312a85.333333 85.333333 0 0 1-120.746667-0.256L106.24 620.672z"  ></path>' + '' + '<path d="M674.133333 354.133333m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-wrong" viewBox="0 0 1024 1024">' + '' + '<path d="M183.168 243.498667l597.333333 597.333333a42.666667 42.666667 0 0 0 60.330667-60.330667l-597.333333-597.333333a42.666667 42.666667 0 1 0-60.330667 60.330667z"  ></path>' + '' + '<path d="M779.392 183.168L183.168 779.392a42.666667 42.666667 0 0 0 60.330667 60.330667L839.722667 243.498667a42.666667 42.666667 0 1 0-60.330667-60.330667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-warning" viewBox="0 0 1024 1024">' + '' + '<path d="M512 938.666311a424.959646 424.959646 0 0 0 301.695749-124.970562A424.916979 424.916979 0 0 0 938.666311 512a424.916979 424.916979 0 0 0-124.970562-301.695749A424.916979 424.916979 0 0 0 512 85.333689a424.916979 424.916979 0 0 0-301.695749 124.970562A424.959646 424.959646 0 0 0 85.333689 512a424.916979 424.916979 0 0 0 124.970562 301.695749A424.959646 424.959646 0 0 0 512 938.666311z m0 85.333262a510.292908 510.292908 0 0 1-362.026365-149.973208A510.250241 510.250241 0 0 1 0.000427 512a510.292908 510.292908 0 0 1 149.973208-362.026365A510.250241 510.250241 0 0 1 512 0.000427a510.250241 510.250241 0 0 1 362.026365 149.973208A510.250241 510.250241 0 0 1 1023.999573 512a510.250241 510.250241 0 0 1-149.973208 362.026365A510.292908 510.292908 0 0 1 512 1023.999573z"  ></path>' + '' + '<path d="M512 810.666418a63.999947 63.999947 0 0 1 0-127.999894 63.999947 63.999947 0 1 1 0 127.999894z"  ></path>' + '' + '<path d="M469.333369 234.666898v341.333049a42.666631 42.666631 0 0 0 85.333262 0v-341.333049a42.666631 42.666631 0 0 0-85.333262 0z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-use" viewBox="0 0 1024 1024">' + '' + '<path d="M128 682.666667v213.333333h213.333333v-213.333333H128z m-85.333333-0.128C42.666667 635.477333 80.896 597.333333 127.872 597.333333h213.589333C388.522667 597.333333 426.666667 635.562667 426.666667 682.538667v213.589333A85.248 85.248 0 0 1 341.461333 981.333333H127.872A85.248 85.248 0 0 1 42.666667 896.128v-213.589333zM640 896h213.333333v-213.333333h-213.333333v213.333333z m-85.333333-213.461333c0-47.061333 38.229333-85.205333 85.205333-85.205334h213.589333c47.061333 0 85.205333 38.229333 85.205334 85.205334v213.589333A85.248 85.248 0 0 1 853.461333 981.333333h-213.589333A85.248 85.248 0 0 1 554.666667 896.128v-213.589333zM128 384h213.333333V170.666667H128v213.333333zM42.666667 170.538667C42.666667 123.477333 80.896 85.333333 127.872 85.333333h213.589333C388.522667 85.333333 426.666667 123.562667 426.666667 170.538667v213.589333A85.248 85.248 0 0 1 341.461333 469.333333H127.872A85.248 85.248 0 0 1 42.666667 384.128V170.538667zM621.354667 309.845333l200.490666 72.96 72.96-200.448-200.448-72.96-72.96 200.448z m-7.168-229.76a85.248 85.248 0 0 1 109.226666-50.944l200.661334 73.045334a85.248 85.248 0 0 1 50.944 109.226666L901.973333 412.074667a85.248 85.248 0 0 1-109.226666 50.944L592.085333 389.973333a85.248 85.248 0 0 1-50.944-109.226666l73.045334-200.661334z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-pause" viewBox="0 0 1024 1024">' + '' + '<path d="M328 192c22.08 0 40 17.92 40 40v560a40 40 0 0 1-80 0V232C288 209.92 305.92 192 328 192zM696 192c22.08 0 40 17.92 40 40v560a40 40 0 0 1-80 0V232c0-22.08 17.92-40 40-40z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-play" viewBox="0 0 1024 1024">' + '' + '<path d="M451.712 798.464c-55.072 44.48-99.712 22.944-99.712-47.328V272.896c0-70.592 44.384-92 99.712-47.296l280.096 226.24c41.152 33.248 41.12 87.168 0 120.384l-280.096 226.24z"  ></path>' + '' + '<path d="M451.712 798.464c-55.072 44.48-99.712 22.944-99.712-47.328V272.896c0-70.592 44.384-92 99.712-47.296l280.096 226.24c41.152 33.248 41.12 87.168 0 120.384l-280.096 226.24z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-speaker" viewBox="0 0 1024 1024">' + '' + '<path d="M909.994667 390.656A153.685333 153.685333 0 0 0 853.333333 375.253333v-247.04c0-94.634667-61.269333-125.610667-136.874666-69.717333C716.458667 58.496 548.565333 213.333333 341.333333 213.333333 289.749333 213.333333 164.48 159.530667 164.48 159.530667 120.917333 142.464 85.333333 166.101333 85.333333 213.12v597.76c0 47.018667 35.072 70.997333 78.293334 53.589333 0 0 59.221333-25.813333 113.706666-41.685333V960a42.666667 42.666667 0 0 0 85.333334 0v-148.352c195.242667 10.112 353.066667 153.856 353.066666 153.856C792.832 1019.733333 853.333333 990.165333 853.333333 895.786667v-250.709334a153.685333 153.685333 0 0 0 56.661334-15.402666c43.690667-21.376 71.338667-61.909333 71.338666-119.466667s-27.605333-98.176-71.338666-119.552z m-262.357334 423.253333C550.826667 758.826667 447.701333 725.333333 341.333333 725.333333c-28.714667 0-61.653333 7.168-101.717333 19.669334-11.733333 3.669333-23.850667 7.765333-36.266667 12.202666-11.008 3.968-21.973333 8.064-32.682666 12.245334V254.08c11.221333 4.352 22.698667 8.618667 34.261333 12.757333 11.306667 4.010667 22.314667 7.765333 33.024 11.178667C279.381333 291.157333 312.661333 298.666667 341.333333 298.666667c107.349333 0 210.858667-33.493333 307.541334-88.618667 52.608-29.994667 93.141333-60.202667 119.04-83.072l0.085333 1.237333V897.706667c-25.984-22.869333-67.072-53.418667-120.362667-83.797334z m224.853334-260.949333a71.253333 71.253333 0 0 1-19.157334 6.016v-97.706667c5.845333 1.024 12.416 2.730667 19.157334 6.016 15.573333 7.637333 23.509333 19.285333 23.509333 42.88 0 23.552-7.936 35.2-23.509333 42.794667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-service" viewBox="0 0 1024 1024">' + '' + '<path d="M1023.018667 587.434667a999.253333 999.253333 0 0 0-4.778667-64.853334c-6.912-65.493333-20.053333-129.365333-41.088-189.696C905.130667 126.549333 755.029333 0 512 0 286.122667 0 139.52 109.610667 62.037333 292.736 34.176 358.613333 16.810667 430.464 7.637333 505.514667a961.706667 961.706667 0 0 0-6.570666 81.365333C0.768 590.378667 0 593.749333 0 597.333333v170.666667c0 108.885333 104.448 213.333333 213.333333 213.333333h225.152c14.762667 25.386667 41.984 42.666667 73.514667 42.666667a85.333333 85.333333 0 1 0 0-170.666667c-31.488 0-58.709333 17.28-73.514667 42.666667H213.333333a104.106667 104.106667 0 0 1-39.381333-8.874667A127.872 127.872 0 0 0 256 768v-170.666667c0-70.485333-57.301333-128-128-128-10.069333 0-19.754667 1.450667-29.141333 3.669334 9.002667-51.968 22.528-101.546667 41.770666-146.986667C205.44 172.842667 322.474667 85.333333 512 85.333333c203.605333 0 323.669333 101.290667 384.554667 275.712 12.458667 35.669333 21.589333 73.258667 28.330666 111.872A126.293333 126.293333 0 0 0 896 469.333333c-70.570667 0-128 57.301333-128 128v170.666667c0 70.485333 57.301333 128 128 128 70.528 0 128-57.301333 128-128v-170.666667c0-3.370667-0.725333-6.570667-0.981333-9.898666zM128 554.666667c23.466667 0 42.666667 19.242667 42.666667 42.666666v170.666667c0 23.509333-19.2 42.666667-42.666667 42.666667s-42.666667-19.242667-42.666667-42.666667v-128c0-16.64 0.341333-31.914667 0.896-47.018667A42.325333 42.325333 0 0 1 128 554.666667z m810.666667 213.333333c0 23.509333-19.2 42.666667-42.666667 42.666667s-42.666667-19.242667-42.666667-42.666667v-170.666667c0-23.509333 19.2-42.666667 42.666667-42.666666 21.973333 0 39.552 17.066667 41.813333 38.442666 0.597333 15.104 0.853333 30.208 0.853334 46.890667v128z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-delete" viewBox="0 0 1024 1024">' + '' + '<path d="M981.333333 128H42.666667a42.666667 42.666667 0 0 0 0 85.333333h85.333333v725.546667A85.333333 85.333333 0 0 0 213.12 1024h597.76A85.12 85.12 0 0 0 896 938.88V213.333333h85.333333a42.666667 42.666667 0 0 0 0-85.333333z m-170.666666 810.666667s-597.376 0-597.333334 0.213333V213.333333h597.333334v725.333334z"  ></path>' + '' + '<path d="M384 896a42.666667 42.666667 0 0 0 42.666667-42.666667V341.333333a42.666667 42.666667 0 0 0-85.333334 0v512a42.666667 42.666667 0 0 0 42.666667 42.666667zM640 896a42.666667 42.666667 0 0 0 42.666667-42.666667V341.333333a42.666667 42.666667 0 0 0-85.333334 0v512a42.666667 42.666667 0 0 0 42.666667 42.666667zM469.333333 85.333333h85.333334a42.666667 42.666667 0 0 0 0-85.333333h-85.333334a42.666667 42.666667 0 0 0 0 85.333333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-bell" viewBox="0 0 1024 1024">' + '' + '<path d="M938.666667 768h-42.666667v-341.333333c0-185.472-131.456-340.138667-306.218667-376.106667A85.205333 85.205333 0 0 0 512 0c-34.730667 0-64.469333 20.821333-77.781333 50.56C259.413333 86.528 128 241.237333 128 426.666667v341.333333H85.333333a42.666667 42.666667 0 0 0 0 85.333333h853.333334a42.666667 42.666667 0 0 0 0-85.333333zM213.333333 768v-341.333333a298.666667 298.666667 0 0 1 298.666667-298.666667 298.666667 298.666667 0 0 1 298.666667 298.666667v341.333333H213.333333zM576 896h-128a42.666667 42.666667 0 0 0 0 85.333333h128a42.666667 42.666667 0 0 0 0-85.333333z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-choose1" viewBox="0 0 1024 1024">' + '' + '<path d="M512 0C229.248 0 0 229.248 0 512s229.248 512 512 512 512-229.248 512-512S794.752 0 512 0z m0 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333c157.098667 0 294.016 85.162667 368.085333 211.584L533.333333 643.669333l-161.834666-161.834666a42.624 42.624 0 1 0-60.330667 60.330666l192 192a42.624 42.624 0 0 0 60.330667 0l354.133333-354.133333C931.157333 421.632 938.666667 465.92 938.666667 512c0 235.648-191.018667 426.666667-426.666667 426.666667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-clock1" viewBox="0 0 1024 1024">' + '' + '<path d="M938.666667 533.333333c0-235.648-191.018667-426.666667-426.666667-426.666666S85.333333 297.685333 85.333333 533.333333a425.514667 425.514667 0 0 0 152.32 326.528 41.941333 41.941333 0 0 0-9.130666 11.690667l-32 64a42.666667 42.666667 0 0 0 76.330666 38.186667l32-64c0.512-0.981333 0.426667-2.048 0.810667-3.029334A424.448 424.448 0 0 0 512 960c71.253333 0 138.282667-17.706667 197.333333-48.597333l31.146667 62.336a42.666667 42.666667 0 0 0 76.330667-38.186667l-32-64c-1.237333-2.517333-3.328-4.224-4.992-6.357333A425.557333 425.557333 0 0 0 938.666667 533.333333z m-426.666667 341.333334a341.333333 341.333333 0 1 1 0-682.666667 341.333333 341.333333 0 0 1 0 682.666667zM937.6 141.866667l-128-96a42.666667 42.666667 0 0 0-51.2 68.266666l128 96a42.666667 42.666667 0 0 0 51.2-68.266666zM137.6 210.133333l128-96a42.666667 42.666667 0 0 0-51.2-68.266666l-128 96a42.666667 42.666667 0 0 0 51.2 68.266666z"  ></path>' + '' + '<path d="M725.333333 501.333333h-170.666666v-170.666666a42.666667 42.666667 0 0 0-85.333334 0v213.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h213.333333a42.666667 42.666667 0 0 0 0-85.333334z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-send-white" viewBox="0 0 1024 1024">' + '' + '<path d="M505.6 269.4144l-187.648 234.0608a38.4 38.4 0 0 1-59.904-48.0256l254.3872-317.3376c1.3568-1.9712 2.9184-3.84 4.6848-5.5296a38.4 38.4 0 0 1 61.568 9.2928l251.2896 314.1376a38.4 38.4 0 0 1-59.9552 47.9744l-187.6224-234.496V768c0 69.1968-65.2032 134.4-134.4 134.4h-256a38.4 38.4 0 0 1 0-76.8h256c26.8032 0 57.6-30.8224 57.6-57.6V269.4144z" fill="#ffffff" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-bus" viewBox="0 0 1024 1024">' + '' + '<path d="M799.312842 276.659649H224.687158C145.300211 276.659649 80.842105 341.009965 80.842105 420.396912V663.444211a53.894737 53.894737 0 0 0 53.948632 54.056421h55.206175a93.794807 93.794807 0 0 0 92.950456 80.159438 93.758877 93.758877 0 0 0 92.950457-80.159438h258.712701A93.776842 93.776842 0 0 0 727.578947 797.642105a93.758877 93.758877 0 0 0 92.950457-80.159438h68.679859A53.894737 53.894737 0 0 0 943.157895 663.426246V420.396912c0-79.404912-64.404211-143.737263-143.845053-143.737263z m-38.049684 53.894737h38.049684A89.896421 89.896421 0 0 1 889.263158 420.396912v40.977965h-128V330.554386z m-161.684211 0h107.789474v130.820491h-107.789474V330.554386z m-161.68421 0h107.789474v130.820491h-107.789474V330.554386z m-161.684211 0h107.789474v130.820491h-107.789474V330.554386zM134.736842 420.396912c0-48.774737 39.055719-88.315509 87.578947-89.608982v130.586947H134.736842v-40.977965zM322.59593 711.590175c-0.161684 0.790456-0.431158 1.544982-0.628772 2.317474A40.169544 40.169544 0 0 1 282.947368 743.747368a40.187509 40.187509 0 0 1-39.037754-29.857684c-0.197614-0.772491-0.467088-1.509053-0.628772-2.299509a39.289263 39.289263 0 0 1-0.754526-7.455438c0-21.773474 18.000842-39.612632 40.421052-39.612632s40.421053 17.839158 40.421053 39.612632c0 2.551018-0.287439 5.030175-0.772491 7.455438z m444.631579 0c-0.161684 0.790456-0.431158 1.544982-0.628772 2.317474A40.151579 40.151579 0 0 1 727.578947 743.747368a40.187509 40.187509 0 0 1-39.037754-29.857684c-0.197614-0.772491-0.467088-1.509053-0.628772-2.299509a39.307228 39.307228 0 0 1-0.772491-7.455438c0-21.773474 18.000842-39.612632 40.421052-39.612632s40.421053 17.839158 40.421053 39.612632c0.017965 2.551018-0.269474 5.030175-0.754526 7.455438z m121.981754-48.002245h-76.997614a94.100211 94.100211 0 0 0-169.265403 0l-275.366176-0.017965a94.118175 94.118175 0 0 0-169.229474-0.053895A16885.903719 16885.903719 0 0 1 134.736842 663.444211v-148.156632h754.544281c0 68.248702-0.017965 148.300351-0.07186 148.300351z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-train" viewBox="0 0 1024 1024">' + '' + '<path d="M925.085193 659.833263c-0.377263-4.149895-9.916632-102.651509-64.58386-202.338807-32.624281-59.46386-74.572351-106.999018-124.676491-141.258105C672.983579 273.282246 597.710596 251.508772 512.089825 251.508772H196.733754c-53.894737 0-97.747088 43.600842-97.747087 97.20814v102.310176a25.456281 25.456281 0 0 0 0 6.17993v205.105403c0 53.607298 43.852351 97.20814 97.747087 97.20814h68.410386c0.503018 0.03593 1.024 0.03593 1.544983 0.03593l1.544982-0.03593h559.21179c53.894737 0 97.747088-43.600842 97.747087-97.20814a28.923509 28.923509 0 0 0-0.107789-2.479158z m-168.600702-250.664421c0.808421 0 1.616842-0.03593 2.425263-0.107789a369.160982 369.160982 0 0 1 39.810246 52.403649H505.586526v-52.277895h250.897965zM239.005193 704.494035h-42.271439a42.343298 42.343298 0 0 1-42.415158-42.163649V481.639298h84.686597v222.854737z m588.440702 0H294.355088V454.117053c0-15.198316-12.395789-27.522246-27.665965-27.522246H154.336561v-77.877895a42.343298 42.343298 0 0 1 42.415158-42.163649h315.35607c68.985263 0 129.760561 16.006737 180.888702 47.589053H477.920561c-15.28814 0-27.665965 12.32393-27.665965 27.522245v107.322386c0 15.198316 12.395789 27.522246 27.665965 27.522246H825.667368c0.808421 0 1.616842-0.03593 2.407299-0.107789 32.336842 71.931509 40.654596 137.467509 41.750456 147.186526a42.325333 42.325333 0 0 1-42.379228 40.906105z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-plane1" viewBox="0 0 1024 1024">' + '' + '<path d="M979.629451 610.735158l-10.689123-14.30007c-23.731649-31.690105-75.165193-57.487719-114.777824-57.48772H643.092749L449.125592 298.073825c-18.737404-23.264561-58.008702-42.05586-87.776562-42.05586h-58.044631c-39.846175 0-59.068632 29.570246-43.277474 66.039017L361.636469 556.912281h-144.707369c-9.970526 0-20.40814-7.706947-23.336421-17.210386l-6.090105-19.725474c-11.659228-37.834105-53.337825-68.67986-93.022316-68.67986H75.455416c-39.702456 0-69.344561 31.995509-66.254596 71.482386l6.952421 88.567018C22.333171 690.21193 91.749592 754.526316 171.154504 754.526316h736.345824c99.274105 0 131.610947-64.386246 72.129123-143.791158zM907.518293 700.631579H171.154504c-51.2 0-97.28-42.594807-101.268211-93.489404l-6.952421-88.567017c-0.628772-8.12014 4.221754-13.365895 12.521544-13.365895h19.024842c15.988772 0 36.810105 15.377965 41.516913 30.648141l6.090105 19.725473C151.985942 587.70414 183.334714 610.807018 216.9291 610.807018h144.707369c38.768281 0 64.853333-39.720421 49.457403-75.290948L313.490504 309.912702h47.858526c13.473684 0 37.295158 11.407719 45.792562 21.953123L601.108749 572.739368A53.894737 53.894737 0 0 0 643.092749 592.842105h211.069755c22.59986 0 58.062596 17.767298 71.626105 35.893895l10.707088 14.30007C969.335556 686.888421 962.43703 700.631579 907.518293 700.631579z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-bag" viewBox="0 0 1024 1024">' + '' + '<path d="M896.384 213.333333h-108.416c-36.821333-133.034667-123.946667-213.333333-276.864-213.333333-154.325333 0-240.981333 80-276.565333 213.333333H127.616A127.872 127.872 0 0 0 0 341.333333v554.666667c0 70.997333 57.130667 128 127.616 128h768.768A127.872 127.872 0 0 0 1024 896V341.333333c0-70.997333-57.130667-128-127.616-128z m-385.28-128c100.309333 0 157.568 44.330667 187.306667 128H323.882667c28.8-83.925333 85.632-128 187.221333-128zM938.666667 896c0 23.594667-19.072 42.666667-42.282667 42.666667H127.616A42.282667 42.282667 0 0 1 85.333333 896V341.333333c0-23.594667 19.072-42.666667 42.282667-42.666666H218.88c-3.797333 35.2-4.778667 70.954667-4.778667 126.037333v2.901333c0 3.328 1.194667 6.272 1.877334 9.386667A85.12 85.12 0 0 0 256 597.333333a85.333333 85.333333 0 0 0 85.333333-85.333333c0-32-17.834667-59.605333-43.946666-74.197333 0.853333-3.328 2.048-6.570667 2.048-10.197334v-2.901333c0-57.045333 1.066667-91.392 5.376-126.037333h413.653333c4.949333 36.650667 6.186667 72.917333 6.186667 131.882666 0 2.645333 1.024 4.949333 1.493333 7.466667A85.077333 85.077333 0 0 0 768 597.333333a85.333333 85.333333 0 0 0 85.333333-85.333333c0-32.341333-18.176-60.117333-44.714666-74.581333 0.384-2.304 1.365333-4.394667 1.365333-6.826667 0-56.96-1.109333-94.677333-5.504-131.882667h91.861333A42.24 42.24 0 0 1 938.666667 341.333333v554.666667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-arrow_down" viewBox="0 0 1024 1024">' + '' + '<path d="M115.499 268.501c-7.665-7.41-18.12-11.977-29.641-11.977-23.564 0-42.667 19.103-42.667 42.667 0 11.522 4.567 21.976 11.989 29.653l426.655 426.655c7.721 7.718 18.386 12.492 30.165 12.492 11.78 0 22.445-4.774 30.165-12.492l426.667-426.667c7.41-7.665 11.977-18.12 11.977-29.641 0-23.564-19.103-42.667-42.667-42.667-11.522 0-21.976 4.567-29.653 11.989l-396.489 396.49-396.501-396.501z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-arrow_back" viewBox="0 0 1024 1024">' + '' + '<path d="M755.499 115.499c7.41-7.665 11.977-18.12 11.977-29.641 0-23.564-19.103-42.667-42.667-42.667-11.522 0-21.976 4.567-29.653 11.989l-426.655 426.655c-7.718 7.721-12.492 18.386-12.492 30.165 0 11.78 4.774 22.445 12.492 30.165l426.667 426.667c7.665 7.41 18.12 11.977 29.641 11.977 23.564 0 42.667-19.103 42.667-42.667 0-11.522-4.567-21.976-11.989-29.653l-396.49-396.489 396.501-396.501z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-arrow_next" viewBox="0 0 1024 1024">' + '' + '<path d="M268.501 908.501c-7.41 7.665-11.977 18.12-11.977 29.641 0 23.564 19.103 42.667 42.667 42.667 11.522 0 21.976-4.567 29.653-11.989l426.655-426.655c7.718-7.721 12.492-18.386 12.492-30.165 0-11.78-4.774-22.445-12.492-30.165l-426.667-426.667c-7.665-7.41-18.12-11.977-29.641-11.977-23.564 0-42.667 19.103-42.667 42.667 0 11.522 4.567 21.976 11.989 29.653l396.49 396.489-396.501 396.501z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-forward_down" viewBox="0 0 1024 1024">' + '' + '<path d="M286.165 524.501c-7.665-7.41-18.12-11.977-29.641-11.977-23.564 0-42.667 19.103-42.667 42.667 0 11.522 4.567 21.976 11.989 29.653l255.988 255.988c7.721 7.718 18.386 12.492 30.165 12.492 11.78 0 22.445-4.774 30.165-12.492l256-256c8.036-7.769 13.026-18.647 13.026-30.69 0-23.564-19.103-42.667-42.667-42.667-12.043 0-22.92 4.989-30.678 13.014l-225.846 225.847-225.835-225.835z"  ></path>' + '' + '<path d="M286.165 225.835c-7.665-7.41-18.12-11.977-29.641-11.977-23.564 0-42.667 19.103-42.667 42.667 0 11.522 4.567 21.976 11.989 29.653l255.988 255.988c7.721 7.718 18.386 12.492 30.165 12.492 11.78 0 22.445-4.774 30.165-12.492l256-256c7.41-7.665 11.977-18.12 11.977-29.641 0-23.564-19.103-42.667-42.667-42.667-11.522 0-21.976 4.567-29.653 11.989l-225.823 225.823-225.835-225.835z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-forward_next" viewBox="0 0 1024 1024">' + '' + '<path d="M524.501 737.835c-7.41 7.665-11.977 18.12-11.977 29.641 0 23.564 19.103 42.667 42.667 42.667 11.522 0 21.976-4.567 29.653-11.989l255.988-255.988c7.718-7.721 12.492-18.386 12.492-30.165 0-11.78-4.774-22.445-12.492-30.165l-256-256c-7.769-8.036-18.647-13.026-30.69-13.026-23.564 0-42.667 19.103-42.667 42.667 0 12.043 4.989 22.92 13.014 30.678l225.847 225.846-225.835 225.835z"  ></path>' + '' + '<path d="M225.835 737.835c-7.41 7.665-11.977 18.12-11.977 29.641 0 23.564 19.103 42.667 42.667 42.667 11.522 0 21.976-4.567 29.653-11.989l255.988-255.988c7.718-7.721 12.492-18.386 12.492-30.165 0-11.78-4.774-22.445-12.492-30.165l-256-256c-7.665-7.41-18.12-11.977-29.641-11.977-23.564 0-42.667 19.103-42.667 42.667 0 11.522 4.567 21.976 11.989 29.653l225.823 225.823-225.835 225.835z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-forward_back" viewBox="0 0 1024 1024">' + '' + '<path d="M499.499 286.165c7.41-7.665 11.977-18.12 11.977-29.641 0-23.564-19.103-42.667-42.667-42.667-11.522 0-21.976 4.567-29.653 11.989l-255.988 255.988c-7.718 7.721-12.492 18.386-12.492 30.165 0 11.78 4.774 22.445 12.492 30.165l256 256c7.769 8.036 18.647 13.026 30.69 13.026 23.564 0 42.667-19.103 42.667-42.667 0-12.043-4.989-22.92-13.014-30.678l-225.847-225.846 225.835-225.835z"  ></path>' + '' + '<path d="M798.165 286.165c7.41-7.665 11.977-18.12 11.977-29.641 0-23.564-19.103-42.667-42.667-42.667-11.522 0-21.976 4.567-29.653 11.989l-255.988 255.988c-7.718 7.721-12.492 18.386-12.492 30.165 0 11.78 4.774 22.445 12.492 30.165l256 256c7.665 7.41 18.12 11.977 29.641 11.977 23.564 0 42.667-19.103 42.667-42.667 0-11.522-4.567-21.976-11.989-29.653l-225.823-225.823 225.835-225.835z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-addphoto" viewBox="0 0 1024 1024">' + '' + '<path d="M985.6 819.2H896v-89.6a38.4 38.4 0 0 0-76.8 0V819.2h-89.6a38.4 38.4 0 0 0 0 76.8H819.2v89.6a38.4 38.4 0 0 0 76.8 0V896h89.6a38.4 38.4 0 0 0 0-76.8z"  ></path>' + '' + '<path d="M582.4 871.04V870.4H102.272A25.472 25.472 0 0 1 76.8 844.8256V281.5744c0-14.1824 11.3664-25.5744 25.472-25.5744h742.656c14.1056 0 25.472 11.392 25.472 25.5744V588.8a38.4 38.4 0 0 0 76.8 0V281.5744A102.272 102.272 0 0 0 844.928 179.2H102.272A102.272 102.272 0 0 0 0 281.5744V844.8c0 56.6528 45.7984 102.4 102.272 102.4H582.4v-0.64c18.1504-3.072 32-18.7392 32-37.76s-13.8496-34.688-32-37.76z"  ></path>' + '' + '<path d="M473.6 332.8c-127.2576 0-230.4 103.1424-230.4 230.4s103.1424 230.4 230.4 230.4 230.4-103.1424 230.4-230.4-103.1424-230.4-230.4-230.4z m0 384a153.6 153.6 0 1 1 0-307.2 153.6 153.6 0 0 1 0 307.2zM512 115.2h204.8a38.4 38.4 0 0 0 0-76.8h-204.8a38.4 38.4 0 0 0 0 76.8z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-handcar" viewBox="0 0 1024 1024">' + '' + '<path d="M810.666667 896m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '<path d="M426.666667 896m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"  ></path>' + '' + '<path d="M938.709333 192H426.666667a42.666667 42.666667 0 0 0 0 85.333333h503.552l-68.608 377.386667c-0.469333 2.645333-5.248 6.613333-8.192 6.613333H383.914667c-4.522667 0-12.501333-5.973333-13.696-9.941333L235.861333 197.802667C217.088 134.485333 151.210667 85.333333 85.290667 85.333333H42.666667a42.666667 42.666667 0 0 0 0 85.333334h42.624c28.16 0 60.714667 24.32 68.736 51.370666l134.4 453.589334c11.946667 40.234667 53.248 71.04 95.530666 71.04h469.461334c44.074667 0 84.266667-33.365333 92.16-76.672l70.186666-386.048c8.874667-48.981333-27.008-91.946667-77.056-91.946667z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-normaliconshangwu" viewBox="0 0 1024 1024">' + '' + '<path d="M372.48 826.88c-8.96 10.24-12.8 26.88-11.52 46.08C231.68 816.64 153.6 688.64 153.6 541.44c0-200.96 138.24-363.52 364.8-363.52S883.2 340.48 883.2 541.44c0 148.48-78.08 275.2-207.36 331.52 1.28-19.2-2.56-35.84-11.52-46.08 99.84-49.92 168.96-147.2 168.96-254.72 0-34.56-3.84-62.72-14.08-84.48C798.72 413.44 725.76 358.4 637.44 358.4c-44.8 0-87.04 20.48-120.32 46.08-33.28-25.6-75.52-46.08-120.32-46.08-87.04 0-160 55.04-180.48 129.28-8.96 21.76-14.08 49.92-14.08 84.48 1.28 107.52 70.4 204.8 170.24 254.72z m221.44-267.52c0-15.36 12.8-28.16 28.16-28.16 15.36 0 28.16 12.8 28.16 28.16v28.16c0 14.08-11.52 24.32-25.6 24.32h-6.4c-14.08 0-25.6-11.52-25.6-24.32v-28.16z m-200.96 0c0-15.36 12.8-28.16 28.16-28.16 15.36 0 28.16 12.8 28.16 28.16v28.16c0 14.08-11.52 24.32-25.6 24.32h-6.4c-14.08 0-25.6-11.52-25.6-24.32v-28.16z m75.52 94.72c0-20.48 16.64-37.12 37.12-37.12H537.6c20.48 0 37.12 16.64 37.12 37.12v5.12c0 23.04-19.2 42.24-42.24 42.24h-23.04c-23.04 0-42.24-19.2-42.24-42.24v-5.12z m64 217.6s72.96-35.84 106.24-35.84c33.28 0 12.8 112.64-20.48 112.64s-89.6-56.32-89.6-56.32c-6.4-7.68-5.12-16.64 3.84-20.48z m-28.16 0c8.96 3.84 10.24 14.08 3.84 20.48 0 0-56.32 56.32-89.6 56.32s-53.76-112.64-20.48-112.64 106.24 35.84 106.24 35.84z m171.52-689.92c-17.92 0-49.92-2.56-52.48-6.4-5.12-6.4 6.4-25.6 29.44-46.08s69.12-34.56 92.16-14.08c19.2 17.92 12.8 49.92-16.64 61.44-12.8 3.84-34.56 5.12-52.48 5.12z m-314.88 0c-17.92 0-39.68-1.28-52.48-5.12-29.44-11.52-35.84-43.52-16.64-61.44 23.04-20.48 67.84-6.4 92.16 14.08s35.84 40.96 29.44 46.08c-2.56 3.84-34.56 6.4-52.48 6.4z m-56.32 455.68c-1.28-6.4 3.84-12.8 10.24-14.08s12.8 3.84 14.08 10.24c0 1.28 0 2.56 1.28 6.4 1.28 5.12 2.56 10.24 5.12 16.64 6.4 17.92 14.08 34.56 26.88 51.2 33.28 46.08 83.2 72.96 156.16 72.96s122.88-26.88 156.16-72.96c11.52-16.64 20.48-33.28 26.88-51.2 2.56-6.4 3.84-11.52 5.12-16.64 1.28-2.56 1.28-5.12 1.28-6.4 1.28-6.4 7.68-11.52 14.08-10.24 6.4 1.28 11.52 7.68 10.24 14.08-1.28 5.12-2.56 15.36-7.68 26.88-6.4 19.2-16.64 38.4-29.44 57.6-37.12 52.48-96 83.2-176.64 83.2s-139.52-32-176.64-83.2c-12.8-17.92-23.04-37.12-29.44-57.6-3.84-12.8-6.4-21.76-7.68-26.88z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-miniiconshangwu1" viewBox="0 0 1024 1024">' + '' + '<path d="M259.2 147.2c12.8 6.4 41.6 6.4 60.8 6.4s57.6-3.2 64-6.4c6.4-6.4-6.4-28.8-35.2-54.4-28.8-25.6-83.2-41.6-108.8-16-22.4 22.4-16 57.6 19.2 70.4zM496 851.2s-86.4-41.6-124.8-41.6c-38.4 0-12.8 134.4 25.6 134.4 38.4 0 102.4-67.2 102.4-67.2 9.6-9.6 6.4-19.2-3.2-25.6zM700.8 153.6c19.2 0 48 0 64-6.4 35.2-12.8 41.6-48 19.2-70.4-28.8-25.6-80-9.6-108.8 16-28.8 22.4-41.6 48-35.2 54.4 3.2 3.2 41.6 6.4 60.8 6.4zM390.4 627.2c22.4 0 35.2-16 35.2-32v-38.4c0-16-12.8-32-32-32h-3.2c-16 0-32 12.8-32 32v38.4c0 19.2 16 32 32 32zM627.2 627.2c19.2 0 32-16 32-32v-38.4c0-16-12.8-32-32-32h-3.2c-16 0-32 12.8-32 32v38.4c0 19.2 16 32 35.2 32z"  ></path>' + '' + '<path d="M512 144C272 144 128 320 128 537.6c0 147.2 70.4 275.2 188.8 345.6-3.2-3.2-3.2-6.4-3.2-9.6-3.2-22.4-3.2-41.6 0-57.6 3.2-12.8 6.4-22.4 12.8-28.8-70.4-54.4-115.2-137.6-115.2-227.2 0-35.2 3.2-64 12.8-86.4 19.2-76.8 89.6-131.2 172.8-131.2 41.6 0 83.2 22.4 115.2 48 32-25.6 73.6-48 115.2-48 83.2 0 153.6 57.6 172.8 131.2 9.6 22.4 12.8 51.2 12.8 86.4 0 89.6-44.8 172.8-115.2 227.2 6.4 9.6 9.6 19.2 12.8 28.8 3.2 16 3.2 38.4 0 57.6-3.2 3.2-3.2 6.4-3.2 9.6 118.4-67.2 188.8-198.4 188.8-345.6C896 320 752 144 512 144z"  ></path>' + '' + '<path d="M656 809.6c-38.4 0-124.8 41.6-124.8 41.6-12.8 6.4-12.8 16-3.2 25.6 0 0 64 67.2 102.4 67.2 41.6 0 64-134.4 25.6-134.4z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-micc" viewBox="0 0 1024 1024">' + '' + '<path d="M396.8 358.1696v154.0352c0 70.69184 57.30816 128 128 128s128-57.30816 128-128V358.1696c0-70.69184-57.30816-128-128-128s-128 57.30816-128 128z" fill="#FFDD8C" ></path>' + '' + '<path d="M563.2 881.536v81.9456a38.4 38.4 0 0 1-76.8 0v-82.0736C277.6064 862.2848 128 691.8656 128 486.4a38.4 38.4 0 0 1 76.8 0c0 176.4352 134.8864 319.5648 320.1024 320 179.2768 0.4096 294.2976-135.8336 294.2976-320a38.4 38.4 0 0 1 76.8 0c0 210.9696-129.7664 376.96-332.8 395.136zM320 230.1696C320 117.1968 411.9296 25.6 524.8 25.6c113.1008 0 204.8 91.776 204.8 204.5696v282.0352c0 112.9728-91.9296 204.5696-204.8 204.5696-113.1008 0-204.8-91.776-204.8-204.5696V230.1696z m76.8 0v282.0352c0 70.69184 57.30816 128 128 128s128-57.30816 128-128V230.1696c0-70.69184-57.30816-128-128-128s-128 57.30816-128 128z" fill="#666E70" ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-apps" viewBox="0 0 1024 1024">' + '' + '<path d="M387.264 479.68h-192c-52.928 0-96-43.072-96-96v-192c0-52.928 43.072-96 96-96h192c52.928 0 96 43.072 96 96v192c0 52.96-43.072 96-96 96z m-192-320c-17.632 0-32 14.368-32 32v192c0 17.632 14.368 32 32 32h192c17.632 0 32-14.368 32-32v-192c0-17.632-14.368-32-32-32h-192zM387.264 927.68h-192c-52.928 0-96-43.072-96-96v-192c0-52.928 43.072-96 96-96h192c52.928 0 96 43.072 96 96v192c0 52.96-43.072 96-96 96z m-192-320c-17.632 0-32 14.336-32 32v192c0 17.664 14.368 32 32 32h192c17.632 0 32-14.336 32-32v-192c0-17.664-14.368-32-32-32h-192zM832.128 479.68h-192c-52.928 0-96-43.072-96-96v-192c0-52.928 43.072-96 96-96h192c52.928 0 96 43.072 96 96v192c0 52.96-43.072 96-96 96z m-192-320c-17.664 0-32 14.368-32 32v192c0 17.632 14.336 32 32 32h192c17.664 0 32-14.368 32-32v-192c0-17.632-14.336-32-32-32h-192zM832.128 927.68h-192c-52.928 0-96-43.072-96-96v-192c0-52.928 43.072-96 96-96h192c52.928 0 96 43.072 96 96v192c0 52.96-43.072 96-96 96z m-192-320c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32h-192z"  ></path>' + '' + '</symbol>' + '' + '<symbol id="icon-recharge" viewBox="0 0 1024 1024">' + '' + '<path d="M384 341.333333h85.333333v42.666667H384a42.666667 42.666667 0 0 0 0 85.333333h85.333333v86.229334a42.666667 42.666667 0 0 0 85.333334 0V469.333333h85.333333a42.666667 42.666667 0 0 0 0-85.333333h-85.333333V341.333333h85.333333a42.666667 42.666667 0 0 0 0-85.333333h-9.344l8.064-32.298667a42.666667 42.666667 0 1 0-82.816-20.693333L542.677333 256h-61.354666l-13.269334-53.034667a42.666667 42.666667 0 1 0-82.773333 20.736L393.344 256H384a42.666667 42.666667 0 0 0 0 85.333333z"  ></path>' + '' + '<path d="M768.256 0H255.744A85.333333 85.333333 0 0 0 170.666667 85.546667v852.906666A85.333333 85.333333 0 0 0 255.744 1024h512.512A85.333333 85.333333 0 0 0 853.333333 938.453333V85.546667A85.333333 85.333333 0 0 0 768.256 0zM768 85.546667L768.042667 682.666667H256c0-251.306667-0.085333-597.333333-0.256-597.333334 0 0 512.256 0.042667 512.256 0.213334zM256 938.453333V768h512.085333c0.042667 100.224 0.085333 170.666667 0.170667 170.666667 0 0-512.256-0.042667-512.256-0.213334z"  ></path>' + '' + '<path d="M512 853.333333m-42.666667 0a42.666667 42.666667 0 1 0 85.333334 0 42.666667 42.666667 0 1 0-85.333334 0Z"  ></path>' + '' + '</symbol>' + '' + '</svg>';
  var script = function () {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1];
  }();
  var shouldInjectCss = script.getAttribute('data-injectcss');

  var ready = function ready(fn) {
    function IEContentLoaded(w, callback) {
      var d = w.document;
      var done = false;

      var init = function init() {
        if (!done) {
          done = true;
          callback();
        }
      };

      var polling = function polling() {
        try {
          d.documentElement.doScroll('left');
        } catch (e) {
          setTimeout(polling, 50);
          return;
        }


        init();
      };

      polling();

      d.onreadystatechange = function () {
        if (d.readyState === 'complete') {
          d.onreadystatechange = null;
          init();
        }
      };
    }
    if (document.addEventListener) {
      if (~['complete', 'loaded', 'interactive'].indexOf(document.readyState)) {
        setTimeout(fn, 0);
      } else {
        var loadFn = function loadFn() {
          document.removeEventListener('DOMContentLoaded', loadFn, false);
          fn();
        };
        document.addEventListener('DOMContentLoaded', loadFn, false);
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn);
    }
  };

  var before = function before(el, target) {
    target.parentNode.insertBefore(el, target);
  };

  var prepend = function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  };

  function appendSvg() {
    var div = document.createElement('div');
    div.innerHTML = svgSprite;
    svgSprite = null;
    var svg = div.getElementsByTagName('svg')[0];
    if (svg) {
      svg.setAttribute('aria-hidden', 'true');
      svg.style.position = 'absolute';
      svg.style.width = 0;
      svg.style.height = 0;
      svg.style.overflow = 'hidden';
      prepend(svg, document.body);
    }
  }

  if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true;
    try {
      document.write('<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>');
    } catch (e) {
      console.log(e);
    }
  }

  ready(appendSvg);
})(window);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {
  switch: {
    knowledgeToManual: {
      enable: true,
      threshhold: 2,
      sopthreshhold: 2
    },
    hideHistory: false,
    robotToLocal: false,
    manualToRobot: false,
    manualToDefaultServiceGroup: {
      enable: false,
      serviceId: 'd'
    },
    hideCommentManualEntrance: false,
    hideRecommend: false
  },
  config: {
    greetings: null,
    shortcuts: [{
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-16',
      name: 'skin',
      means: {
        type: 'text',
        content: 'skin'
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp'
    }, {
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-17',
      name: 'login',
      means: {
        type: 'text',
        content: 'login'
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp'
    }, {
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-18',
      name: 'liveAgent',
      means: {
        type: 'text',
        content: 'liveAgent'
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp'
    }],
    inputTip: 'Check orders',
    autoWord: 'welcome',
    logo: '',
    welcomeMsg: 'Hi,I`m your shopping assistent!!',
    inputType: 'voice',
    toApassManager: true,
    openbaseType: 'answer.do'
  },
  announcements: [],
  easygoinfo: {
    sessionId: '',
    unfinishedCount: null,
    cancelCount: 0,
    userId: 2295212110,
    canHaveOcsService: false,
    imSid: null,
    ocsGroupId: null,
    lastRequirement: null
  },
  theme: 'night',
  pluginVersion: {
    weather: '0.1.2',
    flight: '0.0.4',
    voice: '0.0.6',
    coupon: '0.0.3',
    disney: '0.0.01',
    functip: '0.0.2',
    notice: '0.0.1',
    namecard: '0.0.7',
    rate: '0.0.8',
    recharge: '0.0.5',
    orderlist: '0.0.12',
    std: '0.0.6',
    manproduct: '0.0.1',
    weekend: '0.0.04',
    card: '1.1.8',
    confirmorder: '0.0.6',
    sop: '0.2.4',
    addresselector: '0.0.2',
    sendshortcut: '0.1.0',
    classdemo: '0.0.1',
    game: '0.0.6',
    option: '0.0.1',
    commandpic: '0.0.1',
    servicerecord: '0.0.4'
  },
  prime: {
    newFeed: 0,
    count: 0
  },
  remind: {
    newFeed: 0,
    count: 0
  },
  botId: '77',
  history: [],
  recommend: {
    operations: [{
      id: 102242821687,
      title: 'lazada上线了',
      intro: '',
      link: '//www.lazada.com.my/',
      icon: null,
      image: 'https://gw.alicdn.com/tfs/TB1Q1pLRpXXXXcpXXXXXXXXXXXX-654-243.png',
      time: '2017-05-18T12:57:06.000Z'
    }],
    knowledges: null,
    suggestions: [],
    articles: null,
    briefs: [{
      title: 'First level briefing',
      content: null,
      link: null,
      type: null,
      expand: false,
      subContent: [{
        title: 'Second level briefing',
        content: 'Second level content',
        link: null,
        type: null,
        expand: false,
        subContent: null
      }]
    }]
  },
  session: {
    isNeedResume: false,
    continuedResume: false
  },
  onedata: null,
  user: {
    userId: 2295212110,
    nick: '乐弋',
    phone: ' ',
    gender: 'M',
    memberType: 'normal',
    birth: '19900606',
    todayIsBirthDay: false,
    isFirstVisit: false,
    lastVisitTime: 1495422412461,
    corpId: 0
  },
  msgbox: null,
  messages: [],
  from: 'unknown',
  imsid: 'd021f9b03e9b11e7a053f363da23eda4',
  connect: false,
  sourceId: '1506162234',
  time: 1495422459083,
  xcode: 'b79de3b1adcadc6824e9a4f3949fb5d2',
  robotCode: 'alicare_intention',
  robotScene: 'alicare_intention_scene',
  skin: 'normal',
  actionTips: {
    managerOnline: {
      type: 'system',
      tip: '[\u4EBA\u5DE5\u5C0F\u871C] ' + name + ' \u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u6109\u5FEB\u804A\u8D77\u6765~'
    },
    managerOffline: {
      type: 'system',
      tip: '[人工小蜜] 已退出服务，很高兴遇见您~'
    }
  },
  env: 'pre'
};

exports.default = config;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appConfigDefault = exports.appConfigFormat = undefined;

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatUserInfo() {
  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var birth = userInfo.birth,
      corpId = userInfo.corpId,
      gender = userInfo.gender,
      isFirstVisit = userInfo.isFirstVisit,
      lastVisitTime = userInfo.lastVisitTime,
      memberType = userInfo.memberType,
      nick = userInfo.nick,
      phone = userInfo.phone,
      todayIsBirthDay = userInfo.todayIsBirthDay,
      userId = userInfo.userId;

  return {
    birth: birth,

    todayIsBirthDay: todayIsBirthDay,

    corpId: corpId,

    gender: gender,

    isFirstVisit: isFirstVisit,

    lastVisitTime: lastVisitTime,

    memberType: memberType,

    nick: nick,

    phone: phone,

    userId: userId
  };
}

function formatSession(data) {
  var session = data.session || {};

  var _ref = session.data || {},
      _ref$isInQueue = _ref.isInQueue,
      isInQueue = _ref$isInQueue === undefined ? {} : _ref$isInQueue,
      queuing = _ref.queuing,
      servicerGroupId = _ref.servicerGroupId,
      servicerUserId = _ref.servicerUserId,
      p2pTimestamp = _ref.p2pTimestamp,
      p2pToken = _ref.p2pToken,
      resumeSid = _ref.resumeSid,
      sessionId = _ref.sessionId,
      sid = _ref.sid,
      toId = _ref.toId,
      token = _ref.token,
      vendor = _ref.vendor;

  return {
    actionTips: data.actionTips,
    openToken: data.openToken,
    openbaseType: data.config.openbaseType,
    connect: data.connect,
    xcode: data.xcode,
    timestemp: data.time,
    continuedResume: session.continuedResume,
    isNeedResume: session.isNeedResume,
    isInQueue: isInQueue,
    queuing: queuing,
    servicerGroupId: servicerGroupId,
    servicerUserId: servicerUserId,
    resumeSid: resumeSid,
    p2pToken: p2pToken,
    p2pTimestamp: p2pTimestamp,
    sessionId: sessionId,
    sid: sid,
    toId: toId,
    token: token,
    vendor: vendor
  };
}

function formatBase(data) {
  return {
    imsid: data.imsid,

    from: data.from,

    sourceId: data.sourceId,
    appName: data.config.appName || 'alixm',

    env: data.env,

    bu: data.bu
  };
}

function formatRobot(data) {
  return {
    botId: data.botId,
    robotCode: data.robotCode,
    robotScene: data.robotScene
  };
}

function formatAppConfig(data) {
  var _data$config = data.config,
      autoWord = _data$config.autoWord,
      greetings = _data$config.greetings,
      inputTip = _data$config.inputTip,
      inputType = _data$config.inputType,
      logo = _data$config.logo,
      openbaseType = _data$config.openbaseType,
      shortcuts = _data$config.shortcuts,
      toApassManager = _data$config.toApassManager,
      welcomeMsg = _data$config.welcomeMsg,
      appName = _data$config.appName,
      customSmiley = _data$config.customSmiley,
      defaultManualAvatar = _data$config.defaultManualAvatar,
      theme = _data$config.theme,
      robotAvatar = _data$config.robotAvatar;

  return {
    autoWord: autoWord,
    greetings: greetings,
    inputTip: inputTip,
    inputType: inputType,
    logo: logo,
    openbaseType: openbaseType,
    shortcuts: shortcuts,
    toApassManager: toApassManager,

    welcomeMsg: welcomeMsg,

    defaultManualAvatar: defaultManualAvatar,

    theme: theme,

    customSmiley: customSmiley || [],

    appName: appName || 'alixm',

    skin: data.skin || 'normal',

    switch: data.switch,

    pluginVersion: data.pluginVersion,

    actionTips: data.actionTips,

    robotAvatar: robotAvatar
  };
}

function formatBUConfig() {
  return {
    customization: null
  };
}

function dataMap(data) {
  var r = new Map();

  r.set('base', formatBase(data));

  r.set('qs', _util2.default.queryString.parse(location.search.replace(/^\?/, '')));

  r.set('user', formatUserInfo(data.user));

  r.set('ocs', formatSession(data));

  r.set('robot', formatRobot(data));

  r.set('appConfig', formatAppConfig(data));

  r.set('bu', formatBUConfig(data));

  r.set('recommend', {
    banner: data.config.banner,
    list: data.config.recommend
  });

  r.set('easygo', data.easygo);

  r.set('announcements', data.announcements);

  r.set('history', data.history);

  r.set('msgbox', data.msgbox);
  r.set('onedata', data.onedata);
  r.set('switches', data.switch);
  r.set('prime', data.prime);
  r.set('remind', data.remind);
  r.set('messages', data.messages);
  r.set('redirector', data.redirector);

  r.set('plugin', data.plugin);

  return r;
}

function appConfigFormat(data) {
  _util2.default.storage.setItem('lastConfig', JSON.stringify(data));
  return dataMap(data);
}

function appConfigDefault() {
  if (_util2.default.storage.getItem('lastConfig')) {
    return dataMap(JSON.parse(_util2.default.storage.getItem('lastConfig')));
  }
  var qs = _util2.default.queryString.parse(location.search.replace(/^\?/, ''));
  var data = {
    robotCode: 'alicare_new',
    robotScene: 'alicare_new_scene',
    sourceId: '1506162234',
    imsid: new Date().getTime(),
    session: {
      resume: false
    },
    qs: qs,
    announcements: [],
    from: qs.from || 'unknow',
    recommend: null,
    history: [],
    user: {},
    config: {
      welcomeMsg: _util2.default.lang.get('WELCOME:MESSAGE')
    },
    switch: {
      hideCommentManualEntrance: true,
      knowledgeToManual: {
        enable: false
      }
    }
  };
  return dataMap(data);
}

exports.appConfigFormat = appConfigFormat;
exports.appConfigDefault = appConfigDefault;

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(316);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _main = __webpack_require__(317);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _main2.default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

var _querystring = __webpack_require__(15);

var _querystring2 = _interopRequireDefault(_querystring);

var _model = __webpack_require__(318);

var _model2 = _interopRequireDefault(_model);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _lang = __webpack_require__(319);

var _lang2 = _interopRequireDefault(_lang);

var _util = __webpack_require__(4);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(324);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.alicare_env_ispc = _util2.default.isPC();

var Mebot = function () {
  function Mebot() {
    _classCallCheck(this, Mebot);

    var env = this.__getQueryString('env');
    this.model = new _model2.default({
      env: env
    });
  }

  _createClass(Mebot, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var ncfg = null;
      ncfg = Object.assign({}, cfg, { model: this.model, lang: _lang2.default });
      if (ncfg.param.token) {
        this.model.lazadaLogin({
          _user_access_token: ncfg.param.token,
          appId: ncfg.param.appId
        }).then(function (res) {
          _this.model.xcookie = res.xCookie;
          ncfg.param.showLiveAgent = ncfg.param.showLiveAgent;
          ncfg.param.greetingType = ncfg.param.greetingType || 'card';
          _this.__lazada(ncfg);
        }, function () {
          _this.showError(cfg);
        });
      } else {
        this.model.getToken({
          appId: cfg.param.appId
        }).then(function (d) {
          ncfg.param.token = d;
          _this.model.lazadaLogin({
            _user_access_token: d,
            appId: ncfg.param.appId
          }).then(function (res) {
            _this.model.xcookie = res.xCookie;
            ncfg.param.showLiveAgent = ncfg.param.showLiveAgent || true;
            ncfg.param.greetingType = ncfg.param.greetingType || 'card';
            _this.__lazada(ncfg);
          }, function () {
            _this.showError(cfg);
          });
        });
      }
    }
  }, {
    key: '__lazada',
    value: function __lazada(ncfg) {
      var _this2 = this;

      this.model.getConfig({
        appId: ncfg.param.appId
      }).then(function (res) {
        _this2.language = (0, _lang2.default)(res.language);
        ncfg.config = res;
        ncfg.lang = _this2.language;
        var app = new _index2.default(ncfg);
        _this2.cfg = ncfg;
        _this2.app = app;
        _this2.__init(ncfg);
      });
    }
  }, {
    key: '__init',
    value: function __init(cfg) {
      var _this3 = this;

      var app = this.app;
      app.start();

      app.on('ready', function (e) {
        cfg.onReady(e, function (d) {
          _this3.ready(d);
        });
      });

      app.on('login', function (e) {
        cfg.onLogin(e, function (p) {
          _this3.login(p);
        });
      });

      app.on('liveAgent', function (e) {
        cfg.onLiveAgent(e, function (d) {
          _this3.live(d);
        });
      });

      app.on('cancelResult', function (e) {
        cfg.onCancel(e, function (d) {
          _this3.cancel(d);
        });
      });

      app.on('bankTransfer', function (e) {
        cfg.onRefund(e, function (d) {
          _this3.cancel(d);
        });
      });

      app.on('sessionExpired', function () {
        _this3.__sessionExpired();
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.app.app.view.$frame.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.app.app.view.$frame.show();
      this.app.app.view.resize();
      this.app.pvLog();
      window.alicare_firstmessage.resize();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      (0, _tarzanZepto2.default)(this.cfg.container).empty();
      this.app = null;
    }
  }, {
    key: 'ready',
    value: function ready() {
      console.log('Alime is Ready');
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.app.app.view.scrollToBottom();
    }
  }, {
    key: 'login',
    value: function login(e) {
      var _this4 = this;

      if (!e.error || e.error && e.error.code === 0) {
        this.model.lazadaLogin({
          _user_access_token: e.token,
          appId: this.cfg.param.appId
        }).then(function (res) {
          _this4.model.xcookie = res.xCookie;
          _this4.app.robotMock(_this4.language['LOGIN:SUCCESS']);
          if (e.action) {
            _this4.app.feedback(e);
          }
        }, function () {
          _this4.app.robotMock(_this4.language['ROBOT:EXCEPTION']);
        });
      } else {
        this.app.robotMock(e.error.msg);
      }
    }
  }, {
    key: 'live',
    value: function live(e) {
      if (!e.error || e.error && e.error.code === 0) {
        this.app.feedback(e);
      } else {
        this.app.robotMock(e.error.msg);
      }
    }
  }, {
    key: 'cancel',
    value: function cancel(e) {
      if (!e.error || e.error && e.error.code === 0) {
        this.app.feedback(e);
      } else {
        this.app.robotMock(e.error.msg);
      }
    }
  }, {
    key: 'sendMsg',
    value: function sendMsg(text) {
      this.app.robotMock(text);
    }
  }, {
    key: 'showError',
    value: function showError(cfg) {
      var $tpl = (0, _tarzanZepto2.default)('\n        <div class="ali-alime-errorpage">\n            <div class="error">\n                <img src="//gw.alicdn.com/tps/TB1IKcGOpXXXXXvXVXXXXXXXXXX-281-311.png">\n                <p>' + this.language('PAGE:404') + '</p>\n                <a href="javascript:;" class="reload">Reload</a>\n            </div>\n        </div>\n    ');
      (0, _tarzanZepto2.default)(cfg.container || 'body').append($tpl);
      $tpl.find('.reload').on('tap', function () {
        location.reload();
      });
    }
  }, {
    key: '__getQueryString',
    value: function __getQueryString(name) {
      var p = _querystring2.default.parse(location.search.replace(/^\?/, ''));
      return p[name];
    }
  }, {
    key: '__sessionExpired',
    value: function __sessionExpired() {
      var _this5 = this;

      this.model.getToken({
        appId: this.cfg.param.appId
      }).then(function (d) {
        _this5.cfg.param.token = d;
        _this5.model.lazadaLogin({
          _user_access_token: d,
          appId: _this5.cfg.param.appId
        }).then(function (res) {
          _this5.model.xcookie = res.xCookie;
          _this5.app.robotMock();
        }, function () {
          _this5.showError(_this5.cfg);
        });
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(left, top) {
      this.app.app.view.$frame.css({ left: left, top: top });
    }
  }, {
    key: 'setSize',
    value: function setSize(width, height) {
      this.app.app.view.$frame.css({ width: width, height: height });
    }
  }]);

  return Mebot;
}();

var Alime = new Mebot();

exports.default = Alime;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tarzanZepto = __webpack_require__(1);

var _tarzanZepto2 = _interopRequireDefault(_tarzanZepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Model = function () {
  function Model() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Model);

    var env = options.env;

    var beebotDomain = void 0;

    this.xcookie = null;

    if (env === 'daily') {
      beebotDomain = '//ebee.daily.taobao.net';
    } else if (env === 'pre') {
      beebotDomain = '//pre-beebot.alibaba.com';
    } else {
      beebotDomain = '//beebot-sg.alibaba.com';
    }
    Object.assign(this, {
      env: env,
      beebotDomain: beebotDomain
    });
  }

  _createClass(Model, [{
    key: 'getToken',
    value: function getToken(params) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.requestJSONP({
          url: _this.beebotDomain + '/lazada/guest',
          data: params
        }).then(function (data) {
          resolve(data);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'getConfig',
    value: function getConfig(params) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.requestJSONP({
          url: _this2.beebotDomain + '/lazada/init',
          data: params
        }).then(function (data) {
          resolve(data);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'openair',
    value: function openair(data, timeout) {
      return this.requestJSONP({
        url: this.beebotDomain + '/lazada/pivot',
        data: data,
        timeout: timeout || 10000
      });
    }
  }, {
    key: 'lazadaLogin',
    value: function lazadaLogin(params) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.requestJSONP({
          url: _this3.beebotDomain + '/lazada/refresh',
          data: params
        }).then(function (data) {
          resolve(data);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'refreshUrl',
    value: function refreshUrl(params) {
      return this.beebotDomain + '/lazada/refresh?_user_access_token=' + params._user_access_token + '&appId=' + params.appId;
    }
  }, {
    key: 'robotRate',
    value: function robotRate(data) {
      return this.requestJSONP({
        url: this.beebotDomain + '/lazada/feedback',
        data: data
      });
    }
  }, {
    key: 'lazadaLogout',
    value: function lazadaLogout() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.requestJSONP({
          url: _this4.beebotDomain + '/logout'
        }).then(function (data) {
          resolve(data);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'requestJSONP',
    value: function requestJSONP() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$data = options.data,
          data = _options$data === undefined ? {} : _options$data,
          url = options.url,
          _options$timeout = options.timeout,
          timeout = _options$timeout === undefined ? 10000 : _options$timeout,
          _options$traditional = options.traditional,
          traditional = _options$traditional === undefined ? !!0 : _options$traditional;

      Object.assign(data || {}, {
        _input_charset: 'utf-8'
      });

      if (this.xcookie) {
        Object.assign(data || {}, {
          'x-cookie': this.xcookie
        });
      }

      return new Promise(function (resolve, reject) {
        _tarzanZepto2.default.ajax({
          url: url,
          data: data,
          timeout: timeout,
          traditional: traditional,
          type: 'get',
          dataType: 'jsonp',
          success: function success() {
            var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var status = response.status,
                success = response.success,
                code = response.code;

            var result = status;

            if (status === undefined) {
              result = success !== undefined ? !!success : !code;
            }

            return result ? resolve(response.data) : reject(response);
          },
          error: function error(xhr, errorType) {
            reject(errorType);
          }
        });
      });
    }
  }, {
    key: 'requestJSON',
    value: function requestJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$data2 = options.data,
          data = _options$data2 === undefined ? {} : _options$data2,
          url = options.url,
          _options$timeout2 = options.timeout,
          timeout = _options$timeout2 === undefined ? 10000 : _options$timeout2,
          _options$traditional2 = options.traditional,
          traditional = _options$traditional2 === undefined ? !!0 : _options$traditional2;

      Object.assign(data || {}, {
        _input_charset: 'utf-8'
      });

      return new Promise(function (resolve, reject) {
        _tarzanZepto2.default.ajax({
          url: url,
          data: data,
          beforeSend: function beforeSend(xhr) {
            try {
              xhr.withCredentials = true;
            } catch (e) {
              var nativeOpen = xhr.open;
              xhr.open = function () {
                var result = nativeOpen.apply(xhr, data);
                xhr.withCredentials = true;
                return result;
              };
            }
          },

          timeout: timeout,
          traditional: traditional,
          type: 'get',
          dataType: 'json',
          success: function success() {
            var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var status = response.status,
                success = response.success,
                code = response.code;

            var result = status;

            if (status === undefined) {
              result = success !== undefined ? !!success : !code;
            }
            return result ? resolve(response.data) : reject(response);
          },
          error: function error(xhr, errorType) {
            reject(errorType);
          }
        });
      });
    }
  }]);

  return Model;
}();

exports.default = Model;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (lang) {
  console.log(lang);
  if (lang === 'en-us') {
    return _enUs2.default;
  } else if (lang === 'id-id') {
    return _idId2.default;
  } else if (lang === 'vi-VN') {
    return _viVn2.default;
  } else if (lang === 'th-TH') {
    return _thTh2.default;
  }
  return _enUs2.default;
};

var _enUs = __webpack_require__(320);

var _enUs2 = _interopRequireDefault(_enUs);

var _idId = __webpack_require__(321);

var _idId2 = _interopRequireDefault(_idId);

var _viVn = __webpack_require__(322);

var _viVn2 = _interopRequireDefault(_viVn);

var _thTh = __webpack_require__(323);

var _thTh2 = _interopRequireDefault(_thTh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ROBOT:EXCEPTION': 'Uh oh! Something went wrong at our side. Don`t worry, it`s not you. Sorry about that.',
  'ROBOT:NOANSWER': 'Sorry,I can`t understand, you can ask in a different way',
  'ROBOT:SUGGEST': 'I guess you want to say',
  'LOGIN:SUCCESS': 'Awesome! You`re logged in now!',
  'KNOWLEDGE:GOOD': 'What else can I help you with?',
  'KNOWLEDGE:BAD': 'Seems my response wasn`t useful for you. Would you like to rephrase the question or ask something else?',
  'SHIPPING:ADDRESS': 'Shipping Address',
  'ROBOT:RECOMMEND': 'Do you still want to know the following：',
  'ROBOT:RECOMMEND:RELATED': 'Perhaps these suggestions related to your question:',
  'TRACKING:DETAIL': 'Tracking Details',
  'ORDER:STATUS': 'Order Status',
  'CANCEL:ITEM': 'Cancel Item',
  'BUTTON:MORE': 'View More',
  'SHOW:ALLORDERS': 'Show all of my orders',
  'ROBOT:WELCOME': '...or answer questions you have about Lazada.',
  'ROBOT:LIVEAGENT': 'I`d prefer to Chat with a Live Agent',
  'PAGE:404': 'Sorry,your page was taken away',
  'WORD:ITEM': 'Item',
  'FEEDBACK:QUESTION': 'Was this helpful?',
  'FEEDBACK:THANKS': 'Thank you!',
  'LIVE:AGENT': 'live agent',
  openOrder: function openOrder(n) {
    return 'Alright, you`ve got ' + n + ' open orders';
  },
  indexOrder: function indexOrder(o, n) {
    return 'Order ' + o + ' of ' + n;
  },
  packageDetail: function packageDetail(o, n) {
    return 'Details for order ' + o + ' with ' + n + ' packages';
  },
  orderDetail: function orderDetail(o, p, n) {
    return 'Order number  ' + o + ' placed ' + p + ' has ' + n + ' items';
  },
  packageOrder: function packageOrder(p, n) {
    return 'Package ' + p + ' of ' + n;
  },
  tracking: function tracking(p, n) {
    return 'Here `s your tracking details for <span class="bold">Package  ' + p + '</span>  of order number <span class="bold">' + n + '</span>';
  }
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ROBOT:EXCEPTION': 'Uh oh! Mohon maaf ya sepertinya terjadi kesalahan.. Silahkan coba lagi.',
  'ROBOT:NOANSWER': 'Maaf, Saya kurang paham. Bisa Anda ulangi lagi?',
  'ROBOT:SUGGEST': 'Saya kira Anda ingin mengatakan:',
  'LOGIN:SUCCESS': 'Keren! Anda sudah login sekarang！',
  'KNOWLEDGE:GOOD': 'Ada lagi yang bisa saya bantu?',
  'KNOWLEDGE:BAD': 'Maaf ya sepertinya informasi yang saya berikan kurang membantu. Apakah ada pertanyaan atau informasi lain yang dibutuhkan?',
  'SHIPPING:ADDRESS': 'Alamat pengiriman',
  'ROBOT:RECOMMEND': 'Apakah Anda ingin masih ingin mengetahui informasi mengenai hal berikut:',
  'ROBOT:RECOMMEND:RELATED': 'Mungkin informasi berikut bisa menjawab pertanyaan Anda:',
  'TRACKING:DETAIL': 'Rincian status',
  'ORDER:STATUS': 'Status pesanan',
  'CANCEL:ITEM': 'Pembatalan pesanan',
  'BUTTON:MORE': 'lihat selengkapnya',
  'SHOW:ALLORDERS': 'Tampilkan seluruh pesanan saya',
  'ROBOT:WELCOME': '..atau jawab pertanyaan yang Anda punya mengenai Lazada.',
  'ROBOT:LIVEAGENT': 'Saya ingin chat langsung dengan Agent',
  'PAGE:404': 'Maaf, halaman yang Anda cari tidak tersedia.',
  'WORD:ITEM': 'Item',
  'FEEDBACK:QUESTION': 'Apakah artikel ini membantu?',
  'FEEDBACK:THANKS': 'Terima kasih!',
  'LIVE:AGENT': 'live agent',
  openOrder: function openOrder(n) {
    return 'Baik, Anda punya ' + n + ' pesanan yang masih berjalan';
  },
  indexOrder: function indexOrder(o, n) {
    return 'Pesanan ' + o + ' dari ' + n;
  },
  packageDetail: function packageDetail(o, n) {
    return 'Rincian untuk pesanan ' + o + ' dengan ' + n + ' produk';
  },
  orderDetail: function orderDetail(o, p, n) {
    return 'Nomor pesanan ' + o + ' dipesan pada ' + p + ' terdiri dari ' + n;
  },
  packageOrder: function packageOrder(p, n) {
    return 'Pesanan ' + p + ' dari ' + n;
  },
  tracking: function tracking(p, n) {
    return 'Berikut rincian pesanan untuk <span class="bold">Pesanan ' + p + '</span> dari nomor pesanan <span class="bold">' + n + '</span>';
  }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ROBOT:EXCEPTION': 'Ồ ! Có trục trặc từ phía chúng tôi rồi. Đừng lo mà, không phải tại bạn đâu. Xin lỗi về điều đó nhé',
  'ROBOT:NOANSWER': 'Xin lỗi, tôi chưa hiểu lắm, bạn có thể hỏi bằng cách khác được mà',
  'ROBOT:SUGGEST': 'Tôi nghĩ là bạn muốn nói gì đó phải không',
  'LOGIN:SUCCESS': 'Tuyệt ! Giờ thì bạn đã đăng nhập được hệ thống rồi đó!',
  'KNOWLEDGE:GOOD': 'Tôi có thể giúp gì thêm cho bạn?',
  'KNOWLEDGE:BAD': 'Có vẻ như phản hồi của tôi không hữu ích cho bạn thì phải. Hay là bạn thử đặt lại câu hỏi hay hỏi gì khác nhé?',
  'SHIPPING:ADDRESS': 'Địa chỉ giao hàng',
  'ROBOT:RECOMMEND': 'Bạn vẫn muốn biết các mục sau chứ:',
  'ROBOT:RECOMMEND:RELATED': 'Tôi thấy các đề xuất sau đây có lẽ sẽ liên quan tới câu hỏi của bạn:',
  'TRACKING:DETAIL': 'Thông tin tra cứu',
  'ORDER:STATUS': 'Trạng thái đơn hàng',
  'CANCEL:ITEM': 'Hủy sản phẩm',
  'BUTTON:MORE': 'Xem thêm',
  'SHOW:ALLORDERS': 'Hiện ra hết tất cả các đơn hàng của tôi',
  'ROBOT:WELCOME': '...hoặc trả lời các câu hỏi của bạn về Lazada.',
  'ROBOT:LIVEAGENT': 'Tôi muốn gặp tư vấn viên',
  'PAGE:404': 'Xin lỗi, trang của bạn hiện không tồn tại',
  'WORD:ITEM': 'Sản phẩm',
  'FEEDBACK:QUESTION': 'Bạn thấy cái này có ích chứ ?',
  'FEEDBACK:THANKS': 'Cảm ơn bạn!',
  'LIVE:AGENT': 'Gặp tư vấn viên',
  openOrder: function openOrder(n) {
    return '\u0110\u01B0\u1EE3c r\u1ED3i, b\u1EA1n \u0111ang c\xF3 ' + n + ' \u0111\u01A1n h\xE0ng ch\u01B0a \u0111\u01B0\u1EE3c giao';
  },
  indexOrder: function indexOrder(o, n) {
    return '\u0110\u01A1n h\xE0ng ' + o + ' c\u1EE7a ' + n;
  },
  packageDetail: function packageDetail(o, n) {
    return 'C\xE1c th\xF4ng tin cho \u0111\u01A1n h\xE0ng ' + o + ' v\u1EDBi s\u1ED1 ki\u1EC7n h\xE0ng ' + n;
  },
  orderDetail: function orderDetail(o, p, n) {
    return '\u0110\u01A1n h\xE0ng s\u1ED1 ' + o + ' \u0111\xE3 \u0111\u1EB7t ' + p + ' c\xF3 ' + n + ' s\u1EA3n ph\u1EA9m';
  },
  packageOrder: function packageOrder(p, n) {
    return 'Ki\u1EC7n h\xE0ng ' + p + ' c\u1EE7a ' + n;
  },
  tracking: function tracking(p, n) {
    return '\u0110\xE2y l\xE0 th\xF4ng tin tra c\u1EE9u cho <span class="bold"> ki\u1EC7n h\xE0ng ' + p + '</span> c\u1EE7a \u0111\u01A1n h\xE0ng s\u1ED1 <span class="bold">' + n + '</span>';
  }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ROBOT:EXCEPTION': 'โอ๊ะโอ! เกิดความขัดข้องจากทางเรา ขอโทษด้วยนะ',
  'ROBOT:NOANSWER': 'ขอโทษนะ ฉันไม่เข้าใจคำถามของคุณ ช่วยเรียบเรียงคำถาม หรือถามแบบอื่นได้มั้ย?',
  'ROBOT:SUGGEST': 'ฉันเดาว่าคุณต้องการจะพูดว่า:',
  'LOGIN:SUCCESS': 'เย้! คุณเข้าสู่ระบบเรียบร้อย!',
  'KNOWLEDGE:GOOD': 'ให้ฉันช่วยอะไรอีกมั้ย?',
  'KNOWLEDGE:BAD': 'ดูเหมือนฉันจะตอบไม่ตรงคำถาม คุณอยากลองถามอีกรอบ หรือถามอย่างอื่นมั้ย?',
  'SHIPPING:ADDRESS': 'ที่อยู่สำหรับการจัดส่ง',
  'ROBOT:RECOMMEND': 'คุณยังต้องการทราบข้อมูลต่อไปนี้หรือไม่:',
  'ROBOT:RECOMMEND:RELATED': 'บางทีคำแนะนำต่อไปนี้อาจเกี่ยวข้องกับคำถามของคุณ:',
  'TRACKING:DETAIL': 'รายละเอียดการติดตามสินค้า',
  'ORDER:STATUS': 'สถานะคำสั่งซื้อ',
  'CANCEL:ITEM': 'ยกเลิกสินค้า',
  'BUTTON:MORE': 'ดูรายละเอียดเพิ่มเติม',
  'SHOW:ALLORDERS': 'แสดงคำสั่งซื้อทั้งหมดของฉัน',
  'ROBOT:WELCOME': '..หรือคำถามที่คุณมีเกี่ยวกับลาซาด้า.',
  'ROBOT:LIVEAGENT': 'ฉันต้องการคุยกับเจ้าหน้าที่จริงๆ ไม่ใช่หุ่นยนต์',
  'PAGE:404': 'ขอโทษนะที่หน้าเว็บหายไป.',
  'WORD:ITEM': 'สินค้า',
  'FEEDBACK:QUESTION': 'มีประโยชน์มั้ย?',
  'FEEDBACK:THANKS': 'ขอบคุณ!',
  'LIVE:AGENT': 'แชทกับจนท',
  openOrder: function openOrder(n) {
    return '\u0E42\u0E2D\u0E40\u0E04 \u0E04\u0E38\u0E13\u0E21\u0E35 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D ' + n + ' \u0E2D\u0E22\u0E39\u0E48';
  },
  indexOrder: function indexOrder(o, n) {
    return '\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E17\u0E35\u0E48 ' + o + ' \u0E08\u0E32\u0E01 ' + n;
  },
  packageDetail: function packageDetail(o, n) {
    return '\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D ' + o + ' \u0E17\u0E35\u0E48\u0E21\u0E35\u0E1E\u0E31\u0E2A\u0E14\u0E38 ' + n + ' \u0E0A\u0E34\u0E49\u0E19';
  },
  orderDetail: function orderDetail(o, p, n) {
    return '\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D ' + o + ' \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A ' + p + ' \u0E21\u0E35 ' + n + ' \u0E0A\u0E34\u0E49\u0E19';
  },
  packageOrder: function packageOrder(p, n) {
    return '\u0E1E\u0E31\u0E2A\u0E14\u0E38\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02 ' + p + ' \u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D ' + n;
  },
  tracking: function tracking(p, n) {
    return '\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E1E\u0E31\u0E2A\u0E14\u0E38 <span class="bold">' + p + '</span> \u0E02\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D <span class="bold">' + n + '</span>';
  }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(325);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./base.scss", function() {
			var newContent = require("!!../../../node_modules/_css-loader@0.25.0@css-loader/index.js??ref--3-1!../../../node_modules/_sass-loader@4.0.2@sass-loader/index.js??ref--3-2!../../../node_modules/_postcss-loader@1.3.3@postcss-loader/index.js??ref--3-3!./base.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".ali-alime-errorpage .error {\n  width: 300px;\n  margin: 0 auto;\n  color: #999;\n  text-align: center;\n  margin-top: 100px;\n  font-size: 16px; }\n  .ali-alime-errorpage .error img {\n    width: 140px;\n    height: 150px; }\n  .ali-alime-errorpage .error p {\n    margin: 15px 50px; }\n  .ali-alime-errorpage .error a {\n    display: inline-block;\n    padding: 10px 0;\n    width: 120px;\n    color: #666;\n    border: 1px solid #999;\n    border-radius: 5px;\n    text-decoration: none; }\n", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// alime_pc.js